import React from "react";
import { Flame, OctagonX, TriangleAlert, Info, Tag, Layers, Database, Building, FolderClosed, ExternalLink, X, ArrowRight, ChartNoAxesCombined, SlidersHorizontal, ChevronRight,Workflow, GitBranch, Expand, Maximize2 } from 'lucide-react';
import NavigationHeader from '../components/navigationHeader';
import { CopyRightsFooter } from '../components/copyrights';
import NotifyToast from '../components/notifyToast';
import LineageModal from '../components/LineageModal';
import VerticalDashboardModal from './components/verticalDashboardModal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// eslint-disable-next-line 
import { faLayerGroup, faTag, faCalendar, faClock, faCalendarAlt, faDatabase, faEllipsisV, faCube, faChartArea, faAsterisk, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Image from "../components/image";
import Select, { components } from 'react-select';
import RangeSlider from 'react-rangeslider';
import Form from 'react-bootstrap/Form';
import 'react-rangeslider/lib/index.css';
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from 'moment';
import RcTooltip from 'rc-tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
// import Overlay from 'react-bootstrap/Overlay';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import BarChartFullscreen from "../assets/img/incidents/barChart-fullscreen.png";
// import Chart1 from "../assets/img/incidents/chart-1.svg";
// import Chart2 from "../assets/img/incidents/chart-2.svg";
// import Chart3 from "../assets/img/incidents/chart-3.svg";
// import Chart4 from "../assets/img/incidents/chart-4.svg";
// import Chart5 from "../assets/img/incidents/chart-5.svg";
import iconComboChart from "../assets/img/incidents/icon_combo-chart.svg";
import iconBarChart from "../assets/img/incidents/icon_bar-chart.svg";
import iconAreaChart from "../assets/img/incidents/icon_area-chart.svg";
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import FadeUpOnScroll from "../components/fadeUpOnScroll";
// import Chart1 from "../assets/img/incidents/Chart1.png";
import LineageFullscreen from "../assets/img/incidents/lineage-graph-fullscreen.png";
// import PipelineLineage from "../assets/img/incidents/Pipeline-lineage.png";
import $ from 'jquery';
// import VerticalChart from "./components/verticalchart";
import { getTeamId, getUserId } from "../utils/common_utils";

import {
    getLatestEnvironmentList,
    getWatchList,
    getVerticalAllIncidents,
    getVerticalHeroIncidents,
    getVerticalKpiSummaryData,
    getVerticalBusinessAreaIncidents,
    postVerticalInteraction,
    getVerticalAiInsights,
    getVerticalDiagnosticMap
} from "../utils/verticalEventHandling";
import VerticalChart from "./components/verticalchart";
import BarChart from "./components/barchart";
import IncidentAiInsightContent, { getVerticalAiInsightsRequest } from "./components/incidentAiInsightContent";
import { chart_metrics_units, formatChartMetricValue, getCompactMetricParts, getCurrencyDisplayPrefix, normalizeMetricUnits } from "./components/utils_incident";
import { browserHistory } from "react-router";  // for v3
import { LIST_VIEW_OPTIONS_DQ } from "../utils/constant";
import CustomTreeSelectAllincidents from "./components/customTreeSelectAllincidents";

const VERTICAL_INCIDENT_FILTER_STORAGE_KEY = "incidentFilters:vertical";

const getVerticalIncidentFilterStorageKey = () =>
    `${VERTICAL_INCIDENT_FILTER_STORAGE_KEY}:${localStorage.getItem("team_id") || ""}:${localStorage.getItem("user_id") || ""}`;

const readPersistedVerticalIncidentFilters = () => {
    try {
        return JSON.parse(sessionStorage.getItem(getVerticalIncidentFilterStorageKey())) || {};
    } catch (error) {
        sessionStorage.removeItem(getVerticalIncidentFilterStorageKey());
        return {};
    }
};

const KPI_INCIDENT_ICON = (
    <svg className="tw-block" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path d="M14.7695 3.375C15.1483 3.37508 15.469 3.50613 15.7314 3.76855C15.9939 4.03098 16.1249 4.35174 16.125 4.73047V13.2695C16.1249 13.6483 15.9939 13.969 15.7314 14.2314C15.469 14.4939 15.1483 14.6249 14.7695 14.625H3.23047C2.85174 14.6249 2.53098 14.4939 2.26855 14.2314C2.00613 13.969 1.87508 13.6483 1.875 13.2695V4.73047C1.87508 4.35174 2.00613 4.03098 2.26855 3.76855C2.53098 3.50613 2.85174 3.37508 3.23047 3.375H14.7695ZM4.5 6.75V10.8281H5.49316V9.02734L6.86426 10.8281H8.0791L6.44043 8.74902L8.02051 6.75H6.85254L5.49316 8.53906V6.75H4.5ZM8.55078 10.8281H9.54395V9.36426H10.1602C11.1999 9.36426 11.659 8.73726 11.6592 8.06348C11.6592 7.314 11.1595 6.75 10.1602 6.75H8.55078V10.8281ZM12.1768 10.8281H13.1699V6.75H12.1768V10.8281ZM10.085 7.55176C10.4799 7.55183 10.6484 7.7498 10.6484 8.06348C10.6483 8.3769 10.4797 8.57414 10.085 8.57422H9.54395V7.55176H10.085Z" fill="currentColor" />
    </svg>
);

const KpiIcon = ({ size = 18, color = "#B5B5C3", className = "", style = {} }) => (
    <svg
        width={size}
        height={Math.round(size * (19 / 18))}
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`tw-inline-block tw-align-middle tw-shrink-0 ${className}`}
        style={style}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7695 3.84375C15.1483 3.84383 15.469 3.97488 15.7314 4.2373C15.9939 4.49973 16.1249 4.82049 16.125 5.19922V13.7383C16.1249 14.117 15.9939 14.4378 15.7314 14.7002C15.469 14.9626 15.1483 15.0937 14.7695 15.0938H3.23047C2.85174 15.0937 2.53098 14.9626 2.26855 14.7002C2.00613 14.4378 1.87508 14.117 1.875 13.7383V5.19922C1.87508 4.82049 2.00613 4.49973 2.26855 4.2373C2.53098 3.97488 2.85174 3.84383 3.23047 3.84375H14.7695ZM4.5 7.21875V11.2969H5.49316V9.49609L6.86426 11.2969H8.0791L6.44043 9.21777L8.02051 7.21875H6.85254L5.49316 9.00781V7.21875H4.5ZM8.55078 11.2969H9.54395V9.83301H10.1602C11.1999 9.83301 11.659 9.20601 11.6592 8.53223C11.6592 7.78275 11.1595 7.21875 10.1602 7.21875H8.55078V11.2969ZM12.1768 11.2969H13.1699V7.21875H12.1768V11.2969ZM10.085 8.02051C10.4799 8.02058 10.6484 8.21855 10.6484 8.53223C10.6483 8.84565 10.4797 9.04289 10.085 9.04297H9.54395V8.02051H10.085Z"
            fill={color}
        />
    </svg>
);

function formatIncidentTimestamp(ts) {
    if (!ts) return "";
    return ts.replace(/GMT/gi, "UTC");
}

function formatHeroDescription(message) {
  if (!message) return null;

  const formattedMessage = message
    // The API may already include emphasis tags. Strip only those known tags so
    // we can rebuild the content as React elements instead of rendering HTML.
    .replace(/<strong\b[^>]*>|<\/strong>/gi, '')
    .replace(
      /on\s+(\d{1,2}\s+\w+\s+\d{4},\s+\d{1,2}:\d{2}\s+[AP]M\s+GMT)/,
      'on <strong class="tw-font-semibold">$1</strong>'
    )
    .replace(
      /(Increased|Decreased) to\s+([\d.]+)/i,
      '$1 to <strong class="tw-font-semibold">$2</strong>'
    )
    .replace(
      /a\s+([\d.]+)\s*%\s*deviation/,
      'a <strong class="tw-font-semibold">$1%</strong> deviation'
    )
    .replace(
      /average value of\s+([\d.]+)/,
      'average value of <strong class="tw-font-semibold">$1</strong>'
    )
    .replace(
      /last\s+(\d+)\s+refreshes/,
      'last <strong class="tw-font-semibold">$1 refreshes</strong>'
    );

  return formattedMessage.split(/(<strong\b[^>]*>.*?<\/strong>)/gi).map((part, index) => {
    const match = part.match(/^<strong\b[^>]*>(.*?)<\/strong>$/i);
    return match
      ? <strong class="tw-font-semibold" key={index}>{match[1]}</strong>
      : <React.Fragment key={index}>{part}</React.Fragment>;
  });
}


const PERIOD_TYPE_MAPPING = {
    11: "yesterday",
    12: "current day in previous weeks",      
    21: "last week",
    23: "current week in previous months",    
    24: "current week in previous years",     
    31: "last month",
    34: "current month in previous years",    
    41: "last quarter",
    44: "current quarter in previous years",  
    51: "last 6 months",
    54: "Current half-year in previous years",     
    61: "last year",
}

const customSelectWishlist = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="form-control__icon">
            <g opacity="0.75">
                <path d="M15.9351 13.8077C15.2093 13.8077 14.5915 13.5537 14.0819 13.0455C13.5722 12.5373 13.3174 11.9203 13.3174 11.1945C13.3174 10.4687 13.5715 9.851 14.0796 9.3415C14.5878 8.83183 15.2048 8.577 15.9306 8.577C16.6565 8.577 17.2742 8.831 17.7839 9.339C18.2934 9.84717 18.5481 10.4642 18.5481 11.19C18.5481 11.9158 18.2941 12.5336 17.7861 13.0433C17.278 13.5529 16.661 13.8077 15.9351 13.8077ZM11.2214 19.423C10.9652 19.423 10.7505 19.3364 10.5774 19.1633C10.404 18.9899 10.3174 18.7753 10.3174 18.5193V17.9078C10.3174 17.6239 10.3863 17.3536 10.5241 17.0968C10.662 16.8399 10.852 16.6359 11.0944 16.4848C11.8187 16.0603 12.5831 15.7388 13.3876 15.5203C14.1923 15.3016 15.0407 15.1923 15.9329 15.1923C16.825 15.1923 17.6734 15.3016 18.4779 15.5203C19.2824 15.7388 20.0469 16.0603 20.7714 16.4848C21.0135 16.6359 21.2036 16.8399 21.3414 17.0968C21.4792 17.3536 21.5481 17.6239 21.5481 17.9078V18.5193C21.5481 18.7753 21.4615 18.9899 21.2884 19.1633C21.1151 19.3364 20.9004 19.423 20.6444 19.423H11.2214ZM10.1924 13.75H4.19238C3.97988 13.75 3.8018 13.6781 3.65813 13.5343C3.5143 13.3904 3.44238 13.2122 3.44238 12.9998C3.44238 12.7871 3.5143 12.609 3.65813 12.4655C3.8018 12.3218 3.97988 12.25 4.19238 12.25H10.1924C10.4049 12.25 10.583 12.3219 10.7269 12.4658C10.8705 12.6096 10.9424 12.7878 10.9424 13.0003C10.9424 13.2129 10.8705 13.391 10.7269 13.5345C10.583 13.6782 10.4049 13.75 10.1924 13.75ZM14.1924 5.75H4.19238C3.97988 5.75 3.8018 5.67808 3.65813 5.53425C3.5143 5.39042 3.44238 5.21225 3.44238 4.99975C3.44238 4.78708 3.5143 4.609 3.65813 4.4655C3.8018 4.32183 3.97988 4.25 4.19238 4.25H14.1924C14.4049 4.25 14.583 4.32192 14.7269 4.46575C14.8706 4.60958 14.9424 4.78775 14.9424 5.00025C14.9424 5.21292 14.8706 5.391 14.7269 5.5345C14.583 5.67817 14.4049 5.75 14.1924 5.75ZM11.3981 9.75H4.19238C3.97988 9.75 3.8018 9.67808 3.65813 9.53425C3.5143 9.39042 3.44238 9.21225 3.44238 8.99975C3.44238 8.78708 3.5143 8.609 3.65813 8.4655C3.8018 8.32183 3.97988 8.25 4.19238 8.25H12.1349C11.9592 8.46917 11.8117 8.70217 11.6924 8.949C11.5732 9.19583 11.4751 9.46283 11.3981 9.75Z" fill="currentColor" />
            </g>
        </svg>
        {children}
    </components.Control>

);
// eslint-disable-next-line
const customSelectChart = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="form-control__icon">
            <g opacity="0.75">
                <path d="M6.18274 13.0369L8.72441 10.5031L10.3911 12.1698L13.5577 9.01604V10.625H14.8077V6.875H11.0577V8.125H12.6667L10.3911 10.4006L8.72441 8.73396L5.31253 12.1667L6.18274 13.0369ZM4.4392 17.0833C4.01823 17.0833 3.66191 16.9375 3.37024 16.6458C3.07857 16.3542 2.93274 15.9978 2.93274 15.5769V4.42312C2.93274 4.00215 3.07857 3.64583 3.37024 3.35417C3.66191 3.0625 4.01823 2.91667 4.4392 2.91667H15.5929C16.0139 2.91667 16.3702 3.0625 16.6619 3.35417C16.9536 3.64583 17.0994 4.00215 17.0994 4.42312V15.5769C17.0994 15.9978 16.9536 16.3542 16.6619 16.6458C16.3702 16.9375 16.0139 17.0833 15.5929 17.0833H4.4392ZM4.4392 15.8333H15.5929C15.6571 15.8333 15.7159 15.8066 15.7692 15.7531C15.8227 15.6998 15.8494 15.641 15.8494 15.5769V4.42312C15.8494 4.35896 15.8227 4.30021 15.7692 4.24687C15.7159 4.1934 15.6571 4.16667 15.5929 4.16667H4.4392C4.37503 4.16667 4.31628 4.1934 4.26295 4.24687C4.20948 4.30021 4.18274 4.35896 4.18274 4.42312V15.5769C4.18274 15.641 4.20948 15.6998 4.26295 15.7531C4.31628 15.8066 4.37503 15.8333 4.4392 15.8333Z" fill="currentColor" />
            </g>
        </svg>
        {children}
    </components.Control>

);
const IconOption = (props) => (
  <components.Option {...props}>
    <div className="tw-flex tw-items-center tw-gap-2">
      <img src={props.data.icon} alt="" />
      <span>{props.data.label}</span>
    </div>
  </components.Option>
);
const IconSingleValue = (props) => (
  <components.SingleValue {...props}>
    <div className="tw-flex tw-items-center tw-gap-2">
      <img src={props.data.icon} alt="" />
      <span>{props.data.label}</span>
    </div>
  </components.SingleValue>
);

/** Anchor Quick Action menus to the viewport so table overflow/transform
 *  ancestors cannot shift them (same fix as incidents/index.js). */
const ACTION_DROPDOWN_POPPER_CONFIG = {
    strategy: 'fixed',
    modifiers: [
        { name: 'offset', options: { offset: [0, 4] } },
        { name: 'preventOverflow', options: { boundary: 'viewport', padding: 8 } },
        { name: 'flip', options: { fallbackPlacements: ['top-end', 'bottom-end'] } },
    ],
};


const options = [
    { value: 'My Daily Followup', label: 'My Daily Followup' },
    { value: 'Data Check', label: 'Data Check' },
    { value: 'Data Analysis', label: 'Data Analysis' }
]

const filterOptions = [
    { value: 'Top Issues', label: 'Top Issues' },
    { value: 'Top 10', label: 'Top 10' },
    { value: 'Top 25', label: 'Top 25' },
    { value: 'Top 50', label: 'Top 50' },
    { value: 'Top 100', label: 'Top 100' },
]

const chartFilterOptions = [
    { value: 'Combo Chart', label: 'Combo Chart', icon: iconComboChart },
    { value: 'Bar Chart', label: 'Bar Chart', icon: iconBarChart },
    { value: 'Area Chart', label: 'Area Chart', icon: iconAreaChart }
]

// â”€â”€â”€ Per-section slider config â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Sequence cycles from beginning when sections exceed config length.
// Each entry maps to one of the 9 distinct static section designs.
//
// cardStyle:     card template â†’ 'standard' | 'compact' | 'stacked' | 'grid' | 'merchandise'
// chartType:     'bar' | 'area' | 'line'
// titlePosition: 'top' | 'grid-left-48' | 'grid-right-75' | 'grid-left-57'
//   top          = centered title above full-width slider
//   grid-left-48 = Bootstrap row: col-lg-4 title (right-aligned) + col-lg-8 pr-0 slider
//   grid-right-75= Bootstrap row: col-lg-7 pl-0 slider (left) + col-lg-auto title (right)
//   grid-left-57 = Bootstrap row: col-lg-5 title (right-aligned) + col-lg-7 pr-0 slider
// sliderClass:   extra CSS class(es) appended to the <Slider> className
// slidesToShow:  number of visible slides
// titleMaxW:     max-width of the title block for 'top' layout (e.g. '90%', '70%')
// chartHeight:   chart area height inside each card
const VERTICAL_CHART_HEIGHT = {
    HERO_BANNER: 205,
    HERO_KPI_CARD: 70,
    DEFAULT: 145,
};
const VERTICAL_CHART_AXIS_FONT = {
    HERO_BANNER: 12,
    HERO_KPI_CARD: 9,
    DEFAULT: 10,
};
const KPI_SECTION_SLIDER_MIN_HEIGHT = 420;
const MAX_CONCURRENT_KPI_SECTION_LOADS = 1;
/** Prefetch only below the viewport so above-the-fold height never changes while reading. */
const KPI_SECTION_PREFETCH_MARGIN = '0px 0px 600px 0px';
const KPI_SECTION_PAD_CLASS = 'tw-py-[50px] md:tw-py-[65px] xl:tw-py-[80px] 2xl:tw-py-[100px]';
const KPI_SCROLL_IDLE_MS = 200;
const TREND_SVG_PATH_UP = "M14.6663 4.66671L9.42059 9.91246C9.15658 10.1765 9.02457 10.3085 8.87235 10.3579C8.73846 10.4014 8.59423 10.4014 8.46033 10.3579C8.30811 10.3085 8.17611 10.1765 7.91209 9.91246L6.08725 8.08762C5.82324 7.82361 5.69124 7.6916 5.53902 7.64215C5.40512 7.59864 5.26089 7.59864 5.127 7.64215C4.97478 7.6916 4.84277 7.82361 4.57876 8.08762L1.33301 11.3334M14.6663 9.33337V4.66671H9.99967";
const TREND_SVG_PATH_DOWN = "M14.6663 11.3333L9.42059 6.08754C9.15658 5.82353 9.02457 5.69152 8.87235 5.64206C8.73846 5.59856 8.59423 5.59856 8.46033 5.64206C8.30811 5.69152 8.17611 5.82353 7.91209 6.08754L6.08725 7.91238C5.82324 8.17639 5.69124 8.3084 5.53902 8.35785C5.40512 8.40136 5.26089 8.40136 5.127 8.35785C4.97478 8.3084 4.84277 8.17639 4.57876 7.91238L1.33301 4.66663M14.6663 6.66663V11.3333H9.99967";
const TREND_COLOR_RED = "#F87180";
const TREND_TEXT_CLASS = "tw-text-sm tw-font-medium";
// boxBg:         true â†’ renders an absolute background box behind the slider
// rtl:           true â†’ react-slick RTL mode
const SECTION_CONFIG = [
    // 1. Call Center Operations — top title, ~3.5 cards (reference: callCenterIncident)
    {
        name: 'section1',
        title: 'Call Center Operations Incidents',
        matchKeys: [
            'call center operations', 'call center', 'call centre', 'contact center', 'contact centre',
        ],
        description: 'Tracks issues related to call routing, agent performance data, and customer service ticket integrity.',
        cardStyle: 'standard', chartType: 'bar', titlePosition: 'top',
        sliderClass: 'has-left-padding', slidesToShow: 3.5,
        titleMaxW: '70%', chartHeight: '145px', axisFontSize: 10, arrowPosition: 'left',
        glow: { color: '#2F2CE5', position: 'tw-left-[-10%] tw-bottom-[-20%]' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 3.5, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 2. Customer Relationship Management — top title, 4 cards (reference: relationshipIncident)
    {
        name: 'section2',
        title: 'Customer Relationship Management Incidents',
        matchKeys: [
            'customer relationship management', 'customer relationship', 'customer management', 'crm',
        ],
        description: 'Monitors data quality within the CRM, including customer profiles, address data, and loyalty program information.',
        cardStyle: 'standard', chartType: 'area', titlePosition: 'top',
        sliderClass: 'has-left-padding', slidesToShow: 4,
        titleMaxW: '70%', chartHeight: '145px', axisFontSize: 10, arrowPosition: 'left',
        extraSliderClass: 'qd-incidents-slider--relationship tw-pb-[80px]',
        glow: { color: '#E52CA7', position: 'tw-right-[-25%] tw-top-[15%]' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 4, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 3. Customer Order & Fulfillment — standard card (title inside)
    {
        name: 'section3',
        title: 'Customer Order & Fulfillment Incidents',
        matchKeys: [
            'customer order & fulfillment', 'customer order and fulfillment', 'customer order',
            'order management', 'order & fulfillment', 'fulfillment', 'fulfilment',
        ],
        description: 'Focuses on the end-to-end order process, from transaction capture and order creation to invoicing and fulfillment data.',
        cardStyle: 'standard', chartType: 'area', titlePosition: 'top',
        sliderClass: 'has-left-padding', slidesToShow: 4.25,
        titleMaxW: '90%', chartHeight: '145px', axisFontSize: 10, arrowPosition: 'left',
        extraSliderClass: 'slick-slider--action-left',
        glow: { color: '#2F2CE5', position: 'tw-left-[-10%] tw-top-[15%]' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 4.25, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 4. E-Commerce Platform — 2-row zigzag grid 3+2 ONLY (reference: static tw-grid tw-grid-cols-3)
    {
        name: 'section4',
        title: 'E-Commerce Platform Incidents',
        matchKeys: [
            'e-commerce platform', 'ecommerce platform', 'e commerce platform',
            'e-commerce', 'ecommerce', 'e commerce', 'digital commerce',
        ],
        description: 'Monitors the health of online data streams, including live user clickstreams, online transactions, and personalization engines.',
        cardStyle: 'grid', chartType: 'bar', titlePosition: 'top',
        sliderClass: 'has-left-padding', slidesToShow: 1,
        titleMaxW: '90%', chartHeight: '145px', axisFontSize: 9, arrowPosition: 'center',
        glow: { color: '#2F2CE5', position: 'tw-right-[-25%] tw-top-[10%]' },
        sliderSettings: {
            dots: true,
            speed: 500,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 2,
            slidesPerRow: 3,
        },
    },
    // 5. Financial Management & Reporting — top-left title, ~2.5 cards (reference: financialManagementIncident)
    {
        name: 'section5',
        title: 'Financial Management & Reporting Incidents',
        matchKeys: [
            'financial management & reporting', 'financial management and reporting',
            'financial management', 'financial reporting', 'finance',
        ],
        description: 'Tracks the integrity of core financial data, such as the general ledger, invoices, costs, and revenue reporting.',
        cardStyle: 'standard', chartType: 'bar', titlePosition: 'top-left',
        sliderClass: 'has-left-padding', slidesToShow: 2.5,
        titleMaxW: '90%', chartHeight: '145px', axisFontSize: 10, arrowPosition: 'left',
        sectionBg: 'tw-bg-white/5',
        glow: { color: '#E52CA7', position: 'tw-left-[-10%] tw-top-[-10%]' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 2.5, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 6. Forecourt & Fueling — title LEFT + cards RIGHT (reference: foreCourtIncident)
    {
        name: 'section6',
        title: 'Forecourt & Fueling Service Incidents',
        matchKeys: [
            'forecourt & fueling', 'forecourt and fueling', 'forecourt',
            'fueling service', 'fuelling service', 'fueling', 'fuelling', 'fuel',
        ],
        description: 'Focuses on data from fueling transactions, including pump pricing, payment processing, and sales volume data.',
        cardStyle: 'stacked', chartType: 'line', titlePosition: 'grid-left-48',
        sliderClass: 'has-no-padding', slidesToShow: 2.2,
        titleMaxW: '90%', chartHeight: '145px', axisFontSize: 12, arrowPosition: 'left',
        glow: { color: '#2F2CE5', position: 'tw-bottom-[-25%] tw-right-[-10%]', w: '720px', h: '650px' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 2.2, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 7. Manufacturer Data & Integration — title RIGHT + cards LEFT + RTL (reference: integrationIncident)
    {
        name: 'section7',
        title: 'Manufacturer Data & Integration Incidents',
        matchKeys: [
            'manufacturer data & integration', 'manufacturer data and integration',
            'manufacturer data', 'manufacturer', 'data integration', 'supply chain',
            'sourcing & procurement', 'sourcing and procurement', 'sourcing', 'procurement',
        ],
        description: 'Monitors the quality and timeliness of data received from manufacturing partners, such as SKU information and delivery notices.',
        cardStyle: 'standard', chartType: 'bar', titlePosition: 'grid-right-75',
        sliderClass: 'has-no-padding has-box-container tw-bg-white/10 tw-border tw-border-[#6243FF]/40 tw-rounded-r-[32px] tw-pt-[48px] tw-pb-[56px]',
        slidesToShow: 2.2, titleMaxW: '90%', chartHeight: '145px', axisFontSize: 11, arrowPosition: 'left', rtl: true,
        glow: { color: '#2F2CE5', position: 'tw-bottom-[-30%] tw-left-[-10%]', w: '720px', h: '650px' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 2.2, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 8. Marketing Campaign & Analytics — centered title + boxBg + center arrows (reference: manufactureIncident)
    {
        name: 'section8',
        title: 'Marketing Campaign & Analytics Incidents',
        matchKeys: [
            'marketing campaign & analytics', 'marketing campaign and analytics',
            'marketing campaign', 'marketing analytics', 'marketing & advertising',
            'marketing and advertising', 'marketing', 'advertising',
        ],
        description: 'Tracks data quality issues impacting marketing efforts, from campaign audience lists to performance analytics and promotions.',
        cardStyle: 'grid', chartType: 'area', titlePosition: 'top',
        sliderClass: 'has-box-container tw-px-[70px] tw-pb-[80px]',
        slidesToShow: 3, titleMaxW: '90%', chartHeight: '145px', axisFontSize: 11, boxBg: true, arrowPosition: 'center',
        glow: { color: '#E52CA7', position: 'tw-top-[-10%] tw-right-[-25%]', w: '960px', h: '1500px' },
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 3, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 9. Merchandise & Product Management — title LEFT + cards RIGHT (reference: foreCourtIncident + box)
    {
        name: 'section9',
        title: 'Merchandise & Product Management Incidents',
        matchKeys: [
            'merchandise & product management', 'merchandise and product management',
            'merchandise management', 'product management', 'merchandise', 'merchandising',
            'retail inventory management', 'retail inventory', 'inventory management',
        ],
        description: 'Monitors the core product data, including item costs, SKU details, supplier information, and supply chain status.',
        cardStyle: 'merchandise', chartType: 'line', titlePosition: 'grid-left-57',
        sliderClass: 'has-no-padding has-box-container tw-bg-white/10 tw-border tw-border-[#6243FF]/40 tw-rounded-l-[32px] tw-pt-[48px] tw-pb-[56px]',
        slidesToShow: 2.2, titleMaxW: '90%', chartHeight: '145px', axisFontSize: 10, arrowPosition: 'left',
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 2.2, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
    // 10. Point of Service (POS) — top-left title, ~2.2 cards (reference: POSIncident)
    {
        name: 'section10',
        title: 'Point of Service (POS) Transaction Incidents',
        matchKeys: [
            'point of service (pos) transaction', 'point of service', 'pos transaction',
            'pos', 'store operations', 'retail transaction',
        ],
        description: 'Tracks data quality issues in POS transactions, including sales totals, payment methods, and register-level reporting.',
        cardStyle: 'standard', chartType: 'area', titlePosition: 'top-left',
        sliderClass: 'has-left-padding', slidesToShow: 2.2,
        titleMaxW: '90%', chartHeight: '145px', axisFontSize: 11, arrowPosition: 'left',
        sectionBg: 'tw-bg-white/5',
        sliderSettings: { dots: true, speed: 500, infinite: false, slidesToShow: 2.2, slidesToScroll: 1, rows: 1, slidesPerRow: 1 },
    },
];
// ─────────────────────────────────────────────────────────────────────────────

const SECTION_KPI_STYLE_SETTINGS = {
    standard:    { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    compact:     { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    stacked:     { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    grid:        { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    merchandise: { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    split:       { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
    accent:      { arrows: true, dots: true,  speed: 500, infinite: false, slidesToScroll: 1 },
};

const SECTION_TYPE_COUNT = SECTION_CONFIG.length;

/**
 * Layout type follows the designed screenshot sequence by position:
 * 0 Call Center → 1 CRM → 2 Fulfillment → 3 E-Commerce → 4 Financial →
 * 5 Forecourt → 6 Manufacturer → 7 Marketing → 8 Merchandise → 9 POS → wrap.
 * Do NOT match by business name — API titles differ from the mock and caused wrong types.
 */
const getSectionLayoutIndex   = (idx) => ((idx % SECTION_TYPE_COUNT) + SECTION_TYPE_COUNT) % SECTION_TYPE_COUNT;
const getSectionCfg           = (idx) => SECTION_CONFIG[getSectionLayoutIndex(idx)] || SECTION_CONFIG[0];
const getSectionName          = (idx) => getSectionCfg(idx).name || `section${getSectionLayoutIndex(idx) + 1}`;
const getSectionTitle         = (idx) => getSectionCfg(idx).title || '';
const getSectionDescription   = (idx) => getSectionCfg(idx).description || '';
const getSectionChartType     = (idx) => getSectionCfg(idx).chartType;

/** Reserved slider height — multi-row (E-Commerce zigzag) needs ~2× to avoid expand-on-load jerk. */
const getKpiSliderReserveHeight = (layoutIndex) => {
    const rows = Number(getSectionCfg(layoutIndex)?.sliderSettings?.rows) || 1;
    if (rows > 1) return (KPI_SECTION_SLIDER_MIN_HEIGHT * rows) + 48;
    return KPI_SECTION_SLIDER_MIN_HEIGHT;
};

const getKpiShellReserveHeight = (layoutIndex) => (
    getKpiSliderReserveHeight(layoutIndex) + 220
);

/** Prefer kpi_summary; fall back to business_area so slider sections still render. Keep API order. */
const normalizeSectionTitleKey = (section = {}) => (
    String(section?.title || section?.name || section?.kpi_name || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')
);

/**
 * API / demo payloads sometimes repeat the same business area (same id or title).
 * Keep first occurrence so section headers like "Organization and Legal entity" render once.
 */
const dedupeKpiSummarySections = (sections = []) => {
    if (!Array.isArray(sections) || sections.length === 0) return [];

    const seenIds = new Set();
    const seenTitles = new Set();
    const unique = [];

    sections.forEach((section) => {
        if (!section || typeof section !== 'object') return;

        const businessId = section.business_id ?? section.id ?? null;
        const idKey = businessId != null && businessId !== '' ? String(businessId) : null;
        const titleKey = normalizeSectionTitleKey(section);

        if (idKey && seenIds.has(idKey)) return;
        if (titleKey && seenTitles.has(titleKey)) return;

        if (idKey) seenIds.add(idKey);
        if (titleKey) seenTitles.add(titleKey);
        unique.push(section);
    });

    return unique;
};

const normalizeKpiSummarySections = (summaryRoot = {}) => {
    const fromKpi = Array.isArray(summaryRoot.kpi_summary) ? summaryRoot.kpi_summary : [];
    if (fromKpi.length) return dedupeKpiSummarySections(fromKpi);

    const fromBusiness = Array.isArray(summaryRoot.business_area) ? summaryRoot.business_area : [];
    if (!fromBusiness.length) return [];

    return dedupeKpiSummarySections(fromBusiness.map((area) => ({
        ...area,
        title: area.title || area.name || '',
        business_description: area.business_description || area.description || '',
        business_id: area.business_id ?? area.id ?? null,
    })));
};

// Maps SECTION_CONFIG chartType + API slider field â†’ VerticalChart type prop
const normalizeKpiChartType = (type) => {
    if (type === 'bar' || type === 'area' || type === 'line') return type;
    return 'area';
};

const resolveKpiChartType = ({
    kpiChartTypes,
    kpiItemKey,
    selectedChartFilter,
    sectionChartType,
    itemSlider,
    slideIndex,
    sectionOrderIndex = 0,
}) => {
    if (kpiChartTypes[kpiItemKey]) {
        return kpiChartTypes[kpiItemKey];
    }
    if (selectedChartFilter === 'Bar Chart') return 'bar';
    if (selectedChartFilter === 'Area Chart') return 'area';
    if (selectedChartFilter === 'Line Chart') return 'line';
    // Combo Chart for business_area sections (excl. Hero/Summary/Table):
    // Odd API calls (1st, 3rd…): Area → Bar → Area → Bar…
    // Even API calls (2nd, 4th…): Bar → Area → Bar → Area…
    if (selectedChartFilter === 'Combo Chart') {
        const isOddApiCall = sectionOrderIndex % 2 === 0;
        const isOddCard = slideIndex % 2 === 0;
        if (isOddApiCall) {
            return isOddCard ? 'area' : 'bar';
        }
        return isOddCard ? 'bar' : 'area';
    }
    if (itemSlider === 'bar' || itemSlider === 'area' || itemSlider === 'line') {
        return itemSlider;
    }
    return normalizeKpiChartType(sectionChartType);
};

const resolveHeroChartType = ({
    heroChartTypes,
    chartKey,
    selectedChartFilter,
    chartSlot = 'main',
}) => {
    if (heroChartTypes[chartKey]) {
        return heroChartTypes[chartKey];
    }
    if (selectedChartFilter === 'Bar Chart') return 'bar';
    if (selectedChartFilter === 'Area Chart') return 'area';
    if (selectedChartFilter === 'Line Chart') return 'line';
    if (selectedChartFilter === 'Combo Chart') {
        if (chartSlot === 'float-right') return 'area';
        return 'bar';
    }
    return 'bar';
};
const getSectionCardStyle     = (idx) => getSectionCfg(idx).cardStyle;
const getSectionTitlePosition = (idx) => getSectionCfg(idx).titlePosition;
const getSectionSliderClass   = (idx) => getSectionCfg(idx).sliderClass || 'has-left-padding';
const getSectionSlidesToShow  = (idx) => getSectionCfg(idx).slidesToShow || 3;
const getSectionChartHeight   = (idx) => getSectionCfg(idx).chartHeight || `${VERTICAL_CHART_HEIGHT.DEFAULT}px`;
const getSectionAxisFontSize  = (idx) => getSectionCfg(idx).axisFontSize ?? VERTICAL_CHART_AXIS_FONT.DEFAULT;
const getSectionBoxBg         = (idx) => getSectionCfg(idx).boxBg || false;
const getSectionRtl           = (idx) => getSectionCfg(idx).rtl || false;
const getSectionArrowPosition = (idx) => getSectionCfg(idx).arrowPosition || 'left';
const getSectionGlow          = (idx) => getSectionCfg(idx).glow || null;
const getSectionExtraSliderClass = (idx) => getSectionCfg(idx).extraSliderClass || '';
const getSectionBg               = (idx) => getSectionCfg(idx).sectionBg || '';
const getSectionSliderClassName = (idx, extra = '', itemsCount = 0) => {
    let sc  = getSectionSliderClass(idx);
    let paddingClass = '';
    if (sc.includes('has-left-padding')) {
        sc = sc.replace('has-left-padding', '').trim();
        if (itemsCount >= 4) {
            paddingClass = 'has-dynamic-left-padding';
        }
    }
    const ac  = getSectionArrowPosition(idx) === 'center' ? 'slick-slider--action-center' : 'slick-slider--action-left';
    return `qd-incidents-slider ${ac} ${sc} ${paddingClass} ${extra} tw-cursor-grab active:tw-cursor-grabbing`.replace(/\s+/g, ' ').trim();
};

const allIncidentPageSizeOptions = [
    { value: 10, label: 10 },
    { value: 25, label: 25 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
    { value: 'All', label: 'All' }
];

export default class VerticalIncidents extends React.Component {
    constructor(props) {
        super(props);
        const persistedFilters = readPersistedVerticalIncidentFilters();
        this.state = {
            tblRowExpanded: false,
            rangeValue: 0,
            showFullscreen: false,
            showBarFullscreen: false,
            selectedOption: options[0],
            selectedFilterOption: filterOptions[1],
            selectedChartFilterOption: chartFilterOptions[0],
            chartWidgetSwap: false,
            showDropdown: false,
            heroChartTypes: {},
            kpiDropdownOpen: null,
            kpiChartTypes: {},
            teamId: getTeamId(),
            userId: getUserId(),
            selectedEnvId: "",
            selectedEnvName: "",
            envList: [],
            watchList: options,
            displayDate: "Today",
            selcetedDate: moment().format("YYYY-MM-DD"),
            pagePerRecord: 100,
            currentPage: 1,
            verticalHeroIncidents: [],
            verticalIncidentList: [],
            verticalBusinessAreas: [],
            verticalSummaryTotal: 0,
            verticalKpiSummary: [],
            renderedCharts: {},
            renderedHeroCharts: {},
            renderedHeroKpiCharts: {},
            sliderChartVersions: {},
            mountedKpiSections: {},
            sliderReadySections: {},
            hiddenKpiSections: {},
            emptyKpiSections: {},
            businessAreaData: {},
            verticalIncidentLevel: "",
            verticalLoading: false,
            verticalError: false,
            noData: true,
            sk_loader: true,
            selectedBusinessArea: null,
            verticalBusinessAreaIncidents: {},
            loadingBusinessArea: false,
            likedIncidents: {},
            heroAiVote: {},
            ignoredIncidents: {},
            unreadIncidents: {},
            resolvedIncidents: {},
            kpiFullscreenItem: null,
            allIncidentsearchQuery: "",
            allIncidentsortField: null,
            allIncidentsortOrder: "asc",
            allIncidentpageSize: allIncidentPageSizeOptions[0],
            allIncidentcurrentPage: 1,
            activeTabAllIncident: "all_issues",
            includePartitions: localStorage.getItem('includePartitions') === 'true',
            selectedViewOption: LIST_VIEW_OPTIONS_DQ[0],
            selectedKpiFilters: [],
            kpiFilterOptions: [{ label: "No options", value: "none", disabled: true }],
            kpiFilterOptionsVersion: 0,
            // tblRowExpanded: false, // duplicate key removed
            critical_count: 0,
            sever_count: 0,
            warning_count: 0,
            informative_count: 0,
            severityActiveTab: { type: '', value: 10 },
            heroCarouselIndex: 0,
            heroKpiCarouselIndices: {},
            showAiInsights: {},
            aiInsightsData: {},
            aiInsightsLoading: {},
            aiInsightsError: {},
            activeSectionSlides: {},
            summaryCarouselIndex: 0,
            kpiSummaryCarouselIndex: 0,
            placeholderSummaryCarouselIndex: 0,
            expandedIncidentRows: [],
            allIncidentApiTotal: 0,
            allIncidentApiPaginated: false,
            showLineageModal: false,
            showMonitorDataDriftModal: false,
            selectedDriftIncident: null,
            selectedDriftTargetType: null,
            diagnosticMapData: null,
            diagnosticMapLoading: false,
            diagnosticMapError: null,
            diagnosticMapIncident: null,
            lineageZoom: 1,
            showNotifyToast: false,
            notifyMessage: "",
            notifyToastVariant: "default",
            notifyToastIcon: "",
            selectedIncidentIds: [],
            ...persistedFilters,
        }
        this.setRangeValue = this.setRangeValue.bind(this);
        this.sliderRef = React.createRef();
        this.navigationHeaderRef = React.createRef();
        this.verticalTableRef = React.createRef();
        this.summarySectionRef = React.createRef();
        this.kpiTrackRef = React.createRef();
        this.activeHeroKpiCarouselId = null;
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragOffset = 0;
        this.dragStyleTag = null;
        this.businessAreaSectionRefs = {};
        this.kpiSectionRefs = {};
        this.sectionSliderRefs = {};
        this.businessAreaObserver = null;
        this.sliderLoadQueue = [];
        this.queuedSliderLoadKeys = new Set();
        this.activeSliderLoads = 0;
        this.businessAreaFetchPromises = {};
        this._observedKpiSectionKeys = new Set();
        this._sectionLayoutLocks = {};
        this._lockedSectionHeights = {};
        this._userScrollTimer = null;
        this._allIncidentSearchTimer = null;
        this._kpiSliderChangeTimer = null;
        this.callbackEnvironemnt = this.callbackEnvironemnt.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleSelectAllIncident = this.handleSelectAllIncident.bind(this);
        this.handleNotifyToast = this.handleNotifyToast.bind(this);
        this.handleIncludePartitionsChange = this.handleIncludePartitionsChange.bind(this);


    }



findMatchingKpiIncident = (assocKpi) => {
    const kpiName = String(assocKpi?.kpi_name || "").trim().toLowerCase();
    if (!kpiName) return null;

    const source = assocKpi?.source || {};
    const subjectName = String(source.subject_area_name || "").trim().toLowerCase();
    const datasetId = source.data_set_id;
    const candidates = [];
    const pushCandidate = (item) => {
        if (item && typeof item === "object") {
            candidates.push(item);
        }
    };

    (this.state.verticalHeroIncidents || []).forEach(pushCandidate);
    (this.state.verticalIncidentList || []).forEach((row) => {
        if (row?.parent) {
            pushCandidate(row.parent);
            (Array.isArray(row.details) ? row.details : []).forEach(pushCandidate);
        } else {
            pushCandidate(row);
        }
    });
    (this.state.verticalKpiSummary || []).forEach((section) => {
        this.getKpiSectionItems(section).forEach(pushCandidate);
    });

    const nameMatches = candidates.filter((item) =>
        String(item?.kpi_name || "").trim().toLowerCase() === kpiName
    );
    if (!nameMatches.length) return null;

    return nameMatches.find((item) =>
        (datasetId != null && item?.source?.data_set_id === datasetId)
        || (subjectName
            && String(item?.subject_name || item?.source?.subject_area_name || "").trim().toLowerCase() === subjectName)
    ) || nameMatches.find((item) => item?.kpi_id != null) || nameMatches[0];
};

buildAssociatedKpiRedirectItem = (assocKpi, parentIncident = null) => {
    if (!assocKpi) return parentIncident;
    const matched = this.findMatchingKpiIncident(assocKpi);
    return {
        ...(matched || {}),
        ...assocKpi,
        kpi_id: assocKpi.kpi_id ?? matched?.kpi_id ?? null,
        business_id: assocKpi.business_id ?? matched?.business_id ?? parentIncident?.business_id ?? null,
        subject_id: assocKpi.subject_id ?? matched?.subject_id ?? parentIncident?.subject_id ?? null,
        source: assocKpi.source || matched?.source || parentIncident?.source || {},
        kpi_name: assocKpi.kpi_name || matched?.kpi_name,
        type: assocKpi.type ?? matched?.type ?? parentIncident?.type,
    };
};

redirectToAssociatedKpi = (assocKpi, parentIncident = null) => {
    this.redirectToVerticalDasboard(
        this.buildAssociatedKpiRedirectItem(assocKpi, parentIncident),
        "KPI"
    );
};

redirectToVerticalDasboard = (item, targetType = null) => {
    const metricsId = item?.metrics_details?.[0]?.metrics_id ?? null;
    let jsonData = {
        tab_type: 4,
        tenant_id: String(this.state.teamId),
        env_id: this.state.selectedEnvId,
        start_date: this.state.selcetedDate,
        end_date: moment(this.state.selcetedDate).add(1, 'days').format('YYYY-MM-DD'),
        integration_id: item?.source?.integration_id,
        data_set_id: item?.source?.data_set_id,
        meta_data_id: metricsId != null ? [metricsId] : [],
        menu_type: "VERTICAL",
        user_id: String(this.state.userId),
        selectedMeticsName: "",
        type: item?.type,
        selected_ids: metricsId != null ? [metricsId] : [],
        ids_type: "dataset",
        selected_period: "default",
        viewIncidentData: {
            integration_id: item?.source?.integration_id,
            dataset_id: item?.source?.data_set_id,
            attribute_id: item?.source?.attribute_id,
            metrics_id: metricsId,
            business_id: item?.business_id,
            subject_id: item?.subject_id,
            kpi_id: item?.kpi_id,
            kpi_name: item?.kpi_name || item?.metrics_details?.[0]?.metrics_name,
            period_type: item?.period_type ?? item?.period_type_id ?? 10,
            target_type: targetType,
            incident_uuid: Date.now().toString()
        }
    };
    //     console.log("=== redirectToVerticalDasboard clicked! ===");
    // console.log("Clicked item type (targetType):", targetType || item?.type || "Unknown/KPI");
    
    // // Print the requested mappings for KPIs -> Subject Area -> Business Area
    // console.log("--- Selected KPI Mappings ---");
    // console.log(`- KPI: ${item?.kpi_name || item?.metrics_details?.[0]?.metrics_name || "Unknown"} (ID: ${item?.kpi_id || "N/A"})`);
    // console.log(`- Subject Area: ${item?.subject_name || "N/A"} (ID: ${item?.subject_id || "N/A"})`);
    // console.log(`- Business Area: ${item?.business_name || "N/A"} (ID: ${item?.business_id || "N/A"})`);
    // console.log("-----------------------------");
    
    // console.log("item:", item);
    // console.log("verticalincidents.js - redirectToVerticalDasboard - item:", item);
    // console.log("verticalincidents.js - redirectToVerticalDasboard - item.type:", item?.type);
    // console.log("verticalincidents.js - redirectToVerticalDasboard - jsonData.viewIncidentData:", jsonData.viewIncidentData);
    sessionStorage.removeItem("realtimeSelectedTab");
    browserHistory.push({
        pathname: "/realtime",
        state: { data: jsonData }
    });
};

handleIncludePartitionsChange = (e) => {
  const isChecked = e.target.checked;
  localStorage.setItem('includePartitions', isChecked.toString());
  this.setState({
    includePartitions: isChecked,
    allIncidentcurrentPage: 1
  });
};

handleSelectAllIncident = (key) => {
  const validTabs = ["all_issues", "ignored", "read", "like"];
  if (!validTabs.includes(key)) return;
  this.setState({ activeTabAllIncident: key, allIncidentcurrentPage: 1 });
};

handleSearch = (e) => {
  const value = e.target.value;
  this.setState({
    allIncidentsearchQuery: value,
    allIncidentcurrentPage: 1
  }, () => {
    if (this.shouldUseAllIncidentApiSearch() || (
      this.state.severityActiveTab?.value === 'All'
      && this.state.activeTabAllIncident === 'all_issues'
      && !String(value || '').trim()
    )) {
      clearTimeout(this._allIncidentSearchTimer);
      this._allIncidentSearchTimer = setTimeout(() => {
        this.loadPagedAllIncidents(1);
      }, 400);
    }
  });
};

shouldUseAllIncidentApiSearch = () => {
  const searchValue = String(this.state.allIncidentsearchQuery || '').trim();
  return this.state.severityActiveTab?.value === 'All'
    && this.state.activeTabAllIncident === 'all_issues'
    && searchValue.length > 0;
};

getAllIncidentsPageSize = () => {
  const pageSize = this.state.allIncidentpageSize?.value;
  if (pageSize && pageSize !== 'All') {
    return Number(pageSize);
  }
  const total = Number(this.state.allIncidentApiTotal) || 0;
  return total > 0 ? total : 1000;
};

buildAllIncidentsRequest = (page = 1) => {
  const params = this.buildVerticalRequest({
    page_per_record: this.getAllIncidentsPageSize(),
    current_page: page,
    top_issues: 'All',
  });

  if (this.shouldUseAllIncidentApiSearch()) {
    params.request_type = 'search';
    params.search_value = String(this.state.allIncidentsearchQuery || '').trim();
  }

  return params;
};

scrollToAllIncidents = () => {
  if (this.verticalTableRef.current) {
    this.verticalTableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

toSummaryKpiFilter = (item) => {
  const label = item?.kpi_name || item?.name || item?.issue_type || item?.title || "KPI";
  const kpiId = item?.kpi_id ?? item?.metrics_id ?? label;
  return {
    label,
    value: kpiId,
    kpi_id: item?.kpi_id ?? kpiId,
    metrics_id: item?.kpi_id ?? item?.metrics_id ?? kpiId,
    kpi_name: label,
  };
};

handleViewAllIncident = (event, section) => {
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  const items = section ? this.getKpiSectionItems(section) : [];
  const filters = items
    .map((item) => this.toSummaryKpiFilter(item))
    .filter((item) => item.label && item.label !== "KPI");
  const businessId = section?.business_id ?? section?.id ?? null;
  const applyFilters = (sectionIncidents) => {
    const sourceIncidents = [
      ...(Array.isArray(sectionIncidents) ? sectionIncidents : []),
      ...(this.state.verticalIncidentList || []),
    ];
    this.setState((prevState) => ({
      selectedBusinessArea: businessId ? section : null,
      selectedKpiFilters: filters,
      activeTabAllIncident: "all_issues",
      allIncidentcurrentPage: 1,
      allIncidentsearchQuery: "",
      kpiFilterOptionsVersion: (prevState.kpiFilterOptionsVersion || 0) + 1,
      kpiFilterOptions: this.buildKpiFilterOptions(sourceIncidents, filters),
      verticalBusinessAreaIncidents: businessId ? {
        ...prevState.verticalBusinessAreaIncidents,
        [businessId]: Array.isArray(sectionIncidents) ? sectionIncidents : [],
      } : prevState.verticalBusinessAreaIncidents,
    }), this.scrollToAllIncidents);
  };

  if (businessId && this.state.selectedEnvId) {
    this.fetchBusinessAreaIncidents(businessId)
      .then((list) => applyFilters(Array.isArray(list) ? list : []))
      .catch(() => applyFilters([]));
    return;
  }
  applyFilters([]);
};

handleSummaryIncidentSelect = (item) => {
  const label = item?.kpi_name || item?.name || item?.issue_type || "KPI";
  const kpiId = item?.kpi_id ?? item?.metrics_id ?? label;
  const filter = {
    label,
    value: kpiId,
    kpi_id: item?.kpi_id ?? kpiId,
    metrics_id: item?.kpi_id ?? kpiId,
    kpi_name: label,
  };
  this.setState({
    selectedBusinessArea: null,
    selectedKpiFilters: [filter],
    activeTabAllIncident: "all_issues",
    allIncidentcurrentPage: 1,
    allIncidentsearchQuery: "",
    kpiFilterOptionsVersion: (this.state.kpiFilterOptionsVersion || 0) + 1,
    kpiFilterOptions: this.buildKpiFilterOptions(this.state.verticalIncidentList, [filter]),
  }, this.scrollToAllIncidents);
};

buildKpiFilterOptions = (incidents = [], selected = []) => {
  const selectedIds = new Set((selected || []).map((item) => String(item?.kpi_id ?? item?.value ?? "")));
  const selectedNames = new Set((selected || []).map((item) => String(item?.label || item?.kpi_name || "").toLowerCase()).filter(Boolean));
  const seen = new Set();
  const options = [{ label: "All", value: "*", checked: false }];
  (incidents || []).forEach((incident) => {
    const name = incident?.kpi_name || incident?.metrics_name || "";
    const id = incident?.kpi_id ?? name;
    const key = String(id);
    if (!name || seen.has(key)) return;
    seen.add(key);
    options.push({
      label: name,
      value: id,
      metrics_id: id,
      kpi_id: incident?.kpi_id ?? id,
      checked: selectedIds.has(key) || selectedNames.has(String(name).toLowerCase()),
    });
  });
  if (options.length === 1) {
    options.push({ label: "No options", value: "none", disabled: true });
  }
  return options;
};

handleKpiFilterSelection = (selectedOptions) => {
  const selected = [];
  const walk = (nodes) => {
    (nodes || []).forEach((node) => {
      if (node?.value !== "*" && node?.checked === true && node.children === undefined && !node.disabled) {
        selected.push({
          label: node.label,
          value: node.value ?? node.kpi_id,
          kpi_id: node.kpi_id ?? node.value,
          metrics_id: node.metrics_id ?? node.kpi_id ?? node.value,
          kpi_name: node.label,
        });
      }
      if (node?.children) walk(node.children);
    });
  };
  walk(Array.isArray(selectedOptions) ? selectedOptions : []);
  this.setState({
    selectedKpiFilters: selected,
    selectedBusinessArea: null,
    allIncidentcurrentPage: 1,
    activeTabAllIncident: "all_issues",
  }, this.scrollToAllIncidents);
};

handleRemoveKpiFilter = (idVal) => {
  const idStr = String(idVal);
  const remaining = (this.state.selectedKpiFilters || []).filter(
    (item) => String(item.kpi_id ?? item.value ?? item.label) !== idStr
  );
  this.setState({
    selectedKpiFilters: remaining,
    allIncidentcurrentPage: 1,
    kpiFilterOptionsVersion: (this.state.kpiFilterOptionsVersion || 0) + 1,
    kpiFilterOptions: this.buildKpiFilterOptions(this.state.verticalIncidentList, remaining),
  });
};

applyListChromeFilters = (incidents) => {
  let rows = Array.isArray(incidents) ? incidents : [];
  const filters = this.state.selectedKpiFilters || [];
  if (filters.length > 0) {
    const ids = new Set(filters.map((item) => String(item.kpi_id ?? item.metrics_id ?? item.value ?? "")).filter((id) => id && id !== "undefined"));
    const names = new Set(filters.map((item) => String(item.label || item.kpi_name || "").trim().toLowerCase()).filter(Boolean));
    const matched = rows.filter((incident) => {
      const id = String(incident?.kpi_id ?? "");
      const name = String(
        incident?.kpi_name
        || incident?.metrics_name
        || incident?.metrics_details?.[0]?.metrics_name
        || incident?.title
        || ""
      ).trim().toLowerCase();
      return (id && ids.has(id)) || (name && names.has(name));
    });
    if (matched.length > 0 || !this.state.selectedBusinessArea) {
      rows = matched;
    }
  }
  return rows;
};

renderViewAllIncidentsButton = (section) => (
  <a href="#!" className="btn btn-light" onClick={(event) => this.handleViewAllIncident(event, section)}>
    View All Incidents
    <i className="ml-1">
      <svg className="d-block" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0003 12.5061L5.57715 8.08296L6.16694 7.49316L10.0003 11.3265L13.8336 7.49316L14.4234 8.08296L10.0003 12.5061Z" fill="#535862"/>
      </svg>
    </i>
  </a>
);

getIncidentSelectionId = (item) => {
    if (!item) return "";
    return `vi_${item.kpi_incident_id || item.incident_id || item.id}`;
};

getVisibleIncidentRows = () => {
    return this.getDisplayedIncidentList();
};

handleIncidentSelection = (item, checked) => {
    const selectionId = this.getIncidentSelectionId(item);
    this.setState((prevState) => ({
        selectedIncidentIds: checked
            ? [...new Set([...(prevState.selectedIncidentIds || []), selectionId])]
            : (prevState.selectedIncidentIds || []).filter((id) => id !== selectionId),
    }));
};

handleSelectAllVisibleIncidents = (checked) => {
    this.setState({
        selectedIncidentIds: checked
            ? this.getVisibleIncidentRows().map((item) => this.getIncidentSelectionId(item))
            : [],
    });
};

areAllVisibleIncidentsSelected = () => {
    const visibleRows = this.getVisibleIncidentRows();
    if (!visibleRows.length) {
        return false;
    }
    const selectedIds = new Set(this.state.selectedIncidentIds || []);
    return visibleRows.every((item) => selectedIds.has(this.getIncidentSelectionId(item)));
};

isSomeVisibleIncidentsSelected = () => {
    const visibleRows = this.getVisibleIncidentRows();
    if (!visibleRows.length) {
        return false;
    }
    const selectedIds = new Set(this.state.selectedIncidentIds || []);
    return visibleRows.some((item) => selectedIds.has(this.getIncidentSelectionId(item)));
};

setSelectAllCheckboxIndeterminate = (el) => {
    if (!el) {
        return;
    }
    const input = el.querySelector ? el.querySelector('input[type="checkbox"]') : el;
    if (input) {
        input.indeterminate = this.isSomeVisibleIncidentsSelected() && !this.areAllVisibleIncidentsSelected();
    }
};

clearIncidentCheckboxes = () => {
    document.querySelectorAll(
        '#vi-select-all, input[id^="check-parent-"], input[id^="check-child-"]'
    ).forEach((checkbox) => {
        checkbox.checked = false;
        checkbox.indeterminate = false;
    });
};

getIncidentActionPayload = (item, action) => {
    const payload = {
        incident_id: item.kpi_incident_id || item.incident_id || item.id,
        read: item.read,
        liked: item.liked,
        ignored: item.ignored,
        tenant_id: Number(this.state.teamId),
        user_id: Number(this.state.userId),
    };

    if (action === "like") payload.liked = !item.liked;
    if (action === "ignore") payload.ignored = !item.ignored;
    if (action === "unread") payload.read = !item.read;
    if (action === "resolved") payload.resolved = !item.resolved;

    return payload;
};

getUpdatedIncident = (item, action) => {
    const updated = { ...item };
    if (action === "like") updated.liked = !item.liked;
    if (action === "ignore") updated.ignored = !item.ignored;
    if (action === "unread") updated.read = !item.read;
    if (action === "resolved") updated.resolved = !item.resolved;
    return updated;
};

handleSelectedIncidentAction = (action) => {
    const selectedIds = this.state.selectedIncidentIds || [];
    if (selectedIds.length === 0) return;

    const selectedRows = this.getVisibleIncidentRows().filter((item) =>
        selectedIds.includes(this.getIncidentSelectionId(item))
    );
    if (selectedRows.length === 0) return;

    if (action === "share") {
        this.clearIncidentCheckboxes();
        this.setState({ selectedIncidentIds: [] });
        this.handleNotifyToast("Your " + action + " has been recorded successfully.");
        return;
    }

    const selectedIdSet = new Set(selectedIds);
    const updateRows = (rows) => (Array.isArray(rows)
        ? rows.map((item) => selectedIdSet.has(this.getIncidentSelectionId(item))
            ? this.getUpdatedIncident(item, action)
            : item)
        : rows);

    this.setState((prevState) => ({
        summary: updateRows(prevState.summary),
        verticalIncidentList: updateRows(prevState.verticalIncidentList),
        selectedIncidentIds: [],
    }), () => {
        this.clearIncidentCheckboxes();
    });

    selectedRows.forEach((item) => this.postVerticalInteraction(this.getIncidentActionPayload(item, action)));
    this.handleNotifyToast("Your " + action + " has been recorded successfully.");
};

handleScrollToSummary = () => {
  const target = this.summarySectionRef?.current;
  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

loadPagedAllIncidents = async (page) => {
  const params = this.buildAllIncidentsRequest(page);
  try {
      const allResponse = await getVerticalAllIncidents(params);
      const body = this.extractResponseBody(allResponse);
      const total = this.extractAllIncidentTotal(allResponse);
      this.setState({
          verticalIncidentList: this.extractIncidentList(allResponse),
          allIncidentApiTotal: total || this.state.allIncidentApiTotal,
          allIncidentApiPaginated: true,
          critical_count: body?.Critical ?? this.state.critical_count,
          sever_count: body?.Severe ?? this.state.sever_count,
          warning_count: body?.Warning ?? this.state.warning_count,
          informative_count: body?.Informational ?? this.state.informative_count,
      });
  } catch (err) {
      console.error("Error loading paged incidents:", err);
  }
};

handleallIncidentpageSizeChange = (selectedOption) => {
  this.setState({ allIncidentpageSize: selectedOption, allIncidentcurrentPage: 1 }, () => {
      this.loadPagedAllIncidents(1);
  });
};

handleAllIncidentPageChange = (page) => {
  let pageNum = Number(page);
  if (!Number.isFinite(pageNum) || pageNum <= 0) pageNum = 1;
  this.setState({ allIncidentcurrentPage: pageNum, expandedIncidentRows: [] }, () => {
      this.loadPagedAllIncidents(pageNum);
  });
};

handleViewOptionChange = (selectedOption) => {
  this.setState({
    selectedViewOption: selectedOption,
    allIncidentcurrentPage: 1
  });
};

getFilteredIncidentList = () => {
  const businessId = this.state.selectedBusinessArea?.business_id;
  const businessAreaIncidents = businessId ? this.state.verticalBusinessAreaIncidents[businessId] : null;
  let incidents = Array.isArray(businessAreaIncidents) ? businessAreaIncidents : this.state.verticalIncidentList || [];

  // Filter by severity level when a specific type is selected
  const severityType = this.state.severityActiveTab?.type;
  if (severityType) {
    incidents = incidents.filter((incident) =>
      incident?.incident_level === severityType
    );
  }

  const activeTab = this.state.activeTabAllIncident || "all_issues";
  if (activeTab !== "all_issues") {
    incidents = incidents.filter((incident) => {
      if (activeTab === "ignored") return incident?.ignored === true;
      if (activeTab === "like") return incident?.liked === true;
      if (activeTab === "read") return incident?.read === true;
      return true;
    });
  }
  incidents = this.applyListChromeFilters(incidents);

  const searchQuery = String(this.state.allIncidentsearchQuery || "").trim().toLowerCase();
  if (searchQuery && !this.shouldUseAllIncidentApiSearch()) {
    incidents = incidents.filter((incident) => {
      try {
        return JSON.stringify(incident).toLowerCase().includes(searchQuery);
      } catch (error) {
        return false;
      }
    });
  }

  if (this.state.allIncidentsortField) {
    incidents = incidents.slice().sort((a, b) => {
      const field = this.state.allIncidentsortField;
      const aVal = String(a?.[field] ?? "").toLowerCase();
      const bVal = String(b?.[field] ?? "").toLowerCase();
      if (aVal < bVal) return this.state.allIncidentsortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return this.state.allIncidentsortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  return incidents;
};

getDisplayedIncidentList = () => {
  const isIncidentIgnored = (incident) => Boolean(incident?.ignored ?? incident?.ignore);
  const isIncidentLiked = (incident) => Boolean(incident?.liked ?? incident?.likes);

  if (this.state.allIncidentApiPaginated && !(this.state.selectedKpiFilters || []).length) {
    let incidents = this.state.verticalIncidentList || [];

    // Filter by severity level when a specific type is selected
    const severityType = this.state.severityActiveTab?.type;
    if (severityType) {
      incidents = incidents.filter((incident) =>
        incident?.incident_level === severityType
      );
    }

    const activeTab = this.state.activeTabAllIncident || "all_issues";
    if (activeTab !== "all_issues") {
      incidents = incidents.filter((incident) => {
        if (activeTab === "ignored") return isIncidentIgnored(incident);
        if (activeTab === "like") return isIncidentLiked(incident);
        if (activeTab === "read") return incident?.read === true;
        return true;
      });
    }
    incidents = this.applyListChromeFilters(incidents);
    const searchQuery = String(this.state.allIncidentsearchQuery || "").trim().toLowerCase();
    if (searchQuery && !this.shouldUseAllIncidentApiSearch()) {
      incidents = incidents.filter((incident) => {
        try { return JSON.stringify(incident).toLowerCase().includes(searchQuery); }
        catch { return false; }
      });
    }
    return incidents;
  }
  const incidents = this.getFilteredIncidentList();
  const pageSizeOption = this.state.allIncidentpageSize;
  const pageSize = pageSizeOption?.value;
  const currentPage = Number(this.state.allIncidentcurrentPage) || 1;
  if (!pageSize || pageSize === "All") {
    return incidents;
  }
  const startIndex = (currentPage - 1) * Number(pageSize);
  return incidents.slice(startIndex, startIndex + Number(pageSize));
};

getIncidentTabCount = (tabKey) => {
  const isIncidentIgnored = (incident) => Boolean(incident?.ignored ?? incident?.ignore);
  const isIncidentLiked = (incident) => Boolean(incident?.liked ?? incident?.likes);
  const isAllIssues = this.state.severityActiveTab?.value === 'All';
  const apiTotal = this.state.allIncidentApiTotal || 0;
  const severityType = this.state.severityActiveTab?.type;
  const rawList = this.state.verticalIncidentList || [];
  // Apply severity filter to counts so tab badges reflect filtered data
  const list = severityType
    ? rawList.filter((incident) => incident?.incident_level === severityType)
    : rawList;
  if (tabKey === "all_issues") return isAllIssues && !severityType && apiTotal > 0 ? apiTotal : list.length;
  if (tabKey === "ignored") return list.filter(isIncidentIgnored).length;
  if (tabKey === "resolved") return list.filter((incident) => incident?.resolved === true).length;
  if (tabKey === "like") return list.filter(isIncidentLiked).length;
  if (tabKey === "read") return list.filter((incident) => incident?.read === true).length;
  return 0;
};

handleNotifyToast = (message, variant = "default", icon) => {
    if (this._notifyToastTimer) {
        clearTimeout(this._notifyToastTimer);
    }
    this.setState({
        showNotifyToast: true,
        notifyMessage: message,
        notifyToastVariant: variant,
        notifyToastIcon: icon
    });
    this._notifyToastTimer = setTimeout(() => {
        this.setState({
            showNotifyToast: false,
            notifyMessage: "",
            notifyToastVariant: "default",
            notifyToastIcon: ""
        });
    }, 3000);
};

showInteractionToast = (action, nextValue) => {
    switch (action) {
        case "like":
            if (nextValue) {
                this.handleNotifyToast("Added to your likes", "green",
                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="rgba(255,255,255,0.75)"><path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z"></path></svg>
                );
            }
            break;
        case "read":
            this.handleNotifyToast(nextValue ? "Marked as read" : "Marked as unread", "blue",
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.62769 11.1228H9.88307V10.0717H4.62769V11.1228ZM4.62769 9.02067H12.6859V7.96959H4.62769V9.02067ZM4.62769 6.91851H12.3153V6.87542C12.0135 6.78643 11.7418 6.65726 11.5002 6.48792C11.2585 6.31858 11.0474 6.11175 10.8667 5.86744H4.62769V6.91851ZM2 16.23V4.50647C2 4.15249 2.12263 3.85287 2.36788 3.60762C2.61313 3.36237 2.91274 3.23975 3.26672 3.23975H10.3035C10.2658 3.41492 10.2458 3.58899 10.2436 3.76196C10.2414 3.93492 10.2524 4.1112 10.2765 4.29082H3.26672C3.21277 4.29082 3.16337 4.3133 3.11852 4.35827C3.07356 4.40311 3.05108 4.45251 3.05108 4.50647V13.6698L4.03208 12.6994H14.0469C14.1009 12.6994 14.1503 12.677 14.1951 12.632C14.2401 12.5871 14.2626 12.5377 14.2626 12.4838V7.17865C14.4638 7.13369 14.6509 7.07617 14.8238 7.0061C14.9967 6.93603 15.1599 6.84395 15.3136 6.72984V12.4838C15.3136 12.8378 15.191 13.1374 14.9458 13.3826C14.7005 13.6279 14.4009 13.7505 14.0469 13.7505H4.47949L2 16.23ZM3.05108 4.50647V13.1845V4.29082V4.50647ZM13.5618 5.85395C13.0273 5.85395 12.5725 5.66645 12.1975 5.29145C11.8224 4.91633 11.6349 4.4615 11.6349 3.92697C11.6349 3.39244 11.8224 2.93768 12.1975 2.56268C12.5725 2.18756 13.0273 2 13.5618 2C14.0964 2 14.5511 2.18756 14.9261 2.56268C15.3013 2.93768 15.4888 3.39244 15.4888 3.92697C15.4888 4.4615 15.3013 4.91633 14.9261 5.29145C14.5511 5.66645 14.0964 5.85395 13.5618 5.85395Z" fill="rgba(255,255,255,0.75)"></path></svg>
            );
            break;
        case "ignored":
            if (nextValue) {
                this.handleNotifyToast("Issue ignored", "yellow",
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8525 16.4567L13.1607 14.7649C12.5627 15.1985 11.9132 15.5336 11.2122 15.7703C10.5112 16.0068 9.77366 16.125 8.99966 16.125C8.01403 16.125 7.08778 15.9379 6.22091 15.5638C5.35403 15.1898 4.59997 14.6822 3.95872 14.0409C3.31747 13.3997 2.80984 12.6456 2.43584 11.7788C2.06172 10.9119 1.87466 9.98563 1.87466 9C1.87466 8.226 1.99291 7.4885 2.22941 6.7875C2.46603 6.0865 2.80116 5.437 3.23478 4.839L1.54297 3.14719L2.34491 2.34525L15.6544 15.6548L14.8525 16.4567ZM8.99966 15C9.61403 15 10.202 14.9096 10.7637 14.7289C11.3252 14.5481 11.853 14.289 12.3473 13.9515L4.04816 5.65238C3.71066 6.14663 3.45153 6.6745 3.27078 7.236C3.09003 7.79762 2.99966 8.38563 2.99966 9C2.99966 10.6625 3.58403 12.0781 4.75278 13.2469C5.92153 14.4156 7.33716 15 8.99966 15ZM14.988 12.8653L14.1675 12.0446C14.4425 11.5793 14.65 11.0923 14.7898 10.5836C14.9297 10.075 14.9997 9.54713 14.9997 9C14.9997 7.3375 14.4153 5.92188 13.2465 4.75313C12.0778 3.58438 10.6622 3 8.99966 3C8.45253 3 7.92466 3.06994 7.41603 3.20981C6.90741 3.34969 6.42041 3.55713 5.95503 3.83213L5.13434 3.01162C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 8.99966 1.875C9.98528 1.875 10.9115 2.06206 11.7784 2.43619C12.6453 2.81019 13.3993 3.31781 14.0406 3.95906C14.6818 4.60031 15.1895 5.35437 15.5635 6.22125C15.9376 7.08812 16.1247 8.01438 16.1247 9C16.1247 9.70675 16.0271 10.3845 15.832 11.0333C15.6367 11.6819 15.3554 12.2926 14.988 12.8653Z" fill="rgba(255,255,255,0.75)"></path></svg>
                );
            }
            break;
        case "resolved":
            if (nextValue) {
                this.handleNotifyToast("Issue marked as resolved", "green",
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.625 13.0958L15.4817 9.23909C15.5856 9.13522 15.7161 9.08209 15.8734 9.07972C16.0305 9.07734 16.1634 9.13047 16.2722 9.23909C16.3808 9.34772 16.4351 9.47947 16.4351 9.63434C16.4351 9.78909 16.3808 9.92078 16.2722 10.0294L12.0996 14.202C11.9639 14.3377 11.8058 14.4055 11.625 14.4055C11.4443 14.4055 11.2861 14.3377 11.1504 14.202L9.09225 12.1438C8.9885 12.04 8.93538 11.9095 8.93288 11.7523C8.9305 11.5951 8.98363 11.4622 9.09225 11.3535C9.201 11.2449 9.33275 11.1906 9.4875 11.1906C9.64225 11.1906 9.774 11.2449 9.88275 11.3535L11.625 13.0958ZM3.98081 15.3747C3.60794 15.3747 3.28875 15.2419 3.02325 14.9764C2.75775 14.7109 2.625 14.3917 2.625 14.0188V3.98047C2.625 3.60759 2.75775 3.28841 3.02325 3.02291C3.28875 2.75741 3.60794 2.62466 3.98081 2.62466H7.28513C7.389 2.25928 7.60125 1.95641 7.92188 1.71603C8.2425 1.47566 8.60188 1.35547 9 1.35547C9.4135 1.35547 9.77863 1.47566 10.0954 1.71603C10.4123 1.95641 10.6226 2.25928 10.7265 2.62466H14.0192C14.3921 2.62466 14.7113 2.75741 14.9768 3.02291C15.2423 3.28841 15.375 3.60759 15.375 3.98047V6.93716C15.375 7.09653 15.3211 7.23016 15.2132 7.33803C15.1053 7.44578 14.9717 7.49966 14.8123 7.49966C14.6528 7.49966 14.5192 7.44578 14.4116 7.33803C14.3039 7.23016 14.25 7.09653 14.25 6.93716V3.98047C14.25 3.92272 14.2259 3.86984 14.1778 3.82184C14.1298 3.77372 14.0769 3.74966 14.0192 3.74966H12.375V5.03328C12.375 5.22541 12.3103 5.38641 12.1809 5.51628C12.0516 5.64616 11.8913 5.71109 11.7 5.71109H6.29981C6.10856 5.71109 5.94831 5.64616 5.81906 5.51628C5.68969 5.38641 5.625 5.22541 5.625 5.03328V3.74966H3.98081C3.92306 3.74966 3.87019 3.77372 3.82219 3.82184C3.77406 3.86984 3.75 3.92272 3.75 3.98047V14.0188C3.75 14.0766 3.77406 14.1295 3.82219 14.1775C3.87019 14.2256 3.92306 14.2497 3.98081 14.2497H7.6875C7.84688 14.2497 7.9805 14.3036 8.08838 14.4115C8.19613 14.5193 8.25 14.653 8.25 14.8123C8.25 14.9718 8.19613 15.1054 8.08838 15.213C7.9805 15.3208 7.84688 15.3747 7.6875 15.3747H3.98081ZM9.00131 3.83628C9.19369 3.83628 9.35456 3.77116 9.48394 3.64091C9.61319 3.51078 9.67781 3.34947 9.67781 3.15697C9.67781 2.96459 9.61275 2.80372 9.48263 2.67434C9.3525 2.54509 9.19119 2.48047 8.99869 2.48047C8.80631 2.48047 8.64544 2.54553 8.51606 2.67566C8.38681 2.80591 8.32219 2.96722 8.32219 3.15959C8.32219 3.35197 8.38725 3.51284 8.51738 3.64222C8.6475 3.77159 8.80881 3.83628 9.00131 3.83628Z" fill="rgba(255,255,255,0.75)"></path></svg>
                );
            }
            break;
        default:
            break;
    }
};

    async callbackEnvironemnt(pmtest, loader = 'loader') {
        this.setState(
            {
                selectedEnvId: pmtest.value,
                selectedEnvName: pmtest.label,
                sk_loader: loader === 'loader' ? true : false,
                selectedOption: options[0],
            },
            async () => {
                try {
                    await this.loadVerticalWatchLists();
                    this.loadVerticalIncidentData();
                } catch (error) {
                    console.error("Error in callbackEnvironemnt:", error);
                }
            }
        );
    }
    setRangeValue = (event) => {
        this.setState({ rangeValue: event });
    }
    handleFullscreenVisible = () => {
        this.setState({ showFullscreen: !this.state.showFullscreen });
    }
    handleBarFullscreen = () => {
        this.setState({ showBarFullscreen: !this.state.showBarFullscreen });
    }
    handleChartWidgetSwap = (data) => {
        switch (data) {
            case 'refreshIssue1':
                this.setState((prevState) => ({
                    chartWidgetSwap: prevState.chartWidgetSwap === 'refreshIssue1' ? null : 'refreshIssue1',
                }));
                break;
            case 'volumeIssue':
                this.setState((prevState) => ({
                    chartWidgetSwap: prevState.chartWidgetSwap === 'volumeIssue' ? null : 'volumeIssue',
                }));
                break;
            case 'dataIssue':
                this.setState((prevState) => ({
                    chartWidgetSwap: prevState.chartWidgetSwap === 'dataIssue' ? null : 'dataIssue',
                }));
                break;
            case 'failedPipeline':
                this.setState((prevState) => ({
                    chartWidgetSwap: prevState.chartWidgetSwap === 'failedPipeline' ? null : 'failedPipeline',
                }));
                break;
            case 'errorPipeline':
                this.setState((prevState) => ({
                    chartWidgetSwap: prevState.chartWidgetSwap === 'errorPipeline' ? null : 'errorPipeline',
                }));
                break;
            default: break;
        }
    }

    toggleDropdown = () => {
        this.setState({ showDropdown: !this.state.showDropdown })
    }

    getAiInsightsKey = (incidentId) => String(incidentId);

    handleHeroAiVote = (heroIncidentId, type) => {
        const key = this.getAiInsightsKey(heroIncidentId);
        const currentVote = this.state.heroAiVote?.[key];
        const nextVote = currentVote === type ? null : type;
        this.setState((prev) => ({
            heroAiVote: {
                ...(prev.heroAiVote || {}),
                [key]: nextVote,
            }
        }));
        if (this.showInteractionToast) {
            if (nextVote === "up") {
                this.showInteractionToast("like", true);
            } else if (nextVote === "down") {
                this.showInteractionToast("dislike", true);
            }
        }
    };

    handleAiInsightsToggle = async (incident, incidentKey) => {
        const incidentId = incident?.kpi_incident_id;
        const key = this.getAiInsightsKey(incidentKey ?? incidentId);
        const isCurrentlyOpen = !!this.state.showAiInsights?.[key];

        if (isCurrentlyOpen) {
            this.setState((prev) => ({
                showAiInsights: {
                    ...(prev.showAiInsights || {}),
                    [key]: false,
                },
            }));
            return;
        }

        if (!incidentId) {
            this.handleNotifyToast("Incident id is missing.");
            return;
        }

        const hasCachedResult = !!this.state.aiInsightsData?.[key];

        this.setState((prev) => ({
            showAiInsights: { [key]: true },
            aiInsightsLoading: {
                ...(prev.aiInsightsLoading || {}),
                [key]: !hasCachedResult,
            },
            aiInsightsError: {
                ...(prev.aiInsightsError || {}),
                [key]: null,
            },
        }));

        if (hasCachedResult) {
            return;
        }

        try {
            const incidentLevel = incident?.incident_level;
            // Critical keeps GET; all other severity levels use POST
            const method = incidentLevel === "Critical" ? "GET" : "POST";
            const requestParams = {
                tenant_id: String(this.state.teamId),
                user_id: String(this.state.userId),
                incident_id: incidentId,
            };
            if (method === "POST" && incidentLevel) {
                requestParams.incident_level = incidentLevel;
            }

            const response = await getVerticalAiInsights(requestParams, method);

            if (response?.code === 200 && response?.response) {
                this.setState((prev) => ({
                    aiInsightsData: {
                        ...(prev.aiInsightsData || {}),
                        [key]: response.response,
                    },
                    aiInsightsError: {
                        ...(prev.aiInsightsError || {}),
                        [key]: null,
                    },
                    aiInsightsLoading: {
                        ...(prev.aiInsightsLoading || {}),
                        [key]: false,
                    },
                }));
            } else {
                this.setState((prev) => ({
                    aiInsightsError: {
                        ...(prev.aiInsightsError || {}),
                        [key]: response?.message || "Failed to load AI insights.",
                    },
                    aiInsightsLoading: {
                        ...(prev.aiInsightsLoading || {}),
                        [key]: false,
                    },
                }));
            }
        } catch (error) {
            console.error("Error fetching AI insights:", error);
            this.setState((prev) => ({
                aiInsightsError: {
                    ...(prev.aiInsightsError || {}),
                    [key]: "Failed to load AI insights.",
                },
                aiInsightsLoading: {
                    ...(prev.aiInsightsLoading || {}),
                    [key]: false,
                },
            }));
        }
    }

    handleDiagnosticsMapOpen = async (incident) => {
        const incidentId = incident?.kpi_incident_id;
        if (!incidentId) {
            this.handleNotifyToast("Incident id is missing.");
            return;
        }

        this.setState({
            showLineageModal: true,
            diagnosticMapLoading: true,
            diagnosticMapError: null,
            diagnosticMapData: null,
            diagnosticMapIncident: incident,
        });

        try {
            const response = await getVerticalDiagnosticMap({
                tenant_id: String(this.state.teamId),
                user_id: String(this.state.userId),
                incident_id: incidentId,
            });

            const diagnosticMapData = this.extractDiagnosticMapData(response);
            if (diagnosticMapData) {
                this.setState({
                    diagnosticMapData,
                    diagnosticMapError: null,
                    diagnosticMapLoading: false,
                });
            } else {
                this.setState({
                    diagnosticMapError: response?.message || "Failed to load diagnostics map.",
                    diagnosticMapLoading: false,
                });
            }
        } catch (error) {
            console.error("Error fetching diagnostics map:", error);
            this.setState({
                diagnosticMapError: "Failed to load diagnostics map.",
                diagnosticMapLoading: false,
            });
        }
    }

    extractDiagnosticMapData = (response) => {
        if (!response || typeof response !== 'object') return null;

        // Standard API envelope: { code, message, response }
        if (response.response && typeof response.response === 'object') {
            const code = Number(response.code);
            if (!Number.isNaN(code) && code !== 200) return null;
            return response.response;
        }

        // Direct payload (lineage map without envelope)
        if (response.datasource || response.kpi || response.pipelines || response.stats) {
            return response;
        }

        return null;
    }

    handleDiagnosticsMapClose = () => {
        this.setState({
            showLineageModal: false,
            diagnosticMapLoading: false,
            diagnosticMapError: null,
        });
    }

    handleOpenMonitorDataDriftModal = (incident = null, targetType = null) => {
        this.setState({
            showMonitorDataDriftModal: true,
            selectedDriftIncident: incident,
            selectedDriftTargetType: targetType
        });
    }

    handleCloseMonitorDataDriftModal = () => {
        this.setState({
            showMonitorDataDriftModal: false
        });
    }

    setHeroChartType = (id, type) => {
        this.setState(prev => ({
            heroChartTypes: { ...prev.heroChartTypes, [id]: type },
            showDropdown: false,
        }));
    }

    resolveHeroChartTypeForKey = (chartKey, chartSlot = 'main') => resolveHeroChartType({
        heroChartTypes: this.state.heroChartTypes,
        chartKey,
        selectedChartFilter: this.state.selectedChartFilterOption?.value || 'Combo Chart',
        chartSlot,
    });

    renderChartTypeDropdown = ({ wrapperClass, toggleId, currentType, onSelectType }) => {
        const chartTypeItemProps = (type) => ({
            active: currentType === type,
            className: `tw-flex tw-items-center tw-gap-2${currentType === type ? ' tw-text-white' : ''}`,
            onClick: () => onSelectType(type),
        });

        return (
            <div className={wrapperClass}>
                <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                    <Dropdown.Toggle variant="" id={toggleId} className="!tw-p-1 tw-border-0 tw-bg-transparent !tw-rounded-full hover:tw-bg-white/10 focus:tw-bg-white/25 tw-transition-all tw-duration-300 tw-ease-in-out">
                        <i>
                            <svg className="d-block" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99935 10.832C10.4596 10.832 10.8327 10.4589 10.8327 9.9987C10.8327 9.53846 10.4596 9.16536 9.99935 9.16536C9.53911 9.16536 9.16602 9.53846 9.16602 9.9987C9.16602 10.4589 9.53911 10.832 9.99935 10.832Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9.99935 4.9987C10.4596 4.9987 10.8327 4.6256 10.8327 4.16536C10.8327 3.70513 10.4596 3.33203 9.99935 3.33203C9.53911 3.33203 9.16602 3.70513 9.16602 4.16536C9.16602 4.6256 9.53911 4.9987 9.99935 4.9987Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9.99935 16.6654C10.4596 16.6654 10.8327 16.2923 10.8327 15.832C10.8327 15.3718 10.4596 14.9987 9.99935 14.9987C9.53911 14.9987 9.16602 15.3718 9.16602 15.832C9.16602 16.2923 9.53911 16.6654 9.99935 16.6654Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        alignRight
                        popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                    >
                        <Dropdown.Item {...chartTypeItemProps('bar')}>
                            <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chart-column"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M18 17V9"/><path d="M13 17V5"/><path d="M8 17v-3"/></svg>
                            </i>
                            <span>Bar Chart</span>
                        </Dropdown.Item>
                        <Dropdown.Item {...chartTypeItemProps('area')}>
                            <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chart-area"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="M21 11.25a2.5 2.5 0 0 0-2.5 2.5H16l-3.875-5.166a2.5 2.5 0 0 0-4.05 0L4 13.5"/><path d="M21 16H3"/></svg>
                            </i>
                            <span>Area Chart</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    };

    renderHeroChartTypeDropdown = (chartKey, chartSlot = 'main') => {
        const currentType = this.resolveHeroChartTypeForKey(chartKey, chartSlot);
        return this.renderChartTypeDropdown({
            wrapperClass: 'hero-more-btn tw-relative tw-inline-block',
            toggleId: `hero-more-toggle-${chartKey}`,
            currentType,
            onSelectType: (type) => this.setHeroChartType(chartKey, type),
        });
    }

    toggleKpiDropdown = (id) => {
        this.setState(prev => ({ kpiDropdownOpen: prev.kpiDropdownOpen === id ? null : id }));
    }

    setKpiChartType = (id, type) => {
        this.setState(prev => ({
            kpiChartTypes: { ...prev.kpiChartTypes, [id]: type },
            kpiDropdownOpen: null,
        }));
    }

    handleSeverityFilterChip = (type, value) => {
        this.setState({ severityActiveTab: { type, value }, allIncidentcurrentPage: 1, allIncidentApiTotal: 0 }, async () => {
            document.body.click();
            this.loadVerticalIncidentData();
        });
    }

    resetSliderIndices = () => ({
        heroCarouselIndex: 0,
        heroKpiCarouselIndices: {},
        renderedHeroCharts: {},
        renderedHeroKpiCharts: {},
        summaryCarouselIndex: 0,
        kpiSummaryCarouselIndex: 0,
        placeholderSummaryCarouselIndex: 0,
        activeSectionSlides: {},
        mountedKpiSections: {},
        sliderReadySections: {},
        hiddenKpiSections: {},
        emptyKpiSections: {},
    });

    buildMountedKpiSections = (kpiSummary = []) => {
        const mounted = {};
        (Array.isArray(kpiSummary) ? kpiSummary : []).forEach((_, index) => {
            mounted[index] = true;
        });
        return mounted;
    };

    syncSlidersToFirstSlide = () => {
        setTimeout(() => {
            if (this.heroSliderRef?.slickGoTo) {
                this.heroSliderRef.slickGoTo(0, true);
            }
            if (this.summarySliderRef?.slickGoTo) {
                this.summarySliderRef.slickGoTo(0, true);
            }
            if (this.kpiSummarySliderRef?.slickGoTo) {
                this.kpiSummarySliderRef.slickGoTo(0, true);
            }
            if (this.placeholderSummarySliderRef?.slickGoTo) {
                this.placeholderSummarySliderRef.slickGoTo(0, true);
            }
            Object.values(this.sectionSliderRefs || {}).forEach((slider) => {
                if (slider?.slickGoTo) {
                    slider.slickGoTo(0, true);
                }
            });
        }, 0);
    };

    resetAllSlidersToFirst = (callback) => {
        this.setState(this.resetSliderIndices(), () => {
            this.syncSlidersToFirstSlide();
            if (typeof callback === 'function') {
                callback();
            }
        });
    };

    getSelectedTopIssues = (selectedFilterOption = this.state.selectedFilterOption) => {
        const value = selectedFilterOption?.value || selectedFilterOption?.label || "";
        const parsedValue = parseInt(String(value).replace(/\D/g, ""), 10);
        return Number.isFinite(parsedValue) ? parsedValue : 10;
    }

    getSelectedWatchlistId = () => {
        const selectedValue = String(this.state.selectedOption?.value || "");
        if (selectedValue.indexOf("##") === 0) {
            return selectedValue.replace(/^#+/, "");
        }
        return null;
    }

    getSelectedIncidentType = () => {
        const selectedValue = String(this.state.selectedOption?.value || "");
        if (selectedValue === "All Pipeline & All Dataset") {
            return "BOTH";
        }
        if (selectedValue === "All Pipeline" || selectedValue.indexOf("###") === 0) {
            return "PIPELINE";
        }
        return "DQ";
    }

    buildVerticalRequest = (overrides = {}) => ({
        tenant_id: this.state.teamId,
        "env_id": this.state.selectedEnvId, 
        "date": this.state.selcetedDate,
     //  "user_id": 5,
        //env_id: this.state.selectedEnvId,
        //date: this.state.selcetedDate,
        watchlist_id: this.getSelectedWatchlistId(),
        page_per_record: this.state.pagePerRecord,
        current_page: this.state.currentPage,
        incident_level: this.state.severityActiveTab?.type || "Critical",
        top_issues: this.state.severityActiveTab?.value ?? this.getSelectedTopIssues(),
        ...overrides
    })

    getLatestEnvironmentResponse = () => {
        return getLatestEnvironmentList({
            tenant_id: this.state.teamId,
            user_id: this.state.userId,
            tab_type: 13
        });
    }

    loadVerticalWatchLists = async () => {
        if (!this.state.selectedEnvId) {
            return;
        }

        const baseWatchList = [
            { value: "All Dataset", label: "All KPI" },
            //{ value: "All Pipeline", label: "All Pipeline" },
          //  { value: "All Pipeline & All Dataset", label: "All Pipeline & All Dataset" }
        ];

        try {
            const requestBase = {
                tenant_id: this.state.teamId,
                env_id: this.state.selectedEnvId,
                user_id: this.state.userId
            };
            const [dqResponse, pipelineResponse] = await Promise.all([
                getWatchList({ ...requestBase, tab_type: 4 }),
               // getWatchList({ ...requestBase, tab_type: 3 })
            ]);
            const watchList = [...baseWatchList];
            if (dqResponse?.code === 200 && Array.isArray(dqResponse?.result?.watch_list)) {
                dqResponse.result.watch_list.forEach((item) => {
                    watchList.push({ value: `##${item.watch_list_id}`, label: item.watch_list_name });
                });
            }
            if (pipelineResponse?.code === 200 && Array.isArray(pipelineResponse?.result?.watch_list)) {
                pipelineResponse.result.watch_list.forEach((item) => {
                    watchList.push({ value: `###${item.watch_list_id}`, label: item.watch_list_name });
                });
            }
            this.setState((prevState) => ({
                watchList,
                selectedOption: watchList.find((item) => item.value === prevState.selectedOption?.value) || watchList[0]
            }));
        } catch (error) {
            console.error("Error loading vertical watchlists:", error);
            this.setState({ watchList: baseWatchList, selectedOption: baseWatchList[0] });
        }
    }

    extractResponseBody = (response) => {
        const raw = response?.response;
        return Array.isArray(raw) ? (raw[0] || {}) : (raw || {});
    }

    extractAllIncidentTotal = (response) => {
        const body = this.extractResponseBody(response);
        if (body?.all_count != null && body.all_count !== '') {
            return Number(body.all_count) || 0;
        }
        const level = this.state.severityActiveTab?.type;
        if (level && body?.[level] != null && body[level] !== '') {
            return Number(body[level]) || 0;
        }
        return (body?.Informational || 0) + (body?.Warning || 0) + (body?.Critical || 0) + (body?.Severe || 0);
    }

    extractIncidentList = (response) => {
        const raw = response?.response;
        const responseBody = Array.isArray(raw) ? (raw[0] || {}) : (raw || {});
        if (Array.isArray(responseBody?.incident_list)) {
            return responseBody.incident_list;
        }
        if (Array.isArray(responseBody?.hero_section)) {
            return responseBody.hero_section;
        }
        return [];
    }

    loadVerticalIncidentData = async () => {
        if (!this.state.selectedEnvId) {
            this.setState({ verticalLoading: false, sk_loader: false });
            return;
        }

        this.setState({ verticalLoading: true, verticalError: false, sk_loader: true });

        try {
            const requestParams = this.buildVerticalRequest();

            // Step 1: Fetch hero data first â€” if empty, skip all other API calls
            const heroResponse = await getVerticalHeroIncidents(requestParams);
            const heroIncidents = this.extractIncidentList(heroResponse);

            const resolvedIncidentLevel = heroResponse?.response?.incident_level || "Critical";

            if (heroIncidents.length === 0) {
                this.resetSliderLoadQueue();
                this.setState({
                    verticalHeroIncidents: [],
                    verticalIncidentList: [],
                    verticalBusinessAreas: [],
                    verticalKpiSummary: [],
                    renderedCharts: {},
                    renderedHeroCharts: {},
                    renderedHeroKpiCharts: {},
                    sliderChartVersions: {},
                    sliderReadySections: {},
                    verticalSummaryTotal: 0,
                    verticalIncidentLevel: resolvedIncidentLevel,
                    severityActiveTab: {
                        type: resolvedIncidentLevel,
                        value: this.state.severityActiveTab?.value ?? 10,
                    },
                    critical_count: 0,
                    sever_count: 0,
                    warning_count: 0,
                    informative_count: 0,
                    selectedBusinessArea: null,
                    businessAreaData: {},
                    verticalLoading: false,
                    sk_loader: false,
                    ...this.resetSliderIndices(),
                }, this.syncSlidersToFirstSlide);
                return;
            }

            // Step 2: Show hero immediately, then fetch remaining data
            this.setState({
                verticalHeroIncidents: heroIncidents,
                verticalIncidentLevel: resolvedIncidentLevel,
                severityActiveTab: {
                    type: resolvedIncidentLevel,
                    value: this.state.severityActiveTab?.value ?? 10,
                },
                sk_loader: false,
                verticalLoading: true,
            });

            const allIncidentRequestParams = this.buildVerticalRequest({
                page_per_record: this.getAllIncidentsPageSize(),
                current_page: 1,
                top_issues: 'All',
            });
            const [summaryResponse, allResponse] = await Promise.all([
                getVerticalKpiSummaryData(requestParams),
                getVerticalAllIncidents(allIncidentRequestParams)
            ]);

            const summaryRoot = Array.isArray(summaryResponse?.response)
                ? (summaryResponse.response[0] || {})
                : (summaryResponse?.response || {});

            this.businessAreaSectionRefs = {};
            this.kpiSectionRefs = {};
            this.sectionSliderRefs = {};
            this.resetSliderLoadQueue();
            const resolvedLevelFromAll = allResponse?.response?.incident_level
                || heroResponse?.response?.incident_level
                || "Critical";
            const kpiSummary = normalizeKpiSummarySections(summaryRoot);

            this._kpiSummaryObserverHandled = true;
            this.setState({
                verticalHeroIncidents: heroIncidents,
                verticalIncidentList: this.extractIncidentList(allResponse),
                verticalBusinessAreas: dedupeKpiSummarySections(
                    Array.isArray(summaryRoot.business_area) ? summaryRoot.business_area : []
                ),
                verticalKpiSummary: kpiSummary,
                verticalSummaryTotal: summaryRoot.all_count || 0,
                verticalIncidentLevel: resolvedLevelFromAll,
                severityActiveTab: {
                    type: resolvedLevelFromAll,
                    value: this.state.severityActiveTab?.value ?? 10,
                },
                critical_count: allResponse?.response?.Critical ?? heroResponse?.response?.Critical ?? 0,
                sever_count: allResponse?.response?.Severe ?? heroResponse?.response?.Severe ?? 0,
                warning_count: allResponse?.response?.Warning ?? heroResponse?.response?.Warning ?? 0,
                informative_count: allResponse?.response?.Informational ?? heroResponse?.response?.Informational ?? 0,
                allIncidentApiTotal: this.extractAllIncidentTotal(allResponse),
                allIncidentApiPaginated: true,
                allIncidentcurrentPage: 1,
                selectedBusinessArea: null,
                businessAreaData: {},
                renderedCharts: {},
                renderedHeroCharts: {},
                renderedHeroKpiCharts: {},
                sliderChartVersions: {},
                verticalLoading: false,
                sk_loader: false,
                ...this.resetSliderIndices(),
                // Keep real section shells mounted so title/layout never remounts on scroll.
                mountedKpiSections: this.buildMountedKpiSections(kpiSummary),
                sliderReadySections: {},
                // Hide known-zero sections up front so their titles never flash then vanish.
                hiddenKpiSections: this.buildHiddenKpiSectionsFromSummary(kpiSummary),
                emptyKpiSections: {},
            }, () => {
                requestAnimationFrame(() => {
                    // Titles stay fixed; only slider data loads when scrolled into view.
                    this.setupBusinessAreaObserver();
                    this.syncSlidersToFirstSlide();
                    if (this.shouldUseAllIncidentApiSearch()) {
                        this.loadPagedAllIncidents(1);
                    }
                });
            });
        } catch (error) {
            console.error("Error loading vertical incidents:", error);
            this.setState({ verticalLoading: false, verticalError: true, sk_loader: false });
        }
    }

    resetSliderLoadQueue = () => {
        this.sliderLoadQueue = [];
        this.queuedSliderLoadKeys = new Set();
        this.activeSliderLoads = 0;
        this.businessAreaFetchPromises = {};
        this._businessAreaResultCache = {};
        this._observedKpiSectionKeys = new Set();
        this._sectionLayoutLocks = {};
        this._lockedSectionHeights = {};
        this._pendingSafeHide = [];
        if (this._userScrollTimer) {
            clearTimeout(this._userScrollTimer);
            this._userScrollTimer = null;
        }
    };

    /**
     * NEVER call window.scrollTo during lazy-load — that fights the user and causes
     * up/down page jerk. Keep document height stable instead.
     */
    applySectionLoadState = (sectionIndex, businessId, sectionItems, chartKey, indices, activeSlide) => {
        const isEmpty = !Array.isArray(sectionItems) || sectionItems.length === 0;
        const el = this.kpiSectionRefs[sectionIndex];
        const measuredH = el?.offsetHeight || 0;

        // Lock shell height so placeholder → cards cannot resize the page.
        if (measuredH > 0) {
            this._lockedSectionHeights[sectionIndex] = measuredH;
        }

        return new Promise((resolve) => {
            this.setState((prev) => {
                if (prev.sliderReadySections[sectionIndex] || prev.hiddenKpiSections?.[sectionIndex]) {
                    return null;
                }

                if (isEmpty) {
                    // Do NOT remove from layout yet — keep a reserved-height ghost so scrollY
                    // stays stable. Real hide happens only when fully below the viewport.
                    const next = {
                        emptyKpiSections: {
                            ...(prev.emptyKpiSections || {}),
                            [sectionIndex]: true,
                        },
                        sliderReadySections: {
                            ...prev.sliderReadySections,
                            [sectionIndex]: true,
                        },
                    };
                    if (businessId) {
                        next.businessAreaData = {
                            ...prev.businessAreaData,
                            [businessId]: {
                                incidents: [],
                                loading: false,
                                loaded: true,
                                currentPage: 1,
                                pagePerRecord: 20,
                            },
                        };
                    }
                    return next;
                }

                const existing = prev.renderedCharts[chartKey] || new Set();
                const merged = new Set(existing);
                indices.forEach((idx) => merged.add(idx));

                const next = {
                    emptyKpiSections: {
                        ...(prev.emptyKpiSections || {}),
                        [sectionIndex]: false,
                    },
                    renderedCharts: {
                        ...prev.renderedCharts,
                        [chartKey]: merged,
                    },
                    activeSectionSlides: {
                        ...prev.activeSectionSlides,
                        [sectionIndex]: activeSlide,
                    },
                    sliderReadySections: {
                        ...prev.sliderReadySections,
                        [sectionIndex]: true,
                    },
                };

                if (businessId) {
                    next.businessAreaData = {
                        ...prev.businessAreaData,
                        [businessId]: {
                            incidents: sectionItems,
                            loading: false,
                            loaded: true,
                            currentPage: 1,
                            pagePerRecord: 20,
                        },
                    };
                }
                return next;
            }, () => {
                // After empty load, try safe-hide if already below fold.
                if (isEmpty) {
                    this.scheduleSafeHideEmptySections();
                }
                resolve();
            });
        });
    };

    onKpiPageScroll = () => {
        if (this._userScrollTimer) clearTimeout(this._userScrollTimer);
        this._userScrollTimer = setTimeout(() => {
            this.scheduleSafeHideEmptySections();
        }, KPI_SCROLL_IDLE_MS);
    };

    /** Remove empty shells only when fully below the viewport — zero scroll impact. */
    scheduleSafeHideEmptySections = () => {
        const emptyMap = this.state.emptyKpiSections || {};
        const hiddenMap = this.state.hiddenKpiSections || {};
        const viewportH = window.innerHeight || 0;
        const toHide = {};

        Object.keys(emptyMap).forEach((key) => {
            const index = Number(key);
            if (!emptyMap[index] || hiddenMap[index]) return;
            const el = this.kpiSectionRefs[index];
            if (!el || !el.isConnected) {
                toHide[index] = true;
                return;
            }
            // Fully below fold → safe to drop height without moving anything on screen.
            if (el.getBoundingClientRect().top >= viewportH) {
                toHide[index] = true;
            }
        });

        if (!Object.keys(toHide).length) return;

        Object.keys(toHide).forEach((key) => {
            delete this._lockedSectionHeights[Number(key)];
        });

        this.setState((prev) => ({
            hiddenKpiSections: {
                ...(prev.hiddenKpiSections || {}),
                ...toHide,
            },
        }));
    };

    getKpiSectionShellStyle = (layoutIndex = 0, sectionIndex = null) => {
        const reserve = getKpiShellReserveHeight(layoutIndex);
        const locked = sectionIndex != null ? this._lockedSectionHeights?.[sectionIndex] : null;
        return {
            minHeight: `${Math.max(reserve, locked || 0)}px`,
            overflowAnchor: 'none',
        };
    };

    renderKpiSectionSliderPlaceholder = (layoutIndex = 0) => {
        const reserveH = getKpiSliderReserveHeight(layoutIndex);
        const rows = Number(getSectionCfg(layoutIndex)?.sliderSettings?.rows) || 1;
        const cards = rows > 1 ? 6 : 3;
        return (
            <div className="tw-flex tw-flex-wrap tw-gap-4 tw-px-8 tw-w-full tw-h-full tw-box-border" style={{ minHeight: `${reserveH}px` }}>
                {Array.from({ length: cards }, (_, i) => (
                    <div
                        key={i}
                        className="tw-bg-[#191932]/60 tw-rounded-[30px] tw-border tw-border-solid tw-border-[#ffffff]/10 tw-p-8 tw-flex tw-flex-col"
                        style={{
                            minHeight: `${KPI_SECTION_SLIDER_MIN_HEIGHT}px`,
                            flex: rows > 1 ? '1 1 calc(33.333% - 1rem)' : '1 1 0',
                            maxWidth: rows > 1 ? 'calc(33.333% - 0.75rem)' : undefined,
                        }}
                        aria-hidden="true"
                    >
                        <div className="tw-h-4 tw-bg-white/10 tw-rounded tw-mb-4 tw-w-1/2" />
                        <div className="tw-h-10 tw-bg-white/10 tw-rounded tw-mb-3 tw-w-3/4" />
                        <div className="tw-flex-1 tw-min-h-[145px] tw-bg-white/5 tw-rounded-xl" />
                    </div>
                ))}
            </div>
        );
    };

    mountKpiSectionsBatch = (entries = []) => {
        if (!Array.isArray(entries) || entries.length === 0) return;

        // Shells (title/description/layout) stay mounted; scroll only triggers data fetch.
        entries.forEach(({ sectionIndex, businessId }) => {
            if (Number.isNaN(sectionIndex)) return;
            if (this.state.hiddenKpiSections?.[sectionIndex]) return;
            this.enqueueSliderLoad({ businessId, sectionIndex });
        });
    };

    mountKpiSection = (sectionIndex, businessId) => {
        this.mountKpiSectionsBatch([{ sectionIndex, businessId }]);
    };

    enqueueSliderLoad = ({ businessId, sectionIndex }) => {
        if (Number.isNaN(sectionIndex)) return;
        if (this.state.hiddenKpiSections?.[sectionIndex]) return;
        if (this.state.emptyKpiSections?.[sectionIndex]) return;

        // Queue key is per-section so two sections sharing a business_id both load.
        // HTTP dedupe for the same business_id happens in fetchBusinessAreaIncidents.
        const key = `s${sectionIndex}`;
        if (this.queuedSliderLoadKeys.has(key)) return;
        if (this.state.sliderReadySections[sectionIndex]) return;

        const section = (this.state.verticalKpiSummary || [])[sectionIndex];
        // Only lazy-load business_area incidents when summary has content.
        if (businessId && !this.shouldFetchBusinessAreaIncidents(section)) {
            this.markKpiSectionReadyWithoutFetch(sectionIndex, businessId, []);
            return;
        }

        // Queue key is per-section so two sections sharing a business_id both load.
        // HTTP dedupe for the same business_id happens in fetchBusinessAreaIncidents.
        const key1 = `s${sectionIndex}`;
        if (this.queuedSliderLoadKeys.has(key1)) return;

        if (businessId) {
            this.assignComboSectionOrder(sectionIndex, businessId);
        } else {
            this.assignComboSectionOrder(sectionIndex, null);
        }

        this.queuedSliderLoadKeys.add(key1);
        this.sliderLoadQueue.push({ businessId, sectionIndex, key1 });
        this.sliderLoadQueue.sort((a, b) => a.sectionIndex - b.sectionIndex);
        this.scheduleSliderLoadQueue();
    };

    shouldFetchBusinessAreaIncidents = (section) => {
        if (!section || typeof section !== 'object') return false;
        const summaryLen = Array.isArray(section.summary) ? section.summary.length : 0;
        if (summaryLen > 0) return true;
        return this.getSummarySectionIncidentCount(section) > 0;
    };

    /**
     * Combo chart pattern follows business_area API call order (1st=odd, 2nd=even…).
     * Assigned when a section is first queued/fetched; stable for the page lifetime.
     */
    assignComboSectionOrder = (sectionIndex, businessId = null) => {
        if (!this._sectionComboOrder) this._sectionComboOrder = {};
        if (!this._businessIdComboOrder) this._businessIdComboOrder = {};
        if (this._sectionComboOrder[sectionIndex] != null) {
            return this._sectionComboOrder[sectionIndex];
        }
        if (businessId != null && this._businessIdComboOrder[businessId] != null) {
            this._sectionComboOrder[sectionIndex] = this._businessIdComboOrder[businessId];
            return this._sectionComboOrder[sectionIndex];
        }
        const order = this._businessAreaCallSeq || 0;
        this._businessAreaCallSeq = order + 1;
        this._sectionComboOrder[sectionIndex] = order;
        if (businessId != null) {
            this._businessIdComboOrder[businessId] = order;
        }
        return order;
    };

    getComboSectionOrderIndex = (sectionIndex, businessId = null) => {
        if (this._sectionComboOrder?.[sectionIndex] != null) {
            return this._sectionComboOrder[sectionIndex];
        }
        if (businessId != null && this._businessIdComboOrder?.[businessId] != null) {
            return this._businessIdComboOrder[businessId];
        }
        // Fallback: order among kpi_summary sections that will call business_area
        const summary = this.state.verticalKpiSummary || [];
        let order = 0;
        for (let i = 0; i < sectionIndex; i++) {
            if (this.state.hiddenKpiSections?.[i]) continue;
            if (this.shouldFetchBusinessAreaIncidents(summary[i])) {
                order += 1;
            }
        }
        return order;
    };

    markKpiSectionReadyWithoutFetch = (sectionIndex, businessId = null, incidents = []) => {
        this.setState((prev) => {
            if (prev.sliderReadySections[sectionIndex] || prev.hiddenKpiSections?.[sectionIndex]) {
                return null;
            }
            const isEmpty = !Array.isArray(incidents) || incidents.length === 0;
            const next = {
                sliderReadySections: {
                    ...prev.sliderReadySections,
                    [sectionIndex]: true,
                },
            };
            if (isEmpty) {
                next.hiddenKpiSections = {
                    ...(prev.hiddenKpiSections || {}),
                    [sectionIndex]: true,
                };
            }
            if (businessId) {
                next.businessAreaData = {
                    ...prev.businessAreaData,
                    [businessId]: {
                        incidents: incidents || [],
                        loading: false,
                        loaded: true,
                        currentPage: 1,
                        pagePerRecord: 20,
                    },
                };
            }
            return next;
        });
    };

    scheduleSliderLoadQueue = () => {
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(() => this.processSliderLoadQueue());
        } else {
            setTimeout(() => this.processSliderLoadQueue(), 0);
        }
    };

    processSliderLoadQueue = () => {
        while (
            this.activeSliderLoads < MAX_CONCURRENT_KPI_SECTION_LOADS
            && this.sliderLoadQueue.length > 0
        ) {
            const task = this.sliderLoadQueue.shift();
            if (!task) break;
            // Keep task.key in queuedSliderLoadKeys until the load finishes so the
            // same section cannot be enqueued again while a request is in flight.
            this.activeSliderLoads += 1;

            Promise.resolve()
                .then(() => this.loadBusinessAreaDataForSection(task))
                .catch((error) => {
                    console.error('Error loading KPI slider section:', error);
                })
                .finally(() => {
                    this.queuedSliderLoadKeys.delete(task.key);
                    this.activeSliderLoads = Math.max(0, this.activeSliderLoads - 1);
                    if (this.sliderLoadQueue.length > 0) {
                        this.scheduleSliderLoadQueue();
                    }
                });
        }
    };

    fetchBusinessAreaIncidents = (businessId) => {
        if (!businessId) {
            return Promise.resolve([]);
        }

        const cached = this.state.businessAreaData[businessId];
        if (cached?.loaded) {
            return Promise.resolve(cached.incidents || []);
        }

        if (!this._businessAreaResultCache) {
            this._businessAreaResultCache = {};
        }
        if (Object.prototype.hasOwnProperty.call(this._businessAreaResultCache, businessId)) {
            return Promise.resolve(this._businessAreaResultCache[businessId]);
        }

        if (this.businessAreaFetchPromises[businessId]) {
            return this.businessAreaFetchPromises[businessId];
        }

        this.businessAreaFetchPromises[businessId] = getVerticalBusinessAreaIncidents(this.buildVerticalRequest({
            tenant_id: String(this.state.teamId),
            user_id: String(this.state.userId),
            type: this.getSelectedIncidentType(),
            page_per_record: 20,
            current_page: 1,
            business_id: businessId
        }))
            .then((response) => {
                const incidents = this.extractIncidentList(response);
                this._businessAreaResultCache[businessId] = incidents;
                return incidents;
            })
            .catch(() => {
                const empty = [];
                this._businessAreaResultCache[businessId] = empty;
                return empty;
            });
            // Keep the promise cached so concurrent section loads share one HTTP call.
            // Cleared only on full queue reset (watchlist/env refresh).

        return this.businessAreaFetchPromises[businessId];
    };

    loadBusinessAreaData = async (businessId) => {
        if (!businessId) return [];
        const current = this.state.businessAreaData[businessId];
        if (current?.loaded) return current.incidents || [];
        return this.fetchBusinessAreaIncidents(businessId);
    };

    /**
     * Build layout-type map for sections that actually paint chrome/content.
     * Layout indices are locked once assigned so empty collapses / late loads
     * don't remount other sliders (major scroll-jerk source).
     */
    buildSectionLayoutMap = () => {
        const summary = this.state.verticalKpiSummary || [];
        const { businessAreaData, sliderReadySections, hiddenKpiSections, emptyKpiSections } = this.state;
        if (!this._sectionLayoutLocks) this._sectionLayoutLocks = {};
        const locks = this._sectionLayoutLocks;
        const map = {};
        const participants = [];

        summary.forEach((section, index) => {
            if (hiddenKpiSections?.[index] || this.isKpiSectionKnownEmpty(section)) {
                delete locks[index];
                map[index] = null;
                return;
            }

            // Empty ghosts keep their locked layout so reserved height stays consistent.
            if (emptyKpiSections?.[index]) {
                if (typeof locks[index] === 'number') {
                    map[index] = locks[index];
                    participants.push(index);
                } else {
                    map[index] = getSectionLayoutIndex(0);
                }
                return;
            }

            const businessId = section?.business_id;
            const lazyData = businessId ? businessAreaData[businessId] : null;
            const needsLazyLoad = Boolean(businessId);
            const isLoaded = !needsLazyLoad || lazyData?.loaded;
            const isSliderReady = Boolean(sliderReadySections?.[index]);
            const sectionItems = isLoaded
                ? (needsLazyLoad ? (lazyData?.incidents || []) : this.getKpiSectionItems(section))
                : [];

            if (isLoaded && isSliderReady && sectionItems.length === 0) {
                if (typeof locks[index] === 'number') {
                    map[index] = locks[index];
                    participants.push(index);
                } else {
                    map[index] = getSectionLayoutIndex(0);
                }
                return;
            }

            const showTitleChrome = isLoaded && isSliderReady
                ? sectionItems.length > 0
                : true;

            if (!showTitleChrome) {
                map[index] = null;
                return;
            }

            participants.push(index);
        });

        let nextLayout = 0;
        Object.keys(locks).forEach((key) => {
            const idx = Number(key);
            if (!participants.includes(idx)) {
                delete locks[idx];
                return;
            }
            const locked = locks[idx];
            if (typeof locked === 'number' && locked >= nextLayout) {
                nextLayout = locked + 1;
            }
        });

        participants.forEach((index) => {
            if (typeof locks[index] === 'number') {
                map[index] = locks[index];
                return;
            }
            const layoutIndex = getSectionLayoutIndex(nextLayout);
            locks[index] = layoutIndex;
            map[index] = layoutIndex;
            nextLayout += 1;
        });

        return map;
    };

    /** Designed layout type for a section index (Call Center → … → POS cycle). */
    getLayoutIndexForSection = (sectionIndex) => {
        const map = this.buildSectionLayoutMap();
        this.sectionLayoutIndexMap = map;
        if (map[sectionIndex] != null) return map[sectionIndex];
        return getSectionLayoutIndex(0);
    };

    loadBusinessAreaDataForSection = async ({ businessId, sectionIndex }) => {
        const section = (this.state.verticalKpiSummary || [])[sectionIndex];
        if (!section) return;
        if (this.state.sliderReadySections[sectionIndex] || this.state.hiddenKpiSections?.[sectionIndex]) return;

        let sectionItems = [];
        if (businessId) {
            sectionItems = await this.fetchBusinessAreaIncidents(businessId);
        } else {
            sectionItems = this.getKpiSectionItems(section);
        }

        const layoutIndex = this.getLayoutIndexForSection(sectionIndex);
        const activeSlide = this.state.activeSectionSlides[sectionIndex] || 0;
        const indices = this.getKpiVisibleSlideIndices(layoutIndex, activeSlide, sectionItems.length);
        const chartKey = `s${sectionIndex}`;

        await this.applySectionLoadState(
            sectionIndex,
            businessId,
            sectionItems,
            chartKey,
            indices,
            activeSlide
        );
    };

    setupBusinessAreaObserver = () => {
        if (this.businessAreaObserver) {
            this.businessAreaObserver.disconnect();
        }

        this.businessAreaObserver = new IntersectionObserver(
            (entries) => {
                const visibleEntries = entries
                    .filter((entry) => entry.isIntersecting)
                    .map((entry) => ({
                        sectionIndex: Number(entry.target.dataset.sectionIndex),
                        businessId: entry.target.dataset.businessId
                            ? Number(entry.target.dataset.businessId)
                            : null,
                        target: entry.target,
                        observeKey: entry.target.dataset.observeKey || `${entry.target.dataset.sectionIndex}`,
                    }))
                    .filter((entry) => !Number.isNaN(entry.sectionIndex))
                    .filter((entry) => !this.state.hiddenKpiSections?.[entry.sectionIndex])
                    .sort((a, b) => a.sectionIndex - b.sectionIndex);

                if (visibleEntries.length === 0) return;

                visibleEntries.forEach(({ target, observeKey }) => {
                    if (this._observedKpiSectionKeys.has(observeKey)) return;
                    this._observedKpiSectionKeys.add(observeKey);
                    this.businessAreaObserver.unobserve(target);
                });

                this.mountKpiSectionsBatch(visibleEntries);
            },
            { rootMargin: KPI_SECTION_PREFETCH_MARGIN, threshold: 0.01 }
        );

        Object.entries(this.kpiSectionRefs).forEach(([index, el]) => {
            if (!el) return;
            const sectionIndex = Number(index);
            if (this.state.hiddenKpiSections?.[sectionIndex]) return;
            if (this.state.sliderReadySections[sectionIndex]) return;
            const observeKey = el.dataset.observeKey || `s${index}`;
            if (this._observedKpiSectionKeys.has(observeKey)) return;
            this.businessAreaObserver.observe(el);
        });
    }

    initializeVerticalIncidents = async () => {
        this.setState({ verticalLoading: true });
        try {
            const environmentResponse = await this.getLatestEnvironmentResponse();
            const envDetails = environmentResponse?.response?.env_details || [];
            const latestEnvId = environmentResponse?.response?.latest_env_id;
            const restoredEnvId = this.state.selectedEnvId;
            const selectedEnv = envDetails.find((env) => String(env.env_id) === String(restoredEnvId))
                || envDetails.find((env) => env.env_id === latestEnvId)
                || envDetails[0];

            if (!selectedEnv) {
                // No environment configured at all â€” show "not configured" state, no API calls
                this.setState({ verticalLoading: false, noData: true, sk_loader: false });
                return;
            }

            this.setState({
                selectedEnvId: selectedEnv.env_id,
                selectedEnvName: selectedEnv.env_name,
                envList: envDetails,
                noData: false,
            }, async () => {
                await this.loadVerticalWatchLists();
                this.loadVerticalIncidentData();
            });
        } catch (error) {
            console.error("Error initializing vertical incidents:", error);
            this.setState({ verticalLoading: false, verticalError: true });
        }
    }

    handleWatchlistChange = (selectedOption) => {
        this.setState({ selectedOption, selectedBusinessArea: null }, this.loadVerticalIncidentData);
    }

    handleFilterChange = (selectedFilterOption) => {
        this.setState({ selectedFilterOption, selectedBusinessArea: null }, this.loadVerticalIncidentData);
    }

    handleChangeDate = (event, picker) => {
        const selectedDate = picker.startDate;
        const today = moment();
        const yesterday = moment().subtract(1, "days");
        const displayDate = selectedDate.isSame(today, "day")
            ? "Today"
            : selectedDate.isSame(yesterday, "day")
                ? "Yesterday"
                : selectedDate.format("DD MMM YYYY");

        this.setState({
            selcetedDate: selectedDate.format("YYYY-MM-DD"),
            displayDate,
            selectedBusinessArea: null
        }, this.loadVerticalIncidentData);
    }

    handleBusinessAreaSelect = async (businessArea) => {
        if (!businessArea?.business_id || !this.state.selectedEnvId) {
            return;
        }

        this.setState({ selectedBusinessArea: businessArea, loadingBusinessArea: true });

        try {
            const response = await getVerticalBusinessAreaIncidents(this.buildVerticalRequest({
                tenant_id: String(this.state.teamId),
                user_id: String(this.state.userId),
                type: this.getSelectedIncidentType(),
                business_id: businessArea.business_id
            }));
            const incidentList = this.extractIncidentList(response);
            this.setState((prevState) => ({
                verticalBusinessAreaIncidents: {
                    ...prevState.verticalBusinessAreaIncidents,
                    [businessArea.business_id]: incidentList
                },
                loadingBusinessArea: false
            }), () => {
                if (this.verticalTableRef.current) {
                    this.verticalTableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            });
        } catch (error) {
            console.error("Error loading vertical business area incidents:", error);
            this.setState({ loadingBusinessArea: false });
        }
    }

    getIncidentInteractionState = (incident, field) => {
        const id = incident?.kpi_incident_id;
        if (!id) {
            return field === 'read';
        }

        if (field === 'liked') {
            return Boolean(this.state.likedIncidents[id] ?? incident?.likes ?? incident?.liked ?? false);
        }
        if (field === 'ignored') {
            return Boolean(this.state.ignoredIncidents[id] ?? incident?.ignored ?? incident?.ignore ?? false);
        }
        if (field === 'read') {
            if (this.state.unreadIncidents[id] !== undefined) {
                return !this.state.unreadIncidents[id];
            }
            return incident?.read !== false;
        }
        if (field === 'resolved') {
            return Boolean(this.state.resolvedIncidents[id] ?? incident?.resolved ?? false);
        }

        return false;
    }

    updateIncidentInteraction = (incidentId, updates) => {
        const incidentUpdates = {};
        if ('liked' in updates) {
            incidentUpdates.likes = updates.liked;
            incidentUpdates.liked = updates.liked;
        }
        if ('ignored' in updates) {
            incidentUpdates.ignored = updates.ignored;
            incidentUpdates.ignore = updates.ignored;
        }
        if ('read' in updates) {
            incidentUpdates.read = updates.read;
        }
        if ('resolved' in updates) {
            incidentUpdates.resolved = updates.resolved;
        }

        const updateList = (list) => (list || []).map((item) => (
            item.kpi_incident_id === incidentId ? { ...item, ...incidentUpdates } : item
        ));

        this.setState((prevState) => {
            const verticalBusinessAreaIncidents = {};
            Object.keys(prevState.verticalBusinessAreaIncidents || {}).forEach((businessId) => {
                verticalBusinessAreaIncidents[businessId] = updateList(prevState.verticalBusinessAreaIncidents[businessId]);
            });

            const nextState = {
                verticalHeroIncidents: updateList(prevState.verticalHeroIncidents),
                verticalIncidentList: updateList(prevState.verticalIncidentList),
                verticalBusinessAreaIncidents,
            };

            if ('liked' in updates) {
                nextState.likedIncidents = {
                    ...prevState.likedIncidents,
                    [incidentId]: updates.liked,
                };
            }
            if ('ignored' in updates) {
                nextState.ignoredIncidents = {
                    ...prevState.ignoredIncidents,
                    [incidentId]: updates.ignored,
                };
            }
            if ('read' in updates) {
                nextState.unreadIncidents = {
                    ...prevState.unreadIncidents,
                    [incidentId]: !updates.read,
                };
            }
            if ('resolved' in updates) {
                nextState.resolvedIncidents = {
                    ...prevState.resolvedIncidents,
                    [incidentId]: updates.resolved,
                };
            }

            return nextState;
        });
    }

    submitVerticalIncidentInteraction = async (incident, updates) => {
        if (!incident?.kpi_incident_id) {
            return;
        }

        const incidentId = incident.kpi_incident_id;
        const rollbackUpdates = {};
        if ('liked' in updates) {
            rollbackUpdates.liked = this.getIncidentInteractionState(incident, 'liked');
        }
        if ('ignored' in updates) {
            rollbackUpdates.ignored = this.getIncidentInteractionState(incident, 'ignored');
        }
        if ('read' in updates) {
            rollbackUpdates.read = this.getIncidentInteractionState(incident, 'read');
        }
        if ('resolved' in updates) {
            rollbackUpdates.resolved = this.getIncidentInteractionState(incident, 'resolved');
        }

        this.updateIncidentInteraction(incidentId, updates);

        try {
            const response = await postVerticalInteraction({
                tenant_id: String(this.state.teamId),
                user_id: String(this.state.userId),
                kpi_incident_id: incidentId,
                ...updates,
            });
            if (response?.code && response.code !== 200) {
                this.updateIncidentInteraction(incidentId, rollbackUpdates);
            }
        } catch (error) {
            console.error("Error posting vertical incident interaction:", error);
            this.updateIncidentInteraction(incidentId, rollbackUpdates);
        }
    }

    handleVerticalInteraction = async (incident) => {
        const nextLiked = !this.getIncidentInteractionState(incident, 'liked');
        this.showInteractionToast("like", nextLiked);
        await this.submitVerticalIncidentInteraction(incident, { liked: nextLiked });
    }

    handleKpiFullscreen = (item) => {
        this.setState({ kpiFullscreenItem: item || null });
    }

    handleKpiCloseFullscreen = () => {
        this.setState({ kpiFullscreenItem: null });
    }

    handleKpiLike = (item) => {
        this.handleVerticalInteraction(item);
    }

    handleKpiIgnore = (item) => {
        const nextIgnored = !this.getIncidentInteractionState(item, 'ignored');
        this.showInteractionToast("ignored", nextIgnored);
        this.submitVerticalIncidentInteraction(item, { ignored: nextIgnored });
    }

    handleKpiMarkUnread = (item) => {
        const nextRead = !this.getIncidentInteractionState(item, 'read');
        this.showInteractionToast("read", nextRead);
        this.submitVerticalIncidentInteraction(item, { read: nextRead });
    }

    handleKpiResolve = (item) => {
        const nextResolved = !this.getIncidentInteractionState(item, 'resolved');
        this.showInteractionToast("resolved", nextResolved);
        this.submitVerticalIncidentInteraction(item, { resolved: nextResolved });
    }

    handleKpiShare = (item) => {
        const incidentId = item?.kpi_incident_id;
        const shareUrl = incidentId
            ? `${window.location.origin}${window.location.pathname}${window.location.search}#incident-${incidentId}`
            : window.location.href;

        const copyToClipboard = navigator.clipboard?.writeText
            ? navigator.clipboard.writeText(shareUrl)
            : Promise.reject(new Error("Clipboard unavailable"));

        copyToClipboard
            .then(() => this.handleNotifyToast("Share link copied to clipboard", "blue"))
            .catch(() => this.handleNotifyToast("Unable to copy share link", "yellow"));
    }

    formatMetricValue = (value, units = '') => {
        return formatChartMetricValue(value, units, { fallback: 'NA', maximumFractionDigits: 1 });
    }

    toSlideIndex = (index) => {
        const n = Number(index);
        if (!Number.isFinite(n)) return 0;
        return Math.max(0, Math.floor(n));
    }

    getSliderPagingLabel = (activeSlide, totalItems) => {
        const total = Math.max(0, Number(totalItems) || 0);
        if (total === 0) return '0 of 0';
        const current = Math.min(this.toSlideIndex(activeSlide) + 1, total);
        return `${current} of ${total}`;
    }

    formatLocaleMetricValue = (value, maximumFractionDigits = 2, fallback = "—", units = '') => {
        return formatChartMetricValue(value, units, { maximumFractionDigits, fallback });
    }

    parseKpiNameUnits = (kpiName = '') => {
        if (!kpiName || typeof kpiName !== 'string') {
            return { name: '', units: '' };
        }
        if (kpiName.includes('(') && kpiName.endsWith(')')) {
            const start = kpiName.lastIndexOf('(');
            return {
                name: kpiName.slice(0, start).trim(),
                units: kpiName.slice(start + 1, -1).trim(),
            };
        }
        return { name: kpiName.trim(), units: '' };
    }

    getChartDisplayUnits = (item = null) => {
        if (!item) {
            return '';
        }

        const directUnit = item.units ?? item.unit;
        if (directUnit !== null && directUnit !== undefined && String(directUnit).trim() !== '') {
            return String(directUnit).trim();
        }

        const rawName = item.kpi_name || item.metrics_name || item.title || item.name || '';
        const parsed = this.parseKpiNameUnits(rawName);
        if (parsed.units) {
            return parsed.units;
        }

        const lookupName = parsed.name || rawName;
        const mappedUnit = chart_metrics_units[lookupName];
        if (mappedUnit !== undefined && mappedUnit !== null && String(mappedUnit).trim() !== '') {
            return String(mappedUnit).trim();
        }

        return '';
    }

    getHeroKpiCarouselIndex = (incidentId) => {
        const indices = this.state.heroKpiCarouselIndices || {};
        const index = Number(indices[incidentId]);
        return Number.isFinite(index) && index >= 0 ? index : 0;
    };

    setHeroKpiCarouselIndex = (incidentId, nextIndex, options = {}) => {
        if (!incidentId) return;
        const cardsPerPage = options.cardsPerPage || 3;
        const totalCards = Number.isFinite(options.totalCards) ? options.totalCards : Number.MAX_SAFE_INTEGER;
        const safeIndex = Math.max(0, Number(nextIndex) || 0);
        this.setState(prev => {
            const prevIndex = Number(prev.heroKpiCarouselIndices?.[incidentId]) || 0;
            const rendered = new Set(prev.renderedHeroKpiCharts?.[incidentId] || []);
            const markRange = (start) => {
                const end = Math.min(totalCards - 1, start + cardsPerPage - 1);
                for (let i = Math.max(0, start); i <= end; i += 1) {
                    rendered.add(i);
                }
            };
            markRange(prevIndex);
            markRange(safeIndex);
            return {
                heroKpiCarouselIndices: {
                    ...(prev.heroKpiCarouselIndices || {}),
                    [incidentId]: safeIndex,
                },
                renderedHeroKpiCharts: {
                    ...(prev.renderedHeroKpiCharts || {}),
                    [incidentId]: rendered,
                },
            };
        });
    };

    getIncidentValue = (incident) => {
        const units = this.getChartDisplayUnits(incident);
        if (incident?.kpi_agg_value !== null && incident?.kpi_agg_value !== undefined && incident?.kpi_agg_value !== "") {
            const formatted = this.formatMetricValue(incident.kpi_agg_value, units);
            if (formatted !== "NA") {
                return formatted;
            }
        }
        const yValues = this.getIncidentAxisValues(incident, 'y');
        return this.formatMetricValue(yValues[yValues.length - 1], units);
    }

    getIncidentRawValue = (incident) => {
        if (incident?.kpi_agg_value !== null && incident?.kpi_agg_value !== undefined && incident?.kpi_agg_value !== "") {
            return incident.kpi_agg_value;
        }
        const yValues = this.getIncidentAxisValues(incident, 'y');
        return yValues.length ? yValues[yValues.length - 1] : null;
    }

    renderMetricValueWithUnits = (rawValue, units = '', className = '', maximumFractionDigits = 1, fallback = "—", Tag = 'span', isHero = false) => {
        const compactParts = (rawValue !== null && rawValue !== undefined && rawValue !== "")
            ? getCompactMetricParts(rawValue, maximumFractionDigits)
            : null;
        const itemValue = compactParts ? `${compactParts.number}${compactParts.suffix}` : fallback;
        const currencyPrefix = getCurrencyDisplayPrefix(units);
        const trailingUnits = (!currencyPrefix && normalizeMetricUnits(units)) ? normalizeMetricUnits(units) : "";
        const wrapClass = currencyPrefix ? '!tw-flex-nowrap' : 'tw-flex-wrap';

        return (
            <Tag className={`tw-inline-flex ${wrapClass} tw-items-baseline tw-gap-x-1 tw-gap-y-0.5 ${className || ''}`}>
                {currencyPrefix ? <span>{currencyPrefix}</span> : null}
                <span>{itemValue}</span>
                {trailingUnits ? (
                    <sub className={`!tw-bottom-0 tw-inline-block tw-leading-none tw-whitespace-nowrap ${isHero ? 'tw-text-[#F7F7F7]/50' : 'tw-text-[#6C737F]'}`}>
                        {trailingUnits}
                    </sub>
                ) : null}
            </Tag>
        );
    }

    getIncidentSourceName = (incident) => {
        const source = incident?.source || {};
        return source.data_set_name || source.integration_name || source.env_name || incident?.subject_name || "Vertical KPI";
    }

    getIncidentDate = (value, format = "DD MMM YYYY HH:mm") => {
        if (!value) {
            return "NA";
        }
        const parsedDate = moment(value);
        return parsedDate.isValid() ? parsedDate.format(format) : value;
    }

    isTrendUp = (item) => this.getTrendDirection(item) === "up";

    getTrendDirection = (item) => {
        const raw = String(item?.trends ?? item?.trend ?? "").toLowerCase().trim();
        if (["up", "increase", "increasing", "rising", "positive"].includes(raw)) return "up";
        if (["down", "decrease", "decreasing", "falling", "decline", "negative"].includes(raw)) return "down";
        if (raw) return "down";
        const numeric = Number(item?.trends_value);
        if (Number.isFinite(numeric) && numeric > 0) return "up";
        if (Number.isFinite(numeric) && numeric < 0) return "down";
        return "down";
    }

    renderTrendIcon = (itemOrIsUp, size = 16) => {
        const isUp = typeof itemOrIsUp === "boolean"
            ? itemOrIsUp
            : this.isTrendUp(itemOrIsUp);
        return (
            <svg
                className="qd-trend-icon tw-block tw-flex-shrink-0"
                width={size}
                height={size}
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                style={{ width: size, height: size, maxWidth: size }}
            >
                <path
                    d={isUp ? TREND_SVG_PATH_UP : TREND_SVG_PATH_DOWN}
                    stroke={TREND_COLOR_RED}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    renderTrendValue = (value, className = TREND_TEXT_CLASS) => (
        <span className={className} style={{ color: TREND_COLOR_RED }}>
            {value}
        </span>
    )

    renderTrendBadge = (itemOrIsUp, value, iconSize = 16) => (
        <span className="tw-flex tw-items-center tw-gap-1" style={{ color: TREND_COLOR_RED }}>
            {this.renderTrendIcon(itemOrIsUp, iconSize)}
            {this.renderTrendValue(value)}
        </span>
    )

    formatDriftDisplayValue = (value, fallback = "NA", maximumFractionDigits = 2) => {
        if (value === null || value === undefined || value === "") {
            return fallback;
        }
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue)) {
            return fallback;
        }
        return this.formatLocaleMetricValue(Math.abs(numericValue), maximumFractionDigits, fallback, '%');
    }

    getIncidentAxisValues = (item, axis = 'y') => {
        if (!item || typeof item !== 'object') return [];
        const primaryKey = `${axis}_value`;
        const altKey = `${axis}_axis`;
        const primary = item[primaryKey];
        const alt = item[altKey];

        if (Array.isArray(primary) && primary.length) return primary;
        if (Array.isArray(alt) && alt.length) return alt;
        if (Array.isArray(primary)) return primary;
        if (Array.isArray(alt)) return alt;

        // Scalar threshold / single metric fallback (common for z / aggregated values).
        if (primary != null && primary !== '' && !Array.isArray(primary)) return [primary];
        if (alt != null && alt !== '' && !Array.isArray(alt)) return [alt];
        return [];
    }

    getIncidentChartSeries = (item) => {
        let xValues = this.getIncidentAxisValues(item, 'x');
        let yValues = this.getIncidentAxisValues(item, 'y');
        const zValues = this.getIncidentAxisValues(item, 'z');
        const compareIndex = this.getIncidentCompareIndex(item);
        const driftValues = this.getIncidentSeriesArray(item, ['drift']);
        const previousAvgValues = this.getIncidentSeriesArray(item, ['previous_avg_values', 'prev_avg_values']);

        // Single-point / sparse payloads: synthesize a plottable series from kpi_agg_value.
        if ((!yValues.length || yValues.every((v) => v == null || v === ''))
            && item?.kpi_agg_value != null
            && item.kpi_agg_value !== '') {
            yValues = [item.kpi_agg_value];
        }
        if (yValues.length && !xValues.length) {
            const fallbackX = item?.generated_at
                || item?.created_time
                || item?.report_date
                || xValues[0]
                || new Date().toISOString();
            xValues = [fallbackX];
        }

        return { xValues, yValues, zValues, compareIndex, driftValues, previousAvgValues };
    }

    getIncidentSeriesArray = (item, keys = []) => {
        if (!item || typeof item !== 'object') return [];
        for (let i = 0; i < keys.length; i += 1) {
            const value = item[keys[i]];
            if (Array.isArray(value) && value.length) return value;
        }
        for (let i = 0; i < keys.length; i += 1) {
            const value = item[keys[i]];
            if (value != null && value !== '' && !Array.isArray(value)) return [value];
        }
        return [];
    }

    getIncidentCompareIndex = (item) => {
        if (item == null || item.compare_index == null || item.compare_index === '') {
            return null;
        }
        const parsed = Number(item.compare_index);
        return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
    }

    getIncidentBarHighlight = (incident) => {
        const { xValues, compareIndex } = this.getIncidentChartSeries(incident);
        if (compareIndex != null && xValues[compareIndex] != null) {
            return xValues[compareIndex];
        }
        return incident?.generated_at;
    }

    getThresholdValue = (item) => {
        if (item?.threshold_value != null && item.threshold_value !== "") {
            return item.threshold_value;
        }
        const zValues = this.getIncidentAxisValues(item, 'z');
        if (zValues.length > 0) {
            return zValues[0];
        }
        return null;
    }

    getCurrentDriftValue = (item) => (
        item?.trends_value != null && item.trends_value !== "" ? item.trends_value : null
    )

    getIncidentChartDetails = (item) => {
        const details = typeof item?.chart_details === 'string' ? item.chart_details.trim() : '';
        return details || null;
    }

    getIncidentChartDetailsParts = (item) => {
        const details = this.getIncidentChartDetails(item);
        if (!details) return null;

        const separatorIndex = details.lastIndexOf(':');
        if (separatorIndex === -1) {
            return { label: details, value: '' };
        }

        return {
            label: details.slice(0, separatorIndex).trim(),
            value: details.slice(separatorIndex + 1).trim(),
        };
    }

    getTrendText = (incident) => this.formatDriftDisplayValue(incident?.trends_value, "NA", 1);

    getTrendClassName = (incident) => {
        return TREND_TEXT_CLASS;
    }

    getTrendStroke = (incident) => {
        return TREND_COLOR_RED;
    }

    getTrendIconPath = (incident) => (
        this.isTrendUp(incident) ? TREND_SVG_PATH_UP : TREND_SVG_PATH_DOWN
    )

    getPeriodLabel = (periodType) => {
        if (periodType == null || periodType === "") return "vs previous refresh";
        return `vs ${PERIOD_TYPE_MAPPING[Number(periodType)] || "previous refresh"}`;
    }

    normalizeAttributeNames = (value) => {
        if (value == null) {
            return [];
        }
        if (typeof value === "string") {
            const trimmed = value.trim();
            if (!trimmed) {
                return [];
            }
            if (trimmed.startsWith("[")) {
                try {
                    return this.normalizeAttributeNames(JSON.parse(trimmed));
                } catch (error) {
                    return [trimmed];
                }
            }
            return [trimmed];
        }
        if (Array.isArray(value)) {
            return value
                .map((entry) => {
                    if (entry == null) {
                        return "";
                    }
                    if (typeof entry === "string") {
                        return entry.trim();
                    }
                    if (typeof entry === "object") {
                        return String(
                            entry.attribute_name
                            || entry.name
                            || entry.label
                            || entry.value
                            || ""
                        ).trim();
                    }
                    return String(entry).trim();
                })
                .filter((name) => name !== "");
        }
        // Handle plain {id: name} object maps from the API (e.g. attribute_names: {"5362": "cost_of_goods_sold_amount", ...})
        if (typeof value === "object") {
            return Object.values(value)
                .map((v) => (typeof v === "string" ? v.trim() : String(v || "").trim()))
                .filter((name) => name !== "");
        }
        return [];
    }

    // Returns [{id, name}] pairs from the incident's attribute_names map ({id: name} object)
    // Falls back to names-only entries (with id: null) for other formats.
    getIncidentAttributeEntries = (record) => {
        if (!record || typeof record !== "object") return [];
        // Prefer the raw attribute_names object map from the API
        const rawMap = record.attribute_names ?? record.attributeNames;
        if (rawMap && typeof rawMap === "object" && !Array.isArray(rawMap)) {
            // Deduplicate by name to avoid repeating the same attribute multiple times
            const seen = new Set();
            return Object.entries(rawMap)
                .map(([id, name]) => ({ id: String(id), name: typeof name === "string" ? name.trim() : String(name || "").trim() }))
                .filter(({ name }) => { if (!name || seen.has(name)) return false; seen.add(name); return true; });
        }
        // Fallback: plain name list with no IDs
        return this.getIncidentAttributeNames(record).map((name) => ({ id: null, name }));
    }

    getIncidentAttributeNames = (record) => {
        if (!record || typeof record !== "object") {
            return [];
        }
        const candidates = [
            record.attribute_names,
            record.attributeNames,
            record.attributes,
        ];
        for (const candidate of candidates) {
            const names = this.normalizeAttributeNames(candidate);
            if (names.length) {
                return names;
            }
        }
        return this.normalizeAttributeNames(record.attribute_name);
    }

    formatAttributeCountLabel = (count) => (
        `${count} ${count === 1 ? "Attribute" : "Attributes"}`
    )

    renderHeroAttributePopover = (incident, attributeNames) => (
        <div className="tw-p-3 tw-min-w-[280px]">
            <div className="tw-flex tw-items-center tw-justify-between tw-pb-2 tw-border-0 tw-border-b tw-border-solid tw-border-[#414651]">
                <div className="tw-flex tw-items-center tw-gap-2">
                    <div className="tw-w-8 tw-h-8 tw-rounded-[6px] tw-bg-[#22262F] tw-flex tw-items-center tw-justify-center tw-text-white">
                        <Tag size={16} color="#D4D4D4" />
                    </div>
                    <div className="tw-flex tw-flex-col">
                        <span className="tw-text-sm tw-font-medium tw-text-[#D4D4D4]">
                            {this.formatAttributeCountLabel(attributeNames.length)}
                        </span>
                    </div>
                </div>
            </div>
            <div className="tw-flex tw-flex-col tw-gap-2 tw-pt-2">
                <div>
                    <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">Integration</span>
                    <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full">
                        <Database size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                        <span className="tw-text-sm tw-font-medium">
                            <span className="group-hover:tw-underline">
                                {incident.source?.integration_name || incident.source?.env_name || "—"}
                            </span>
                            {/* <ExternalLink size={12} className="tw-inline-block tw-align-middle tw-ml-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-150" /> */}
                        </span>
                    </a>
                </div>
                <div>
                    <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">Dataset</span>
                    <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenMonitorDataDriftModal(incident); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full">
                        <Layers size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                        <span className="tw-text-sm tw-font-medium">
                            <span className="group-hover:tw-underline">
                                {incident.source?.data_set_name || "—"}
                            </span>
                            <ExternalLink size={12} className="tw-inline-block tw-align-middle tw-ml-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-150 tw-cursor-pointer" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.handleOpenMonitorDataDriftModal(incident); }} />
                        </span>
                    </a>
                </div>
                <div className="tw-pl-4">
                    <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">Attributes</span>
                    {this.getIncidentAttributeEntries(incident).map(({ id, name }, idx) => (
                        <a
                            href="#!"
                            key={`${id ?? name}-${idx}`}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const incidentWithAttr = id
                                    ? { ...incident, source: { ...(incident.source || {}), attribute_id: id, attribute_name: name } }
                                    : incident;
                                this.handleOpenMonitorDataDriftModal(incidentWithAttr);
                            }}
                            className="tw-flex tw-items-start tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-mb-1 tw-group tw-w-full"
                        >
                            <Tag size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                            <span className="tw-text-sm tw-font-medium tw-pl-1">
                                <span className="group-hover:tw-underline">{name}</span>
                                <ExternalLink size={12} className="tw-inline-block tw-align-middle tw-ml-1 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-150 tw-cursor-pointer" onClick={(e) => { e.preventDefault(); e.stopPropagation(); const incidentWithAttr = id ? { ...incident, source: { ...(incident.source || {}), attribute_id: id, attribute_name: name } } : incident; this.handleOpenMonitorDataDriftModal(incidentWithAttr); }} />
                            </span>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )

    renderHeroAttributeLabel = (incident, attributeNames, keySuffix = "") => {
        if (!attributeNames.length) {
            return null;
        }

        const labelText = attributeNames.length > 1
            ? this.formatAttributeCountLabel(attributeNames.length)
            : attributeNames[0];

        return (
            <RcTooltip
                key={`hero-attr-${keySuffix}`}
                placement="top"
                trigger={["hover"]}
                overlayClassName="qd-incident-tooltip"
                overlay={this.renderHeroAttributePopover(incident, attributeNames)}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            >
                <span className="tw-flex tw-items-center tw-min-w-0 tw-flex-1 tw-cursor-default">
                    <span className="tw-mx-1 tw-truncate tw-min-w-0 tw-flex-1">{labelText}</span>
                    <Info className="tw-w-[14px] tw-h-[14px] tw-ml-1 tw-flex-shrink-0" />
                </span>
            </RcTooltip>
        );
    }

    getScoreSeverityBadge = (score, incidentLevel = null, incidentType = null) => {
        if (incidentType === 3 && incidentLevel) {
            switch (incidentLevel) {
                case "Critical":
                    return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#C17F8A] tw-bg-[#781633] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDA4AF] tw-text-xs tw-font-medium"><Flame className="tw-w-4 tw-h-4 tw-me-1" color="#FDA4AF" /> Critical</div>;
                case "Severe":
                    return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#84772C] tw-bg-[#3D140E] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDE047] tw-text-xs tw-font-medium"><OctagonX className="tw-w-4 tw-h-4 tw-me-1" color="#FDE047" /> High</div>;
                case "Warning":
                    return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#846443] tw-bg-[#432010] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDBA74] tw-text-xs tw-font-medium"><TriangleAlert className="tw-w-4 tw-h-4 tw-me-1" color="#FDBA74" /> Warning</div>;
                case "Informational":
                    return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4287AA] tw-bg-[#092B3F] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#7DD3FC] tw-text-xs tw-font-medium"><Info className="tw-w-4 tw-h-4 tw-me-1" color="#7DD3FC" /> Informational</div>;
                default: break;
            }
        }
        if (score >= 0 && score <= 1)
            return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4287AA] tw-bg-[#092B3F] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#7DD3FC] tw-text-xs tw-font-medium"><Info className="tw-w-4 tw-h-4 tw-me-1" color="#7DD3FC" /> Informational</div>;
        if (score > 1 && score <= 1.6)
            return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#846443] tw-bg-[#432010] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDBA74] tw-text-xs tw-font-medium"><TriangleAlert className="tw-w-4 tw-h-4 tw-me-1" color="#FDBA74" /> Warning</div>;
        if (score > 1.6 && score <= 2.3)
            return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#84772C] tw-bg-[#3D140E] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDE047] tw-text-xs tw-font-medium"><OctagonX className="tw-w-4 tw-h-4 tw-me-1" color="#FDE047" /> High</div>;
        if (score > 2.3)
            return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#C17F8A] tw-bg-[#781633] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDA4AF] tw-text-xs tw-font-medium"><Flame className="tw-w-4 tw-h-4 tw-me-1" color="#FDA4AF" /> Critical</div>;
        return <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4B5563] tw-bg-[#1F2937] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#B5B7C8] tw-text-xs tw-font-medium"><Info className="tw-w-4 tw-h-4 tw-me-1" color="#B5B7C8" /> Unknown</div>;
    }

    getRawIncidentNumericValue = (incident) => {
        const yValues = this.getIncidentAxisValues(incident, 'y');
        const latestYValue = Number(yValues[yValues.length - 1]);
        if (Number.isFinite(latestYValue)) {
            return latestYValue;
        }

        const aggregateValue = Number(incident?.kpi_agg_value);
        return Number.isFinite(aggregateValue) ? aggregateValue : 0;
    }

    getIncidentChartData = (incident) => {
        const { xValues: xaxis, yValues: yaxis, zValues: threshold } = this.getIncidentChartSeries(incident);
        const fallbackValue = this.getRawIncidentNumericValue(incident);
        const metricsDetails = (xaxis.length ? xaxis : [incident?.generated_at]).map((_, index) => ({
            metrics_name: incident?.kpi_name || "KPI",
            value: yaxis[index] ?? fallbackValue,
            threshold: threshold[index] ?? ""
        }));

        return {
            xaxis: xaxis.length ? xaxis : [incident?.generated_at || moment().toISOString()],
            yaxis: yaxis.length ? yaxis : [fallbackValue],
            threshold,
            metrics_details: metricsDetails
        };
    }

    getIncidentMetricsData = (incident) => {
        const yValues = this.getIncidentAxisValues(incident, 'y');
        const threshold = this.getIncidentAxisValues(incident, 'z');
        return [{
            metrics_name: incident?.kpi_name || "KPI",
            value: yValues[yValues.length - 1] ?? this.getRawIncidentNumericValue(incident),
            threshold: threshold[threshold.length - 1] ?? ""
        }];
    }

    renderChartActionToolbar = (incident, options = {}) => {
        const {
            wrapperClassName = null,
            timestamp = null,
            useChartWidgetShell = false,
        } = options;
        const isLiked = this.getIncidentInteractionState(incident, 'liked');
        const isIgnored = this.getIncidentInteractionState(incident, 'ignored');
        const isResolved = this.getIncidentInteractionState(incident, 'resolved');
        const isUnread = this.getIncidentInteractionState(incident, 'read');
        const activeFill = '#5898FF';
        const dimFill = 'rgba(255,255,255,0.5)';
        const toolbarControls = (
            <>
                <div className="chart-action-toolbar__left d-none">
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>Fullscreen</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className="chart-action-toolbar__btn" onClick={() => this.handleKpiFullscreen(incident)}>
                            <i>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.72622 7.20266C2.46355 7.20266 2.25 6.98985 2.25 6.72644V4.63109C2.25149 3.31703 3.31703 2.25152 4.63109 2.25H6.90207C7.16473 2.25 7.37829 2.46355 7.37829 2.72622C7.37829 2.98962 7.16473 3.20243 6.90207 3.20243H4.63109C3.8431 3.20392 3.20392 3.84236 3.20243 4.63109V6.72644C3.20243 6.85294 3.15258 6.97423 3.06329 7.06351C2.974 7.15279 2.8527 7.20266 2.72622 7.20266Z" fill={dimFill} />
                                    <path d="M15.2591 7.22317C14.9957 7.22317 14.7828 7.01036 14.7828 6.74695V4.65159C14.7806 3.86361 14.1422 3.22517 13.3542 3.22294H11.0817C10.8183 3.22294 10.6055 3.01013 10.6055 2.74673C10.6055 2.48406 10.8183 2.27051 11.0817 2.27051H13.3542C14.6683 2.27274 15.733 3.33754 15.7353 4.65159V6.74695C15.7353 6.87345 15.6847 6.99474 15.5954 7.08402C15.5061 7.1733 15.3848 7.22317 15.2591 7.22317Z" fill={dimFill} />
                                    <path d="M13.3575 15.7362H11.0924C10.8298 15.7362 10.6162 15.5234 10.6162 15.26C10.6162 14.9973 10.8298 14.7838 11.0924 14.7838H13.3575C14.1455 14.7815 14.7839 14.1431 14.7862 13.3551V11.2731C14.7862 11.0104 14.999 10.7969 15.2624 10.7969C15.525 10.7969 15.7386 11.0104 15.7386 11.2731V13.3684C15.7289 14.6773 14.6664 15.7339 13.3575 15.7362Z" fill={dimFill} />
                                    <path d="M6.91532 15.7362H4.64281C3.32875 15.734 2.264 14.6692 2.26172 13.3551V11.2731C2.26172 11.0104 2.47453 10.7969 2.73794 10.7969C3.0006 10.7969 3.21415 11.0104 3.21415 11.2731V13.3684C3.21639 14.1564 3.85482 14.7949 4.64281 14.7971H6.91532C7.17798 14.7971 7.39153 15.0107 7.39153 15.2733C7.39153 15.536 7.17798 15.7495 6.91532 15.7495V15.7362Z" fill={dimFill} />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                </div>
                <div className="chart-action-toolbar__right">
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>{isLiked ? 'Unlike' : 'Like'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className={`chart-action-toolbar__btn thumb-icon${isLiked ? ' active' : ''}`} onClick={() => this.handleKpiLike(incident)}>
                            <i>
                                <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={isLiked ? activeFill : dimFill}>
                                    <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>{isUnread ? 'Mark Unread' : 'Mark Read'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className={`chart-action-toolbar__btn${isUnread ? ' active' : ''}`} onClick={() => this.handleKpiMarkUnread(incident)}>
                            <i>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.62769 11.1228H9.88307V10.0717H4.62769V11.1228ZM4.62769 9.02067H12.6859V7.96959H4.62769V9.02067ZM4.62769 6.91851H12.3153V6.87542C12.0135 6.78643 11.7418 6.65726 11.5002 6.48792C11.2585 6.31858 11.0474 6.11175 10.8667 5.86744H4.62769V6.91851ZM2 16.23V4.50647C2 4.15249 2.12263 3.85287 2.36788 3.60762C2.61313 3.36237 2.91274 3.23975 3.26672 3.23975H10.3035C10.2658 3.41492 10.2458 3.58899 10.2436 3.76196C10.2414 3.93492 10.2524 4.1112 10.2765 4.29082H3.26672C3.21277 4.29082 3.16337 4.3133 3.11852 4.35827C3.07356 4.40311 3.05108 4.45251 3.05108 4.50647V13.6698L4.03208 12.6994H14.0469C14.1009 12.6994 14.1503 12.677 14.1951 12.632C14.2401 12.5871 14.2626 12.5377 14.2626 12.4838V7.17865C14.4638 7.13369 14.6509 7.07617 14.8238 7.0061C14.9967 6.93603 15.1599 6.84395 15.3136 6.72984V12.4838C15.3136 12.8378 15.191 13.1374 14.9458 13.3826C14.7005 13.6279 14.4009 13.7505 14.0469 13.7505H4.47949L2 16.23ZM3.05108 4.50647V13.1845V4.29082V4.50647ZM13.5618 5.85395C13.0273 5.85395 12.5725 5.66645 12.1975 5.29145C11.8224 4.91633 11.6349 4.4615 11.6349 3.92697C11.6349 3.39244 11.8224 2.93768 12.1975 2.56268C12.5725 2.18756 13.0273 2 13.5618 2C14.0964 2 14.5511 2.18756 14.9261 2.56268C15.3013 2.93768 15.4888 3.39244 15.4888 3.92697C15.4888 4.4615 15.3013 4.91633 14.9261 5.29145C14.5511 5.66645 14.0964 5.85395 13.5618 5.85395Z" fill={isUnread ? activeFill : dimFill} />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>Share</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className="chart-action-toolbar__btn" onClick={() => this.handleKpiShare(incident)}>
                            <i>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.5327 8.24982L11.4894 5.20651C11.3731 5.09013 11.3149 4.95651 11.3149 4.80563C11.3149 4.65463 11.3731 4.52094 11.4894 4.40457C11.6058 4.29594 11.7407 4.24282 11.8941 4.24519C12.0473 4.24769 12.1759 4.30082 12.2797 4.40457L15.6504 7.77526C15.7207 7.84551 15.7702 7.91957 15.7989 7.99744C15.8278 8.07532 15.8422 8.15944 15.8422 8.24982C15.8422 8.34019 15.8278 8.42432 15.7989 8.50219C15.7702 8.58007 15.7207 8.65413 15.6504 8.72438L12.2797 12.0951C12.1634 12.2113 12.0317 12.2676 11.8847 12.2638C11.7376 12.2599 11.6058 12.2037 11.4894 12.0951C11.3731 11.9787 11.3142 11.8458 11.3128 11.6963C11.3113 11.5468 11.3663 11.4162 11.4778 11.3046L14.5327 8.24982ZM10.5519 8.81232H5.4375C4.76437 8.81232 4.18987 9.05032 3.714 9.52632C3.238 10.0022 3 10.5767 3 11.2498V13.3123C3 13.4719 2.94613 13.6056 2.83838 13.7132C2.73075 13.8209 2.59712 13.8748 2.4375 13.8748C2.27787 13.8748 2.14425 13.8209 2.03663 13.7132C1.92888 13.6056 1.875 13.4719 1.875 13.3123V11.2498C1.875 10.2652 2.22262 9.42532 2.91787 8.73019C3.613 8.03494 4.45287 7.68732 5.4375 7.68732H10.5519L8.07112 5.20651C7.95487 5.09013 7.89675 4.95651 7.89675 4.80563C7.89675 4.65463 7.95487 4.52094 8.07112 4.40457C8.1875 4.29594 8.32237 4.24282 8.47575 4.24519C8.62912 4.24769 8.75775 4.30082 8.86162 4.40457L12.2321 7.77526C12.3024 7.84551 12.3519 7.91957 12.3808 7.99744C12.4097 8.07532 12.4241 8.15944 12.4241 8.24982C12.4241 8.34019 12.4097 8.42432 12.3808 8.50219C12.3519 8.58007 12.3024 8.65413 12.2321 8.72438L8.86162 12.0951C8.74525 12.2113 8.6135 12.2676 8.46637 12.2638C8.31925 12.2599 8.1875 12.2037 8.07112 12.0951C7.95487 11.9787 7.896 11.8458 7.8945 11.6963C7.893 11.5468 7.94806 11.4162 8.05969 11.3046L10.5519 8.81232Z" fill={dimFill} />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>{isIgnored ? 'Unignore' : 'Ignore'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className={`chart-action-toolbar__btn${isIgnored ? ' active' : ''}`} onClick={() => this.handleKpiIgnore(incident)}>
                            <i>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.8525 16.4567L13.1607 14.7649C12.5627 15.1985 11.9132 15.5336 11.2122 15.7703C10.5112 16.0068 9.77366 16.125 8.99966 16.125C8.01403 16.125 7.08778 15.9379 6.22091 15.5638C5.35403 15.1898 4.59997 14.6822 3.95872 14.0409C3.31747 13.3997 2.80984 12.6456 2.43584 11.7788C2.06172 10.9119 1.87466 9.98563 1.87466 9C1.87466 8.226 1.99291 7.4885 2.22941 6.7875C2.46603 6.0865 2.80116 5.437 3.23478 4.839L1.54297 3.14719L2.34491 2.34525L15.6544 15.6548L14.8525 16.4567ZM8.99966 15C9.61403 15 10.202 14.9096 10.7637 14.7289C11.3252 14.5481 11.853 14.289 12.3473 13.9515L4.04816 5.65238C3.71066 6.14663 3.45153 6.6745 3.27078 7.236C3.09003 7.79762 2.99966 8.38563 2.99966 9C2.99966 10.6625 3.58403 12.0781 4.75278 13.2469C5.92153 14.4156 7.33716 15 8.99966 15ZM14.988 12.8653L14.1675 12.0446C14.4425 11.5793 14.65 11.0923 14.7898 10.5836C14.9297 10.075 14.9997 9.54713 14.9997 9C14.9997 7.3375 14.4153 5.92188 13.2465 4.75313C12.0778 3.58438 10.6622 3 8.99966 3C8.45253 3 7.92466 3.06994 7.41603 3.20981C6.90741 3.34969 6.42041 3.55713 5.95503 3.83213L5.13434 3.01162C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 8.99966 1.875C9.98528 1.875 10.9115 2.06206 11.7784 2.43619C12.6453 2.81019 13.3993 3.31781 14.0406 3.95906C14.6818 4.60031 15.1895 5.35437 15.5635 6.22125C15.9376 7.08812 16.1247 8.01438 16.1247 9C16.1247 9.70675 16.0271 10.3845 15.832 11.0333C15.6367 11.6819 15.3554 12.2926 14.988 12.8653Z" fill={isIgnored ? activeFill : dimFill} />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                    <RcTooltip trigger={["hover"]} placement="top" overlay={<span>{isResolved ? 'Unresolve' : 'Resolve'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                        <div className={`chart-action-toolbar__btn${isResolved ? ' active' : ''}`} onClick={() => this.handleKpiResolve(incident)}>
                            <i>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.625 13.0958L15.4817 9.23909C15.5856 9.13522 15.7161 9.08209 15.8734 9.07972C16.0305 9.07734 16.1634 9.13047 16.2722 9.23909C16.3808 9.34772 16.4351 9.47947 16.4351 9.63434C16.4351 9.78909 16.3808 9.92078 16.2722 10.0294L12.0996 14.202C11.9639 14.3377 11.8058 14.4055 11.625 14.4055C11.4443 14.4055 11.2861 14.3377 11.1504 14.202L9.09225 12.1438C8.9885 12.04 8.93538 11.9095 8.93288 11.7523C8.9305 11.5951 8.98363 11.4622 9.09225 11.3535C9.201 11.2449 9.33275 11.1906 9.4875 11.1906C9.64225 11.1906 9.774 11.2449 9.88275 11.3535L11.625 13.0958ZM3.98081 15.3747C3.60794 15.3747 3.28875 15.2419 3.02325 14.9764C2.75775 14.7109 2.625 14.3917 2.625 14.0188V3.98047C2.625 3.60759 2.75775 3.28841 3.02325 3.02291C3.28875 2.75741 3.60794 2.62466 3.98081 2.62466H7.28513C7.389 2.25928 7.60125 1.95641 7.92188 1.71603C8.2425 1.47566 8.60188 1.35547 9 1.35547C9.4135 1.35547 9.77863 1.47566 10.0954 1.71603C10.4123 1.95641 10.6226 2.25928 10.7265 2.62466H14.0192C14.3921 2.62466 14.7113 2.75741 14.9768 3.02291C15.2423 3.28841 15.375 3.60759 15.375 3.98047V6.93716C15.375 7.09653 15.3211 7.23016 15.2132 7.33803C15.1053 7.44578 14.9717 7.49966 14.8123 7.49966C14.6528 7.49966 14.5192 7.44578 14.4116 7.33803C14.3039 7.23016 14.25 7.09653 14.25 6.93716V3.98047C14.25 3.92272 14.2259 3.86984 14.1778 3.82184C14.1298 3.77372 14.0769 3.74966 14.0192 3.74966H12.375V5.03328C12.375 5.22541 12.3103 5.38641 12.1809 5.51628C12.0516 5.64616 11.8913 5.71109 11.7 5.71109H6.29981C6.10856 5.71109 5.94831 5.64616 5.81906 5.51628C5.68969 5.38641 5.625 5.22541 5.625 5.03328V3.74966H3.98081C3.92306 3.74966 3.87019 3.77372 3.82219 3.82184C3.77406 3.86984 3.75 3.92272 3.75 3.98047V14.0188C3.75 14.0766 3.77406 14.1295 3.82219 14.1775C3.87019 14.2256 3.92306 14.2497 3.98081 14.2497H7.6875C7.84688 14.2497 7.9805 14.3036 8.08838 14.4115C8.19613 14.5193 8.25 14.653 8.25 14.8123C8.25 14.9718 8.19613 15.1054 8.08838 15.213C7.9805 15.3208 7.84688 15.3747 7.6875 15.3747H3.98081ZM9.00131 3.83628C9.19369 3.83628 9.35456 3.77116 9.48394 3.64091C9.61319 3.51078 9.67781 3.34947 9.67781 3.15697C9.67781 2.96459 9.61275 2.80372 9.48263 2.67434C9.3525 2.54509 9.19119 2.48047 8.99869 2.48047C8.80631 2.48047 8.64544 2.54553 8.51606 2.67566C8.38681 2.80591 8.32219 2.96722 8.32219 3.15959C8.32219 3.35197 8.38725 3.51284 8.51738 3.64222C8.6475 3.77159 8.80881 3.83628 9.00131 3.83628Z" fill={isResolved ? activeFill : dimFill} />
                                </svg>
                            </i>
                        </div>
                    </RcTooltip>
                </div>
            </>
        );

        if (useChartWidgetShell) {
            return (
                <div className="chart-widget__toolbar">
                    <div className="chart-action-toolbar">
                        {toolbarControls}
                    </div>
                </div>
            );
        }

        const collapseContainer = options.disableCollapse ? (
            <div className="tw-relative tw-flex tw-items-center tw-bg-transparent tw-z-[1]">
                {toolbarControls}
            </div>
        ) : (
            <div className="tw-absolute tw-flex tw-items-center tw-bg-[#161a2d] tw-z-[1] tw-w-[100px] tw-overflow-hidden tw-transition-all tw-duration-200 tw-group hover:tw-w-[200px] hover:tw-overflow-visible">
                {toolbarControls}
                <span className="tw-absolute tw-right-0 tw-w-[20px] tw-h-[20px] tw-flex tw-items-center tw-justify-center group-hover:tw-hidden" style={{ background: 'linear-gradient(270deg, #161A2C 60%, rgba(22, 26, 44, 0) 100%)' }}>
                    <svg width="8" height="21" viewBox="0 0 8 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.916626 20.1586V1.24194C0.916626 1.06486 0.976557 0.916457 1.09642 0.796735C1.21628 0.676874 1.36475 0.616943 1.54183 0.616943C1.71906 0.616943 1.86746 0.676874 1.98704 0.796735C2.10677 0.916457 2.16663 1.06486 2.16663 1.24194V20.1586C2.16663 20.3357 2.1067 20.4841 1.98683 20.6038C1.86697 20.7237 1.7185 20.7836 1.54142 20.7836C1.3642 20.7836 1.21579 20.7237 1.09621 20.6038C0.976487 20.4841 0.916626 20.3357 0.916626 20.1586ZM3.9935 13.3782V8.03048C3.9935 7.8516 4.07017 7.73021 4.2235 7.66632C4.37683 7.60243 4.51496 7.63458 4.63788 7.76278L7.016 10.173C7.16128 10.3237 7.23392 10.4994 7.23392 10.7003C7.23392 10.9011 7.16128 11.0769 7.016 11.2276L4.63788 13.6378C4.51496 13.766 4.37683 13.7987 4.2235 13.7359C4.07017 13.6731 3.9935 13.5539 3.9935 13.3782Z" fill="white" fill-opacity="0.65" />
                    </svg>
                </span>
            </div>
        );

        const toolbarBody = (
            <>
                {collapseContainer}
                <div className="tw-relative tw-ml-auto tw-whitespace-nowrap">
                    <span className={timestamp ? 'tw-text-xs tw-text-[#94979C]' : 'tw-text-xs tw-text-[#94979C] / 75'}>
                        {'UTC+00:00 '}<small>in 24 Hours</small>
                    </span>
                </div>
            </>
        );

        if (wrapperClassName) {
            return <div className={wrapperClassName}>{toolbarBody}</div>;
        }

        return toolbarBody;
    }

    renderVerticalLikeButton = (incident) => {
        const liked = this.getIncidentInteractionState(incident, 'liked');
        return (
            <RcTooltip trigger={["hover"]}
                placement="top"
                overlay={<span>{liked ? "Unlike" : "Like"}</span>}
                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
            >
                <button
                    type="button"
                    className="chart-action-toolbar__btn tw-border-0 tw-bg-transparent"
                    onClick={() => this.handleVerticalInteraction(incident)}
                >
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill={liked ? "#FF505D" : "rgba(255,255,255,0.5)"}>
                            <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                        </svg>
                    </i>
                </button>
            </RcTooltip>
        );
    }

    renderVerticalHeroCarousel = () => {
        const incidents = this.state.verticalHeroIncidents;
        if (!incidents.length) {
            return null;
        }

        const currentIdx = this.state.heroCarouselIndex || 0;
        const isFirstSlide = currentIdx === 0;
        const isLastSlide = currentIdx >= incidents.length - 1;

        return (
            <div className="position-relative">
                <Slider
                    ref={slider => { this.heroSliderRef = slider; }}
                    speed={300}
                    infinite={false}
                    slidesToShow={1}
                    slidesToScroll={1}
                    centerMode={false}
                    variableWidth={false}
                    arrows={incidents.length > 1}
                    dots={false}
                    autoplay={false}
                    autoplaySpeed={3000}
                    beforeChange={this.handleHeroBeforeChange}
                    afterChange={this.handleHeroAfterChange}
                    cssEase="cubic-bezier(0.25, 1, 0.5, 1)"
                    touchThreshold={25}
                    swipeToSlide={true}
                    waitForAnimate={false}
                    className="qd-incidents-slider slick-slider--action-center qd-incidents-hero-slick tw-pb-[80px] tw-cursor-grab active:tw-cursor-grabbing"
                >
                {incidents.map((incident, index) => {
                    const heroTitle = incident?.title || incident?.kpi_name || "KPI Incident";
                    const kpiTitle = incident?.kpi_name;
                    
                    const heroUnits = this.getChartDisplayUnits(incident);
                    const heroRawValue = this.getIncidentRawValue(incident);
                    const heroTrendText = this.getTrendText(incident);
                    const heroIncidentKey = String(incident?.kpi_incident_id ?? incident?.kpi_id ?? incident?.id ?? `hero_${index}`);
                    const heroSubject = incident?.subject_name || incident?.source?.subject_area_name || "Subject Area";
                    const heroBusinessArea = incident?.business_area || incident?.source?.subject_area_name || "BusinessArea";

                    const description = incident?.description
                        || incident?.kpi_description
                        || `Operational analysis covering ${heroTitle.toLowerCase()}.`;
                    const heroGeneratedAt = this.getIncidentDate(incident?.generated_at);
                    const { xValues: heroXValues, yValues: heroYValues, zValues: heroZValues, compareIndex: heroCompareIndex, driftValues: heroDriftValues, previousAvgValues: heroPreviousAvgValues } = this.getIncidentChartSeries(incident);
                    const heroIncidentId = incident?.kpi_incident_id ?? index;
                    const effectiveChartType = this.resolveHeroChartTypeForKey(heroIncidentId, 'main');
                    const attribute_names = this.getIncidentAttributeNames(incident);
                    const heroBannerChartHeight = this.getHeroBannerChartHeight(incident.associated_kpis);
                    const hasHeroAssociatedCarousel = this.shouldShowHeroAssociatedCarousel(incident.associated_kpis);

                    return (
                        <div key={incident.kpi_incident_id || index} className="!tw-flex tw-flex-col">
                            <FadeUpOnScroll delay={0} enabled={index === 0}>
                                <div className="tw-text-center tw-px-[24px] md:tw-px-[48px]">
                                    <h1 className="qd-incidents-hero__headline tw-justify-center tw-cursor-text tw-select-text">{index+1}.{heroTitle}</h1>
                                </div>
                            </FadeUpOnScroll>
                            <div className="!tw-flex tw-flex-col tw-px-[24px] md:tw-px-[80px] xl:tw-px-[90px] 2xl:tw-px-[150px]">
                                <FadeUpOnScroll delay={0.2} enabled={index === 0}>
                                    <div className="tw-flex tw-items-center tw-px-6 tw-pt-4 tw-pb-4 xl:tw-px-[100px] 2xl:tw-px-[150px] 2xl:tw-pt-3 2xl:tw-pb-5 tw-relative">
                                        {incidents.length > 1 && (
                                            <>
                                                <button
                                                    type="button"
                                                    disabled={isFirstSlide}
                                                    className={`qd-incidents-hero__top-arrow qd-incidents-hero__top-arrow--prev ${isFirstSlide ? 'disabled slick-disabled' : ''}`}
                                                    onClick={() => this.heroSliderRef && this.heroSliderRef.slickPrev()}
                                                    aria-label="Previous incident"
                                                />
                                                <button
                                                    type="button"
                                                    disabled={isLastSlide}
                                                    className={`qd-incidents-hero__top-arrow qd-incidents-hero__top-arrow--next ${isLastSlide ? 'disabled slick-disabled' : ''}`}
                                                    onClick={() => this.heroSliderRef && this.heroSliderRef.slickNext()}
                                                    aria-label="Next incident"
                                                />
                                            </>
                                        )}
                                        <div className="tw-mr-6 2xl:tw-mr-8">
                                    {this.renderMetricValueWithUnits(
                                        heroRawValue,
                                        heroUnits,
                                        "tw-text-[24px] md:tw-text-[32px] xl:tw-text-[40px] 2xl:tw-text-[52px] tw-font-semibold tw-leading-[40px] md:tw-leading-[50px] xl:tw-leading-[58px] 2xl:tw-leading-[60px] tw-text-white tw-mb-[6px] tw-tracking-[-1px]",
                                        1,
                                        "—",
                                        "h4",
                                        true
                                    )}
                                            <p className="tw-text-[#94979C] tw-text-sm tw-m-0 tw-flex tw-items-center tw-whitespace-nowrap">
                                                <span className="tw-flex tw-items-center tw-mr-2">
                                                    {this.renderTrendBadge(incident, heroTrendText, 16)}
                                                </span>
                                                {this.getPeriodLabel(incident?.period_type)}
                                            </p>
                                        </div>
                                        <div className="tw-flex tw-flex-col tw-pr-6 2xl:tw-pr-8 tw-flex-grow">
                                            <div className="tw-flex tw-items-center tw-gap-[12px] tw-pb-2">
                                                <div className="d-none tw-flex tw-items-center tw-gap-[6px] tw-text-[#CCCCCC] tw-text-base md:text-[20px] tw-text-[24px] tw-font-medium">
                                                <i>
                                                        <Building size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                                    </i>
                                                    {incident.source?.business_area_name}
                                                </div>

                                                <div className="tw-inline-flex tw-items-center tw-gap-[6px] tw-text-[#F64E60]">
                                                    <i>
                                                        <svg className='tw-block tw-flex-shrink-0 tw-w-[20px] tw-h-[20px] 2xl:tw-w-[24px] 2xl:tw-h-[24px]' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                                                            <g>
                                                                <path d="M9.43582 5.9987C9.26448 5.9987 9.12137 5.9412 9.00648 5.8262C8.89148 5.71131 8.83398 5.56692 8.83398 5.39303V2.93786C8.83398 2.76386 8.89193 2.61942 9.00782 2.50453C9.12371 2.38953 9.26726 2.33203 9.43848 2.33203H13.0655C13.2368 2.33203 13.3799 2.38953 13.4948 2.50453C13.6098 2.61942 13.6673 2.76386 13.6673 2.93786V5.39303C13.6673 5.56692 13.6094 5.71131 13.4935 5.8262C13.3776 5.9412 13.234 5.9987 13.0628 5.9987H9.43582ZM2.93582 8.33203C2.76448 8.33203 2.62137 8.27453 2.50648 8.15953C2.39148 8.04453 2.33398 7.90203 2.33398 7.73203V2.93186C2.33398 2.76186 2.39193 2.61942 2.50782 2.50453C2.62371 2.38953 2.76726 2.33203 2.93848 2.33203H6.56548C6.73682 2.33203 6.87993 2.38953 6.99482 2.50453C7.10982 2.61953 7.16732 2.76203 7.16732 2.93203V7.7322C7.16732 7.9022 7.10937 8.04464 6.99348 8.15953C6.8776 8.27453 6.73404 8.33203 6.56282 8.33203H2.93582ZM9.43582 13.6654C9.26448 13.6654 9.12137 13.6079 9.00648 13.4929C8.89148 13.3779 8.83398 13.2354 8.83398 13.0654V8.2652C8.83398 8.0952 8.89193 7.95275 9.00782 7.83786C9.12371 7.72286 9.26726 7.66536 9.43848 7.66536H13.0655C13.2368 7.66536 13.3799 7.72286 13.4948 7.83786C13.6098 7.95286 13.6673 8.09536 13.6673 8.26536V13.0655C13.6673 13.2355 13.6094 13.378 13.4935 13.4929C13.3776 13.6079 13.234 13.6654 13.0628 13.6654H9.43582ZM2.93582 13.6654C2.76448 13.6654 2.62137 13.6079 2.50648 13.4929C2.39148 13.378 2.33398 13.2335 2.33398 13.0595V10.6044C2.33398 10.4305 2.39193 10.2861 2.50782 10.1712C2.62371 10.0562 2.76726 9.9987 2.93848 9.9987H6.56548C6.73682 9.9987 6.87993 10.0562 6.99482 10.1712C7.10982 10.2861 7.16732 10.4305 7.16732 10.6044V13.0595C7.16732 13.2335 7.10937 13.378 6.99348 13.4929C6.8776 13.6079 6.73404 13.6654 6.56282 13.6654H2.93582Z" fill="currentColor" />
                                                            </g>
                                                        </svg>
                                                    </i>
                                                    <span className="tw-text-[20px] 2xl:tw-text-[24px] tw-font-medium">
                                                        {incident.source?.business_area_name}
                                                    </span>
                                                </div>

                                                <div className="tw-inline-flex tw-items-center tw-rounded-[8px] tw-border tw-border-solid tw-border-[#E9EAEB]/25 tw-py-[3px] tw-px-2">
                                                    <i>
                                                        <svg className="tw-block" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g opacity="0.75">
                                                                <path d="M4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H8.925C9.14033 5 9.34967 5.04358 9.553 5.13075C9.75617 5.21792 9.93017 5.33392 10.075 5.47875L11.5963 7H19.3845C19.8448 7 20.2292 7.15417 20.5375 7.4625C20.8458 7.77083 21 8.15517 21 8.6155V17.3845C21 17.8448 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8448 19 19.3845 19H4.6155Z" fill="#007BFF" />
                                                            </g>
                                                        </svg>
                                                    </i>
                                                    <span className="tw-text-sm tw-text-[#CCCCCC] tw-font-medium tw-px-1">
                                                        {heroSubject}
                                                    </span>
                                                    <RcTooltip trigger={["hover"]}
                                                        placement="top"
                                                        overlayClassName="qd-incident-tooltip"
                                                        overlay={
                                                            <div className="tw-p-3 tw-min-w-[280px]">
                                                                <div className="tw-flex tw-flex-col tw-gap-2">
                                                                    <div>
                                                                        <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">BUSSINESS</span>
                                                                        {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(incident, "BusinessArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                                                        <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 

                                                                            <Building size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                                                            <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                                                                {incident.source?.business_area_name}
                                                                                {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                                                                </svg> */}
                                                                            </span>
                                                                        {/* </a> */}
                                                                        </a>
                                                                    </div>
                                                                    <div>
                                                                        <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">FUNCTION</span>
                                                                        {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(incident, "SubjectArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                                                        <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 

                                                                            <FolderClosed size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                                                            <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                                                                {incident.source?.subject_area_name}
                                                                                {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                                                                </svg> */}
                                                                            </span>
                                                                            </a>
                                                                        {/* </a> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                    >
                                                        <i className="tw-cursor-pointer tw-w-[18px] tw-h-[18px] tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white/15">
                                                            <svg className="tw-block" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clipPath={`url(#clip_hero_info_${heroIncidentId})`}>
                                                                    <path d="M6.99999 9.33329V6.99996M6.99999 4.66663H7.00582M12.8333 6.99996C12.8333 10.2216 10.2217 12.8333 6.99999 12.8333C3.77833 12.8333 1.16666 10.2216 1.16666 6.99996C1.16666 3.7783 3.77833 1.16663 6.99999 1.16663C10.2217 1.16663 12.8333 3.7783 12.8333 6.99996Z" stroke="white" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id={`clip_hero_info_${heroIncidentId}`}>
                                                                        <rect width="14" height="14" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </i>
                                                    </RcTooltip>
                                                </div>
                                            </div>
                                            <p className="tw-text[18px] tw-text-[#D5D7DA] tw-m-0 tw-cursor-text tw-select-text">
                                                {formatHeroDescription(description)}
                                            </p>
                                        </div>
                                        <RcTooltip trigger={["hover"]}
                                            placement="top"
                                            overlay={
                                                <span>View in Monitor</span>
                                            }
                                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                        >
                                        <a href="#!" onClick={(e) => { e.preventDefault(); this.handleOpenMonitorDataDriftModal(incident, "KPI"); }} className="tw-w-[72px] tw-h-[72px] tw-rounded-full tw-bg-[#FAFAFA]/10 hover:tw-bg-[#FAFAFA]/20 focus:tw-bg-[#FAFAFA]/25 active:tw-bg-[#FAFAFA]/25 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-cursor-pointer tw-transition tw-duration-100 tw-group">
                                            <svg className="tw-transition tw-duration-100 tw-transform group-hover:tw-scale-105" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g opacity="0.75">
                                                    <path opacity="0.5" d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="#F7F7F7" />
                                                </g>
                                            </svg>
                                        </a>
                                        </RcTooltip>
                                    </div>
                                </FadeUpOnScroll>
                                <FadeUpOnScroll delay={0.4} enabled={index === 0} className="tw-flex tw-flex-col">
                                    <div className="tw-relative tw-h-full tw-flex tw-flex-col tw-flex-grow">
                                        <div className={`tw-w-full tw-flex tw-flex-col tw-flex-grow tw-p-5 tw-rounded-[24px] tw-bg-[#14113A]/50 tw-border tw-border-[#6243FF]/30 tw-mb-1 tw-relative tw-transform tw-transition-transform tw-duration-200 tw-ease-out hover:tw-z-[1]${hasHeroAssociatedCarousel ? '' : ' tw-flex-1'}`} style={{ transform: 'scale(1)', transition: 'transform 0.3s ease-out', width: '100%' }} onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.01)')} onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}>
                                            {Array.isArray(incident.associated_kpis) && incident.associated_kpis.length > 0 && (
                                            <div className="tw-flex tw-items-stretch tw-gap-[24px] tw-mb-6 tw-hidden">
                                                {incident.associated_kpis.map((assocKpi, assocIdx) => {
                                                    const inlineCardId = `${heroIncidentKey}_inline_${assocIdx}`;
                                                    const isHighlighted = assocIdx === 0;
                                                    const cardBg = isHighlighted
                                                        ? "tw-bg-[linear-gradient(134.15deg,rgba(208,198,255,0.75)_-56.93%,rgba(117,69,255,0.75)_78.2%)]"
                                                        : "tw-bg-[#0C0E12]";
                                                    const linkTextColor = isHighlighted ? "tw-text-white" : "tw-text-[#CCCCCC]";
                                                    const assocUnits = this.getChartDisplayUnits(assocKpi);
                                                    const assocTrendValue = this.formatDriftDisplayValue(assocKpi.trends_value, "0");
                                                    const { xValues: assocXValues, yValues: assocYValues, zValues: assocZValues, compareIndex: assocCompareIndex, driftValues: assocDriftValues, previousAvgValues: assocPreviousAvgValues } = this.getIncidentChartSeries(assocKpi);
                                                    return (
                                                    <div key={assocIdx} className={`${cardBg} tw-rounded-[12px] tw-p-5 tw-flex-grow tw-flex tw-flex-col tw-justify-between`}>
                                                    <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
                                                        <a href="#!" onClick={(e) => { e.preventDefault(); this.redirectToAssociatedKpi(assocKpi, incident); }} className={`tw-flex tw-items-center tw-text-sm ${linkTextColor} tw-font-medium hover:tw-text-white hover:tw-no-underline tw-group`}>
                                                            <KpiIcon size={16} color={isHighlighted ? "#ffffff" : "#B5B5C3"} className="tw-mr-1.5 tw-shrink-0" />
                                                            <span>{assocKpi.kpi_name}</span>
                                                            <i className="tw-ml-[6px]">
                                                                <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="18" height="18" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g>
                                                                        <path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" />
                                                                    </g>
                                                                </svg>
                                                            </i>
                                                        </a>
                                                        <div className="tw-flex">
                                                            <div className="tw-relative tw-inline-block">
                                                                {this.renderHeroChartTypeDropdown(inlineCardId, 'grid')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tw-flex tw-items-end tw-justify-between tw-mt-auto">
                                                        <div className="tw-w-1/2">
                                                            {this.renderMetricValueWithUnits(
                                                                assocKpi.kpi_agg_value,
                                                                assocUnits,
                                                                "tw-block tw-text-[20px] md:tw-text-[28px] xl:tw-text-[32px] 2xl:tw-text-[36px] tw-leading-tight tw-text-[#F7F7F7] tw-font-semibold tw-mb-[6px]",
                                                                2
                                                            )}
                                                            <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-flex-col tw-items-start tw-mb-0">
                                                                <span className="tw-flex tw-items-center tw-mr-2">
                                                                    {this.renderTrendBadge(assocKpi, assocTrendValue, 16)}
                                                                    <span className="tw-text-[#94979C] tw-text-xs tw-pl-2">{this.getPeriodLabel(assocKpi?.period_type)}</span>
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <div className="tw-w-1/2 tw-min-w-0 tw-relative tw-z-[50]" style={{ height: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px` }}>
                                                            <VerticalChart xValues={assocXValues} yValues={assocYValues} zValues={assocZValues} compareIndex={assocCompareIndex} driftValues={assocDriftValues} previousAvgValues={assocPreviousAvgValues} type={this.resolveHeroChartTypeForKey(inlineCardId, 'grid')} units={this.getChartDisplayUnits(assocKpi)} height={VERTICAL_CHART_HEIGHT.HERO_KPI_CARD} axisFontSize={VERTICAL_CHART_AXIS_FONT.HERO_KPI_CARD} heroBarLayout={true} />
                                                        </div>
                                                    </div>
                                                </div>
                                                    ); })}
                                            </div>
                                            )}
                                                <div className="tw-bg-[#0A0824] tw-rounded-[12px] tw-p-5 tw-pb-[64px] tw-relative tw-flex tw-flex-col tw-flex-grow">
                                                <div className="tw-mb-4">
                                                    <div class="tw-flex tw-items-center tw-justify-between tw-mb-[6px]">
                                                        <a href="#!" onClick={(e) => { e.preventDefault(); this.redirectToVerticalDasboard(incident, "KPI"); }} className=" tw-flex tw-items-center tw-text-[24px] tw-text-[#CCCCCC] tw-font-semibold hover:tw-text-white hover:tw-no-underline tw-group">
                                                            <KpiIcon size={22} color="#B5B5C3" className="tw-mr-1.5 tw-shrink-0" />
                                                            <span>{kpiTitle}</span>
                                                    <RcTooltip trigger={["hover"]}
                                                        placement="top"
                                                        overlay={
                                                            <span>View in Monitor</span>
                                                        }
                                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                    >
                                                            <i className="tw-ml-[6px]">
                                                                <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <g>
                                                                        <path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" />
                                                                    </g>
                                                                </svg>
                                                        </i>
                                                        </RcTooltip>
                                                        </a>
                                                        <div className="tw-flex tw-items-center">
                                                            <button
                                                                style={{
                                                                    background: 'linear-gradient(#0A0824, #0A0824) padding-box, linear-gradient(45.22deg, #446EFF 14.68%, #2E96FF 40.83%, #B1C5FF 73.34%) border-box',
                                                                    border: '1px solid transparent'
                                                                }}
                                                                className="tw-rounded-full !tw-p-0 tw-shadow-[0px_1px_2px_0px_var(--ColorsEffectsShadowsshadow-xs),0px_-2px_0px_0px_var(--ColorsEffectsShadowsshadow-skeumorphic-inner)_inset,0px_0px_0px_1px_var(--ColorsEffectsShadowsshadow-skeumorphic-inner-border)_inset] tw-text-[#E2EAFE] tw-text-sm tw-font-medium tw-inline-flex tw-items-center tw-gap-[6px] tw-cursor-pointer tw-mr-[8px] tw-transition-all tw-duration-300 tw-outline-none"
                                                                onClick={() => this.handleAiInsightsToggle(incident, heroIncidentId)}
                                                            >
                                                                <div className="tw-flex tw-items-center tw-gap-[8px] tw-bg-[#23213A] tw-py-[6px] tw-pr-[12px] tw-pl-[8px] tw-rounded-full">
                                                                    <Image className="!tw-w-[20px] !tw-h-[20px] tw-flex-shrink-0" src={"icon_ai_assistant"} />
                                                                    <span className="tw-flex-shrink-0">AI Insights</span>
                                                                </div>
                                                            </button>
                                                            <div className="tw-relative tw-inline-block">
                                                                {this.renderHeroChartTypeDropdown(heroIncidentId, 'main')}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tw-flex tw-items-center">
                                                        <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-items-center tw-pr-6 tw-mb-0">
                                                            <span className="tw-flex tw-items-center tw-mr-2">
                                                                {this.renderTrendBadge(incident, heroTrendText, 16)}
                                                            </span>
                                                            {this.getPeriodLabel(incident?.period_type)}
                                                        </p>
                                                        <div className="tw-flex tw-items-center tw-pr-4">
                                                            {incident.source?.data_set_name && (
                                                                <>
                                                                    <i className="tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-text-[#94979C]">
                                                                        <FontAwesomeIcon className="tw-block" icon={faLayerGroup} />
                                                                    </i>
                                                                    <span className="tw-text-sm tw-text-[#CCCCCC] tw-font-medium tw-truncate tw-max-w-[180px]">
                                                                        {incident.source.data_set_name}
                                                                    </span>
                                                                    <i className="tw-flex tw-items-center tw-justify-center tw-mx-1">
                                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M6 12L10 8L6 4" stroke="#6A7894" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                                                        </svg>
                                                                    </i>
                                                                </>
                                                            )}
                                                            {attribute_names.length > 0 && (
                                                            <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(incident, "Attribute"); }} className="tw-flex tw-items-center tw-text-sm tw-text-[#CCCCCC] tw-font-medium hover:tw-text-white hover:tw-no-underline tw-group tw-min-w-0">
                                                                <i className="tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                                                    <FontAwesomeIcon className="tw-block" icon={faTag} />
                                                                </i>
                                                                {this.renderHeroAttributeLabel(incident, attribute_names, heroIncidentId)}
                                                            </a>
                                                            )}
                                                        </div>
                                                        <div className="d-none tw-inline-flex tw-items-center tw-rounded-[999px] tw-border tw-bg-[#000000]/20 tw-border-white/5 tw-py-1 tw-px-[10px]">
                                                            <i>
                                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.85"><path d="M9.43484 6.46745C9.26351 6.46745 9.1204 6.40995 9.00551 6.29495C8.89051 6.18006 8.83301 6.03567 8.83301 5.86178V3.40661C8.83301 3.23261 8.89095 3.08817 9.00684 2.97328C9.12273 2.85828 9.26629 2.80078 9.43751 2.80078H13.0645C13.2358 2.80078 13.379 2.85828 13.4938 2.97328C13.6088 3.08817 13.6663 3.23261 13.6663 3.40661V5.86178C13.6663 6.03567 13.6084 6.18006 13.4925 6.29495C13.3766 6.40995 13.2331 6.46745 13.0618 6.46745H9.43484ZM2.93484 8.80078C2.76351 8.80078 2.6204 8.74328 2.50551 8.62828C2.39051 8.51328 2.33301 8.37078 2.33301 8.20078V3.40061C2.33301 3.23061 2.39095 3.08817 2.50684 2.97328C2.62273 2.85828 2.76629 2.80078 2.93751 2.80078H6.56451C6.73584 2.80078 6.87895 2.85828 6.99384 2.97328C7.10884 3.08828 7.16634 3.23078 7.16634 3.40078V8.20095C7.16634 8.37095 7.1084 8.51339 6.99251 8.62828C6.87662 8.74328 6.73306 8.80078 6.56184 8.80078H2.93484ZM9.43484 14.1341C9.26351 14.1341 9.1204 14.0766 9.00551 13.9616C8.89051 13.8466 8.83301 13.7041 8.83301 13.5341V8.73395C8.83301 8.56395 8.89095 8.4215 9.00684 8.30661C9.12273 8.19161 9.26629 8.13411 9.43751 8.13411H13.0645C13.2358 8.13411 13.379 8.19161 13.4938 8.30661C13.6088 8.42161 13.6663 8.56411 13.6663 8.73411V13.5343C13.6663 13.7043 13.6084 13.8467 13.4925 13.9616C13.3766 14.0766 13.2331 14.1341 13.0618 14.1341H9.43484ZM2.93484 14.1341C2.76351 14.1341 2.6204 14.0766 2.50551 13.9616C2.39051 13.8467 2.33301 13.7023 2.33301 13.5283V11.0731C2.33301 10.8992 2.39095 10.7548 2.50684 10.6399C2.62273 10.5249 2.76629 10.4674 2.93751 10.4674H6.56451C6.73584 10.4674 6.87895 10.5249 6.99384 10.6399C7.10884 10.7548 7.16634 10.8992 7.16634 11.0731V13.5283C7.16634 13.7023 7.1084 13.8467 6.99251 13.9616C6.87662 14.0766 6.73306 14.1341 6.56184 14.1341H2.93484Z" fill="#4B5675"></path></g></svg>
                                                            </i>
                                                            <span className="tw-text-sm tw-text-[#AAAAAA] tw-font-medium tw-px-1">
                                                            {heroBusinessArea}
                                                            </span>
                                                            <RcTooltip trigger={["hover"]}
                                                                placement="top"
                                                                overlayClassName="qd-incident-tooltip"
                                                                overlay={
                                                                    <div className="tw-p-3 tw-min-w-[280px]">
                                                                        <div className="tw-flex tw-flex-col tw-gap-2">
                                                                            <div>
                                                                                <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">BUSSINESS</span>
                                                                                {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(incident, "BusinessArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                                                                <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 

                                                                                    <Building size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                                                                    <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                                                                        {incident.source?.integration_name || "PRESENTATION_FACT"}
                                                                                        {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                                                                        </svg> */}
                                                                                    </span>
                                                                                {/* </a> */}
                                                                                </a>
                                                                            </div>
                                                                            <div>
                                                                                <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">FUNCTION</span>
                                                                                {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(incident, "SubjectArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                                                                <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 

                                                                                    <FolderClosed size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                                                                    <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                                                                        {incident.source?.data_set_name || "T_FACT_ECOMMERCE_BILLING"}
                                                                                        {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                                                                        </svg> */}
                                                                                    </span>
                                                                                    </a>
                                                                                {/* </a> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                            >
                                                                <i className="tw-cursor-pointer tw-w-[18px] tw-h-[18px] tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white/15">
                                                                    <svg className="tw-block" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g clip-path="url(#clip0_24454_51970)">
                                                                            <path d="M6.99999 9.33329V6.99996M6.99999 4.66663H7.00582M12.8333 6.99996C12.8333 10.2216 10.2217 12.8333 6.99999 12.8333C3.77833 12.8333 1.16666 10.2216 1.16666 6.99996C1.16666 3.7783 3.77833 1.16663 6.99999 1.16663C10.2217 1.16663 12.8333 3.7783 12.8333 6.99996Z" stroke="white" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_24454_51970">
                                                                                <rect width="14" height="14" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                </i>
                                                            </RcTooltip>
                                                        </div>
                                                    </div>
                                                    {(() => {
                                                        const showInsights = this.state.showAiInsights?.[heroIncidentId];
                                                        return (
                                                            <div
                                                                style={{
                                                                    maxHeight: showInsights ? '0px' : '30px',
                                                                    opacity: showInsights ? 0 : 1,
                                                                    marginTop: showInsights ? '0px' : '12px',
                                                                    transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                    overflow: 'hidden',
                                                                    pointerEvents: showInsights ? 'none' : 'auto'
                                                                }}
                                                                className="tw-flex tw-items-center tw-gap-[20px]"
                                                            >
                                                                <div className="tw-flex tw-items-center tw-gap-1">
                                                                    <ChartNoAxesCombined size={14} color="#737373" className="tw-flex-shrink-0" />
                                                                    {(() => {
                                                                        const chartDetailsParts = this.getIncidentChartDetailsParts(incident);
                                                                        if (!chartDetailsParts) {
                                                                            return (
                                                                                <span className="tw-text-xs tw-font-medium tw-text-[#A3A3A3]">—</span>
                                                                            );
                                                                        }
                                                                        return (
                                                                            <>
                                                                                <span className="tw-text-xs tw-font-medium tw-text-[#A3A3A3]">
                                                                                    {chartDetailsParts.label}{chartDetailsParts.value ? ':' : ''}
                                                                                </span>
                                                                                {chartDetailsParts.value ? (
                                                                                    <span className="tw-text-xs tw-font-medium tw-text-[#D4D4D4]">
                                                                                        {chartDetailsParts.value}
                                                                                    </span>
                                                                                ) : null}
                                                                            </>
                                                                        );
                                                                    })()}
                                                                </div>
                                                                <div className="tw-flex tw-items-center tw-gap-1">
                                                                    <SlidersHorizontal size={14} color="#737373" className="tw-flex-shrink-0" />
                                                                    <span className="tw-text-xs tw-font-medium tw-text-[#A3A3A3]">Drift Threshold:</span>
                                                                    <span className="tw-text-xs tw-font-medium tw-text-[#D4D4D4]">
                                                                        {this.formatDriftDisplayValue(this.getThresholdValue(incident), "—", 1)}
                                                                    </span>
                                                                </div>
                                                                <div className="tw-flex tw-items-center tw-gap-1">
                                                                    <TriangleAlert size={14} color="#FECDCA" className="tw-flex-shrink-0" />
                                                                    <span className="tw-text-xs tw-font-medium tw-text-[#FECDCA]">Current Drift:</span>
                                                                    <span className="tw-text-xs tw-font-medium tw-text-[#FECDCA]">
                                                                        {this.formatDriftDisplayValue(this.getCurrentDriftValue(incident), "—", 1)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                                {(() => {
                                                    const showInsights = this.state.showAiInsights?.[heroIncidentId];
                                                    const insightsKey = this.getAiInsightsKey(heroIncidentId);
                                                    const insightsData = this.state.aiInsightsData?.[insightsKey];
                                                    const insightsError = this.state.aiInsightsError?.[insightsKey];
                                                    const isInsightsLoading = this.state.aiInsightsLoading?.[insightsKey];
                                                    return (
                                                        <div
                                                            style={{
                                                                maxHeight: showInsights ? '2000px' : '0px',
                                                                opacity: showInsights ? 1 : 0,
                                                                transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                overflow: 'hidden',
                                                                pointerEvents: showInsights ? 'auto' : 'none'
                                                            }}
                                                            className={showInsights ? 'tw-mb-6' : 'tw-mb-0'}
                                                        >
                                                            <div className="tw-p-[1px] tw-rounded-[12px]" style={{ background: "linear-gradient(45deg, #446EFF 15%, #2E96FF 40%, #B1C5FF 73%)" }}>
                                                            <div
                                                                style={{
                                                                        background: 'linear-gradient(135deg, #250E3C -85%, #280B3D 78%)',
                                                                }}
                                                                className="tw-rounded-[12px] tw-p-6"
                                                            >
                                                                <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
                                                                    <div className="tw-flex tw-items-center tw-gap-2">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                            <g clip-path="url(#clip0_31369_201361)">
                                                                                <path d="M16.6665 1.66667V5M18.3332 3.33333H14.9999M9.18071 2.345C9.21642 2.15384 9.31786 1.98118 9.46746 1.85693C9.61706 1.73269 9.80541 1.66467 9.99988 1.66467C10.1943 1.66467 10.3827 1.73269 10.5323 1.85693C10.6819 1.98118 10.7833 2.15384 10.819 2.345L11.6949 6.97667C11.7571 7.30596 11.9171 7.60885 12.1541 7.84581C12.391 8.08277 12.6939 8.2428 13.0232 8.305L17.6549 9.18084C17.846 9.21654 18.0187 9.31798 18.1429 9.46758C18.2672 9.61719 18.3352 9.80553 18.3352 10C18.3352 10.1945 18.2672 10.3828 18.1429 10.5324C18.0187 10.682 17.846 10.7835 17.6549 10.8192L13.0232 11.695C12.6939 11.7572 12.391 11.9172 12.1541 12.1542C11.9171 12.3912 11.7571 12.694 11.6949 13.0233L10.819 17.655C10.7833 17.8462 10.6819 18.0188 10.5323 18.1431C10.3827 18.2673 10.1943 18.3353 9.99988 18.3353C9.80541 18.3353 9.61706 18.2673 9.46746 18.1431C9.31786 18.0188 9.21642 17.8462 9.18071 17.655L8.30488 13.0233C8.24267 12.694 8.08265 12.3912 7.84569 12.1542C7.60873 11.9172 7.30584 11.7572 6.97655 11.695L2.34488 10.8192C2.15372 10.7835 1.98106 10.682 1.85681 10.5324C1.73256 10.3828 1.66455 10.1945 1.66455 10C1.66455 9.80553 1.73256 9.61719 1.85681 9.46758C1.98106 9.31798 2.15372 9.21654 2.34488 9.18084L6.97655 8.305C7.30584 8.2428 7.60873 8.08277 7.84569 7.84581C8.08265 7.60885 8.24267 7.30596 8.30488 6.97667L9.18071 2.345ZM4.99988 16.6667C4.99988 17.5871 4.25369 18.3333 3.33321 18.3333C2.41274 18.3333 1.66655 17.5871 1.66655 16.6667C1.66655 15.7462 2.41274 15 3.33321 15C4.25369 15 4.99988 15.7462 4.99988 16.6667Z" stroke="black" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M16.6665 1.66667V5M18.3332 3.33333H14.9999M9.18071 2.345C9.21642 2.15384 9.31786 1.98118 9.46746 1.85693C9.61706 1.73269 9.80541 1.66467 9.99988 1.66467C10.1943 1.66467 10.3827 1.73269 10.5323 1.85693C10.6819 1.98118 10.7833 2.15384 10.819 2.345L11.6949 6.97667C11.7571 7.30596 11.9171 7.60885 12.1541 7.84581C12.391 8.08277 12.6939 8.2428 13.0232 8.305L17.6549 9.18084C17.846 9.21654 18.0187 9.31798 18.1429 9.46758C18.2672 9.61719 18.3352 9.80553 18.3352 10C18.3352 10.1945 18.2672 10.3828 18.1429 10.5324C18.0187 10.682 17.846 10.7835 17.6549 10.8192L13.0232 11.695C12.6939 11.7572 12.391 11.9172 12.1541 12.1542C11.9171 12.3912 11.7571 12.694 11.6949 13.0233L10.819 17.655C10.7833 17.8462 10.6819 18.0188 10.5323 18.1431C10.3827 18.2673 10.1943 18.3353 9.99988 18.3353C9.80541 18.3353 9.61706 18.2673 9.46746 18.1431C9.31786 18.0188 9.21642 17.8462 9.18071 17.655L8.30488 13.0233C8.24267 12.694 8.08265 12.3912 7.84569 12.1542C7.60873 11.9172 7.30584 11.7572 6.97655 11.695L2.34488 10.8192C2.15372 10.7835 1.98106 10.682 1.85681 10.5324C1.73256 10.3828 1.66455 10.1945 1.66455 10C1.66455 9.80553 1.73256 9.61719 1.85681 9.46758C1.98106 9.31798 2.15372 9.21654 2.34488 9.18084L6.97655 8.305C7.30584 8.2428 7.60873 8.08277 7.84569 7.84581C8.08265 7.60885 8.24267 7.30596 8.30488 6.97667L9.18071 2.345ZM4.99988 16.6667C4.99988 17.5871 4.25369 18.3333 3.33321 18.3333C2.41274 18.3333 1.66655 17.5871 1.66655 16.6667C1.66655 15.7462 2.41274 15 3.33321 15C4.25369 15 4.99988 15.7462 4.99988 16.6667Z" stroke="url(#paint0_linear_31369_201361)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </g>
                                                                            <defs>
                                                                                <linearGradient id="paint0_linear_31369_201361" x1="4.09548" y1="15.8724" x2="15.9216" y2="4.13483" gradientUnits="userSpaceOnUse">
                                                                                    <stop stop-color="#446EFF" />
                                                                                    <stop offset="0.37" stop-color="#2E96FF" />
                                                                                    <stop offset="0.83" stop-color="#B1C5FF" />
                                                                                </linearGradient>
                                                                                <clipPath id="clip0_31369_201361">
                                                                                    <rect width="20" height="20" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                        <span className="tw-text-[18px] tw-font-semibold tw-text-white">QualdoAI Insights</span>
                                                                        {insightsData?.quick_view && (
                                                                            <div className="tw-bg-[#53030C] tw-border tw-border-solid tw-border-[#F64E60] tw-rounded-[6px] tw-py-[3px] tw-px-2 tw-text-xs tw-font-medium tw-text-[#F7BAC1] tw-inline-flex tw-items-center tw-gap-1 tw-leading-none">
                                                                                <TriangleAlert size={12} />
                                                                                <span>{insightsData.quick_view}</span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="tw-flex tw-items-center tw-gap-[2px] tw-text-[#94979C]">
                                                                        <button
                                                                            type="button"
                                                                            className="tw-p-1 tw-w-[32px] tw-h-[32px] tw-border-0 tw-bg-transparent hover:tw-text-white hover:!tw-bg-white/10 tw-rounded-full tw-transition-colors cursor-pointer"
                                                                            style={{
                                                                                color: this.state.heroAiVote?.[insightsKey] === "up" ? "#FFFFFF" : "#94979C"
                                                                            }}
                                                                            onClick={() => this.handleHeroAiVote(heroIncidentId, "up")}
                                                                            title="Helpful"
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor">
                                                                                {this.state.heroAiVote?.[insightsKey] === "up" ? (
                                                                                    <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                                                                ) : (
                                                                                    <path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z" />
                                                                                )}
                                                                            </svg>
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="tw-p-1 tw-w-[32px] tw-h-[32px] tw-border-0 tw-bg-transparent hover:tw-text-white hover:!tw-bg-white/10 tw-rounded-full tw-transition-colors cursor-pointer"
                                                                            style={{
                                                                                color: this.state.heroAiVote?.[insightsKey] === "down" ? "#FFFFFF" : "#94979C"
                                                                            }}
                                                                            onClick={() => this.handleHeroAiVote(heroIncidentId, "down")}
                                                                            title="Not helpful"
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor">
                                                                                <g transform="rotate(180 480 -480)">
                                                                                    {this.state.heroAiVote?.[insightsKey] === "down" ? (
                                                                                        <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                                                                    ) : (
                                                                                        <path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z" />
                                                                                    )}
                                                                                </g>
                                                                            </svg>
                                                                        </button>
                                                                        <button className="tw-p-1 tw-w-[32px] tw-h-[32px] tw-border-0 tw-bg-transparent tw-text-[#94979C] hover:tw-text-white hover:!tw-bg-white/10 tw-rounded-full tw-transition-colors" onClick={() => this.handleAiInsightsToggle(incident, heroIncidentId)}><X size={16} /></button>
                                                                    </div>
                                                                </div>
                                                                <div className="tw-pl-[28px] ai-insights-panel-scroll" style={{ maxHeight: "55vh" }}>
                                                                    {isInsightsLoading ? (
                                                                        <p className="tw-text-[14px] tw-text-[#E2EAFE]/85 tw-mb-0 tw-leading-relaxed">Loading AI insights...</p>
                                                                    ) : insightsError ? (
                                                                        <p className="tw-text-[14px] tw-text-[#F7BAC1] tw-mb-0 tw-leading-relaxed">{insightsError}</p>
                                                                    ) : (
                                                                        <>
                                                                            {insightsData?.title && (
                                                                                <h4 className="tw-text-[16px] tw-font-semibold tw-text-white tw-mb-2 tw-leading-snug">
                                                                                    {insightsData.title}
                                                                                </h4>
                                                                            )}
                                                                            {insightsData?.description && (
                                                                                <p className="tw-text-[14px] tw-text-[#E2EAFE]/85 tw-mb-4 tw-leading-relaxed">
                                                                                    {insightsData.description}
                                                                                </p>
                                                                            )}
                                                                            {insightsData?.recommendation && (
                                                                                <div className="tw-bg-[#13161B7A] tw-border tw-border-solid tw-border-[#22262F] tw-rounded-[12px] tw-py-3 tw-px-4 tw-mt-3">
                                                                                    <div className="tw-text-[14px] tw-text-white tw-leading-normal tw-mb-3">
                                                                                        <span className="tw-text-white tw-font-semibold tw-mr-[6px]">Recommended:</span>
                                                                                        {insightsData.recommendation}
                                                                                    </div>
                                                                                    <div className="tw-flex tw-items-center tw-gap-3 tw-flex-wrap">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="tw-bg-[rgba(51,85,221,0.25)] tw-border tw-border-solid tw-border-[#3355DD] tw-rounded-full tw-py-[6px] tw-px-[12px] tw-text-[14px] tw-font-semibold tw-text-white tw-inline-flex tw-items-center tw-gap-[4px] tw-cursor-pointer hover:tw-bg-[rgba(51,85,221,0.4)] tw-transition-all tw-duration-200 tw-whitespace-nowrap"
                                                                                            onClick={() => this.handleDiagnosticsMapOpen(incident)}
                                                                                        >
                                                                                            <Workflow size={16} color="#7991EF" />
                                                                                            <span>Diagnostics Map</span>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="tw-bg-[rgba(51,85,221,0.25)] tw-border tw-border-solid tw-border-[#3355DD] tw-rounded-full tw-py-[6px] tw-px-[12px] tw-text-[14px] tw-font-semibold tw-text-white tw-inline-flex tw-items-center tw-gap-[4px] tw-cursor-pointer hover:tw-bg-[rgba(51,85,221,0.4)] tw-transition-all tw-duration-200 tw-whitespace-nowrap"
                                                                                            onClick={() => this.redirectToVerticalDasboard(incident, "KPI")}
                                                                                        >
                                                                                            <Maximize2 size={16} color="#7991EF" />
                                                                                            <span>Open Monitor View</span>
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="tw-bg-[rgba(51,85,221,0.25)] tw-border tw-border-solid tw-border-[#3355DD] tw-rounded-full tw-py-[6px] tw-px-[12px] tw-text-[14px] tw-font-semibold tw-text-white tw-inline-flex tw-items-center tw-gap-[4px] tw-cursor-pointer hover:tw-bg-[rgba(51,85,221,0.4)] tw-transition-all tw-duration-200 tw-whitespace-nowrap"
                                                                                            onClick={() => this.navigationHeaderRef.current?.handleShowAiAssistant()}
                                                                                        >
                                                                                            <Image className="!tw-w-[16px] !tw-h-[16px] tw-flex-shrink-0" src={"icon_ai_assistant"} />
                                                                                            <span>Ask QualdoAI</span>
                                                                                            <ArrowRight size={18} className="tw-opacity-65" />
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })()}
                                        <div className="tw-flex-grow tw-flex tw-flex-col tw-relative tw-z-[50]"
                                            style={{ height: `${heroBannerChartHeight}px`, minHeight: `${heroBannerChartHeight}px` }}
                                        >
                                                    {this.shouldRenderHeroChart(index) && heroXValues.length > 0 && heroYValues.length > 0 ? (
                                                    <VerticalChart
                                                        xValues={heroXValues}
                                                        yValues={heroYValues}
                                                        zValues={heroZValues}
                                                        compareIndex={heroCompareIndex}
                                                        driftValues={heroDriftValues}
                                                        previousAvgValues={heroPreviousAvgValues}
                                                        type={effectiveChartType}
                                                        showYAxis={true}
                                                        units={heroUnits || ''}
                                                        height={heroBannerChartHeight}
                                                        axisFontSize={VERTICAL_CHART_AXIS_FONT.HERO_BANNER}
                                                        heroBarLayout={true}
                                                />
                                                    ) : (
                                                        <div
                                                            className="tw-w-full tw-flex-grow"
                                                            style={{ height: `${heroBannerChartHeight}px`, minHeight: `${heroBannerChartHeight}px` }}
                                                            aria-hidden="true"
                                                        />
                                                    )}
                                                </div>
                                        {this.renderChartActionToolbar(incident, { wrapperClassName: 'tw-flex tw-items-center tw-justify-between tw-absolute tw-left-5 tw-right-5 tw-bottom-5', disableCollapse: true, timestamp: heroGeneratedAt || null, })}
                                            </div>
                                            {index === this.state.heroCarouselIndex
                                                ? (
                                                    this.shouldShowHeroAssociatedCarousel(incident.associated_kpis)
                                                        ? this.renderHeroKpiCarousel(incident.associated_kpis, heroIncidentKey, incident)
                                                        : null
                                                )
                                                : (
                                                    this.shouldShowHeroAssociatedCarousel(incident.associated_kpis) ? (
                                                        <div
                                                            className="tw-mt-6"
                                                            style={{ minHeight: `${this.getHeroAssociatedCarouselMinHeight()}px` }}
                                                            aria-hidden="true"
                                                        />
                                                    ) : null
                                                )}
                                        </div>

                                        {this.renderHeroAssociatedKpiSidePanels(incident, heroIncidentKey, index === this.state.heroCarouselIndex)}

                                    </div>
                                </FadeUpOnScroll>
                            </div>
                        </div>
                 
                    // <div className="tw-flex tw-flex-col" key={incident.kpi_incident_id || `${incident.kpi_id}-${index}`}>
                    //     <FadeUpOnScroll delay={0}>
                    //             {/* Header: title + more button */}
                    //             <div className="tw-mb-6">
                    //                 <div className="tw-flex tw-items-center tw-justify-between tw-mb-[6px]">
                    //                     <a href="!#" className="tw-flex tw-items-center tw-text-[24px] tw-text-[#CCCCCC] tw-font-semibold hover:tw-text-white hover:tw-no-underline tw-group">
                    //                         {index + 1}. {incident.title || incident.kpi_name || "Vertical Incident"}
                    //                         <i className="tw-ml-[6px]">
                    //                             <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //                                 <g>
                    //                                     <path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" />
                    //                                 </g>
                    //                             </svg>
                    //                         </i>
                    //                     </a>
                    //                     <div className="tw-flex">
                    //                         <div className="tw-relative tw-inline-block">
                    //                             <RcTooltip trigger={["hover"]} placement="top" overlay={<span>More</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                    //                                 <button className="tw-p-2 tw-border-0 tw-bg-transparent tw-rounded-full hover:tw-bg-white/10 focus:tw-bg-white/25 tw-transition-all tw-duration-300 tw-ease-in-out" onClick={this.toggleDropdown}>
                    //                                     <svg className="d-block" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //                                         <path d="M9.99935 10.832C10.4596 10.832 10.8327 10.4589 10.8327 9.9987C10.8327 9.53846 10.4596 9.16536 9.99935 9.16536C9.53911 9.16536 9.16602 9.53846 9.16602 9.9987C9.16602 10.4589 9.53911 10.832 9.99935 10.832Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    //                                         <path d="M9.99935 4.9987C10.4596 4.9987 10.8327 4.6256 10.8327 4.16536C10.8327 3.70513 10.4596 3.33203 9.99935 3.33203C9.53911 3.33203 9.16602 3.70513 9.16602 4.16536C9.16602 4.6256 9.53911 4.9987 9.99935 4.9987Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    //                                         <path d="M9.99935 16.6654C10.4596 16.6654 10.8327 16.2923 10.8327 15.832C10.8327 15.3718 10.4596 14.9987 9.99935 14.9987C9.53911 14.9987 9.16602 15.3718 9.16602 15.832C9.16602 16.2923 9.53911 16.6654 9.99935 16.6654Z" stroke="#A4A7AE" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    //                                     </svg>
                    //                                 </button>
                    //                             </RcTooltip>
                    //                             {this.state.showDropdown && (
                    //                                 <ul className="tw-absolute tw-right-0 tw-mt-2 tw-min-w-[180px] tw-bg-[#0D0D1E] tw-rounded-md tw-py-2 tw-px-0 tw-border tw-border-black/10 tw-overflow-hidden tw-z-50 tw-shadow-[0px_0px_2px_0px_rgba(255,255,255,0.04),0px_0px_4px_1px_rgba(255,255,255,0.03),0px_0px_8px_2px_rgba(255,255,255,0.08)]">
                    //                                     <li className="tw-py-1">
                    //                                         <button className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-px-4 tw-py-2 tw-bg-transparent tw-border-0 hover:tw-bg-white/10 tw-bg-white/20">
                    //                                             <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 20V19H21V20H3ZM4 17.2308V12H6V17.2308H4ZM8.65375 17.2308V7H10.6537V17.2308H8.65375ZM13.327 17.2308V10H15.327V17.2308H13.327ZM18 17.2308V4H20V17.2308H18Z" fill="rgba(255,255,255,0.5)"></path></svg>
                    //                                             <span className="tw-text-xs tw-font-medium tw-text-white">Bar Chart</span>
                    //                                         </button>
                    //                                     </li>
                    //                                     <li className="tw-py-1">
                    //                                         <button className="tw-flex tw-items-center tw-gap-2 tw-w-full tw-px-4 tw-py-2 tw-bg-transparent tw-border-0 hover:tw-bg-white/10">
                    //                                             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28"><path fill="rgba(255,255,255,0.5)" fillRule="evenodd" d="m25.35 5.35-9.5 9.5-.35.36-.35-.36-4.65-4.64-8.15 8.14-.7-.7 8.5-8.5.35-.36.35.36 4.65 4.64 9.15-9.14.7.7ZM2 21h1v1H2v-1Zm2-1H3v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1V9h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1H6v1H5v1H4v1Zm1 0v1H4v-1h1Zm1 0H5v-1h1v1Zm1 0v1H6v-1h1Zm0-1H6v-1h1v1Zm1 0H7v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v1h1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1H8v1H7v1h1v1Zm1 0v1H8v-1h1Zm0-1H8v-1h1v1Zm1 0H9v1h1v1h1v-1h1v1h1v-1h1v1h1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v1H9v1h1v1Zm1 0v1h-1v-1h1Zm0-1v-1h-1v1h1Zm0 0v1h1v1h1v-1h-1v-1h-1Zm6 2v-1h1v1h-1Zm2 0v1h-1v-1h1Zm0-1h-1v-1h1v1Zm1 0h-1v1h1v1h1v-1h1v1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1v1h-1v1h-1v1h-1v1h1v1Zm1 0h-1v1h1v-1Zm0-1h1v1h-1v-1Zm0-1h1v-1h-1v1Zm0 0v1h-1v-1h1Zm-4 3v1h-1v-1h1Z"></path></svg>
                    //                                             <span className="tw-text-xs tw-font-medium tw-text-white">Area Chart</span>
                    //                                         </button>
                    //                                     </li>
                    //                                 </ul>
                    //                             )}
                    //                         </div>
                    //                     </div>
                    //                 </div>
                    //                 {/* Metrics row */}
                    //                 <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-3">
                    //                     <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-items-center tw-m-0">
                    //                         <span className="tw-flex tw-items-center tw-mr-2">
                    //                             <i className="tw-mr-1">
                    //                                 <svg className="tw-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //                                     <path d="M14.6663 11.3333L9.42059 6.08754C9.15658 5.82353 9.02457 5.69152 8.87235 5.64206C8.73846 5.59856 8.59423 5.59856 8.46033 5.64206C8.30811 5.69152 8.17611 5.82353 7.91209 6.08754L6.08725 7.91238C5.82324 8.17639 5.69124 8.3084 5.53902 8.35785C5.40512 8.40136 5.26089 8.40136 5.127 8.35785C4.97478 8.3084 4.84277 8.17639 4.57876 7.91238L1.33301 4.66663M14.6663 11.3333H9.99967M14.6663 11.3333V6.66663" stroke="#F87180" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    //                                 </svg>
                    //                             </i>
                    //                             <span className={`tw-text-sm tw-font-medium ${this.getTrendClassName(incident)}`}>{this.getTrendText(incident)}</span>
                    //                         </span>
                    //                         vs selected period
                    //                     </p>
                    //                     <div className="tw-flex tw-items-center tw-gap-1">
                    //                         <i className="tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-text-[#94979C]">
                    //                             <FontAwesomeIcon className="tw-block" icon={faLayerGroup} />
                    //                         </i>
                    //                         <span className="tw-text-sm tw-text-[#CCCCCC]">{this.getIncidentSourceName(incident)}</span>
                    //                     </div>
                    //                     <div className="tw-inline-flex tw-items-center tw-rounded-[999px] tw-border tw-bg-[#000000]/20 tw-border-white/5 tw-py-1 tw-px-[10px] tw-gap-1">
                    //                         <FontAwesomeIcon icon={faClock} className="tw-text-[#94979C]" />
                    //                         <span className="tw-text-sm tw-text-[#AAAAAA] tw-font-medium">{this.getIncidentDate(incident.generated_at)}</span>
                    //                     </div>
                    //                 </div>
                    //             </div>
                    //             {/* Value */}
                    //             <div className="tw-flex tw-items-end tw-mb-4">
                    //                 <span className="tw-text-[20px] md:tw-text-[28px] xl:tw-text-[32px] 2xl:tw-text-[40px] 2xl:tw-leading-[48px] tw-text-[#F7F7F7] tw-font-semibold tw-mr-[6px]">{this.getIncidentValue(incident)}</span>
                    //             </div>
                    //             {/* Chart */}
                    //             <div className="tw-min-h-[360px]">
                    //                 <BarChart
                    //                     chartData={this.getIncidentChartData(incident)}
                    //                     metricsData={this.getIncidentMetricsData(incident)}
                    //                     isActive={true}
                    //                 />
                    //             </div>
                    //             {/* Bottom action toolbar */}
                    //             <div className="tw-flex tw-items-center tw-justify-between tw-absolute tw-left-5 tw-right-5 tw-bottom-5">
                    //                 <div className="tw-relative tw-flex tw-items-center">
                    //                     <div className="chart-action-toolbar__left">
                    //                         <RcTooltip trigger={["hover"]} placement="top" overlay={<span>Fullscreen</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                    //                             <div className="chart-action-toolbar__btn">
                    //                                 <i>
                    //                                     <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //                                         <path d="M2.72622 7.20266C2.46355 7.20266 2.25 6.98985 2.25 6.72644V4.63109C2.25149 3.31703 3.31703 2.25152 4.63109 2.25H6.90207C7.16473 2.25 7.37829 2.46355 7.37829 2.72622C7.37829 2.98962 7.16473 3.20243 6.90207 3.20243H4.63109C3.8431 3.20392 3.20392 3.84236 3.20243 4.63109V6.72644C3.20243 6.85294 3.15258 6.97423 3.06329 7.06351C2.974 7.15279 2.8527 7.20266 2.72622 7.20266Z" fill="rgba(255,255,255,0.5)" />
                    //                                         <path d="M15.2591 7.22317C14.9957 7.22317 14.7828 7.01036 14.7828 6.74695V4.65159C14.7806 3.86361 14.1422 3.22517 13.3542 3.22294H11.0817C10.8183 3.22294 10.6055 3.01013 10.6055 2.74673C10.6055 2.48406 10.8183 2.27051 11.0817 2.27051H13.3542C14.6683 2.27274 15.733 3.33754 15.7353 4.65159V6.74695C15.7353 6.87345 15.6847 6.99474 15.5954 7.08402C15.5061 7.1733 15.3848 7.22317 15.2591 7.22317Z" fill="rgba(255,255,255,0.5)" />
                    //                                         <path d="M13.3575 15.7362H11.0924C10.8298 15.7362 10.6162 15.5234 10.6162 15.26C10.6162 14.9973 10.8298 14.7838 11.0924 14.7838H13.3575C14.1455 14.7815 14.7839 14.1431 14.7862 13.3551V11.2731C14.7862 11.0104 14.999 10.7969 15.2624 10.7969C15.525 10.7969 15.7386 11.0104 15.7386 11.2731V13.3684C15.7289 14.6773 14.6664 15.7339 13.3575 15.7362Z" fill="rgba(255,255,255,0.5)" />
                    //                                         <path d="M6.91532 15.7362H4.64281C3.32875 15.734 2.264 14.6692 2.26172 13.3551V11.2731C2.26172 11.0104 2.47453 10.7969 2.73794 10.7969C3.0006 10.7969 3.21415 11.0104 3.21415 11.2731V13.3684C3.21639 14.1564 3.85482 14.7949 4.64281 14.7971H6.91532C7.17798 14.7971 7.39153 15.0107 7.39153 15.2733C7.39153 15.536 7.17798 15.7495 6.91532 15.7495V15.7362Z" fill="rgba(255,255,255,0.5)" />
                    //                                     </svg>
                    //                                 </i>
                    //                             </div>
                    //                         </RcTooltip>
                    //                     </div>
                    //                 </div>
                    //                 <div className="tw-relative">
                    //                     <span className="tw-text-xs tw-text-[#94979C]">GMT+05:30</span>
                    //                 </div>
                    //                 <div className="chart-action-toolbar__right">
                    //                     {this.renderVerticalLikeButton(incident)}
                    //                 </div>
                    //             </div>
                    //         </div>
                    //     </FadeUpOnScroll>
                    // </div>
                );
            })}
            </Slider>
            <div className={incidents.length <= 1 ? "custom-slider-wrap d-none" : "custom-slider-wrap"}>
                <span className="custom-slider-length">{this.getSliderPagingLabel(this.state.heroCarouselIndex, incidents.length)}</span>
                <div className="custom-slider-dots">
                 {(() => {
                    const currentPage = Math.floor(this.state.heroCarouselIndex / 10);
                    const startDot = currentPage * 10;
                    const endDot = Math.min(startDot + 10, incidents.length);
                    return Array.from({ length: endDot - startDot }, (_, i) => {
                        const dotIndex = startDot + i;
                        return (
                            <span
                                key={dotIndex}
                                className={`custom-slider-dot ${dotIndex === this.state.heroCarouselIndex ? 'active' : ''}`}
                                onClick={() => {
                                    this.setState({ heroCarouselIndex: dotIndex });
                                    if (this.heroSliderRef) {
                                        this.heroSliderRef.slickGoTo(dotIndex);
                                    }
                                }}
                                style={{ cursor: 'pointer' }}
                            >{dotIndex + 1}</span>
                        );
                    });
                 })()}
                </div>
            </div>
        </div>
        );
    }

    getSummarySectionIncidentCount = (section) => {
        if (!section || typeof section !== 'object') return 0;

        const kpiItems = this.getKpiSectionItems(section);
        const issueTotal = kpiItems.reduce((sum, item) => sum + (Number(item?.issue_count) || 0), 0);
        if (issueTotal > 0) return issueTotal;

        const summaryItems = Array.isArray(section.summary) ? section.summary : [];
        const summaryIssueTotal = summaryItems.reduce((sum, item) => sum + (Number(item?.issue_count) || 0), 0);
        if (summaryIssueTotal > 0) return summaryIssueTotal;

        const explicitCount = Number(
            section?.issue_count
            ?? section?.incident_count
            ?? section?.all_count
            ?? section?.count
            ?? 0
        );
        return Number.isFinite(explicitCount) ? explicitCount : 0;
    };

    sectionHasIncidentCountSignal = (section) => {
        if (!section || typeof section !== 'object') return false;
        if (['issue_count', 'incident_count', 'all_count', 'count'].some((key) => (
            section[key] != null && section[key] !== ''
        ))) {
            return true;
        }
        return this.getKpiSectionItems(section).length > 0;
    };

    isKpiSectionKnownEmpty = (section) => (
        this.sectionHasIncidentCountSignal(section)
        && this.getSummarySectionIncidentCount(section) === 0
    );

    isKpiSectionLikelyHasContent = (section) => {
        if (this.isKpiSectionKnownEmpty(section)) return false;
        return this.getSummarySectionIncidentCount(section) > 0;
    };

    buildHiddenKpiSectionsFromSummary = (kpiSummary = []) => {
        const hidden = {};
        (Array.isArray(kpiSummary) ? kpiSummary : []).forEach((section, index) => {
            if (this.isKpiSectionKnownEmpty(section)) {
                hidden[index] = true;
            }
        });
        return hidden;
    };

    getRenderableKpiSummarySections = () => {
        const kpiSummary = Array.isArray(this.state.verticalKpiSummary) ? this.state.verticalKpiSummary : [];
        return kpiSummary.filter((section) => {
            if (this.getKpiSectionItems(section).length === 0) return false;
            return this.getSummarySectionIncidentCount(section) > 0;
        });
    };

    getRenderableBusinessAreaSummaries = () => {
        const businessAreas = Array.isArray(this.state.verticalBusinessAreas) ? this.state.verticalBusinessAreas : [];
        return businessAreas.filter((businessArea) => {
            if (this.getKpiSectionItems(businessArea).length === 0
                && !(Array.isArray(businessArea.summary) && businessArea.summary.length > 0)) {
                return false;
            }
            return this.getSummarySectionIncidentCount(businessArea) > 0;
        });
    };

    hasRenderableSummaryContent = () => (
        this.getRenderableKpiSummarySections().length > 0
        || this.getRenderableBusinessAreaSummaries().length > 0
    );

    renderVerticalSummaryCarousel = (incidentSummary) => {
        const businessAreas = this.getRenderableBusinessAreaSummaries();
        if (!businessAreas.length) {
            return null;
        }

        return (
            <div className="position-relative">
                <Slider
                    ref={slider => { this.summarySliderRef = slider; }}
                    {...incidentSummary}
                    dots={false}
                    afterChange={(idx) => this.setState({ summaryCarouselIndex: this.toSlideIndex(idx) })}
                    className={`qd-incidents-slider qd-incidents-slider--summary tw-pb-[80px] tw-cursor-grab active:tw-cursor-grabbing ${businessAreas.length >= 4 ? 'has-dynamic-left-padding' : ''}`}
                >
                    {businessAreas.map((businessArea, index) => {
                        const summaryItems = Array.isArray(businessArea.summary) ? businessArea.summary : [];
                        const issueCount = this.getSummarySectionIncidentCount(businessArea);
                        const isActiveCard = index === this.state.summaryCarouselIndex;
                        return (
                            <FadeUpOnScroll delay={Math.min(0.2 + (index * 0.1), 0.8)} key={businessArea.business_id || businessArea.title} enabled={index < 4}>
                                <div className={`qd-incidents-summarywidget ${isActiveCard ? ' is-card-active' : ''}`}>
                                    <div className="qd-id-sw__top">
                                        <span className="tagline ">{issueCount} Incidents</span>
                                        <h4 className="headline">{businessArea.title || "Business Area"}</h4>
                                        <p className="paratext">{businessArea.description || "No description available."}</p>
                                    </div>
                                    <div className="qd-id-sw__content">
                                        <ul className="qd-id-sw__items">
                                            {summaryItems.length ? summaryItems.map((item) => (
                                                <li
                                                    className="qd-id-sw__item"
                                                    key={`${businessArea.business_id}-${item.kpi_id}`}
                                                    onClick={() => this.handleSummaryIncidentSelect(item)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <label>
                                                        <RcTooltip trigger={["hover"]}
                                                            placement="top"
                                                            overlay={<span>{item.kpi_name}</span>}
                                                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                        >
                                                            <span className="kpi-text tw-inline-flex tw-items-center"><KpiIcon size={18} color="#B5B5C3" className="tw-mr-1 tw-shrink-0" />{item.kpi_name}</span>
                                                        </RcTooltip>
                                                        <i className="ml-1">
                                                            <RcTooltip
                                                                placement="top"
                                                                overlay={<span>Click View All Incidents</span>}
                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                            >
                                                                <div>
                                                                    <Image src={"icon_keyboard_right"} alt="" />
                                                                </div>
                                                            </RcTooltip>
                                                        </i>
                                                    </label>
                                                    <span className="value">{item.issue_count}</span>
                                                </li>
                                            )) : null}
                                        </ul>
                                    </div>
                                    <div className="qd-id-sw__actions">
                                        {this.renderViewAllIncidentsButton(businessArea)}
                                    </div>
                                </div>
                            </FadeUpOnScroll>
                        );
                    })}
                </Slider>
                <div className={businessAreas.length <= 1 ? "custom-slider-wrap d-none" : "custom-slider-wrap"}>
                    <span className="custom-slider-length">{this.getSliderPagingLabel(this.state.summaryCarouselIndex, businessAreas.length)}</span>
                    <div className="custom-slider-dots">
                     {(() => {
                        const slidesToShow = incidentSummary.slidesToShow || 3.15;
                        const currentPage = Math.floor(this.state.summaryCarouselIndex / 10);
                        const startDot = currentPage * 10;
                        const endDot = Math.min(startDot + 10, businessAreas.length);
                        return Array.from({ length: endDot - startDot }, (_, i) => {
                            const dotIndex = startDot + i;
                            return (
                                <span
                                    key={dotIndex}
                                    className={`custom-slider-dot ${dotIndex === this.state.summaryCarouselIndex ? 'active' : ''}`}
                                    onClick={() => {
                                        const safeIdx = Math.min(dotIndex, Math.max(0, businessAreas.length - Math.ceil(slidesToShow)));
                                        this.setState({ summaryCarouselIndex: dotIndex });
                                        if (this.summarySliderRef) {
                                            this.summarySliderRef.slickGoTo(safeIdx);
                                        }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >{dotIndex + 1}</span>
                            );
                        });
                     })()}
                    </div>
                </div>
            </div>
        );
    }

    renderKpiSummaryDynamic = (incidentSummary) => {
        const filteredSummary = this.getRenderableKpiSummarySections();
        if (filteredSummary.length === 0) {
            return null;
        }
        return (
            <div className="position-relative">
                <Slider
                    ref={slider => { this.kpiSummarySliderRef = slider; }}
                    {...incidentSummary}
                    dots={false}
                    afterChange={(idx) => this.setState({ kpiSummaryCarouselIndex: this.toSlideIndex(idx) })}
                    className={`qd-incidents-slider qd-incidents-slider--summary tw-pb-[80px] tw-cursor-grab active:tw-cursor-grabbing ${filteredSummary.length >= 4 ? 'has-dynamic-left-padding tw-pb-[80px]' : ''}`}
                >
                    {filteredSummary.map((section, index) => {
                        const sectionTitle = section?.title || section?.name || section?.kpi_name || `Section ${index + 1}`;
                        const sectionDesc = section?.description || section?.subtitle || "";
                        const kpiItems = this.getKpiSectionItems(section);
                        const incidentCount = this.getSummarySectionIncidentCount(section);
                        const tagline = `${Number.isInteger(incidentCount) ? incidentCount : incidentCount.toFixed(1)} Incidents`;

                        const isActiveCard = index === this.state.kpiSummaryCarouselIndex;
                        return (
                            <FadeUpOnScroll delay={Math.min(0.2 + (index * 0.1), 0.8)} key={section?.business_id || sectionTitle || index} enabled={index < 4}>
                                <div className={`qd-incidents-summarywidget${isActiveCard ? ' is-card-active' : ''}`}>
                                    <div className="qd-id-sw__top">
                                        <span className="tagline">{tagline}</span>
                                        <h4 className="headline">{sectionTitle}</h4>
                                        {sectionDesc && <p className="paratext">{sectionDesc}</p>}
                                    </div>
                                    <div className="qd-id-sw__content">
                                        <ul className="qd-id-sw__items">
                                            {kpiItems.map((item, itemIdx) => {
                                                const rawVal = item?.kpi_agg_value ?? item?.issue_count ?? item?.value ?? item?.count;
                                                const numVal = parseFloat(rawVal);
                                                const displayVal = isNaN(numVal) ? (rawVal ?? "—") : (numVal % 1 === 0 ? Math.round(numVal) : numVal.toFixed(2));
                                                return (
                                                    <li
                                                        className="qd-id-sw__item"
                                                        key={item?.kpi_id || item?.kpi_incident_id || itemIdx}
                                                        onClick={() => this.handleSummaryIncidentSelect(item)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <label>
                                                            <RcTooltip trigger={["hover"]}
                                                                placement="top"
                                                                overlay={<span>{item?.kpi_name || item?.name || "KPI"}</span>}
                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                            >
                                                                <span className="kpi-text tw-inline-flex tw-items-center"><KpiIcon size={18} color="#B5B5C3" className="tw-mr-1 tw-shrink-0" />{item?.kpi_name || item?.name || "KPI"}</span>
                                                            </RcTooltip>
                                                            <i className="ml-1">
                                                                <RcTooltip
                                                                    placement="top"
                                                                    overlay={<span>Click View All Incidents</span>}
                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                >
                                                                    <div>
                                                                        <Image src={"icon_keyboard_right"} alt="" />
                                                                    </div>
                                                                </RcTooltip>
                                                            </i>
                                                        </label>
                                                        <span className="value">{displayVal}</span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                    <div className="qd-id-sw__actions">
                                        {this.renderViewAllIncidentsButton(section)}
                                    </div>
                                </div>
                            </FadeUpOnScroll>
                        );
                    })}
                </Slider>
                <div className={filteredSummary.length <= 1 ? "custom-slider-wrap d-none" : "custom-slider-wrap"}>
                    <span className="custom-slider-length">{this.getSliderPagingLabel(this.state.kpiSummaryCarouselIndex, filteredSummary.length)}</span>
                    <div className="custom-slider-dots">
                     {(() => {
                        const slidesToShow = incidentSummary.slidesToShow || 3.15;
                        const currentPage = Math.floor(this.state.kpiSummaryCarouselIndex / 10);
                        const startDot = currentPage * 10;
                        const endDot = Math.min(startDot + 10, filteredSummary.length);
                        return Array.from({ length: endDot - startDot }, (_, i) => {
                            const dotIndex = startDot + i;
                            return (
                                <span
                                    key={dotIndex}
                                    className={`custom-slider-dot ${dotIndex === this.state.kpiSummaryCarouselIndex ? 'active' : ''}`}
                                    onClick={() => {
                                        const safeIdx = Math.min(dotIndex, Math.max(0, filteredSummary.length - Math.ceil(slidesToShow)));
                                        this.setState({ kpiSummaryCarouselIndex: dotIndex });
                                        if (this.kpiSummarySliderRef) {
                                            this.kpiSummarySliderRef.slickGoTo(safeIdx);
                                        }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >{dotIndex + 1}</span>
                            );
                        });
                     })()}
                    </div>
                </div>
            </div>
        );
    }

    handleKpiDragStart = (e, incidentId) => {
        e.stopPropagation();
        const CARDS_PER_PAGE = 3;
        const totalCards = this.kpiTrackRef.current ? this.kpiTrackRef.current.children.length : 0;
        if (!incidentId || totalCards <= CARDS_PER_PAGE) return;

        // Prevent native browser text selection and ghost dragging
        if (e.type === 'mousedown') {
            e.preventDefault();
        }

        this.activeHeroKpiCarouselId = incidentId;
        this.isDragging = true;
        this.dragOffset = 0;
        this.dragStartX = e.clientX || (e.touches && e.touches[0].clientX) || 0;

        if (this.kpiTrackRef.current) {
            this.kpiTrackRef.current.style.transition = 'transform 0.15s cubic-bezier(0.2, 0.8, 0.2, 1)';
            // Set transition to none on all child cards to ensure lag-free drag
            Array.from(this.kpiTrackRef.current.children).forEach(child => {
                child.style.transition = 'none';
            });
        }

        // Clean up any existing style tag just in case
        if (this.dragStyleTag && this.dragStyleTag.parentNode) {
            this.dragStyleTag.parentNode.removeChild(this.dragStyleTag);
        }

        // Inject global style rule to force grabbing cursor and block user text selection on all elements
        this.dragStyleTag = document.createElement('style');
        this.dragStyleTag.innerHTML = `
            * {
                cursor: grabbing !important;
                user-select: none !important;
                -webkit-user-select: none !important;
            }
        `;
        document.head.appendChild(this.dragStyleTag);
    };

    handleKpiDragMove = (e) => {
        if (!this.isDragging) return;
        e.stopPropagation();

        const clientX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
        this.dragOffset = clientX - this.dragStartX;

        // Prevent page scroll when swiping horizontally on mobile
        if (e.touches && Math.abs(this.dragOffset) > 10) {
            if (e.cancelable) {
                e.preventDefault();
            }
        }

        const CARDS_PER_PAGE = 3;
        const cardWidthPct = 100 / CARDS_PER_PAGE;
        const incidentId = this.activeHeroKpiCarouselId;
        const carouselIndex = incidentId ? this.getHeroKpiCarouselIndex(incidentId) : 0;
        const translateX = carouselIndex * cardWidthPct;

        if (this.kpiTrackRef.current) {
            this.kpiTrackRef.current.style.transform = `translateX(calc(-${translateX}% - ${carouselIndex * (24 / CARDS_PER_PAGE)}px + ${this.dragOffset}px))`;
        }
    };

    handleKpiDragEnd = (e) => {
        if (e) e.stopPropagation();
        if (!this.isDragging) return;
        this.isDragging = false;

        const CARDS_PER_PAGE = 3;
        const incidentId = this.activeHeroKpiCarouselId;
        const totalCards = this.kpiTrackRef.current ? this.kpiTrackRef.current.children.length : 0;
        const maxIndex = Math.max(0, totalCards - CARDS_PER_PAGE);
        const carouselIndex = incidentId ? this.getHeroKpiCarouselIndex(incidentId) : 0;

        let nextIndex = carouselIndex;
        const threshold = 80;

        if (this.dragOffset < -threshold && carouselIndex < maxIndex) {
            nextIndex = carouselIndex + 1;
        } else if (this.dragOffset > threshold && carouselIndex > 0) {
            nextIndex = carouselIndex - 1;
        }

        const cardWidthPct = 100 / CARDS_PER_PAGE;
        const targetTranslateX = nextIndex * cardWidthPct;

        if (this.kpiTrackRef.current) {
            this.kpiTrackRef.current.style.transition = 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)';
            this.kpiTrackRef.current.style.transform = `translateX(calc(-${targetTranslateX}% - ${nextIndex * (24 / CARDS_PER_PAGE)}px))`;
            // Reset transition on all child cards
            Array.from(this.kpiTrackRef.current.children).forEach(child => {
                child.style.transition = '';
            });
        }

        // Remove the global grabbing override style tag
        if (this.dragStyleTag && this.dragStyleTag.parentNode) {
            this.dragStyleTag.parentNode.removeChild(this.dragStyleTag);
            this.dragStyleTag = null;
        }

        if (nextIndex !== carouselIndex && incidentId) {
            this.setHeroKpiCarouselIndex(incidentId, nextIndex, {
                totalCards,
                cardsPerPage: CARDS_PER_PAGE,
            });
        }

        this.activeHeroKpiCarouselId = null;

        setTimeout(() => {
            this.dragOffset = 0;
        }, 50);
    };

    handleKpiClickCapture = (e) => {
        if (Math.abs(this.dragOffset) > 10) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    handleKpiGoLeft = (incidentId, totalCards = Number.MAX_SAFE_INTEGER, cardsPerPage = 3) => {
        const current = this.getHeroKpiCarouselIndex(incidentId);
        if (current > 0) {
            this.setHeroKpiCarouselIndex(incidentId, current - 1, { totalCards, cardsPerPage });
        }
    };

    handleKpiGoRight = (incidentId, totalCards, cardsPerPage = 3) => {
        const maxIndex = Math.max(0, totalCards - cardsPerPage);
        const current = this.getHeroKpiCarouselIndex(incidentId);
        if (current < maxIndex) {
            this.setHeroKpiCarouselIndex(incidentId, current + 1, { totalCards, cardsPerPage });
        }
    };

    shouldShowHeroAssociatedCarousel = (associatedKpis) => (
        Array.isArray(associatedKpis) && associatedKpis.length >= 3
    );

    getHeroAssociatedKpiSideCards = (associatedKpis) => {
        if (!Array.isArray(associatedKpis) || associatedKpis.length === 0 || associatedKpis.length > 2) {
            return [];
        }
        const positions = ['left', 'right'];
        return associatedKpis.slice(0, 2).map((assocKpi, assocIdx) => ({
            assocKpi,
            assocIdx,
            position: positions[assocIdx],
        }));
    };

    renderHeroAssociatedKpiSideCard = (assocKpi, position, incident, assocIdx, heroIncidentKey) => {
        const cardId = `${heroIncidentKey}_side_${assocIdx}`;
        const positionClass = position === 'left'
            ? 'tw-w-[250px] tw-h-[250px] tw-absolute tw-bottom-[32%] tw-left-[-6%] 2xl:tw-left-[-8%]'
            : 'tw-w-[250px] tw-h-[250px] tw-absolute tw-top-[15%] tw-right-[-6%] 2xl:tw-right-[-8%]';
        const assocUnits = this.getChartDisplayUnits(assocKpi);
        const assocTrendValue = this.formatDriftDisplayValue(assocKpi.trends_value, "0");
        const chartSlot = position === 'right' ? 'float-right' : 'float-left';
        const kpiName = assocKpi.kpi_name || '—';

        return (
            <div key={cardId} className={positionClass}>
                <div className="tw-rounded-[24px] tw-p-[1px] tw-bg-gradient-to-br tw-from-[#D0C6FF] tw-to-[#6343FF] tw-h-full">
                    <div className="tw-rounded-[24px] tw-bg-[#14113A] tw-p-6 tw-h-full tw-flex tw-flex-col" style={{ boxShadow: 'inset 0 0 50px 0 #6343FF80' }}>
                        <div className="tw-flex tw-items-center tw-justify-between tw-mb-3 tw-relative">
                            <a href="#!" onClick={(e) => { e.preventDefault(); this.redirectToAssociatedKpi(assocKpi, incident); }} className="tw-w-[calc(100%-24px)] tw-flex tw-items-center tw-text-sm tw-text-[#CCCCCC] tw-font-medium hover:tw-text-white hover:tw-no-underline tw-group">
                                <KpiIcon size={16} color="#B5B5C3" className="tw-mr-1 tw-shrink-0" />
                                <RcTooltip trigger={["hover"]} placement="top" overlay={<span>{kpiName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span className="tw-w-[calc(100%-20px)] tw-overflow-hidden tw-whitespace-nowrap tw-truncate">{kpiName}</span>
                                </RcTooltip>
                                <RcTooltip trigger={["hover"]} placement="top" overlay={<span>View in Monitor</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <i className="tw-ml-[6px]">
                                        <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="18" height="18" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                        </svg>
                                    </i>
                                </RcTooltip>
                            </a>
                            <div className="tw-flex tw-ml-1 tw-flex-shrink-0 tw-absolute tw-right-[-16px]">
                                <div className="tw-relative tw-inline-block">
                                    {this.renderHeroChartTypeDropdown(cardId, chartSlot)}
                                </div>
                            </div>
                        </div>
                        <div className="tw-flex tw-flex-wrap tw-items-center tw-w-full tw-gap-y-1">
                            {this.renderMetricValueWithUnits(
                                assocKpi.kpi_agg_value,
                                assocUnits,
                                "tw-text-[20px] md:tw-text-[28px] xl:tw-text-[32px] 2xl:tw-text-[40px] tw-leading-tight tw-text-[#F7F7F7] tw-font-semibold tw-mr-1",
                                2
                            )}
                            <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-items-center tw-mb-0 tw-flex-shrink-0 tw-ml-auto">
                                <span className="tw-flex tw-items-center">
                                    {this.renderTrendBadge(assocKpi, assocTrendValue, 16)}
                                </span>
                            </p>
                        </div>
                        {/* <div className="tw-w-full tw-min-w-0 tw-mt-auto" style={{ height: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px` }}>
                            <VerticalChart xValues={assocXValues} yValues={assocYValues} zValues={assocZValues} compareIndex={assocCompareIndex} driftValues={assocDriftValues} previousAvgValues={assocPreviousAvgValues} type={chartType} units={this.getChartDisplayUnits(assocKpi)} height={VERTICAL_CHART_HEIGHT.HERO_KPI_CARD} axisFontSize={VERTICAL_CHART_AXIS_FONT.HERO_KPI_CARD} heroBarLayout={true} />
                        </div> */}
                    </div>
                </div>
            </div>
        );
    };

    renderHeroAssociatedKpiSidePanels = (incident, heroIncidentKey, isActive) => {
        if (!isActive) return null;
        const associatedKpis = incident.associated_kpis;
        if (!Array.isArray(associatedKpis) || associatedKpis.length === 0) return null;
        return this.getHeroAssociatedKpiSideCards(associatedKpis).map(({ assocKpi, assocIdx, position }) =>
            this.renderHeroAssociatedKpiSideCard(assocKpi, position, incident, assocIdx, heroIncidentKey)
        );
    };

    getHeroAssociatedCarouselMinHeight = () => {
        const sectionMarginTop = 20;
        const cardPaddingY = 20;
        const titleBlock = 40;
        return sectionMarginTop + cardPaddingY + titleBlock + VERTICAL_CHART_HEIGHT.HERO_KPI_CARD;
    };

    getHeroBannerChartHeight = (associatedKpis) => {
        const baseHeight = VERTICAL_CHART_HEIGHT.HERO_BANNER;
        if (this.shouldShowHeroAssociatedCarousel(associatedKpis)) {
            return baseHeight;
        }
        return baseHeight + this.getHeroAssociatedCarouselMinHeight() + 24;
    };

    renderCardMetaInfo = (cardId, item = {}) => {
        if (!this.labelRefs) {
            this.labelRefs = {};
        }
        const labelEl = this.labelRefs[cardId];
        const isTruncated = labelEl ? (labelEl.scrollWidth > labelEl.clientWidth) : false;
        const driftThresholdDisplay = this.formatDriftDisplayValue(this.getThresholdValue(item), "—", 1);
        const currentDriftDisplay = this.formatDriftDisplayValue(this.getCurrentDriftValue(item), "—", 1);
        const chartDetailsParts = this.getIncidentChartDetailsParts(item);
        const chartDetailsLabel = chartDetailsParts?.label || "—";
        const chartDetailsValue = chartDetailsParts?.value || "";

        return (
            <div className="tw-flex tw-items-center tw-min-w-0 tw-w-full">
                {/* Label & Value wrapper */}
                <div className="tw-flex tw-items-center tw-gap-1 tw-min-w-0 tw-flex-grow">
                    <ChartNoAxesCombined size={14} color="#737373" className="tw-flex-shrink-0" />
                    <span 
                        ref={el => this.labelRefs[cardId] = el}
                        className="tw-text-xs tw-font-medium tw-text-[#A3A3A3] tw-truncate"
                    >
                        {chartDetailsLabel}
                    </span>
                    {chartDetailsValue ? (
                        <>
                            <span className="tw-text-xs tw-font-medium tw-text-[#A3A3A3] tw-flex-shrink-0">:</span>
                            <span className="tw-text-xs tw-font-medium tw-text-[#D4D4D4] tw-flex-shrink-0">{chartDetailsValue}</span>
                        </>
                    ) : null}
                </div>
                
                {/* Separator */}
                <div className="tw-w-[1px] tw-h-5 tw-bg-[#373A41] tw-mx-1 tw-flex-shrink-0" />
                
                {/* Tooltip trigger */}
                <RcTooltip trigger={["hover"]}
                    placement="top"
                    overlayClassName="qd-incident-tooltip"
                    overlay={
                        <div className="tw-p-3 tw-min-w-[200px]">
                            {isTruncated && (
                                <>
                                    <div>
                                        <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase tw-mb-1">{chartDetailsLabel}</span>
                                        <div className="tw-flex tw-items-center tw-gap-2">
                                            <ChartNoAxesCombined size={14} color="#737373" className="tw-flex-shrink-0" />
                                            <span className="tw-text-sm tw-font-medium tw-text-[#D4D4D4]">{chartDetailsValue || "—"}</span>
                                        </div>
                                    </div>
                                    <div className="tw-h-[1px] tw-bg-[#373A41] tw-my-[6px]" />
                                </>
                            )}
                            <div>
                                <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase tw-mb-1">DRIFT THRESHOLD</span>
                                <div className="tw-flex tw-items-center tw-gap-2">
                                    <SlidersHorizontal size={14} color="#737373" className="tw-flex-shrink-0" />
                                    <span className="tw-text-sm tw-font-medium tw-text-[#D4D4D4]">{driftThresholdDisplay}</span>
                                </div>
                            </div>
                            <div className="tw-h-[1px] tw-bg-[#373A41] tw-my-[6px]" />
                            <div>
                                <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase tw-mb-1">CURRENT DRIFT:</span>
                                <div className="tw-flex tw-items-center tw-gap-2">
                                    <TriangleAlert size={14} color="#FECDCA" className="tw-flex-shrink-0" />
                                    <span className="tw-text-sm tw-font-medium tw-text-[#FECDCA]">{currentDriftDisplay}</span>
                                </div>
                            </div>
                        </div>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <span className="tw-inline-flex tw-items-center tw-px-[2px] tw-text-xs tw-font-medium tw-text-[#A3A3A3] tw-cursor-pointer hover:tw-text-white tw-flex-shrink-0">
                        <span>+2</span>
                        <ChevronRight size={16} color="currentColor" className="tw-flex-shrink-0" />
                    </span>
                </RcTooltip>
            </div>
        );
    };


    renderHeroKpiCarousel = (associatedKpis, incidentId = '', parentIncident = null) => {
        const carouselMinHeight = this.getHeroAssociatedCarouselMinHeight();
        if (!Array.isArray(associatedKpis) || associatedKpis.length === 0) {
            return (
                <div
                    className="tw-mt-6"
                    style={{ minHeight: `${carouselMinHeight}px` }}
                    aria-hidden="true"
                />
            );
        }
        const CARDS_PER_PAGE = 3;
        const CARD_COLORS = ['#6343FF', '#E52CA7', '#2F2CE5', '#0891B2', '#16A34A'];
        const heroCards = associatedKpis.map((kpi, idx) => {
            const series = this.getIncidentChartSeries(kpi);
            return {
            id: `${incidentId}_card_${idx}`,
            idx,
            title: kpi.kpi_name || '—',
            rawValue: kpi.kpi_agg_value,
            trend: this.formatDriftDisplayValue(kpi.trends_value, "NA"),
            trendUp: this.isTrendUp(kpi),
            label: '',
            desc: kpi.impact || '',
            color: CARD_COLORS[idx % CARD_COLORS.length],
            xValues: series.xValues,
            yValues: series.yValues,
            zValues: series.zValues,
            compareIndex: series.compareIndex,
            driftValues: series.driftValues,
            previousAvgValues: series.previousAvgValues,
            units: this.getChartDisplayUnits(kpi),
            attributeNames: this.getIncidentAttributeNames(kpi),
            kpiRef: kpi,
            source: kpi.source || {},
        };
        });

        const totalCards = heroCards.length;
        const maxIndex = Math.max(0, totalCards - CARDS_PER_PAGE);
        const heroKpiCarouselIndex = Math.min(this.getHeroKpiCarouselIndex(incidentId), maxIndex);
        const canGoLeft = heroKpiCarouselIndex > 0;
        const canGoRight = heroKpiCarouselIndex < maxIndex;
        const isScrollable = totalCards > CARDS_PER_PAGE;

        const cardWidthPct = 100 / CARDS_PER_PAGE;
        const translateX = heroKpiCarouselIndex * cardWidthPct;
        const visibleStart = heroKpiCarouselIndex;
        const visibleEnd = heroKpiCarouselIndex + CARDS_PER_PAGE - 1;
        const renderedAssocCharts = this.state.renderedHeroKpiCharts?.[incidentId] || new Set();

        return (
            <div className="tw-mt-5" style={{ position: 'relative', minHeight: `${carouselMinHeight}px` }}>
                {/* Left arrow */}
                {isScrollable && canGoLeft && (
                    <button
                        onClick={() => this.handleKpiGoLeft(incidentId, totalCards)}
                        disabled={!canGoLeft}
                        className={`tw-absolute tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-outline-none tw-transition-all tw-duration-200 tw-ease-in-out tw-border-0 ${canGoLeft
                            ? 'tw-opacity-100 tw-cursor-pointer'
                            : 'tw-opacity-60 tw-cursor-not-allowed'
                            }`}
                        style={{
                            background: 'linear-gradient(135deg, rgb(246, 245, 255) -56%, rgb(142, 114, 232) 78.2%)',
                            boxShadow: '0px 0px 50px 0px rgba(255,255,255,0.5)',
                            position: 'absolute',
                            left: '-16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 20,
                            width: '32px',
                            height: '32px',
                            border: 'none',
                            outline: 'none'
                        }}
                        aria-label="Previous cards"
                    >
                        <svg className="tw-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 12L6 8L10 4" stroke={canGoLeft ? '#ffffff' : 'rgba(255,255,255,0.7)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                )}
                {/* Right arrow */}
                {isScrollable && canGoRight && (
                    <button
                        onClick={() => this.handleKpiGoRight(incidentId, totalCards)}
                        disabled={!canGoRight}
                        className={`tw-absolute tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-outline-none tw-transition-all tw-duration-200 tw-ease-in-out tw-border-0 ${canGoRight
                            ? 'tw-opacity-100 tw-cursor-pointer'
                            : 'tw-opacity-60 tw-cursor-not-allowed'
                            }`}
                        style={{
                            background: 'linear-gradient(135deg, rgb(246, 245, 255) -56%, rgb(142, 114, 232) 78.2%)',
                            boxShadow: '0px 0px 50px 0px rgba(255,255,255,0.5)',
                            position: 'absolute',
                            right: '-16px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 20,
                            width: '32px',
                            height: '32px',
                            border: 'none',
                            outline: 'none'
                        }}
                        aria-label="Next cards"
                    >
                        <svg className="tw-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 12L10 8L6 4" stroke={canGoRight ? '#ffffff' : 'rgba(255,255,255,0.7)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                )}

                {/* Card track — clip horizontal scroll only; allow chart tooltips to paint above */}
                <div
                    className="tw-w-full tw-overflow-x-hidden tw-overflow-y-visible tw-relative tw-select-none tw-z-[2]"
                    style={{ width: '100%' }}
                    onMouseMove={this.handleKpiDragMove}
                    onMouseUp={this.handleKpiDragEnd}
                    onMouseLeave={this.handleKpiDragEnd}
                    onTouchMove={this.handleKpiDragMove}
                    onTouchEnd={this.handleKpiDragEnd}
                    onClickCapture={this.handleKpiClickCapture}
                >
                    <div
                        ref={this.kpiTrackRef}
                        className="tw-flex tw-gap-6"
                        style={{
                            transform: `translateX(calc(-${translateX}% - ${heroKpiCarouselIndex * (24 / CARDS_PER_PAGE)}px))`,
                            transition: 'transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
                            willChange: 'transform',
                            gap: '24px',
                        }}
                    >
                        {heroCards.map((card) => (
                            <div
                                key={card.id}
                                className="tw-bg-[#0C0E12] tw-rounded-[12px] tw-p-5 tw-flex-grow tw-flex tw-flex-col tw-justify-between tw-transition tw-duration-200 tw-ease-in-out tw-overflow-visible tw-relative tw-z-[1] hover:tw-z-[40]"
                                onMouseDown={(e) => this.handleKpiDragStart(e, incidentId)}
                                onTouchStart={(e) => this.handleKpiDragStart(e, incidentId)}
                                onDragStart={(e) => e.preventDefault()}
                                style={{
                                    minWidth: `calc(${cardWidthPct}% - ${(CARDS_PER_PAGE - 1) * 24 / CARDS_PER_PAGE}px)`,
                                    flex: `0 0 calc(${cardWidthPct}% - ${(CARDS_PER_PAGE - 1) * 24 / CARDS_PER_PAGE}px)`,
                                    cursor: isScrollable ? 'grab' : 'default',
                                }}
                            >
                                <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                    {/* Title */}
                                    <a
                                        href="#!"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            this.redirectToAssociatedKpi(card.kpiRef, parentIncident);
                                        }}
                                        className="tw-flex tw-items-center tw-text-sm tw-text-[#CCCCCC] tw-font-medium hover:tw-text-white hover:tw-no-underline tw-group tw-min-w-0"
                                    >
                                        <KpiIcon size={16} color="#B5B5C3" className="tw-mr-1 tw-shrink-0" />
                                        <span className="tw-overflow-hidden tw-whitespace-nowrap tw-truncate">{card.title}</span>
                                        <RcTooltip trigger={["hover"]} placement="top" overlay={<span>View in Monitor</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                            <i className="tw-ml-[6px] tw-flex-shrink-0">
                                                <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="18" height="18" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                                </svg>
                                            </i>
                                        </RcTooltip>
                                    </a>
                                    <div className="tw-flex">
                                        <div className="tw-relative tw-inline-block">
                                            {this.renderHeroChartTypeDropdown(card.id, 'grid')}
                                        </div>
                                    </div>
                                </div>
                                <div className="tw-flex tw-items-end tw-justify-between">
                                    <div className="tw-w-1/2">
                                        {this.renderMetricValueWithUnits(
                                            card.rawValue,
                                            card.units,
                                            "tw-block tw-text-[20px] md:tw-text-[28px] xl:tw-text-[32px] 2xl:tw-text-[36px] tw-leading-tight tw-text-[#F7F7F7] tw-font-semibold tw-mb-[6px]",
                                            1
                                        )}
                                        <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-flex-col tw-items-start tw-mb-0">
                                            <span className="tw-flex tw-items-center tw-mr-2">
                                                {this.renderTrendBadge(card.trendUp, card.trend, 14)}
                                            </span>
                                            {/* <span className="tw-text-[#94979C] tw-text-xs tw-mt-1">{card.desc}</span> */}
                                        </p>
                                    </div>
                                    <div className="tw-w-1/2 tw-min-w-0 tw-relative tw-z-[50]" style={{ height: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px`, minHeight: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px` }}>
                                        {(renderedAssocCharts.has(card.idx) || (card.idx >= visibleStart && card.idx <= visibleEnd)) && card.xValues.length > 0 && card.yValues.length > 0 ? (
                                        <VerticalChart xValues={card.xValues} yValues={card.yValues} zValues={card.zValues} compareIndex={card.compareIndex} driftValues={card.driftValues} previousAvgValues={card.previousAvgValues} type={this.resolveHeroChartTypeForKey(card.id, 'grid')} units={card?.units || ''} height={VERTICAL_CHART_HEIGHT.HERO_KPI_CARD} axisFontSize={VERTICAL_CHART_AXIS_FONT.HERO_KPI_CARD} heroBarLayout={true} showXAxis={false} />
                                        ) : (
                                            <div
                                                className="tw-w-full"
                                                style={{ height: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px`, minHeight: `${VERTICAL_CHART_HEIGHT.HERO_KPI_CARD}px` }}
                                                aria-hidden="true"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    getKpiSliderSettings = (layoutIndex) => {
        const cfg = getSectionCfg(layoutIndex);
        if (cfg.sliderSettings) {
            return {
                ...cfg.sliderSettings,
                cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
                touchThreshold: 15,
                swipeToSlide: true,
                waitForAnimate: false,
                ...(cfg.rtl ? { rtl: true } : {})
            };
        }
        const cardStyle    = getSectionCardStyle(layoutIndex);
        const slidesToShow = getSectionSlidesToShow(layoutIndex);
        const rtl          = getSectionRtl(layoutIndex);
        const baseSettings = SECTION_KPI_STYLE_SETTINGS[cardStyle] || SECTION_KPI_STYLE_SETTINGS.standard;
        return {
            ...baseSettings,
            slidesToShow,
            cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
            touchThreshold: 15,
            swipeToSlide: true,
            waitForAnimate: false,
            ...(rtl ? { rtl: true } : {})
        };
    }

    getKpiSectionItems = (section) => {
        if (!section || typeof section !== 'object') {
            return [];
        }
        const arrays = [
            section.items,
            section.kpi_items,
            section.summary,
            section.kpis,
            section.kpi_summary,
            section.data,
            section.history,
            section.series,
            section.values,
        ];
        for (const candidate of arrays) {
            if (Array.isArray(candidate) && candidate.length) {
                return candidate;
            }
        }
        return [];
    }

    getKpiVisibleSlideIndices = (layoutIndex, activeSlide, totalItems = Number.MAX_SAFE_INTEGER) => {
        const cfg = getSectionCfg(layoutIndex);
        const slidesToShow = Math.max(1, Math.ceil(cfg.sliderSettings?.slidesToShow || cfg.slidesToShow || 3));
        const safeTotal = Math.max(0, totalItems);
        if (safeTotal === 0) return [];
        const start = Math.max(0, Math.min(activeSlide, safeTotal - 1));
        const end = Math.min(safeTotal - 1, start + slidesToShow - 1);
        const indices = [];
        for (let i = start; i <= end; i++) indices.push(i);
        return indices;
    }

    setKpiSectionChartsRendered = (sectionIndex, activeSlide, totalItems = Number.MAX_SAFE_INTEGER, options = {}) => {
        const { bumpVersion = false } = options;
        const layoutIndex = options.layoutIndex != null
            ? options.layoutIndex
            : this.getLayoutIndexForSection(sectionIndex);
        const normalizedSlide = this.toSlideIndex(activeSlide);
        const indices = this.getKpiVisibleSlideIndices(layoutIndex, normalizedSlide, totalItems);
        const key = `s${sectionIndex}`;
        const prevSet = this.state.renderedCharts[key];
        const prevSlide = this.state.activeSectionSlides[sectionIndex] || 0;
        const sameSlide = prevSlide === normalizedSlide;
        const allVisibleAlreadyRendered = indices.length > 0
            && indices.every((idx) => prevSet?.has(idx));
        const hasNewCharts = indices.some((idx) => !prevSet?.has(idx));

        // Visible charts already mounted — only update active slide if it changed.
        if (allVisibleAlreadyRendered) {
            if (sameSlide) {
                return Promise.resolve();
            }
            return new Promise((resolve) => {
                this.setState(prev => ({
                    activeSectionSlides: {
                        ...prev.activeSectionSlides,
                        [sectionIndex]: normalizedSlide,
                    },
                }), resolve);
            });
        }

        if (sameSlide && !hasNewCharts && !bumpVersion) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            this.setState(prev => {
                const existing = prev.renderedCharts[key] || new Set();
                const merged = new Set(existing);
                indices.forEach((idx) => merged.add(idx));
                const chartsChanged = merged.size !== existing.size
                    || indices.some((idx) => !existing.has(idx));

                const next = {
                    activeSectionSlides: {
                        ...prev.activeSectionSlides,
                        [sectionIndex]: normalizedSlide,
                    },
                };

                if (chartsChanged) {
                    next.renderedCharts = {
                        ...prev.renderedCharts,
                        [key]: merged,
                    };
                }

                // Remount only when newly rendered charts need a layout pass.
                if (bumpVersion && chartsChanged) {
                    next.sliderChartVersions = {
                        ...prev.sliderChartVersions,
                        [key]: (prev.sliderChartVersions[key] || 0) + 1,
                    };
                }
                return next;
            }, resolve);
        });
    };

    waitForSectionRenderComplete = () => Promise.resolve();

    markSectionChartsRendered = (sectionIndex, startSlide = 0, totalItems = Number.MAX_SAFE_INTEGER) => {
        this.setKpiSectionChartsRendered(sectionIndex, startSlide, totalItems);
    };

    closeAllAiInsights = () => {
        const openInsights = this.state.showAiInsights || {};
        const hasOpen = Object.values(openInsights).some(Boolean);
        if (!hasOpen) return;
        this.setState({ showAiInsights: {} });
    };

    shouldRenderHeroChart = (index) => {
        if (this.state.renderedHeroCharts?.[index]) {
            return true;
        }
        const activeIndex = this.state.heroCarouselIndex;
        return Math.abs(index - activeIndex) <= 1;
    };

    handleHeroBeforeChange = (_currentSlide, nextSlide) => {
        const index = this.toSlideIndex(nextSlide);
        if (index === this.state.heroCarouselIndex) return;
        this.closeAllAiInsights();
        this.setState((prev) => {
            const total = (prev.verticalHeroIncidents || []).length;
            const nextRendered = { ...(prev.renderedHeroCharts || {}) };
            const markAround = (center) => {
                for (let i = center - 1; i <= center + 1; i += 1) {
                    if (i >= 0 && i < total) {
                        nextRendered[i] = true;
                    }
                }
            };
            markAround(prev.heroCarouselIndex);
            markAround(index);
            return {
                heroCarouselIndex: index,
                renderedHeroCharts: nextRendered,
            };
        });
    };

    handleHeroAfterChange = (currentSlide) => {
        const index = this.toSlideIndex(currentSlide);
        this.isDragging = false;
        this.dragOffset = 0;
        this.activeHeroKpiCarouselId = null;
        if (index !== this.state.heroCarouselIndex) {
            this.closeAllAiInsights();
        }
        this.setState((prev) => {
            const total = (prev.verticalHeroIncidents || []).length;
            const nextRendered = { ...(prev.renderedHeroCharts || {}) };
            const markAround = (center) => {
                for (let i = center - 1; i <= center + 1; i += 1) {
                    if (i >= 0 && i < total) {
                        nextRendered[i] = true;
                    }
                }
            };
            markAround(prev.heroCarouselIndex);
            markAround(index);
            if (index === prev.heroCarouselIndex) {
                const alreadyMarked = [index - 1, index, index + 1].every(
                    (i) => i < 0 || i >= total || nextRendered[i]
                );
                if (alreadyMarked && Object.keys(nextRendered).length === Object.keys(prev.renderedHeroCharts || {}).length) {
                    return null;
                }
            }
            return {
                heroCarouselIndex: index,
                renderedHeroCharts: nextRendered,
            };
        });
    };

    handleKpiSliderAfterChange = (sectionIndex, currentSlide, totalItems = Number.MAX_SAFE_INTEGER, layoutIndex = sectionIndex) => {
        if (this._kpiSliderChangeTimer) {
            clearTimeout(this._kpiSliderChangeTimer);
        }
        const slideIndex = this.toSlideIndex(currentSlide);
        this._kpiSliderChangeTimer = setTimeout(() => {
            this.setKpiSectionChartsRendered(sectionIndex, slideIndex, totalItems, { layoutIndex });
        }, 50);
    };

    getKpiChartData = (item) => {
        if (!item || typeof item !== 'object') {
            return [];
        }
        // Primary: x/y value or axis arrays (API may send either naming)
        const { xValues, yValues } = this.getIncidentChartSeries(item);
        if (xValues.length && yValues.length) {
            return xValues.map((x, i) => ({
                label: String(x ?? i),
                value: Number(yValues[i] ?? 0),
            }));
        }
        const candidates = [item.trend_data, item.data, item.history, item.series, item.values, item.chart_data];
        let dataArray = null;
        for (const candidate of candidates) {
            if (Array.isArray(candidate) && candidate.length) { dataArray = candidate; break; }
        }
        if (!Array.isArray(dataArray)) return [];
        return dataArray.map((point, i) => ({
            label: String(point?.label ?? point?.x ?? point?.name ?? point?.date ?? i),
            value: Number(point?.value ?? point?.y ?? point?.count ?? point?.amount ?? point?.issue_count ?? 0),
        }));
    }

    renderAiInsightPopover = (customSourceDataset, customSourceAttribute, item = null, buttonClass = "", imageClass = "") => {
        const attributeCount = this.getIncidentAttributeNames(item).length;
        const sourceAttributeLabel = attributeCount > 0
            ? this.formatAttributeCountLabel(attributeCount)
            : customSourceAttribute;
        return (
            <OverlayTrigger
                trigger="click"
                rootClose
                flip={true}
                placement="auto"
                popperConfig={{
                    strategy: 'fixed',
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: 'viewport',
                                padding: 12,
                                altAxis: true,
                            },
                        },
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['left', 'right'],
                                allowedAutoPlacements: ['left', 'right'],
                                checkAltAxis: false,
                                boundary: 'viewport',
                                padding: 12,
                            },
                        },
                    ],
                }}
                overlay={
                    <Popover className="ai-popover ai-popover--incident tw-flex tw-flex-col">
                        <Popover.Content className="tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-overflow-hidden">
                            <i className="icon-close !tw-z-10" onClick={() => document.body.click()}>
                                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </i>
                            <div className="ai-popover__stack tw-overflow-y-auto tw-flex-1 tw-min-h-0 [scrollbar-width:thin] [scrollbar-color:rgba(255,255,255,0.2)_transparent]">
                                <IncidentAiInsightContent
                                    request={getVerticalAiInsightsRequest(item, this.state.teamId, this.state.userId)}
                                    sourceDataset={customSourceDataset}
                                    sourceAttribute={sourceAttributeLabel}
                                />
                            </div>
                            <div className="ai-popover__action tw-shrink-0 tw-flex tw-items-center tw-justify-between">
                                <div className="dap-foot-left tw-flex tw-items-center tw-justify-start">
                                    <div className="dap-vote-group tw-flex tw-items-center tw-gap-1">
                                        <button
                                            type="button"
                                            className="dap-vote"
                                            data-ai-vote="up"
                                            aria-pressed="false"
                                            aria-label="This insight was helpful"
                                            title="This insight was helpful"
                                            onClick={(e) => {
                                                const btn = e.currentTarget;
                                                const isPressed = btn.getAttribute('aria-pressed') === 'true';
                                                const parent = btn.parentElement;
                                                parent.querySelectorAll('[data-ai-vote]').forEach(b => {
                                                    b.setAttribute('aria-pressed', 'false');
                                                });
                                                btn.setAttribute('aria-pressed', String(!isPressed));
                                                if (this.showInteractionToast) {
                                                    this.showInteractionToast(isPressed ? 'rating_removed' : 'like', !isPressed);
                                                }
                                            }}
                                        >
                                            <svg className="vote-icon-lined" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                                                <path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z" />
                                            </svg>
                                            <svg className="vote-icon-filled" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                                                <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                            </svg>
                                        </button>
                                        <button
                                            type="button"
                                            className="dap-vote"
                                            data-ai-vote="down"
                                            aria-pressed="false"
                                            aria-label="This insight was not helpful"
                                            title="This insight was not helpful"
                                            onClick={(e) => {
                                                const btn = e.currentTarget;
                                                const isPressed = btn.getAttribute('aria-pressed') === 'true';
                                                const parent = btn.parentElement;
                                                parent.querySelectorAll('[data-ai-vote]').forEach(b => {
                                                    b.setAttribute('aria-pressed', 'false');
                                                });
                                                btn.setAttribute('aria-pressed', String(!isPressed));
                                                if (this.showInteractionToast) {
                                                    this.showInteractionToast(isPressed ? 'rating_removed' : 'dislike', !isPressed);
                                                }
                                            }}
                                        >
                                            <svg className="vote-icon-lined" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                                                <g transform="rotate(180 480 -480)">
                                                    <path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z" />
                                                </g>
                                            </svg>
                                            <svg className="vote-icon-filled" xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor">
                                                <g transform="rotate(180 480 -480)">
                                                    <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="dap-foot-right tw-flex tw-items-center tw-justify-end tw-gap-1.5">
                                    <button
                                        type="button"
                                        className="dap-act"
                                        data-ai-lineage="true"
                                        aria-label="View lineage"
                                        title="View lineage"
                                        onClick={() => {
                                            document.body.click();
                                            if (item && this.handleDiagnosticsMapOpen) {
                                                this.handleDiagnosticsMapOpen(item);
                                            }
                                        }}
                                    >
                                        <GitBranch size={16} />
                                    </button>
                                    <button
                                        type="button"
                                        className="dap-act"
                                        data-ai-monitor="true"
                                        aria-label="Open monitor view"
                                        title="Open monitor view"
                                        onClick={() => {
                                            document.body.click();
                                            if (item) {
                                                if (this.redirectToVerticalDasboard) {
                                                    this.redirectToVerticalDasboard(item);
                                                } else if (this.handleViewIncident) {
                                                    this.handleViewIncident(item);
                                                }
                                            }
                                        }}
                                    >
                                        <Expand size={16} />
                                    </button>
                                    <button
                                        type="button"
                                        className="dap-more"
                                        data-ai-details="true"
                                        onClick={() => {
                                            document.body.click();
                                            if (this.navigationHeaderRef && this.navigationHeaderRef.current && this.navigationHeaderRef.current.handleShowAiAssistant) {
                                                this.navigationHeaderRef.current.handleShowAiAssistant();
                                            }
                                        }}
                                    >
                                        Ask QualdoAI <ArrowRight size={15} />
                                    </button>
                                </div>
                            </div>
                        </Popover.Content>
                    </Popover>
                }
            >
                <button
                    type="button"
                    className={`tw-cursor-pointer tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-transparent hover:tw-bg-white/20 tw-transition-colors tw-border-0 tw-outline-none tw-align-middle ${buttonClass || "tw-w-8 tw-h-8"}`}
                    aria-label="AI Insights"
                    title="AI Insights"
                >
                    <Image className={`tw-flex-shrink-0 ${imageClass || "!tw-w-[20px] !tw-h-[20px]"}`} src={"icon_ai_assistant"} />
                </button>
            </OverlayTrigger>
        );
    };

    renderKpiSliderItem = (item, itemIndex, sectionIndex = 0, isChartRendered = false, activeSlide = -1, layoutIndex = null) => {
        // --- field extraction from API response ---
        const resolvedLayoutIndex = layoutIndex != null ? layoutIndex : getSectionLayoutIndex(sectionIndex);
        const sectionChartType = getSectionChartType(resolvedLayoutIndex);
        const chartHeight = getSectionChartHeight(resolvedLayoutIndex);
        const axisFontSize = getSectionAxisFontSize(resolvedLayoutIndex);
        const itemTitle = item?.kpi_name || item?.title || item?.name || "KPI Metric";

        // Stable per-item key (computed early for chart type resolution)
        const kpiItemKey = `s${sectionIndex}_${item?.kpi_incident_id || item?.kpi_id || item?.id || `${itemTitle}-${itemIndex}`}`;

        // Resolve chart type: per-item override → Combo by business_area API order → global filter → API slider
        const selectedChart = this.state.selectedChartFilterOption?.value || 'Combo Chart';
        const sectionBusinessId = item?.business_id
            || (this.state.verticalKpiSummary || [])[sectionIndex]?.business_id
            || null;
        const sectionOrderIndex = this.getComboSectionOrderIndex(sectionIndex, sectionBusinessId);
        const resolvedChartType = resolveKpiChartType({
            kpiChartTypes: this.state.kpiChartTypes,
            kpiItemKey,
            selectedChartFilter: selectedChart,
            sectionChartType,
            itemSlider: item?.slider,
            slideIndex: itemIndex,
            sectionOrderIndex,
        });
        const rawValue = item?.kpi_agg_value ?? item?.issue_count ?? item?.value ?? item?.count;
        const units = this.getChartDisplayUnits(item);
        const renderKpiMetricValue = (valueClassName) => this.renderMetricValueWithUnits(rawValue, units, valueClassName, 1);
        const periodLabel = this.getPeriodLabel(item?.period_type);
        const trendsValue = item?.trends_value != null ? item.trends_value : null;
        const src = item?.source || {};
        const sourceLabel = src.subject_area_name || src.business_area_name || item?.subject_name || "KPI";
        const datasetName = src.data_set_name || src.integration_name || "";
        const itemAttributeNames = this.getIncidentAttributeNames(item);
        const generatedAt = item?.generated_at ? this.getIncidentDate(item.generated_at) : "";
        const trendIsUp = this.isTrendUp(item);

        const { xValues: chartXValues, yValues: chartYValues, zValues: chartZValues, compareIndex: chartCompareIndex, driftValues: chartDriftValues, previousAvgValues: chartPreviousAvgValues } = this.getIncidentChartSeries(item);

        // Shared sub-blocks reused across designs
        const sourceBadge = (
            <div className="tw-inline-flex tw-items-center tw-rounded-[999px] tw-bg-[#000000]/20 tw-py-1 tw-px-2 tw-border tw-border-[#ffffff]/5">
                <i>
                    <svg className="tw-block" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.75"><path d="M4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H8.925C9.14033 5 9.34967 5.04358 9.553 5.13075C9.75617 5.21792 9.93017 5.33392 10.075 5.47875L11.5963 7H19.3845C19.8448 7 20.2292 7.15417 20.5375 7.4625C20.8458 7.77083 21 8.15517 21 8.6155V17.3845C21 17.8448 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8448 19 19.3845 19H4.6155Z" fill="#007BFF" /></g>
                    </svg>
                </i>
                <span className="tw-text-xs tw-text-[#AAAAAA] tw-font-medium tw-px-1">{sourceLabel}</span>
                <RcTooltip trigger={["hover"]}
                    placement="top"
                    overlayClassName="qd-incident-tooltip"
                    overlay={
                        <div className="tw-p-3 tw-min-w-[280px]">
                            <div className="tw-flex tw-flex-col tw-gap-2">
                                <div>
                                    <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">BUSSINESS</span>
                                    {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(item, "BusinessArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                    <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 

                                        <Building size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                        <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                            {item?.source?.business_area_name}
                                            {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                            </svg> */}
                                        </span>
                                        </a>
                                    {/* </a> */}
                                </div>
                                <div>
                                    <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">FUNCTION</span>
                                    {/* <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(item, "SubjectArea"); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> */}
                                    <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} className="tw-flex tw-items-start tw-gap-1 tw-text-[#D4D4D4] hover:tw-text-[#D4D4D4] hover:tw-no-underline tw-group tw-w-full"> 
                                        <FolderClosed size={12} color="#D4D4D4" className="tw-flex-shrink-0 tw-mt-1" />
                                        <span className="tw-text-sm tw-font-medium group-hover:tw-underline">
                                            {item?.source?.subject_area_name}
                                            {/* <svg className="tw-inline-block tw-text-[#F7F7F7] tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 tw-ml-1 tw-align-middle" width="12" height="12" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g><path d="M10.0001 6.66667C8.15564 6.66667 6.66675 8.15556 6.66675 10V30C6.66675 31.8444 8.15564 33.3333 10.0001 33.3333H30.0001C31.8445 33.3333 33.3334 31.8444 33.3334 30V22.2222H31.1112V30C31.1112 30.2947 30.9941 30.5773 30.7858 30.7857C30.5774 30.9941 30.2948 31.1111 30.0001 31.1111H10.0001C9.7054 31.1111 9.42278 30.9941 9.21441 30.7857C9.00603 30.5773 8.88897 30.2947 8.88897 30V10C8.88897 9.37778 9.37786 8.88889 10.0001 8.88889H17.7779V6.66667H10.0001ZM24.4445 8.88889H29.5556L20.3112 18.1111L21.8667 19.6667L31.1112 10.4667V15.5556H33.3334V6.66667H24.4445V8.88889Z" fill="currentColor" /></g>
                                            </svg> */}
                                        </span> </a>
                                    {/* </a> */}
                                </div>
                            </div>
                        </div>
                    }
                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                >
                    <i className="tw-cursor-pointer tw-w-[18px] tw-h-[18px] tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white/15">
                        <svg className="tw-block" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.99999 9.33329V6.99996M6.99999 4.66663H7.00582M12.8333 6.99996C12.8333 10.2216 10.2217 12.8333 6.99999 12.8333C3.77833 12.8333 1.16666 10.2216 1.16666 6.99996C1.16666 3.7783 3.77833 1.16663 6.99999 1.16663C10.2217 1.16663 12.8333 3.7783 12.8333 6.99996Z" stroke="white" strokeOpacity="0.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </i>
                </RcTooltip>
            </div>
        );

        const moreBtn = this.renderChartTypeDropdown({
            wrapperClass: 'kpi-more-btn tw-relative tw-inline-block',
            toggleId: `kpi-more-toggle-${kpiItemKey}`,
            currentType: resolvedChartType,
            onSelectType: (type) => this.setKpiChartType(kpiItemKey, type),
        });

        const trendBadge = trendsValue != null && this.renderTrendBadge(
            trendIsUp,
            this.formatDriftDisplayValue(trendsValue, "—"),
            16
        );

        const dataBreadcrumb = (datasetName || itemAttributeNames.length > 0) ? (
                <div className="tw-flex tw-items-center tw-mb-3 tw-min-w-0">
                    {datasetName && (
                        <>
                            <i className="tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center tw-text-[#94979C]">
                                <FontAwesomeIcon className="tw-block" icon={faLayerGroup} />
                            </i>
                            {itemAttributeNames.length > 0 && (
                                <i className="tw-flex tw-items-center tw-justify-center tw-mx-1">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 12L10 8L6 4" stroke="#6A7894" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </i>
                            )}
                        </>
                    )}
                    {itemAttributeNames.length > 0 && (
                        <a href="#!" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.redirectToVerticalDasboard(item, "Attribute"); }} className="tw-flex tw-items-center tw-text-sm tw-text-[#94979C] tw-font-medium hover:tw-text-white hover:tw-no-underline tw-group tw-min-w-0">
                            <i className="tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
                                <FontAwesomeIcon className="tw-block" icon={faTag} />
                            </i>
                            {this.renderHeroAttributeLabel(item, itemAttributeNames, kpiItemKey)}
                        </a>
                    )}
                </div>
        ) : null;

        const footerBar = (pos = 'tw-left-8 tw-right-8 tw-bottom-6') => this.renderChartActionToolbar(item, {
            wrapperClassName: `tw-flex tw-items-center tw-justify-between tw-absolute ${pos}`,
            timestamp: generatedAt || null,
        });

        const chartResizeKey = this.state.sliderChartVersions[`s${sectionIndex}`] || 0;
        const hasChartData = chartXValues.length > 0 && chartYValues.length > 0;

        const chart = (h = `${VERTICAL_CHART_HEIGHT.DEFAULT}px`) => (
            <div className="tw-mb-3 tw-w-full tw-min-w-0" style={{ height: h }}>
                {hasChartData && isChartRendered ? (
                    <VerticalChart
                        key={`${kpiItemKey}-${chartResizeKey}`}
                        xValues={chartXValues}
                        yValues={chartYValues}
                        zValues={chartZValues}
                        compareIndex={chartCompareIndex}
                        driftValues={chartDriftValues}
                        previousAvgValues={chartPreviousAvgValues}
                        type={resolvedChartType}
                        units={units}
                        height={h}
                        axisFontSize={axisFontSize}
                        resizeKey={chartResizeKey}
                    />
                ) : (
                    <div className="tw-w-full" style={{ height: h }} aria-hidden={!isChartRendered} />
                )}
            </div>
        );

        const key = item?.kpi_incident_id || item?.kpi_id || item?.id || `${itemTitle}-${itemIndex}`;
        const delay = Math.min(0.2 + (itemIndex * 0.1), 0.8);
        const isEnabled = false;
        const isActiveCard = activeSlide >= 0 && itemIndex === activeSlide;

        const aiInsightButton = this.renderAiInsightPopover(datasetName, itemAttributeNames?.[0], item);

        const standardCard = (
            <FadeUpOnScroll delay={delay} key={key} enabled={isEnabled}>
                <div className={`tw-bg-[linear-gradient(180deg,#191932,#161A2C)] tw-border tw-border-solid tw-border-[#ffffff]/10 hover:tw-border-[#ffffff]/25 hover:tw-shadow-[0_0_24px_0_rgba(255,255,255,0.16)] tw-rounded-[30px] tw-transform hover:tw-scale-[1.01] tw-transition tw-duration-100 tw-p-6 2xl:tw-p-8 tw-pb-[48px] 2xl:tw-pb-[56px] tw-shadow-lg tw-relative tw-h-full${isActiveCard ? ' is-card-active' : ''}`}>
                    <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                        {sourceBadge}
                        <div className="tw-flex tw-items-center tw-ml-2">
                            {aiInsightButton}
                            {moreBtn}
                        </div>
                    </div>
                    <h3 className="tw-text-base lg:tw-text-xl tw-text-white tw-font-medium tw-h-[68px] tw-mb-12 tw-line-clamp-2">
                        <KpiIcon size={20} color="#B5B5C3" className="tw-mr-1 tw-align-middle tw-shrink-0" />
                        <span className="tw-align-middle">{itemTitle}</span>
                    </h3>
                    {renderKpiMetricValue("tw-text-[28px] md:tw-text-[36px] xl:tw-text-[48px] 2xl:tw-text-[64px] tw-leading-[34px] md:tw-leading-[44px] xl:tw-leading-[56px] 2xl:tw-leading-[60px] tw-text-white tw-font-medium tw-mb-[6px] tw-block tw-tracking-[-4px]")}
                    <p className="tw-text-[#94979C] tw-text-xs tw-mb-3 tw-flex tw-items-center">
                        {trendBadge && <span className="tw-flex tw-items-center tw-mr-2">{trendBadge}</span>}
                        <span className="tw-line-clamp-1">{periodLabel}</span>
                    </p>
                    {dataBreadcrumb}
                    {this.renderCardMetaInfo(kpiItemKey, item)}
                    {chart(chartHeight)}
                    {footerBar()}
                </div>
            </FadeUpOnScroll>
        );

        const gridCard = (
            <FadeUpOnScroll delay={delay} key={key} enabled={isEnabled}>
                <div className={`tw-bg-[linear-gradient(180deg,#191932,#161A2C)] tw-border tw-border-[#ffffff]/15 tw-rounded-[28px] tw-p-8 tw-pb-[56px] tw-relative tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between ${isActiveCard ? ' is-card-active' : ''}`}>
                    <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                        {sourceBadge}
                        <div className="tw-flex tw-items-center tw-ml-2">
                            {aiInsightButton}
                            {moreBtn}
                        </div>
                    </div>
                    <div className="tw-mr-6">
                        <h3 className="tw-text-base lg:tw-text-xl tw-text-white tw-font-medium tw-mb-2 tw-line-clamp-2">
                            <KpiIcon size={20} color="#B5B5C3" className="tw-mr-1 tw-align-middle tw-shrink-0" />
                            <span className="tw-align-middle">{itemTitle}</span>
                        </h3>
                        {dataBreadcrumb}
                    </div>
                    <div className="tw-flex tw-items-end tw-justify-between tw-mb-6 tw-mt-auto">
                        <div className="tw-w-1/2">
                            {renderKpiMetricValue("tw-text-[20px] md:tw-text-[28px] xl:tw-text-[32px] 2xl:tw-text-[40px] tw-leading-tight tw-text-white tw-font-medium tw-block")}
                            <p className="tw-text-[#94979C] tw-text-xs tw-flex tw-items-center">
                                {trendBadge && <span className="tw-flex tw-items-center tw-mr-2">{trendBadge}</span>}
                                <span className="tw-line-clamp-1">{periodLabel}</span>
                            </p>
                            {this.renderCardMetaInfo(kpiItemKey, item)}
                        </div>
                        <div className="tw-w-1/2 tw-min-w-0 tw-relative tw-z-[50]">
                            {chart(chartHeight)}
                        </div>
                    </div>
                    {footerBar()}
                </div>
            </FadeUpOnScroll>
        );

        const stackedCard = (
            <FadeUpOnScroll delay={delay} key={key} enabled={isEnabled}>
                <div className={`tw-border tw-border-[#ffffff]/10 tw-rounded-[28px]${isActiveCard ? ' is-card-active' : ''}`}>
                    <div className="tw-bg-[linear-gradient(180deg,#191932,#161A2C)] tw-rounded-[26px]">
                        <div className="tw-p-6 tw-pb-[56px] tw-relative">
                            <div className="tw-flex tw-items-center tw-justify-end tw-mb-3">
                                {aiInsightButton}
                                {moreBtn}
                            </div>
                            <h3 className="tw-text-base lg:tw-text-xl tw-text-white tw-font-medium tw-mb-2 tw-line-clamp-2">
                                <KpiIcon size={20} color="#B5B5C3" className="tw-mr-1 tw-align-middle tw-shrink-0" />
                                <span className="tw-align-middle">{itemTitle}</span>
                            </h3>
                            {renderKpiMetricValue("tw-text-[24px] tw-leading-[32px] md:tw-text-[32px] md:tw-leading-[40px] xl:tw-text-[40px] xl:tw-leading-[48px] 2xl:tw-text-[56px] 2xl:tw-leading-[64px] tw-text-white tw-font-medium tw-mb-[6px] tw-block")}
                            <p className="tw-text-[#94979C] tw-text-xs tw-mb-3 tw-flex tw-items-center">
                                {trendBadge && <span className="tw-flex tw-items-center tw-mr-2">{trendBadge}</span>}
                                <span className="tw-line-clamp-1">{periodLabel}</span>
                            </p>
                            {dataBreadcrumb}
                            {this.renderCardMetaInfo(kpiItemKey, item)}
                            {chart(chartHeight)}
                            {footerBar()}
                        </div>
                    </div>
                </div>
            </FadeUpOnScroll>
        );

        const merchandiseCard = (
            <FadeUpOnScroll delay={delay} key={key} enabled={isEnabled}>
                <div className={`tw-rounded-[28px] tw-border tw-border-white/10 tw-overflow-visible d-flex tw-flex-col${isActiveCard ? ' is-card-active' : ''}`}>
                    <div className="tw-bg-[linear-gradient(180deg,#191932,#161A2C)] tw-rounded-[26px]">
                        <div className="tw-p-6 tw-pb-[56px] tw-relative">
                            <div className="tw-flex tw-items-center tw-justify-end tw-mb-3">
                                {aiInsightButton}
                                {moreBtn}
                            </div>
                            <h3 className="tw-text-base lg:tw-text-xl tw-text-white tw-font-medium tw-mb-2 tw-line-clamp-2">
                                <KpiIcon size={20} color="#B5B5C3" className="tw-mr-1 tw-align-middle tw-shrink-0" />
                                <span className="tw-align-middle">{itemTitle}</span>
                            </h3>
                            {chart(chartHeight)}
                            {footerBar()}
                        </div>
                    </div>
                </div>
            </FadeUpOnScroll>
        );

        // section1–section10 card layouts (wraps after section10)
        switch (resolvedLayoutIndex) {
            case 0:  // section1 — Call Center Operations
            case 1:  // section2 — Customer Relationship Management
            case 2:  // section3 — Customer Order & Fulfillment
            case 4:  // section5 — Financial Management
            case 6:  // section7 — Manufacturer Data & Integration
            case 9:  // section10 — Point of Service (POS)
                return standardCard;
            case 3:  // section4 — E-Commerce Platform
            case 7:  // section8 — Marketing Campaign & Analytics
                return gridCard;
            case 5:  // section6 — Forecourt & Fueling Service
                return stackedCard;
            case 8:  // section9 — Merchandise & Product Management
                return merchandiseCard;
            default:
                return standardCard;
        }
    }

    renderVerticalKpiSliderSections = (incidentSummary) => {
        const { verticalKpiSummary, businessAreaData } = this.state;
        if (!Array.isArray(verticalKpiSummary) || verticalKpiSummary.length === 0) {
            return null;
        }

        // Layout types follow screenshot sequence for sections that actually render:
        // 0 Call Center (~3.5) → 1 CRM (4, single row) → 2 Fulfillment (~4.25) →
        // 3 E-Commerce (zigzag 3+2 ONLY) → 4 Financial → 5 Forecourt → 6 Manufacturer →
        // 7 Marketing → 8 Merchandise → 9 POS → wrap.
        const layoutBySectionIndex = this.buildSectionLayoutMap();
        this.sectionLayoutIndexMap = layoutBySectionIndex;

        return verticalKpiSummary.map((section, index) => {
            const businessId         = section?.business_id;
            const observeKey         = businessId ? `b${businessId}` : `s${index}`;

            // Permanently hide only after safe below-fold removal (or known-zero from summary).
            if (this.state.hiddenKpiSections?.[index] || this.isKpiSectionKnownEmpty(section)) {
                return null;
            }

            const lazyData           = businessId ? businessAreaData[businessId] : null;
            const needsLazyLoad      = Boolean(businessId);
            const isLoaded           = !needsLazyLoad || lazyData?.loaded;
            const isSliderReady      = Boolean(this.state.sliderReadySections[index]);
            const sectionItems       = isLoaded
                ? (needsLazyLoad ? (lazyData?.incidents || []) : this.getKpiSectionItems(section))
                : [];
            const layoutIndex = layoutBySectionIndex[index] != null
                ? layoutBySectionIndex[index]
                : getSectionLayoutIndex(0);

            // Empty after load: keep reserved-height ghost (no title flash, no height collapse).
            if (this.state.emptyKpiSections?.[index] || (isLoaded && isSliderReady && sectionItems.length === 0)) {
                return (
                    <div
                        key={`kpi-section-${businessId != null ? businessId : 'x'}-${index}`}
                        id={`kpi-section-empty-${index}`}
                        data-section-index={index}
                        data-observe-key={observeKey}
                        data-business-id={businessId || ''}
                        className="position-relative tw-z-[1]"
                        style={{
                            ...this.getKpiSectionShellStyle(layoutIndex, index),
                            visibility: 'hidden',
                            pointerEvents: 'none',
                        }}
                        ref={el => {
                            if (el) this.kpiSectionRefs[index] = el;
                            else delete this.kpiSectionRefs[index];
                        }}
                        aria-hidden="true"
                    />
                );
            }

            // Pending sections always paint the same shell as loaded ones (title + placeholder).
            const showTitleChrome = isLoaded && isSliderReady
                ? sectionItems.length > 0
                : true;

            if (!showTitleChrome) {
                return null;
            }

            const sectionName        = getSectionName(layoutIndex);
            const sectionTitle       = section?.title || section?.name || section?.kpi_name || getSectionTitle(layoutIndex);
            const titlePosition      = getSectionTitlePosition(layoutIndex);
            const boxBg              = getSectionBoxBg(layoutIndex);
            const sectionDescription = section?.business_description || section?.description || section?.subtitle || getSectionDescription(layoutIndex);
            const sliderSettings     = this.getKpiSliderSettings(layoutIndex);
            const sectionGlow        = getSectionGlow(layoutIndex);
            const extraSliderClass   = getSectionExtraSliderClass(layoutIndex);

            // Always keep the same titlePosition layout — never swap to a different sentinel chrome on scroll.
            const titlePadding = 'tw-pb-[28px] md:tw-pb-[32px] xl:tw-pb-[40px] 2xl:tw-pb-[48px]';
            const titleHeadingClass = 'tw-text-[28px] md:tw-text-[36px] xl:tw-text-[48px] 2xl:tw-text-[64px] tw-font-bold tw-text-white tw-leading-[34px] md:tw-leading-[44px] xl:tw-leading-[56px] 2xl:tw-leading-[60px] tw-mb-2 lg:tw-mb-3';
            const titleDescClass = 'tw-text-base lg:tw-text-xl tw-text-[#8F949C] tw-m-0';

            const titleBlock = (extraClass = '', descClass = '') => (
                <div className={`${titlePadding} ${extraClass}`}>
                    <h3 className={titleHeadingClass}>{sectionTitle}</h3>
                    <p className={`${titleDescClass} ${descClass}`}>{sectionDescription}</p>
                </div>
            );

            const renderedSet = this.state.renderedCharts[`s${index}`] || new Set();
            const sliderSettingsLazy = {
                ...sliderSettings,
                waitForAnimate: false,
                afterChange: (idx) => this.handleKpiSliderAfterChange(index, idx, sectionItems.length, layoutIndex),
            };

            const activeSlide = this.state.activeSectionSlides[index] || 0;
            const sliderContent = (isLoaded && isSliderReady) ? (
                <div className="position-relative tw-w-full tw-h-full">
                    <Slider
                        key={`kpi-slider-${index}`}
                        ref={slider => { this.sectionSliderRefs[index] = slider; }}
                        {...sliderSettingsLazy}
                        dots={false}
                        className={getSectionSliderClassName(layoutIndex, extraSliderClass, sectionItems.length)}
                    >
                        {sectionItems.map((item, itemIndex) => this.renderKpiSliderItem(item, itemIndex, index, renderedSet.has(itemIndex), activeSlide, layoutIndex))}
                    </Slider>
                        <div className={sectionItems.length <= 1 ? "custom-slider-wrap d-none" : "custom-slider-wrap !tw-left-[120px] 2xl:!tw-left-[150px] !tw-bottom-[13px] !tw-transform-none"}>
                        <span className="custom-slider-length">{this.getSliderPagingLabel(activeSlide, sectionItems.length)}</span>
                        <div className="custom-slider-dots">
                            {(() => {
                                const sectionSlidesToShow = this.getKpiSliderSettings(layoutIndex).slidesToShow || 3;
                                const currentPage = Math.floor(activeSlide / 10);
                                const startDot = currentPage * 10;
                                const endDot = Math.min(startDot + 10, sectionItems.length);
                                return Array.from({ length: endDot - startDot }, (_, i) => {
                                    const dotIndex = startDot + i;
                                    return (
                                        <span
                                            key={dotIndex}
                                            className={`custom-slider-dot ${dotIndex === activeSlide ? 'active' : ''}`}
                                            onClick={() => {
                                                const safeIdx = Math.min(dotIndex, Math.max(0, sectionItems.length - Math.ceil(sectionSlidesToShow)));
                                                this.setKpiSectionChartsRendered(index, safeIdx, sectionItems.length, { layoutIndex });
                                                if (this.sectionSliderRefs[index]) {
                                                    this.sectionSliderRefs[index].slickGoTo(safeIdx);
                                                }
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >{dotIndex + 1}</span>
                                    );
                                });
                            })()}
                        </div>
                    </div>
                </div>
            ) : this.renderKpiSectionSliderPlaceholder(layoutIndex);

            const sliderNode = (
                <div
                    className="position-relative tw-w-full"
                    style={{ minHeight: `${getKpiSliderReserveHeight(layoutIndex)}px` }}
                >
                    {sliderContent}
                </div>
            );

            let content;
            if (titlePosition === 'grid-left-48') {
                // Forecourt: col-4 title right-aligned + col-8 pr-0 slider
                content = (
                    <div className="tw-px-[15px]">
                        <div className="row tw-items-center">
                            <div className="col-lg-4">
                                {titleBlock('tw-text-right tw-pr-6 tw-pl-4 md:tw-pl-[70px] xl:tw-pl-[120px] 2xl:tw-pl-[150px]')}
                            </div>
                            <div className="col-lg-8 pr-0">
                                {sliderNode}
                            </div>
                        </div>
                    </div>
                );
            } else if (titlePosition === 'grid-right-75') {
                // Integration: flex-row-reverse, col-5 title left-aligned + col-7 pl-0 slider (RTL)
                content = (
                    <div className="tw-px-[15px]">
                        <div className="row flex-row-reverse tw-items-center">
                            <div className="col-lg-5">
                                {titleBlock('tw-text-left tw-pl-6 tw-pr-4 md:tw-pr-[70px] xl:tw-pr-[120px] 2xl:tw-pr-[150px]')}
                            </div>
                            <div className="col-lg-7 pl-0">
                                {sliderNode}
                            </div>
                        </div>
                    </div>
                );
            } else if (titlePosition === 'grid-left-57') {
                // Merchandise: col-5 title right-aligned + col-7 pr-0 slider
                content = (
                    <div className="tw-px-[15px]">
                        <div className="row tw-items-center">
                            <div className="col-lg-5">
                                {titleBlock('tw-text-right tw-pr-6 tw-pl-4 md:tw-pl-[70px] xl:tw-pl-[120px] 2xl:tw-pl-[150px]')}
                            </div>
                            <div className="col-lg-7 pr-0">
                                {sliderNode}
                            </div>
                        </div>
                    </div>
                );
            } else if (boxBg) {
                // Marketing Campaign: centered title + relative wrapper with absolute bg box
                content = (
                    <div className="tw-max-w-[90%] tw-m-auto">
                        {titleBlock('tw-text-center tw-max-w-[90%] tw-mx-auto', 'tw-max-w-[80%] tw-mx-auto')}
                        <div className="tw-pt-2 tw-pb-8 tw-relative">
                            <div className="tw-absolute tw-top-0 tw-bottom-[80px] tw-left-[10%] tw-right-[10%] tw-bg-white/10 tw-border tw-border-[#6243FF]/40 tw-rounded-[32px]"></div>
                            {sliderNode}
                        </div>
                    </div>
                );
            } else if (titlePosition === 'top-left') {
                // Financial / POS: left-aligned title inside container
                content = (
                    <div className="qd-id-container">
                        {titleBlock('tw-max-w-[90%]', 'tw-max-w-[85%]')}
                        <div>{sliderNode}</div>
                    </div>
                );
            } else {
                // top (default): centered title + full-width slider
                content = (
                    <>
                        <div className="tw-max-w-[90%] tw-mx-auto">
                            {titleBlock('tw-text-center', 'tw-max-w-[85%] tw-mx-auto')}
                        </div>
                        <div>{sliderNode}</div>
                    </>
                );
            }

            return (
                <div
                    key={`kpi-section-${businessId != null ? businessId : 'x'}-${index}`}
                    id={sectionName}
                    data-section-name={sectionName}
                    data-section-index={index}
                    data-layout-index={layoutIndex}
                    data-observe-key={observeKey}
                    className={`qd-incidents-${sectionName} ${KPI_SECTION_PAD_CLASS} position-relative tw-z-[1] ${getSectionBg(layoutIndex)}`}
                    style={this.getKpiSectionShellStyle(layoutIndex, index)}
                    data-business-id={businessId || ''}
                    ref={el => {
                        if (el) {
                            this.kpiSectionRefs[index] = el;
                            if (businessId) this.businessAreaSectionRefs[businessId] = el;
                        } else if (this.kpiSectionRefs[index]) {
                            delete this.kpiSectionRefs[index];
                        }
                    }}
                >
                    {sectionGlow && (
                        <div
                            className={`tw-rounded-[999px] tw-opacity-50 tw-z-[-1] tw-absolute ${sectionGlow.position}`}
                            style={{ backgroundColor: sectionGlow.color, filter: 'blur(353.7px)', width: sectionGlow.w || '800px', height: sectionGlow.h || '800px' }}
                        />
                    )}
                    {content}
                </div>
            );
        });
    }

    toggleIncidentRow = (rowId) => {
        const expandedIncidentRows = [...this.state.expandedIncidentRows];
        const idx = expandedIncidentRows.indexOf(rowId);
        if (idx > -1) {
            expandedIncidentRows.splice(idx, 1);
        } else {
            expandedIncidentRows.push(rowId);
        }
        this.setState({ expandedIncidentRows });
    };

    renderVerticalIncidentRows = () => {
        const incidents = this.getDisplayedIncidentList();
        if (!incidents.length) {
            return (
                <tr>
                    <td colSpan="12" className="text-center">
                        No incidents found
                    </td>
                </tr>
            );
        }

        return incidents.map((incident, index) => {
            const rowId = `vi_${incident.kpi_incident_id || index}`;
            const isExpanded = this.state.expandedIncidentRows.includes(rowId);
            const incidentName = incident.kpi_name || incident.title || "KPI Incident";
            const title = incident.title;
            const sourceName = this.getIncidentSourceName(incident);
            const timeStr = this.getIncidentDate(incident.generated_at);
            const description = incident.kpi_description || incident.analysis || "";
            const subject_name = incident?.subject_name || incident?.source?.subject_area_name || "N/A";
            const business_area = incident?.business_area || incident?.source?.business_area_name || "N/A";
            const kpi_threshold_condition = incident?.kpi_threshold_condition || "N/A";
            const trends_value = incident?.threshold_value || "N/A";
            const threshold_value = incident?.trends_value || "N/A";
            //const units = incident?.units || "%";

            const rowAttributeNames = this.getIncidentAttributeNames(incident);
            return (
                <React.Fragment key={rowId}>
                    <tr className={`tbl-row${isExpanded ? ' tbl-row--is-expanded' : ''}`}>
                        <td className="pr-0" onClick={() => this.toggleIncidentRow(rowId)} style={{ cursor: 'pointer' }}>
                            <div className="icon-expand">
                                <i>
                                    <svg className="d-block" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        {isExpanded
                                            ? <path d="M10.0003 12.5061L5.57715 8.08296L6.16694 7.49316L10.0003 11.3265L13.8336 7.49316L14.4234 8.08296L10.0003 12.5061Z" fill="#99A1B7" />
                                            : <path d="M10.4997 10.0003L7.24967 6.75033C7.0969 6.59755 7.02051 6.4031 7.02051 6.16699C7.02051 5.93088 7.0969 5.73644 7.24967 5.58366C7.40245 5.43088 7.5969 5.35449 7.83301 5.35449C8.06912 5.35449 8.26356 5.43088 8.41634 5.58366L12.2497 9.41699C12.333 9.50033 12.392 9.5906 12.4268 9.68783C12.4615 9.78505 12.4788 9.88921 12.4788 10.0003C12.4788 10.1114 12.4615 10.2156 12.4268 10.3128C12.392 10.41 12.333 10.5003 12.2497 10.5837L8.41634 14.417C8.26356 14.5698 8.06912 14.6462 7.83301 14.6462C7.5969 14.6462 7.40245 14.5698 7.24967 14.417C7.0969 14.2642 7.02051 14.0698 7.02051 13.8337C7.02051 13.5975 7.0969 13.4031 7.24967 13.2503L10.4997 10.0003Z" fill="#4B5675" />
                                        }
                                    </svg>
                                </i>
                            </div>
                        </td>
                        <td>
                            <div className="d-flex align-items-center tw-gap-1 tw-min-w-0">
                                <Form.Check
                                    custom
                                    type="checkbox"
                                    id={`vi-chk-${rowId}`}
                                    checked={this.state.selectedIncidentIds.includes(this.getIncidentSelectionId(incident))}
                                    onChange={(event) => this.handleIncidentSelection(incident, event.target.checked)}
                                />
                                <a href="#!" className="tw-font-semibold ml-2 tw-inline-flex tw-items-center tw-gap-2 tw-min-w-0">
                                    <span className="tw-inline-flex tw-items-center tw-justify-center tw-shrink-0 tw-text-current">
                                        {KPI_INCIDENT_ICON}
                                    </span>
                                    <span className="tw-truncate">{title}</span>
                                </a>
                            </div>
                        </td>
                        <td>
                            <div className="d-flex align-items-center">
                                <a href="#!" className="tw-font-semibold ml-2">
                                    {incidentName}
                                </a>
                                {this.renderAiInsightPopover(
                                    incident?.source?.data_set_name || sourceName,
                                    rowAttributeNames?.[0] || incident?.source?.attribute_name,
                                    incident,
                                    "tw-w-5 tw-h-5 tw-p-0 tw-ml-1.5 tw-shrink-0",
                                    "!tw-w-[14px] !tw-h-[14px]"
                                )}
                            </div>
                        </td>
                          <td>
                            {business_area}
                        </td>
                          <td>
                            {subject_name}
                        </td>
                        <td>
                            <div className="metric-stat-btns-group">
                                <div className="metric-stat-btns metric-stat-btns--danger">
                                    <button className="metric-stat-btn">{threshold_value}%:<strong className="value ml-1">
                                         {kpi_threshold_condition} {trends_value} %</strong></button>
                                </div>
                            </div>
                        </td>

                         <td>
                                                                                                {this.getScoreSeverityBadge(incident.parent?.score ?? incident.score ?? 0, this.state.severityActiveTab?.type, incident.parent?.type ?? incident.type)}
                                                                                            </td>
                    
                        <td><p className="d-flex align-items-center mb-0">{timeStr}</p></td>
                        {/* <td><p className="d-flex align-items-center mb-0">{dateStr}</p></td> */}
                        <td style={{ minWidth: '320px' }}>
                            <RcTooltip trigger={["hover"]}
                                placement="top"
                                overlayClassName="qd-incident-tooltip qd-table-source-tooltip"
                                overlay={
                                    rowAttributeNames.length > 0
                                        ? this.renderHeroAttributePopover(incident, rowAttributeNames)
                                        : (
                                            <div className="tw-p-3 tw-min-w-[280px]">
                                                <div className="tw-flex tw-flex-col tw-gap-2">
                                                    <div>
                                                        <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">Integration</span>
                                                        <span className="tw-text-sm tw-font-medium tw-text-[#D4D4D4]">
                                                            {incident.source?.integration_name || sourceName || "â€”"}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className="tw-block tw-text-xs tw-text-[#717680] tw-tracking-wider tw-uppercase">Dataset</span>
                                                        <span className="tw-text-sm tw-font-medium tw-text-[#D4D4D4]">
                                                            {incident.source?.data_set_name || "â€”"}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                                <Breadcrumb className="mb-0 tw-flex tw-items-center tw-flex-nowrap tw-min-w-0 tw-w-full">
                                    {incident.source?.integration_name && (
                                        <Breadcrumb.Item href="#" onClick={(e) => e.preventDefault()} className="tw-min-w-0 tw-flex tw-items-center">
                                            <i className="mr-2 tw-flex-shrink-0"><FontAwesomeIcon icon={faDatabase} /></i>
                                            <span className="tw-truncate tw-inline-block tw-max-w-[120px] tw-align-middle" title={incident.source.integration_name}>
                                                {incident.source.integration_name}
                                            </span>
                                        </Breadcrumb.Item>
                                    )}
                                    {incident.source?.data_set_name && (
                                        <Breadcrumb.Item href="#" onClick={(e) => e.preventDefault()} className="tw-min-w-0 tw-flex tw-items-center">
                                            <i className="mr-2 tw-flex-shrink-0"><FontAwesomeIcon icon={faLayerGroup} /></i>
                                            <span className="tw-truncate tw-inline-block tw-max-w-[120px] tw-align-middle">
                                                {incident.source.data_set_name}
                                            </span>
                                        </Breadcrumb.Item>
                                    )}
                                    {rowAttributeNames.length > 0 && (
                                        <Breadcrumb.Item href="#" onClick={(e) => e.preventDefault()} className="tw-min-w-0 tw-flex tw-items-center">
                                            <i className="mr-2 tw-flex-shrink-0"><FontAwesomeIcon icon={faTag} /></i>
                                            <span className="tw-truncate tw-inline-block tw-max-w-[100px] tw-align-middle" >
                                                {rowAttributeNames.length > 1
                                                    ? this.formatAttributeCountLabel(rowAttributeNames.length)
                                                    : rowAttributeNames[0]}
                                            </span>
                                        </Breadcrumb.Item>
                                    )}
                                    {!incident.source?.integration_name && sourceName && (
                                        <Breadcrumb.Item href="#" onClick={(e) => e.preventDefault()} className="tw-min-w-0 tw-flex tw-items-center">
                                            <span className="tw-truncate tw-inline-block tw-max-w-[120px] tw-align-middle">
                                                {sourceName}
                                            </span>
                                        </Breadcrumb.Item>
                                    )}
                                </Breadcrumb>
                            </RcTooltip>
                        </td>
                        <td>
                            <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                <Dropdown.Toggle variant="" id={`vi-action-${rowId}`}>
                                    <i>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#61656C"/>
                                        </svg>
                                    </i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu
                                    alignRight
                                    popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                >
                                    <Dropdown.Header>Quick Action</Dropdown.Header>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => this.handleVerticalInteraction(incident)}>
                                        <i><svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#99A1B7"><path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z"></path></svg></i>Like
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleKpiMarkUnread(incident)}>
                                        <i><svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.62769 11.1228H9.88307V10.0717H4.62769V11.1228ZM4.62769 9.02067H12.6859V7.96959H4.62769V9.02067ZM4.62769 6.91851H12.3153V6.87542C12.0135 6.78643 11.7418 6.65726 11.5002 6.48792C11.2585 6.31858 11.0474 6.11175 10.8667 5.86744H4.62769V6.91851ZM2 16.23V4.50647C2 4.15249 2.12263 3.85287 2.36788 3.60762C2.61313 3.36237 2.91274 3.23975 3.26672 3.23975H10.3035C10.2658 3.41492 10.2458 3.58899 10.2436 3.76196C10.2414 3.93492 10.2524 4.1112 10.2765 4.29082H3.26672C3.21277 4.29082 3.16337 4.3133 3.11852 4.35827C3.07356 4.40311 3.05108 4.45251 3.05108 4.50647V13.6698L4.03208 12.6994H14.0469C14.1009 12.6994 14.1503 12.677 14.1951 12.632C14.2401 12.5871 14.2626 12.5377 14.2626 12.4838V7.17865C14.4638 7.13369 14.6509 7.07617 14.8238 7.0061C14.9967 6.93603 15.1599 6.84395 15.3136 6.72984V12.4838C15.3136 12.8378 15.191 13.1374 14.9458 13.3826C14.7005 13.6279 14.4009 13.7505 14.0469 13.7505H4.47949L2 16.23ZM3.05108 4.50647V13.1845V4.29082V4.50647ZM13.5618 5.85395C13.0273 5.85395 12.5725 5.66645 12.1975 5.29145C11.8224 4.91633 11.6349 4.4615 11.6349 3.92697C11.6349 3.39244 11.8224 2.93768 12.1975 2.56268C12.5725 2.18756 13.0273 2 13.5618 2C14.0964 2 14.5511 2.18756 14.9261 2.56268C15.3013 2.93768 15.4888 3.39244 15.4888 3.92697C15.4888 4.4615 15.3013 4.91633 14.9261 5.29145C14.5511 5.66645 14.0964 5.85395 13.5618 5.85395Z" fill="#99A1B7"></path></svg></i>Mark Unread
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleKpiShare(incident)}>
                                        <i><svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.5327 8.24982L11.4894 5.20651C11.3731 5.09013 11.3149 4.95651 11.3149 4.80563C11.3149 4.65463 11.3731 4.52094 11.4894 4.40457C11.6058 4.29594 11.7407 4.24282 11.8941 4.24519C12.0473 4.24769 12.1759 4.30082 12.2797 4.40457L15.6504 7.77526C15.7207 7.84551 15.7702 7.91957 15.7989 7.99744C15.8278 8.07532 15.8422 8.15944 15.8422 8.24982C15.8422 8.34019 15.8278 8.42432 15.7989 8.50219C15.7702 8.58007 15.7207 8.65413 15.6504 8.72438L12.2797 12.0951C12.1634 12.2113 12.0317 12.2676 11.8847 12.2638C11.7376 12.2599 11.6058 12.2037 11.4894 12.0951C11.3731 11.9787 11.3142 11.8458 11.3128 11.6963C11.3113 11.5468 11.3663 11.4162 11.4778 11.3046L14.5327 8.24982ZM10.5519 8.81232H5.4375C4.76437 8.81232 4.18987 9.05032 3.714 9.52632C3.238 10.0022 3 10.5767 3 11.2498V13.3123C3 13.4719 2.94613 13.6056 2.83838 13.7132C2.73075 13.8209 2.59712 13.8748 2.4375 13.8748C2.27787 13.8748 2.14425 13.8209 2.03663 13.7132C1.92888 13.6056 1.875 13.4719 1.875 13.3123V11.2498C1.875 10.2652 2.22262 9.42532 2.91787 8.73019C3.613 8.03494 4.45287 7.68732 5.4375 7.68732H10.5519L8.07112 5.20651C7.95487 5.09013 7.89675 4.95651 7.89675 4.80563C7.89675 4.65463 7.95487 4.52094 8.07112 4.40457C8.1875 4.29594 8.32237 4.24282 8.47575 4.24519C8.62912 4.24769 8.75775 4.30082 8.86162 4.40457L12.2321 7.77526C12.3024 7.84551 12.3519 7.91957 12.3808 7.99744C12.4097 8.07532 12.4241 8.15944 12.4241 8.24982C12.4241 8.34019 12.4097 8.42432 12.3808 8.50219C12.3519 8.58007 12.3024 8.65413 12.2321 8.72438L8.86162 12.0951C8.74525 12.2113 8.6135 12.2676 8.46637 12.2638C8.31925 12.2599 8.1875 12.2037 8.07112 12.0951C7.95487 11.9787 7.896 11.8458 7.8945 11.6963C7.893 11.5468 7.94806 11.4162 8.05969 11.3046L10.5519 8.81232Z" fill="#99A1B7"></path></svg></i>Share
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleKpiIgnore(incident)}>
                                        <i><svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8525 16.4567L13.1607 14.7649C12.5627 15.1985 11.9132 15.5336 11.2122 15.7703C10.5112 16.0068 9.77366 16.125 8.99966 16.125C8.01403 16.125 7.08778 15.9379 6.22091 15.5638C5.35403 15.1898 4.59997 14.6822 3.95872 14.0409C3.31747 13.3997 2.80984 12.6456 2.43584 11.7788C2.06172 10.9119 1.87466 9.98563 1.87466 9C1.87466 8.226 1.99291 7.4885 2.22941 6.7875C2.46603 6.0865 2.80116 5.437 3.23478 4.839L1.54297 3.14719L2.34491 2.34525L15.6544 15.6548L14.8525 16.4567ZM8.99966 15C9.61403 15 10.202 14.9096 10.7637 14.7289C11.3252 14.5481 11.853 14.289 12.3473 13.9515L4.04816 5.65238C3.71066 6.14663 3.45153 6.6745 3.27078 7.236C3.09003 7.79762 2.99966 8.38563 2.99966 9C2.99966 10.6625 3.58403 12.0781 4.75278 13.2469C5.92153 14.4156 7.33716 15 8.99966 15ZM14.988 12.8653L14.1675 12.0446C14.4425 11.5793 14.65 11.0923 14.7898 10.5836C14.9297 10.075 14.9997 9.54713 14.9997 9C14.9997 7.3375 14.4153 5.92188 13.2465 4.75313C12.0778 3.58438 10.6622 3 8.99966 3C8.45253 3 7.92466 3.06994 7.41603 3.20981C6.90741 3.34969 6.42041 3.55713 5.95503 3.83213L5.13434 3.01162C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 8.99966 1.875C9.98528 1.875 10.9115 2.06206 11.7784 2.43619C12.6453 2.81019 13.3993 3.31781 14.0406 3.95906C14.6818 4.60031 15.1895 5.35437 15.5635 6.22125C15.9376 7.08812 16.1247 8.01438 16.1247 9C16.1247 9.70675 16.0271 10.3845 15.832 11.0333C15.6367 11.6819 15.3554 12.2926 14.988 12.8653Z" fill="#99A1B7"></path></svg></i>Ignore
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => this.handleKpiResolve(incident)}>
                                        <i><svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.625 13.0958L15.4817 9.23909C15.5856 9.13522 15.7161 9.08209 15.8734 9.07972C16.0305 9.07734 16.1634 9.13047 16.2722 9.23909C16.3808 9.34772 16.4351 9.47947 16.4351 9.63434C16.4351 9.78909 16.3808 9.92078 16.2722 10.0294L12.0996 14.202C11.9639 14.3377 11.8058 14.4055 11.625 14.4055C11.4443 14.4055 11.2861 14.3377 11.1504 14.202L9.09225 12.1438C8.9885 12.04 8.93538 11.9095 8.93288 11.7523C8.9305 11.5951 8.98363 11.4622 9.09225 11.3535C9.201 11.2449 9.33275 11.1906 9.4875 11.1906C9.64225 11.1906 9.774 11.2449 9.88275 11.3535L11.625 13.0958ZM3.98081 15.3747C3.60794 15.3747 3.28875 15.2419 3.02325 14.9764C2.75775 14.7109 2.625 14.3917 2.625 14.0188V3.98047C2.625 3.60759 2.75775 3.28841 3.02325 3.02291C3.28875 2.75741 3.60794 2.62466 3.98081 2.62466H7.28513C7.389 2.25928 7.60125 1.95641 7.92188 1.71603C8.2425 1.47566 8.60188 1.35547 9 1.35547C9.4135 1.35547 9.77863 1.47566 10.0954 1.71603C10.4123 1.95641 10.6226 2.25928 10.7265 2.62466H14.0192C14.3921 2.62466 14.7113 2.75741 14.9768 3.02291C15.2423 3.28841 15.375 3.60759 15.375 3.98047V6.93716C15.375 7.09653 15.3211 7.23016 15.2132 7.33803C15.1053 7.44578 14.9717 7.49966 14.8123 7.49966C14.6528 7.49966 14.5192 7.44578 14.4116 7.33803C14.3039 7.23016 14.25 7.09653 14.25 6.93716V3.98047C14.25 3.92272 14.2259 3.86984 14.1778 3.82184C14.1298 3.77372 14.0769 3.74966 14.0192 3.74966H12.375V5.03328C12.375 5.22541 12.3103 5.38641 12.1809 5.51628C12.0516 5.64616 11.8913 5.71109 11.7 5.71109H6.29981C6.10856 5.71109 5.94831 5.64616 5.81906 5.51628C5.68969 5.38641 5.625 5.22541 5.625 5.03328V3.74966H3.98081C3.92306 3.74966 3.87019 3.77372 3.82219 3.82184C3.77406 3.86984 3.75 3.92272 3.75 3.98047V14.0188C3.75 14.0766 3.77406 14.1295 3.82219 14.1775C3.87019 14.2256 3.92306 14.2497 3.98081 14.2497H7.6875C7.84688 14.2497 7.9805 14.3036 8.08838 14.4115C8.19613 14.5193 8.25 14.653 8.25 14.8123C8.25 14.9718 8.19613 15.1054 8.08838 15.213C7.9805 15.3208 7.84688 15.3747 7.6875 15.3747H3.98081Z" fill="#99A1B7"></path></svg></i>Resolved
                                    </Dropdown.Item>
                                    <Dropdown.Divider />
                                    {/* <Dropdown.Item onClick={() => this.redirectToVerticalDasboard(incident)}><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                    <Dropdown.Item><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                    <Dropdown.Item><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        </td>
                    </tr>
                    <tr className={`tbl-row__expanded-content${isExpanded ? ' tbl-row--is-expanded' : ' d-none'}`} key={`${rowId}_detail`}>
                        <td colSpan="12">
                            <div className="tbl-dialog-box">
                                <i className="icon-close" onClick={() => this.toggleIncidentRow(rowId)}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956907 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25855C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956907 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956907 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25855 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956907 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25855C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25855 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z" fill="#0F101E" />
                                    </svg>
                                </i>
                                <div className="tbl-dialog-box__left">
                                    <h4>{incidentName}</h4>
                                    <p>{description}</p>
                                    <div className="error-detail">
                                        <h6>Incident Details</h6>
                                        <span className="chart-timestamp">{formatIncidentTimestamp(incident.generated_at)}</span>
                                        {incident.source?.integration_name && (
                                            <div className="nodes-group mt-2">
                                                <div className="nodes-group__parent">
                                                    <div className="node">
                                                        <a className="node-label" href="#!">
                                                            <i><FontAwesomeIcon icon={faDatabase} /></i>
                                                            <span>{incident.source.integration_name}</span>
                                                        </a>
                                                    </div>
                                                </div>
                                                {incident.source?.data_set_name && (
                                                    <div className="nodes-group__child">
                                                        <div className="nodes-group__parent">
                                                            <div className="node">
                                                                <a className="node-label" href="#!">
                                                                    <i><FontAwesomeIcon icon={faLayerGroup} /></i>
                                                                    <span>{incident.source.data_set_name}</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="tbl-dialog-box__right">
                                    <div className="chart-box chart-box--lg w-100 m-0">
                                        <BarChart
                                            height={"200px"}
                                            barHighlight={this.getIncidentBarHighlight(incident)}
                                            chartData={this.getIncidentChartData(incident)}
                                            metricsData={incident.metrics_details || []}
                                            additional_metrics_info={incident.additional_metrics_info || {}}
                                            version_type={incident.version_type}
                                            key={`vi_barchart_${rowId}`}
                                            chartId={`vi_barchart_${rowId}`}
                                            isActive={true}
                                        />
                                        {this.renderChartActionToolbar(incident, { useChartWidgetShell: true })}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </React.Fragment>
            );
        });
    }


    componentWillUnmount() {
        document.body.removeAttribute("style");
        $('body').removeClass('qd-incidents-wrap qd-incidents--verticalization');
        $('html').removeClass('has-menu-dark');
        if (this.businessAreaObserver) {
            this.businessAreaObserver.disconnect();
        }
        this.resetSliderLoadQueue();
        if (this._allIncidentSearchTimer) {
            clearTimeout(this._allIncidentSearchTimer);
        }
        if (this._kpiSliderChangeTimer) {
            clearTimeout(this._kpiSliderChangeTimer);
        }
        if (this._userScrollTimer) {
            clearTimeout(this._userScrollTimer);
        }
        window.removeEventListener('scroll', this.onKpiPageScroll);
        document.removeEventListener('click', this._handleKpiDropdownOutsideClick);
    }


    componentDidMount() {
        if (!["all_issues", "ignored", "read", "like"].includes(this.state.activeTabAllIncident)) {
            this.setState({ activeTabAllIncident: "all_issues" });
        }
        $('body').addClass('qd-incidents-wrap qd-incidents--verticalization');
        $('html').addClass('has-menu-dark');
        this.initializeVerticalIncidents();
        setTimeout(() => {
            if (this.sliderRef.current) {
                this.sliderRef.current.slickGoTo(this.sliderRef.current.innerSlider.state.currentSlide, true);
            }
        }, 0);
        this._handleKpiDropdownOutsideClick = (e) => {
            if (this.state.kpiDropdownOpen !== null && !e.target.closest('.kpi-more-btn')) {
                this.setState({ kpiDropdownOpen: null });
            }
        };
        document.addEventListener('click', this._handleKpiDropdownOutsideClick);
        window.addEventListener('scroll', this.onKpiPageScroll, { passive: true });
    }

    componentDidUpdate(_prevProps, prevState) {
        if (prevState.verticalIncidentList !== this.state.verticalIncidentList) {
            const nextOptions = this.buildKpiFilterOptions(this.state.verticalIncidentList, this.state.selectedKpiFilters);
            if (JSON.stringify(nextOptions) !== JSON.stringify(this.state.kpiFilterOptions)) {
                this.setState({ kpiFilterOptions: nextOptions });
            }
        }
        // Only rebind observer when the section list itself changes — not on every
        // lazy-load ready/hidden update (that disconnect/reconnect thrashes scroll).
        const summaryChanged = prevState.verticalKpiSummary !== this.state.verticalKpiSummary;
        const mountChanged = prevState.mountedKpiSections !== this.state.mountedKpiSections;
        if ((summaryChanged || mountChanged) && (this.state.verticalKpiSummary || []).length > 0) {
            // loadVerticalIncidentData already schedules observer setup in its setState callback.
            if (this._kpiSummaryObserverHandled) {
                this._kpiSummaryObserverHandled = false;
                return;
            }
            requestAnimationFrame(() => {
                this.setupBusinessAreaObserver();
            });
        }
        this.persistVerticalIncidentFilters(prevState);
    }

    persistVerticalIncidentFilters = (prevState) => {
        const filterKeys = [
            "selectedEnvId", "selectedEnvName", "selectedOption", "selectedFilterOption",
            "selectedChartFilterOption", "selcetedDate", "displayDate", "severityActiveTab",
            "selectedBusinessArea", "allIncidentsearchQuery", "allIncidentsortField",
            "allIncidentsortOrder", "allIncidentpageSize", "allIncidentcurrentPage",
            "activeTabAllIncident", "includePartitions", "selectedViewOption", "selectedKpiFilters"
        ];

        if (!filterKeys.some((key) => this.state[key] !== prevState[key])) return;

        const filters = filterKeys.reduce((result, key) => {
            result[key] = this.state[key];
            return result;
        }, {});

        try {
            sessionStorage.setItem(getVerticalIncidentFilterStorageKey(), JSON.stringify(filters));
        } catch (error) {
            // Storage may be unavailable; the page remains usable without persistence.
        }
    };

     getScoreSeverityBadge = (score, incidentLevel = null, incidentType = null) => {
            // For pipeline incidents (type: 3), use the incident_level from API response
            if (incidentType === 3 && incidentLevel) {
                switch (incidentLevel) {
                    case "Critical":
                        return (
                            <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#C17F8A] tw-bg-[#781633] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDA4AF] tw-text-xs tw-font-medium">
                                <Flame className="tw-w-4 tw-h-4 tw-me-1" color="#FDA4AF" /> Critical
                            </div>
                        );
                    case "Severe":
                        return (
                            <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#84772C] tw-bg-[#3D140E] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDE047] tw-text-xs tw-font-medium">
                                <OctagonX className="tw-w-4 tw-h-4 tw-me-1" color="#FDE047" /> High
                            </div>
                        );
                    case "Warning":
                        return (
                            <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#846443] tw-bg-[#432010] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDBA74] tw-text-xs tw-font-medium">
                                <TriangleAlert className="tw-w-4 tw-h-4 tw-me-1" color="#FDBA74" /> Warning
                            </div>
                        );
                    case "Informational":
                        return (
                            <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4287AA] tw-bg-[#092B3F] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#7DD3FC] tw-text-xs tw-font-medium">
                                <Info className="tw-w-4 tw-h-4 tw-me-1" color="#7DD3FC" /> Informational
                            </div>
                        );
                    default:
                        break;
                }
            }
            
            // Original logic for non-pipeline incidents or fallback
            if (score >= 0 && score <= 1) {
                return (
                    <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4287AA] tw-bg-[#092B3F] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#7DD3FC] tw-text-xs tw-font-medium">
                        <Info className="tw-w-4 tw-h-4 tw-me-1" color="#7DD3FC" /> Informational
                    </div>
                );
            } else if (score > 1 && score <= 1.6) {
                return (
                    <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#846443] tw-bg-[#432010] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDBA74] tw-text-xs tw-font-medium">
                        <TriangleAlert className="tw-w-4 tw-h-4 tw-me-1" color="#FDBA74" /> Warning
                    </div>
                );
            } else if (score > 1.6 && score <= 2.3) {
                return (
                    <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#84772C] tw-bg-[#3D140E] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDE047] tw-text-xs tw-font-medium">
                        <OctagonX className="tw-w-4 tw-h-4 tw-me-1" color="#FDE047" /> High
                    </div>
                );
            } else if (score > 2.3) {
                return (
                    <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#C17F8A] tw-bg-[#781633] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#FDA4AF] tw-text-xs tw-font-medium">
                        <Flame className="tw-w-4 tw-h-4 tw-me-1" color="#FDA4AF" /> Critical
                    </div>
                );
            }
            return (
                <div className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-[#4B5563] tw-bg-[#1F2937] tw-py-1 tw-ps-[10px] tw-pe-3 tw-text-[#B5B7C8] tw-text-xs tw-font-medium">
                    <Info className="tw-w-4 tw-h-4 tw-me-1" color="#B5B7C8" /> Unknown
                </div>
            );
        };


    render() {



        let { selectedEnvName } = this.state;
        const selectedPageSizeVal = this.state.allIncidentpageSize?.value;
        const isAllIssuesTab = this.state.activeTabAllIncident === 'all_issues';
        const allIncidentApiTotal = this.state.allIncidentApiTotal || 0;
        const displayedCount = this.getDisplayedIncidentList().length;
        const useApiPages = isAllIssuesTab && allIncidentApiTotal > 0 && selectedPageSizeVal !== 'All';
        const PAGE_SIZE = (selectedPageSizeVal && selectedPageSizeVal !== "All")
            ? Number(selectedPageSizeVal)
            : Math.max(allIncidentApiTotal, displayedCount, 1);
        const filteredIncidentCount = useApiPages ? allIncidentApiTotal : displayedCount;
        const allIncidentCurrentPage = Number(this.state.allIncidentcurrentPage) || 1;
        const incidentStart = filteredIncidentCount === 0 ? 0 : ((allIncidentCurrentPage - 1) * PAGE_SIZE) + 1;
        const incidentEnd = useApiPages
            ? Math.min(allIncidentApiTotal, allIncidentCurrentPage * PAGE_SIZE)
            : displayedCount;
        const totalIncidentPages = useApiPages
            ? Math.max(1, Math.ceil(allIncidentApiTotal / PAGE_SIZE))
            : 1;

        // eslint-disable-next-line 
        const criticalIncidentCarousel = {
            dots: true,
            speed: 500,
            infinite: false,
            // fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        };
        // eslint-disable-next-line 
        const recurringIncidentCarousel = {
            dots: true,
            speed: 500,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            // autoplay: true,
            autoplaySpeed: 3000,
        };
        const incidentSummary = {
            dots: false,
            speed: 500,
            infinite: false,
            slidesToShow: 3.15,
            slidesToScroll: 1,
            cssEase: "cubic-bezier(0.25, 1, 0.5, 1)",
            touchThreshold: 15,
            swipeToSlide: true,
            // centerMode: true,
            // centerPadding: '60px',
        };
        return (
            <>
                <NavigationHeader 
                    ref={this.navigationHeaderRef}
                    page="vertical-incidents"
                    selectedEnvName={selectedEnvName}
                    envList={this.state.envList}
                    callbackEnvironemnt={this.callbackEnvironemnt}
                    cachenable = {true}
                    loader={this.state.sk_loader || this.state.paging_loader}
                    />
                <main>
                    <div class="qd-incidents tw-relative">
                        {/* Start: Incident Filter */}
                        <div class="filter-section">
                            <div class="filter-content">
                                <div class="filter-item">
                                    <Select
                                        name="Integration"
                                        id="wishlist"
                                        options={this.state.watchList}
                                        // menuIsOpen
                                        classNamePrefix='form-control'
                                        value={this.state.selectedOption}
                                        onChange={this.handleWatchlistChange}
                                        components={{ Control: customSelectWishlist }}
                                    // placeholder="Choose Pipeline Source"
                                    />
                                </div>
                                <div class="filter-item">
                                    <DateRangePicker
                                        singleDatePicker
                                        autoApply
                                        showDropdowns
                                        startDate={moment(this.state.selcetedDate)}
                                        maxDate={moment()}
                                        onApply={this.handleChangeDate}
                                        className="datepicker-dark"
                                        containerClass="btn btn-datapicker reportrange"
                                    >
                                        <div className="d-flex align-items-center">
                                            <i>
                                                <svg className="d-block" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g opacity="0.75">
                                                        <path d="M16.0689 9.01774H4.21005V13.6405C4.21005 14.2603 4.21051 14.6888 4.23771 15.0216C4.26431 15.3472 4.31369 15.5277 4.38163 15.6611C4.53245 15.9571 4.77338 16.198 5.06937 16.3489C5.2028 16.4168 5.38326 16.4662 5.70889 16.4928C6.04171 16.52 6.47022 16.5204 7.09004 16.5204H13.1889C13.8087 16.5204 14.2372 16.52 14.57 16.4928C14.8957 16.4662 15.0761 16.4168 15.2096 16.3489C15.5056 16.198 15.7465 15.9571 15.8973 15.6611C15.9652 15.5277 16.0146 15.3472 16.0412 15.0216C16.0684 14.6888 16.0689 14.2603 16.0689 13.6405V9.01774ZM12.4388 5.50887V4.66161H7.84016V5.50887C7.84016 5.84301 7.56952 6.11365 7.23538 6.11365C6.90124 6.11365 6.6306 5.84301 6.6306 5.50887V4.66302C6.24717 4.66459 5.95241 4.66936 5.70889 4.68926C5.38326 4.71586 5.2028 4.76524 5.06937 4.83319C4.77338 4.984 4.53245 5.22493 4.38163 5.52092C4.31369 5.65435 4.26431 5.83481 4.23771 6.16044C4.21051 6.49326 4.21005 6.92178 4.21005 7.54159V7.80817H16.0689V7.54159C16.0689 6.92178 16.0684 6.49326 16.0412 6.16044C16.0146 5.83481 15.9652 5.65435 15.8973 5.52092C15.7465 5.22493 15.5056 4.984 15.2096 4.83319C15.0761 4.76524 14.8957 4.71586 14.57 4.68926C14.3265 4.66936 14.0318 4.66459 13.6483 4.66302V5.50887C13.6483 5.84301 13.3777 6.11365 13.0436 6.11365C12.7094 6.11365 12.4388 5.84301 12.4388 5.50887ZM17.2784 13.6405C17.2784 14.2403 17.2794 14.7266 17.2472 15.1201C17.2145 15.5208 17.1444 15.8781 16.975 16.2106C16.7082 16.7342 16.2826 17.1597 15.759 17.4265C15.4266 17.5959 15.0692 17.6661 14.6686 17.6988C14.2751 17.731 13.7888 17.73 13.1889 17.73H7.09004C6.49017 17.73 6.00386 17.731 5.61034 17.6988C5.20973 17.6661 4.85235 17.5959 4.51989 17.4265C3.9963 17.1597 3.57075 16.7342 3.30395 16.2106C3.13455 15.8781 3.06442 15.5208 3.03169 15.1201C2.99954 14.7266 3.00049 14.2403 3.00049 13.6405V7.54159C3.00049 6.94172 2.99954 6.45541 3.03169 6.06189C3.06442 5.66128 3.13455 5.30391 3.30395 4.97144C3.57075 4.44786 3.9963 4.02231 4.51989 3.7555C4.85235 3.5861 5.20973 3.51597 5.61034 3.48324C5.8981 3.45973 6.23549 3.45502 6.6306 3.45346V2.60478C6.6306 2.27064 6.90124 2 7.23538 2C7.56952 2 7.84016 2.27064 7.84016 2.60478V3.45204H12.4388V2.60478C12.4388 2.27064 12.7094 2 13.0436 2C13.3777 2 13.6483 2.27064 13.6483 2.60478V3.45346C14.0434 3.45502 14.3808 3.45973 14.6686 3.48324C15.0692 3.51597 15.4266 3.5861 15.759 3.7555C16.2826 4.02231 16.7082 4.44786 16.975 4.97144C17.1444 5.30391 17.2145 5.66128 17.2472 6.06189C17.2794 6.45541 17.2784 6.94172 17.2784 7.54159V13.6405Z" fill="#C3D4FA" />
                                                    </g>
                                                </svg>
                                            </i>
                                            <span className="d-inline-block mx-2 tw-text-[#F7F7F7]/85">
                                                {this.state.displayDate}
                                            </span>
                                            <i className="icon-close"></i>
                                        </div>
                                    </DateRangePicker>
                                </div>
                                <div class="filter-item">
                                    {/* <Select
                                        name="chartFilter"
                                        id="chartFilter"
                                        value={this.state.selectedChartFilterOption}
                                        options={chartFilterOptions}
                                        classNamePrefix='form-control'
                                        components={{ Control: customSelectChart }}
                                    placeholder="Choose Pipeline Source"
                                    /> */}
                                    <Select
                                        name="chartFilter"
                                        id="chartFilter"
                                        value={this.state.selectedChartFilterOption}
                                        onChange={(selected) => {
                                            this.setState({
                                                selectedChartFilterOption: selected,
                                                heroChartTypes: {},
                                                kpiChartTypes: {},
                                            });
                                        }}
                                        options={chartFilterOptions}
                                        classNamePrefix="form-control"
                                        components={{ Option: IconOption, SingleValue: IconSingleValue }}
                                        />
                                </div>
                                {/* <div class="filter-item">
                                    <Select
                                        name="Integration"
                                        id="wishlist"
                                        value={this.state.selectedFilterOption}
                                        onChange={this.handleFilterChange}
                                        options={filterOptions}
                                        classNamePrefix='form-control'
                                        components={{ Control: customSelectFilter }}
                                    placeholder="Choose Pipeline Source"
                                    />
                                </div> */}
                                <div className="filter-item">
                                        <Dropdown className="severity-filter-dropdown">
                                            <Dropdown.Toggle variant="">
                                                <i className="mr-2">
                                                    <svg className="d-block form-control__icon" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g opacity="0.75">
                                                            <path d="M9.61034 15C9.3628 15 9.15531 14.9201 8.98786 14.7604C8.82041 14.6007 8.73668 14.4028 8.73668 14.1667C8.73668 13.9306 8.82041 13.7326 8.98786 13.5729C9.15531 13.4132 9.3628 13.3333 9.61034 13.3333H11.3577C11.6052 13.3333 11.8127 13.4132 11.9801 13.5729C12.1476 13.7326 12.2313 13.9306 12.2313 14.1667C12.2313 14.4028 12.1476 14.6007 11.9801 14.7604C11.8127 14.9201 11.6052 15 11.3577 15H9.61034ZM6.11572 10.8333C5.86818 10.8333 5.66069 10.7535 5.49324 10.5938C5.32579 10.434 5.24206 10.2361 5.24206 10C5.24206 9.76389 5.32579 9.56597 5.49324 9.40625C5.66069 9.24653 5.86818 9.16667 6.11572 9.16667H14.8523C15.0998 9.16667 15.3073 9.24653 15.4748 9.40625C15.6422 9.56597 15.7259 9.76389 15.7259 10C15.7259 10.2361 15.6422 10.434 15.4748 10.5938C15.3073 10.7535 15.0998 10.8333 14.8523 10.8333H6.11572ZM3.49475 6.66667C3.24721 6.66667 3.03972 6.58681 2.87227 6.42708C2.70482 6.26736 2.62109 6.06944 2.62109 5.83333C2.62109 5.59722 2.70482 5.39931 2.87227 5.23958C3.03972 5.07986 3.24721 5 3.49475 5H17.4732C17.7208 5 17.9283 5.07986 18.0957 5.23958C18.2632 5.39931 18.3469 5.59722 18.3469 5.83333C18.3469 6.06944 18.2632 6.26736 18.0957 6.42708C17.9283 6.58681 17.7208 6.66667 17.4732 6.66667H3.49475Z" fill="currentColor" />
                                                        </g>
                                                    </svg>
                                                </i>
                                                {this.state.severityActiveTab.value === 'All' ? 'All' : `Top ${this.state.severityActiveTab.value}`} {this.state.severityActiveTab.type} {' incidents'}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Header>Incident Filters</Dropdown.Header>
                                                {(() => {
                                                    const filterChips = [
                                                        { label: 'Top 10', value: 10 },
                                                        { label: 'Top 25', value: 25 },
                                                        { label: 'Top 50', value: 50 },
                                                        { label: 'Top 100', value: 100 },
                                                        { label: 'All Issues', value: 'All' },
                                                    ];
                                                    const incidentTypes = [
                                                        {
                                                            key: 'Critical',
                                                            label: 'Critical Incidents',
                                                            color: '#FDA4AF',
                                                            count: this.state.critical_count,
                                                            icon: (
                                                                <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 2.25C9.5 4.25 10.5 5.875 12 7.125C13.5 8.375 14.25 9.75 14.25 11.25C14.25 12.6424 13.6969 13.9777 12.7123 14.9623C11.7277 15.9469 10.3924 16.5 9 16.5C7.60761 16.5 6.27225 15.9469 5.28769 14.9623C4.30312 13.9777 3.75 12.6424 3.75 11.25C3.75 10.4386 4.01317 9.64911 4.5 9C4.5 9.49728 4.69754 9.9742 5.04917 10.3258C5.40081 10.6775 5.87772 10.875 6.375 10.875C6.87228 10.875 7.34919 10.6775 7.70082 10.3258C8.05246 9.9742 8.25 9.49728 8.25 9C8.25 7.5 7.125 6.75 7.125 5.25C7.125 4.25 7.75 3.25 9 2.25Z" stroke="#FDA4AF" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            ),
                                                        },
                                                        {
                                                            key: 'Severe',
                                                            label: 'Severity Incidents',
                                                            color: '#FDE047',
                                                            count: this.state.sever_count,
                                                            icon: (
                                                                <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M11.25 6.75L6.75 11.25M6.75 6.75L11.25 11.25M1.9395 12.5445C1.65818 12.2633 1.50008 11.8818 1.5 11.484V6.516C1.50008 6.11821 1.65818 5.73674 1.9395 5.4555L5.4555 1.9395C5.73674 1.65818 6.11821 1.50008 6.516 1.5H11.484C11.8818 1.50008 12.2633 1.65818 12.5445 1.9395L16.0605 5.4555C16.3418 5.73674 16.4999 6.11821 16.5 6.516V11.484C16.4999 11.8818 16.3418 12.2633 16.0605 12.5445L12.5445 16.0605C12.2633 16.3418 11.8818 16.4999 11.484 16.5H6.516C6.11821 16.4999 5.73674 16.3418 5.4555 16.0605L1.9395 12.5445Z" stroke="#FDE047" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            ),
                                                        },
                                                        {
                                                            key: 'Warning',
                                                            label: 'Warning Incidents',
                                                            color: '#FDBA74',
                                                            count: this.state.warning_count,
                                                            icon: (
                                                                <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.99982 6.75017V9.75017M8.99982 12.7502H9.00732M16.2973 13.5002L10.2973 3.00017C10.1665 2.76932 9.97678 2.57731 9.74752 2.44372C9.51826 2.31013 9.25767 2.23975 8.99232 2.23975C8.72698 2.23975 8.46639 2.31013 8.23713 2.44372C8.00787 2.57731 7.81815 2.76932 7.68732 3.00017L1.68733 13.5002C1.55509 13.7292 1.48575 13.9891 1.48633 14.2536C1.48692 14.518 1.55741 14.7776 1.69066 15.006C1.82391 15.2345 2.01519 15.4236 2.2451 15.5543C2.47501 15.685 2.73538 15.7525 2.99983 15.7502H14.9998C15.263 15.7499 15.5215 15.6804 15.7493 15.5486C15.9771 15.4169 16.1662 15.2275 16.2977 14.9995C16.4292 14.7715 16.4984 14.513 16.4983 14.2498C16.4982 13.9866 16.4289 13.7281 16.2973 13.5002Z" stroke="#FDBA74" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            ),
                                                        },
                                                        {
                                                            key: 'Informational',
                                                            label: 'Informative Incidents',
                                                            color: '#7DD3FC',
                                                            count: this.state.informative_count,
                                                            icon: (
                                                                <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#7DD3FC" strokeLinecap="round" strokeLinejoin="round"/>
                                                                </svg>
                                                            ),
                                                        },
                                                    ];
                                                    return (
                                                        <Accordion>
                                                            {incidentTypes.map((incident, idx) => (
                                                                <Card key={incident.key}>
                                                                    <Accordion.Toggle
                                                                        as={Card.Header}
                                                                        eventKey={incident.count === 0 ? null : String(idx)}
                                                                        onClick={(e) => { if (incident.count === 0) { e.preventDefault(); e.stopPropagation(); } }}
                                                                        style={{ cursor: incident.count === 0 ? 'not-allowed' : 'pointer' }}
                                                                    >
                                                                        <i style={{
                                                                            opacity: incident.count === 0 ? 0.5 : 1,
                                                                        }}>
                                                                            <svg className="d-block" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M6 12L10 8L6 4" stroke="black" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                                                                <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                                                            </svg>
                                                                        </i>
                                                                        <label className={`tw-text-[${incident.color}]`} style={{
                                                                            opacity: incident.count === 0 ? 0.5 : 1,
                                                                        }}>
                                                                            <i>{incident.icon}</i>
                                                                            <span>{incident.label}</span>
                                                                        </label>
                                                                        <span className="count">{incident.count}</span>
                                                                    </Accordion.Toggle>
                                                                    <Accordion.Collapse eventKey={String(idx)}>
                                                                        <Card.Body>
                                                                            <ul className="filter-chips">
                                                                                {filterChips.map(chip => {
                                                                                    const activeType = this.state.severityActiveTab?.type;
                                                                                    const activeValue = this.state.severityActiveTab?.value;
                                                                                    const valueMatch = activeValue === chip.value;
                                                                                    // Highlight if value matches and either this section's type is active
                                                                                    // OR no type is selected yet (show default selection across all sections)
                                                                                    const isActive = valueMatch && (activeType === incident.key || !activeType);
                                                                                    return (
                                                                                        <li
                                                                                            key={chip.value}
                                                                                            className={isActive ? 'filter-chip active' : 'filter-chip'}
                                                                                            onClick={() => this.handleSeverityFilterChip(incident.key, chip.value)}
                                                                                        >
                                                                                            {chip.label}
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ul>
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Card>
                                                            ))}
                                                        </Accordion>
                                                    );
                                                })()}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                            </div>
                        </div>
                        {/* End: Incident Filter */}


                        {/* <VerticalChart data={sampleData} type={"bar"} /> */}


                        {/* Start: Incident Hero Section */}
                        <div className="tw-pb-[48px] xl:tw-pb-[64px] 2xl:tw-pb-[80px] position-relative tw-z-[1]">
                            <div className="tw-w-[600px] tw-h-[600px] 2xl:tw-w-[1200px] 2xl:tw-h-[1200px] tw-rounded-[999px] tw-opacity-50 tw-bg-[#E52CA7]/70 tw-z-[-1] tw-absolute tw-right-[-20%] tw-top-[-20%] " style={{filter: 'blur(354px)'}}></div>
                            <div className="tw-w-[500px] tw-h-[500px] 2xl:tw-w-[1000px] 2xl:tw-h-[1000px] tw-rounded-[999px] tw-opacity-50 tw-bg-[#2F2CE5]/70 tw-z-[-1] tw-absolute tw-left-[-10%] tw-top-[10%]" style={{filter: 'blur(354px)'}}></div>
                            {this.state.sk_loader ? (
                            <div className="qd-incidents-slider slick-slider--action-center qd-incidents-hero-slick tw-pb-[120px]">
                                <div className="tw-flex tw-flex-col tw-items-center tw-justify-center" style={{minHeight: '400px'}}>
                                    <div className="tw-w-full">
                                        <div className="tw-h-8 tw-bg-white/10 tw-rounded tw-mb-4 tw-w-2/3 tw-mx-auto"></div>
                                        <div className="tw-h-4 tw-bg-white/10 tw-rounded tw-mb-6 tw-w-1/2 tw-mx-auto"></div>
                                        <div className="tw-flex tw-gap-4 tw-px-8">
                                            {[1, 2, 3].map(i => (
                                                <div key={i} className="tw-flex-1 tw-bg-white/5 tw-rounded-[28px] tw-p-6 tw-min-h-[280px]">
                                                    <div className="tw-h-4 tw-bg-white/10 tw-rounded tw-mb-4 tw-w-1/2"></div>
                                                    <div className="tw-h-10 tw-bg-white/10 tw-rounded tw-mb-3 tw-w-3/4"></div>
                                                    <div className="tw-h-3 tw-bg-white/10 tw-rounded tw-w-full tw-mb-2"></div>
                                                    <div className="tw-h-3 tw-bg-white/10 tw-rounded tw-w-5/6"></div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ) : this.state.noData ? (
                            <div className="qd-incidents-hero-placeholder">
                                <div className="slick-list">
                                    <div className="qd-incidents-widget">
                                        <div className="qd-incidents-widget__inner">
                                            <div className="mock-msg">
                                                <div className="mb-3">
                                                    <svg width="60" height="66" viewBox="0 0 60 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g filter="url(#filter0_dd_hero_nodata)">
                                                        <path d="M6 6C6 3.79086 7.79086 2 10 2H36L54 20V58C54 60.2091 52.2091 62 50 62H10C7.79086 62 6 60.2091 6 58V6Z" fill="#F64E60"/>
                                                        <path opacity="0.3" d="M36 2L54 20H40C37.7909 20 36 18.2091 36 16V2Z" fill="white"/>
                                                        <path d="M18.5818 33.9387L29.5007 38.8919C29.8195 39.0367 30.1799 39.0367 30.4987 38.8919L41.4176 33.9387C42.1934 33.5867 42.1934 32.4143 41.4176 32.0623L30.4992 27.1086C30.3425 27.037 30.1724 27 30.0002 27C29.828 27 29.6578 27.037 29.5012 27.1086L18.5818 32.0618C17.8061 32.4139 17.8061 33.5867 18.5818 33.9387ZM41.4181 38.0767L38.6951 36.8425L31.1184 40.277C30.764 40.4378 30.3876 40.5194 29.9999 40.5194C29.6123 40.5194 29.2364 40.4378 28.8815 40.277L21.3052 36.8425L18.5818 38.0767C17.8061 38.4283 17.8061 39.6002 18.5818 39.9517L29.5007 44.9012C29.8195 45.0456 30.1799 45.0456 30.4987 44.9012L41.4181 39.9517C42.1938 39.6002 42.1938 38.4283 41.4181 38.0767ZM41.4181 44.0673L38.7054 42.8378L31.1184 46.2769C30.764 46.4377 30.3876 46.5193 29.9999 46.5193C29.6123 46.5193 29.2364 46.4377 28.8815 46.2769L21.2949 42.8378L18.5818 44.0673C17.8061 44.4188 17.8061 45.5907 18.5818 45.9423L29.5007 50.8917C29.8195 51.0361 30.1799 51.0361 30.4987 50.8917L41.4181 45.9423C42.1938 45.5907 42.1938 44.4188 41.4181 44.0673Z" fill="white"/>
                                                        </g>
                                                        <defs><filter id="filter0_dd_hero_nodata" x="-3" y="0" width="66" height="66" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB"><feFlood floodOpacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow"/><feOffset dy="1"/><feGaussianBlur stdDeviation="1"/><feColorMatrix type="matrix" values="0 0 0 0 0.039 0 0 0 0 0.05 0 0 0 0 0.071 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs>
                                                    </svg>
                                                </div>
                                                <div className="mock-msg__content">
                                                    <h5>Welcome to Qualdo! Let's Find Your First Incident.</h5>
                                                    <p>You're all set! The first step is to connect a dataset. Once it's configured and the first scan is complete, your incidents will appear here.</p>
                                                </div>
                                                <div className="mock-msg__action">
                                                    <button className="btn btn-outline-mist-gray btn-circle"><FontAwesomeIcon icon={faPlusCircle} /> Configure Your First Dataset</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ) : this.state.verticalError ? (
                            <div className="qd-incidents-hero-placeholder">
                                <div className="slick-list">
                                    <div className="qd-incidents-widget">
                                        <div className="qd-incidents-widget__inner">
                                            <div className="mock-msg">
                                                <div className="mock-msg__icon">
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm1.25 19.5h-2.5v-2.5h2.5v2.5zm0-5h-2.5v-8h2.5v8z" fill="white"/></svg>
                                                </div>
                                                <div className="mock-msg__content">
                                                    <h4>Something Went Wrong</h4>
                                                    <p>We encountered an error loading your incidents. Please try refreshing the page.</p>
                                                    <button className="btn btn-outline-mist-gray btn-circle" onClick={() => this.loadVerticalIncidentData()}>Retry</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ) : this.state.verticalHeroIncidents.length === 0 ? (
                            <div className="qd-incidents-hero-placeholder">
                                <div className="slick-list">
                                    <div className="qd-incidents-widget">
                                        <div className="qd-incidents-widget__inner">
                                            <div className="mock-msg">
                                                <div className="mock-msg__icon">
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.6927 20.82C10.4158 20.82 8.48762 20.0304 6.90806 18.451C5.32873 16.8715 4.53906 14.9433 4.53906 12.6664C4.53906 10.3895 5.32873 8.46125 6.90806 6.8817C8.48762 5.30236 10.4158 4.5127 12.6927 4.5127C14.9696 4.5127 16.8978 5.30236 18.4774 6.8817C20.0567 8.46125 20.8464 10.3895 20.8464 12.6664C20.8464 13.6186 20.6866 14.528 20.3671 15.3947C20.0473 16.2614 19.6207 17.0151 19.0874 17.656L26.7594 25.328C26.9441 25.5125 27.0385 25.7445 27.0427 26.024C27.0469 26.3036 26.9525 26.5399 26.7594 26.733C26.5663 26.9261 26.3321 27.0227 26.0567 27.0227C25.7816 27.0227 25.5475 26.9261 25.3544 26.733L17.6824 19.061C17.0157 19.6115 16.2491 20.0423 15.3824 20.3534C14.5157 20.6645 13.6192 20.82 12.6927 20.82ZM12.6927 18.8204C14.4107 18.8204 15.8658 18.2241 17.0581 17.0317C18.2505 15.8395 18.8467 14.3844 18.8467 12.6664C18.8467 10.9484 18.2505 9.49325 17.0581 8.30103C15.8658 7.10858 14.4107 6.51236 12.6927 6.51236C10.9747 6.51236 9.51962 7.10858 8.3274 8.30103C7.13495 9.49325 6.53873 10.9484 6.53873 12.6664C6.53873 14.3844 7.13495 15.8395 8.3274 17.0317C9.51962 18.2241 10.9747 18.8204 12.6927 18.8204Z" fill="white"/>
                                                    </svg>
                                                </div>
                                                <div className="mock-msg__content">
                                                    <h4>No Incidents Detected</h4>
                                                    <p>Great news! All of your monitored datasets are healthy and no incidents have been detected. We'll continue monitoring and will alert you here if anything changes.</p>
                                                    <button className="btn btn-outline-mist-gray btn-circle" onClick={() => this.redirectToVerticalDasboard(null)}>View Monitor Page</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            ) : (
                            this.renderVerticalHeroCarousel()
                            )}

                            {this.state.verticalHeroIncidents.length > 0 ? (
                                <div className="scroll-to-summary" onClick={this.handleScrollToSummary}>
                                <div className="line"></div>
                                <RcTooltip trigger={["hover"]} placement="top"
                                    overlay={
                                        <span>Scroll to Summary</span>
                                    }
                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                >
                                    <i className="icon-arrow">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.9999 21.5L5.3269 14.827L6.37115 13.7827L11.2499 18.6462V2.49048H12.7499V18.6365L17.6287 13.7577L18.6729 14.827L11.9999 21.5Z" fill="currentColor"/>
                                        </svg>
                                    </i>
                                </RcTooltip>
                            </div>) :""}

                        </div>

                        {/* End: Incident Hero Section */}

                        {this.state.verticalHeroIncidents.length > 0 && this.state.verticalKpiSummary.length > 0 && this.renderVerticalKpiSliderSections(incidentSummary)}

                        {this.state.verticalHeroIncidents.length > 0 && <>
                        {/* Start: Incident Summary */}
                        {this.hasRenderableSummaryContent() && (
                            <div
                                ref={this.summarySectionRef}
                                className="tw-pt-[50px] tw-pb-[20px] md:tw-pt-[65px] md:tw-pb-[30px] xl:tw-pt-[80px] xl:tw-pb-[40px] 2xl:tw-pt-[100px] tw-relative tw-z-[1]"
                            >
                            <div className="tw-w-[800px] tw-h-[800px] tw-rounded-[999px] tw-opacity-50 tw-bg-[#E52CA7]/70 tw-z-[-1] tw-absolute tw-bottom-[-25%] tw-left-[-15%]" style={{filter: 'blur(354px)'}}></div>
                            <div className="qd-id-container">
                                <FadeUpOnScroll delay={0}>
                                    <div className="tw-pb-[28px] md:tw-pb-[32px] xl:tw-pb-[40px] 2xl:tw-pb-[48px] tw-text-center">
                                        <h3 className="tw-text-[28px] md:tw-text-[36px] xl:tw-text-[48px] 2xl:tw-text-[64px] tw-font-bold tw-text-white tw-leading-[34px] md:tw-leading-[44px] xl:tw-leading-[56px] 2xl:tw-leading-[60px] tw-mb-2">Incidents Summary</h3>
                                        <p className="tw-text-base lg:tw-text-xl tw-text-[#8F949C] tw-max-w-[85%] tw-my-0 tw-mx-auto">A high-level summary of all KPI breaches across Qualdo, providing key metrics for a quick assessment of overall operational health.</p>
                                    </div>
                                </FadeUpOnScroll>
                            </div>
                            <div className="qd-incidents-section__body">
                                {this.renderKpiSummaryDynamic(incidentSummary) || this.renderVerticalSummaryCarousel(incidentSummary)}
                            </div>
                        </div>
                        )}
                        {/* End: Incident Summary */}

                        {/* Start: List of All Incidents */}

                        {/* Start: Incident Table */}
                        <div className="qd-incidents-section" ref={this.verticalTableRef}>
                            <div className="qd-id-container-sm">
                                <FadeUpOnScroll delay={0}>
                                    <div className="qd-incidents-section__header">
                                        <div className="qd-incidents-section__title">
                                            <h3>List of All Incidents</h3>
                                            <p>Uncover patterns and trends in recurring incidents with ease. Gain insights to proactively address and minimize recurring issues for seamless operations</p>
                                        </div>
                                    </div>
                                </FadeUpOnScroll>
                                <FadeUpOnScroll delay={0.2}>
                                    <div className="table-responsive qd-incidents-table">
                                        <div className="qd-incidents-table__top">
                                            <div className="qd-incidents-table__title">
                                                <span className="caption">List of All Incidents </span>
                                                <span className="badge">{this.getIncidentTabCount("all_issues")} Issues</span>
                                            </div>
                                        </div>
                                        <Tab.Container activeKey={this.state.activeTabAllIncident} onSelect={this.handleSelectAllIncident}>
                                            <div className="react-bootstrap-table__header">
                                                <div className="row mb-4">
                                                    <div className="col-8">
                                                        <div className="d-flex align-items-center">
                                                            <div className="btn-group react-table__length" role="group">
                                                                <span className="col-form-label">Show</span>
                                                                <Select
                                                                    classNamePrefix="select-control"
                                                                    options={allIncidentPageSizeOptions}
                                                                    onChange={this.handleallIncidentpageSizeChange}
                                                                    value={this.state.allIncidentpageSize}
                                                                    placeholder="Select..."
                                                                    isSearchable={false}
                                                                />
                                                                <span>items</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className="btn-group react-table__filter" role="group">
                                                            <div className="table-search">
                                                                <input
                                                                    placeholder="Search"
                                                                    id="searchBox"
                                                                    className="form-control"
                                                                    type="text"
                                                                    value={this.state.allIncidentsearchQuery}
                                                                    onChange={this.handleSearch}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="metric-filters">
                                                    <CustomTreeSelectAllincidents
                                                        key={`vi-kpi-filters-${this.state.kpiFilterOptionsVersion}`}
                                                        id="chooseAttributeForVerticalIncidents"
                                                        name="attributes"
                                                        data={this.state.kpiFilterOptions && this.state.kpiFilterOptions.length > 0 ? this.state.kpiFilterOptions : [{ label: "No options", value: "none", disabled: true }]}
                                                        classNamePrefix="form-control"
                                                        prependIcon={<svg xmlns="http://www.w3.org/2000/svg" fill="#61656C" height="20" className="mr-1" viewBox="0 0 24 24" width="20"><path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>}
                                                        placeholder="More filters"
                                                        noMatches="No options"
                                                        handleAttributesSelection={this.handleKpiFilterSelection}
                                                    />
                                                    {(this.state.selectedKpiFilters || []).map((opt) => {
                                                        const idVal = opt.kpi_id ?? opt.value ?? opt.label;
                                                        return (
                                                            <li key={idVal} className="metric-filters-tag">
                                                                <span className="metric-filters-tag__label">{opt.label}</span>
                                                                <i className="metric-filters-tag__action" style={{ cursor: "pointer" }} onClick={() => this.handleRemoveKpiFilter(idVal)}>
                                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                                    </svg>
                                                                </i>
                                                            </li>
                                                        );
                                                    })}
                                                </div>
                                                <div className="tabbable-line">
                                                    <Nav variant="tabs" id="page-nav-tabs" className="pl-5 border-0">
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="all_issues" className="d-flex align-items-center">
                                                                <span className="qd-menu__link-text">All Issues</span>
                                                                <span className="badge ml-2">{this.getIncidentTabCount("all_issues")}</span>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="ignored" className="d-flex align-items-center">
                                                                <span className="qd-menu__link-text">Ignored</span>
                                                                <span className="badge ml-2">
                                                                    {this.getIncidentTabCount("ignored")}
                                                                    <RcTooltip trigger={["hover"]}
                                                                        placement="top"
                                                                        overlay={<span>Ignored Count</span>}
                                                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                    >
                                                                        <div>
                                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clipPath="url(#clip_tab_ignored)">
                                                                                    <path d="M8.00065 10.6663V7.99967M8.00065 5.33301H8.00732M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip_tab_ignored">
                                                                                        <rect width="16" height="16" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        </div>
                                                                    </RcTooltip>
                                                                </span>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="read" className="d-flex align-items-center">
                                                                <span className="qd-menu__link-text">Read</span>
                                                                <span className="badge ml-2">{this.getIncidentTabCount("read")}
                                                                    <RcTooltip trigger={["hover"]}
                                                                        placement="top"
                                                                        overlay={<span>Read Count</span>}
                                                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                    >
                                                                        <div>
                                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clipPath="url(#clip_tab_read)">
                                                                                    <path d="M8.00065 10.6663V7.99967M8.00065 5.33301H8.00732M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip_tab_read">
                                                                                        <rect width="16" height="16" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        </div>
                                                                    </RcTooltip>
                                                                </span>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="like" className="d-flex align-items-center">
                                                                <span className="qd-menu__link-text">Like</span>
                                                                <span className="badge ml-2">{this.getIncidentTabCount("like")}
                                                                    <RcTooltip trigger={["hover"]}
                                                                        placement="top"
                                                                        overlay={<span>Likes Count</span>}
                                                                        arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                    >
                                                                        <div>
                                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clipPath="url(#clip_tab_like)">
                                                                                    <path d="M8.00065 10.6663V7.99967M8.00065 5.33301H8.00732M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967Z" stroke="currentColor" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip_tab_like">
                                                                                        <rect width="16" height="16" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        </div>
                                                                    </RcTooltip>
                                                                </span>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    </Nav>
                                                </div>
                                            </div>
                                            <Tab.Content>
                                                <Tab.Pane eventKey={this.state.activeTabAllIncident}>
                                                    {this.getDisplayedIncidentList().length === 0 ? (
                                                        <div className="empty-msg empty-msg--dark text-center" style={{ minHeight: '400px' }}>
                                                            <div className="empty-msg__dialog">
                                                                <div className="empty-msg__content">
                                                                    <div className="empty-msg__icon">
                                                                        <div className="icon-wrap">
                                                                            {this.state.allIncidentsearchQuery ? (
                                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="#CECFD2"/>
                                                                                </svg>
                                                                            ) : this.state.activeTabAllIncident === "ignored" ? (
                                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M19.8039 21.9423L17.5481 19.6865C16.7508 20.2647 15.8848 20.7115 14.9501 21.027C14.0154 21.3423 13.0321 21.5 12.0001 21.5C10.6859 21.5 9.45094 21.2506 8.29511 20.7518C7.13928 20.2531 6.13386 19.5763 5.27886 18.7213C4.42386 17.8663 3.74703 16.8608 3.24836 15.705C2.74953 14.5492 2.50011 13.3142 2.50011 12C2.50011 10.968 2.65778 9.98467 2.97311 9.05C3.28861 8.11533 3.73544 7.24933 4.31361 6.452L2.05786 4.19625L3.12711 3.127L20.8731 20.873L19.8039 21.9423ZM12.0001 20C12.8193 20 13.6033 19.8795 14.3521 19.6385C15.1008 19.3975 15.8046 19.052 16.4636 18.602L5.39811 7.5365C4.94811 8.1955 4.60261 8.89933 4.36161 9.648C4.12061 10.3968 4.00011 11.1808 4.00011 12C4.00011 14.2167 4.77928 16.1042 6.33761 17.6625C7.89595 19.2208 9.78345 20 12.0001 20ZM19.9846 17.1538L18.8906 16.0595C19.2573 15.439 19.5339 14.7897 19.7204 14.1115C19.9069 13.4333 20.0001 12.7295 20.0001 12C20.0001 9.78333 19.2209 7.89583 17.6626 6.3375C16.1043 4.77917 14.2168 4 12.0001 4C11.2706 4 10.5668 4.09325 9.88861 4.27975C9.21045 4.46625 8.56111 4.74283 7.94061 5.1095L6.84636 4.0155C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 12.0001 1.875C13.3143 2.5 14.5493 2.74942 15.7051 3.24825C16.8609 3.74692 17.8664 4.42375 18.7214 5.27875C19.5764 6.13375 20.2532 7.13917 20.7519 8.295C21.2507 9.45083 21.5001 10.6858 21.5001 12C21.5001 12.9423 21.37 13.846 21.1099 14.711C20.8495 15.5758 20.4744 16.3901 19.9846 17.1538Z" fill="#CECFD2"/>
                                                                                </svg>
                                                                            ) : this.state.activeTabAllIncident === "like" ? (
                                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M20.6923 8.49962C21.1679 8.49962 21.5881 8.68204 21.9527 9.04687C22.3176 9.41154 22.5 9.8317 22.5 10.3074V11.9226C22.5 12.0276 22.4865 12.1401 22.4595 12.2601C22.4327 12.38 22.4026 12.4919 22.3693 12.5959L19.5033 19.3584C19.3601 19.6782 19.1199 19.9484 18.7828 20.1689C18.4456 20.3894 18.0938 20.4996 17.7273 20.4996H7.2115V8.49962L13.0288 2.73237C13.2276 2.5337 13.4578 2.41512 13.7193 2.37662C13.9808 2.33812 14.2313 2.38295 14.471 2.51112C14.7108 2.63945 14.8865 2.82154 14.998 3.05737C15.1095 3.2932 15.1333 3.53745 15.0693 3.79012L13.9923 8.49962H20.6923ZM8.7115 9.13812V18.9996H17.7308C17.8012 18.9996 17.8733 18.9804 17.947 18.9419C18.0208 18.9034 18.077 18.8393 18.1155 18.7496L21 11.9996V10.3074C21 10.2175 20.9712 10.1438 20.9135 10.0861C20.8558 10.0285 20.7821 9.99962 20.6923 9.99962H12.0963L13.35 4.51887L8.7115 9.13812ZM4.30775 20.4996C3.81058 20.4996 3.385 20.3226 3.031 19.9686C2.677 19.6146 2.5 19.189 2.5 18.6919V10.3074C2.5 9.8102 2.677 9.38462 3.031 9.03062C3.385 8.67662 3.81058 8.49962 4.30775 8.49962H7.2115V9.99962H4.30775C4.21792 9.99962 4.14417 10.0285 4.0865 10.0861C4.02883 10.1438 4 10.2175 4 10.3074V18.6919C4 18.7817 4.02883 18.8555 4.0865 18.9131C4.14417 18.9708 4.21792 18.9996 4.30775 18.9996H7.2115V20.4996H4.30775Z" fill="#CECFD2"/>
                                                                                </svg>
                                                                            ) : this.state.activeTabAllIncident === "read" ? (
                                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#CECFD2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                                </svg>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                    <div className="empty-msg__body">
                                                                        {this.state.allIncidentsearchQuery ? (
                                                                            <>
                                                                                <h6>No incidents found</h6>
                                                                                <p>Your search did not return any results. Try adjusting or clearing your filters.</p>
                                                                            </>
                                                                        ) : this.state.activeTabAllIncident === "ignored" ? (
                                                                            <>
                                                                                <h6>No ignored incidents</h6>
                                                                                <p>Incidents you choose to ignore will be listed here for reference and audit tracking.</p>
                                                                            </>
                                                                        ) : this.state.activeTabAllIncident === "like" ? (
                                                                            <>
                                                                                <h6>No liked incidents</h6>
                                                                                <p>Mark incidents you find valuable or insightful to help improve detection accuracy.</p>
                                                                            </>
                                                                        ) : this.state.activeTabAllIncident === "read" ? (
                                                                            <>
                                                                                <h6>No read incidents</h6>
                                                                                <p>Incidents you've marked as read will appear here for easy tracking and review.</p>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <h6>No incidents found</h6>
                                                                                <p>No incidents match the current filters. Try adjusting your selection.</p>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                    <div class="react-bootstrap-table table-responsive overflow-auto border-0">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th width={"62px"}></th>
                                                                    <th>
                                                                        <Form.Check
                                                                            custom
                                                                            type="checkbox"
                                                                            id="vi-select-all"
                                                                            checked={this.areAllVisibleIncidentsSelected()}
                                                                            ref={(el) => this.setSelectAllCheckboxIndeterminate(el)}
                                                                            onChange={(event) => this.handleSelectAllVisibleIncidents(event.target.checked)}
                                                                        />
                                                                    </th>
                                                                     <th>KPI Name
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    <th>Business Area
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    <th>Subject Area
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    <th>Incidents
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                     <th>Severity
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    <th>Generate At
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    {/* <th>Date
                                                                        <span class="order">
                                                                            <span class="dropdown">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                            <span class="dropup">
                                                                                <span class="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th> */}
                                                                    <th style={{ minWidth: '320px' }}>Source
                                                                        <span className="order">
                                                                            <span className="dropdown">
                                                                                <span className="caret"></span>
                                                                            </span>
                                                                            <span className="dropup">
                                                                                <span className="caret"></span>
                                                                            </span>
                                                                        </span>
                                                                    </th>
                                                                    <th></th>
                                                                </tr>
                                                                {this.state.selectedIncidentIds.length > 0 && (
                                                                    <tr>
                                                                        <th width={"62px"}></th>
                                                                        <th colSpan={"7"}>
                                                                            <div className="d-flex align-items-center">
                                                                                <div className="table-action-toolbar">
                                                                                    <div className="table-action-toolbar__col">
                                                                                        <div className="table-action-toolbar__btn" onClick={() => this.handleSelectedIncidentAction("like")}>
                                                                                            <RcTooltip 
                                                                                                placement="top" 
                                                                                                overlay={<span>Like</span>}
                                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                            >
                                                                                            <i className="table-action-toolbar__icon">
                                                                                                <svg className="d-block" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#ffffff">
                                                                                                    <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                                                                                </svg>
                                                                                            </i>
                                                                                            </RcTooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="table-action-toolbar__col">
                                                                                        <div className="table-action-toolbar__btn" onClick={() => this.handleSelectedIncidentAction("unread")}>
                                                                                            <RcTooltip
                                                                                                placement="top"
                                                                                                overlay={<span>Mark Unread</span>}
                                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                            >
                                                                                                <i className="table-action-toolbar__icon">
                                                                                                    <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                        <path d="M4.62769 11.1228H9.88307V10.0717H4.62769V11.1228ZM4.62769 9.02067H12.6859V7.96959H4.62769V9.02067ZM4.62769 6.91851H12.3153V6.87542C12.0135 6.78643 11.7418 6.65726 11.5002 6.48792C11.2585 6.31858 11.0474 6.11175 10.8667 5.86744H4.62769V6.91851ZM2 16.23V4.50647C2 4.15249 2.12263 3.85287 2.36788 3.60762C2.61313 3.36237 2.91274 3.23975 3.26672 3.23975H10.3035C10.2658 3.41492 10.2458 3.58899 10.2436 3.76196C10.2414 3.93492 10.2524 4.1112 10.2765 4.29082H3.26672C3.21277 4.29082 3.16337 4.3133 3.11852 4.35827C3.07356 4.40311 3.05108 4.45251 3.05108 4.50647V13.6698L4.03208 12.6994H14.0469C14.1009 12.6994 14.1503 12.677 14.1951 12.632C14.2401 12.5871 14.2626 12.5377 14.2626 12.4838V7.17865C14.4638 7.13369 14.6509 7.07617 14.8238 7.0061C14.9967 6.93603 15.1599 6.84395 15.3136 6.72984V12.4838C15.3136 12.8378 15.191 13.1374 14.9458 13.3826C14.7005 13.6279 14.4009 13.7505 14.0469 13.7505H4.47949L2 16.23ZM3.05108 4.50647V13.1845V4.29082V4.50647Z" fill="white" />
                                                                                                    </svg>
                                                                                                 </i>
                                                                                            </RcTooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="table-action-toolbar__col">
                                                                                        <div className="table-action-toolbar__btn" onClick={() => this.handleSelectedIncidentAction("share")}>
                                                                                            <RcTooltip
                                                                                                placement="top"
                                                                                                overlay={<span>Share</span>}
                                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                            >
                                                                                                <i className="table-action-toolbar__icon">
                                                                                                    <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                        <path d="M14.5327 8.24982L11.4894 5.20651C11.3731 5.09013 11.3149 4.95651 11.3149 4.80563C11.3149 4.65463 11.3731 4.52094 11.4894 4.40457C11.6058 4.29594 11.7407 4.24282 11.8941 4.24519C12.0473 4.24769 12.1759 4.30082 12.2797 4.40457L15.6504 7.77526C15.7207 7.84551 15.7702 7.91957 15.7989 7.99744C15.8278 8.07532 15.8422 8.15944 15.8422 8.24982C15.8422 8.34019 15.8278 8.42432 15.7989 8.50219C15.7702 8.58007 15.7207 8.65413 15.6504 8.72438L12.2797 12.0951C12.1634 12.2113 12.0317 12.2676 11.8847 12.2638C11.7376 12.2599 11.6058 12.2037 11.4894 12.0951C11.3731 11.9787 11.3142 11.8458 11.3128 11.6963C11.3113 11.5468 11.3663 11.4162 11.4778 11.3046L14.5327 8.24982ZM10.5519 8.81232H5.4375C4.76437 8.81232 4.18987 9.05032 3.714 9.52632C3.238 10.0022 3 10.5767 3 11.2498V13.3123C3 13.4719 2.94613 13.6056 2.83838 13.7132C2.73075 13.8209 2.59712 13.8748 2.4375 13.8748C2.27787 13.8748 2.14425 13.8209 2.03663 13.7132C1.92888 13.6056 1.875 13.4719 1.875 13.3123V11.2498C1.875 10.2652 2.22262 9.42532 2.91787 8.73019C3.613 8.03494 4.45287 7.68732 5.4375 7.68732H10.5519L8.07112 5.20651C7.95487 5.09013 7.89675 4.95651 7.89675 4.80563C7.89675 4.65463 7.95487 4.52094 8.07112 4.40457C8.1875 4.29594 8.32237 4.24282 8.47575 4.24519C8.62912 4.24769 8.75775 4.30082 8.86162 4.40457L12.2321 7.77526C12.3024 7.84551 12.3519 7.91957 12.3808 7.99744C12.4097 8.07532 12.4241 8.15944 12.4241 8.24982C12.4241 8.34019 12.4097 8.42432 12.3808 8.50219C12.3519 8.58007 12.3024 8.65413 12.2321 8.72438L8.86162 12.0951C8.74525 12.2113 8.6135 12.2676 8.46637 12.2638C8.31925 12.2599 8.1875 12.2037 8.07112 12.0951C7.95487 11.9787 7.896 11.8458 7.8945 11.6963C7.893 11.5468 7.94806 11.4162 8.05969 11.3046L10.5519 8.81232Z" fill="white" />
                                                                                                    </svg>
                                                                                                </i>
                                                                                            </RcTooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="table-action-toolbar__col">
                                                                                        <div className="table-action-toolbar__btn" onClick={() => this.handleSelectedIncidentAction("ignore")}>
                                                                                            <RcTooltip
                                                                                                placement="top"
                                                                                                overlay={<span>Ignore</span>}
                                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                            >
                                                                                                <i className="table-action-toolbar__icon">
                                                                                                    <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                        <path d="M14.8525 16.4567L13.1607 14.7649C12.5627 15.1985 11.9132 15.5336 11.2122 15.7703C10.5112 16.0068 9.77366 16.125 8.99966 16.125C8.01403 16.125 7.08778 15.9379 6.22091 15.5638C5.35403 15.1898 4.59997 14.6822 3.95872 14.0409C3.31747 13.3997 2.80984 12.6456 2.43584 11.7788C2.06172 10.9119 1.87466 9.98563 1.87466 9C1.87466 8.226 1.99291 7.4885 2.22941 6.7875C2.46603 6.0865 2.80116 5.437 3.23478 4.839L1.54297 3.14719L2.34491 2.34525L15.6544 15.6548L14.8525 16.4567ZM8.99966 15C9.61403 15 10.202 14.9096 10.7637 14.7289C11.3252 14.5481 11.853 14.289 12.3473 13.9515L4.04816 5.65238C3.71066 6.14663 3.45153 6.6745 3.27078 7.236C3.09003 7.79762 2.99966 8.38563 2.99966 9C2.99966 10.6625 3.58403 12.0781 4.75278 13.2469C5.92153 14.4156 7.33716 15 8.99966 15ZM14.988 12.8653L14.1675 12.0446C14.4425 11.5793 14.65 11.0923 14.7898 10.5836C14.9297 10.075 14.9997 9.54713 14.9997 9C14.9997 7.3375 14.4153 5.92188 13.2465 4.75313C12.0778 3.58438 10.6622 3 8.99966 3C8.45253 3 7.92466 3.06994 7.41603 3.20981C6.90741 3.34969 6.42041 3.55713 5.95503 3.83213L5.13434 3.01162C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 8.99966 1.875C9.98528 1.875 10.9115 2.06206 11.7784 2.43619C12.6453 2.81019 13.3993 3.31781 14.0406 3.95906C14.6818 4.60031 15.1895 5.35437 15.5635 6.22125C15.9376 7.08812 16.1247 8.01438 16.1247 9C16.1247 9.70675 16.0271 10.3845 15.832 11.0333C15.6367 11.6819 15.3554 12.2926 14.988 12.8653Z" fill="white" />
                                                                                                    </svg>
                                                                                                </i>
                                                                                            </RcTooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="table-action-toolbar__col">
                                                                                        <div className="table-action-toolbar__btn" onClick={() => this.handleSelectedIncidentAction("resolved")}>
                                                                                            <RcTooltip
                                                                                                placement="top"
                                                                                                overlay={<span>Resolved</span>}
                                                                                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                            >
                                                                                                <i className="table-action-toolbar__icon">
                                                                                                    <svg className="d-block" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                        <path d="M11.625 13.0958L15.4817 9.23909C15.5856 9.13522 15.7161 9.08209 15.8734 9.07972C16.0305 9.07734 16.1634 9.13047 16.2722 9.23909C16.3808 9.34772 16.4351 9.47947 16.4351 9.63434C16.4351 9.78909 16.3808 9.92078 16.2722 10.0294L12.0996 14.202C11.9639 14.3377 11.8058 14.4055 11.625 14.4055C11.4443 14.4055 11.2861 14.3377 11.1504 14.202L9.09225 12.1438C8.9885 12.04 8.93538 11.9095 8.93288 11.7523C8.9305 11.5951 8.98363 11.4622 9.09225 11.3535C9.201 11.2449 9.33275 11.1906 9.4875 11.1906C9.64225 11.1906 9.774 11.2449 9.88275 11.3535L11.625 13.0958ZM3.98081 15.3747C3.60794 15.3747 3.28875 15.2419 3.02325 14.9764C2.75775 14.7109 2.625 14.3917 2.625 14.0188V3.98047C2.625 3.60759 2.75775 3.28841 3.02325 3.02291C3.28875 2.75741 3.60794 2.62466 3.98081 2.62466H7.28513C7.389 2.25928 7.60125 1.95641 7.92188 1.71603C8.2425 1.47566 8.60188 1.35547 9 1.35547C9.4135 1.35547 9.77863 1.47566 10.0954 1.71603C10.4123 1.95641 10.6226 2.25928 10.7265 2.62466H14.0192C14.3921 2.62466 14.7113 2.75741 14.9768 3.02291C15.2423 3.28841 15.375 3.60759 15.375 3.98047V15.5769C15.375 15.9978 15.3211 16.3542 15.2132 16.6458C16.1053 17.23 15.3211 16.3542 15.2132 16.6458C16.3039 17.23 15.1053 17.0375 16.2132 16.6458C16.3039 7.44578 14.0769 7.49966 14.8123 7.49966C14.6528 7.49966 14.5192 7.44578 14.4116 7.33803C14.3039 7.23016 14.25 7.09653 14.25 6.93716V3.98047C14.25 3.92272 14.2259 3.86984 14.1778 3.82184C14.1298 3.77372 14.0769 3.74966 14.0192 3.74966H12.375V5.03328C12.375 5.22541 12.3103 5.38641 12.1809 5.51628C12.0516 5.64616 11.8913 5.71109 11.7 5.71109H6.29981C6.10856 5.71109 5.94831 5.64616 5.81906 5.51628C5.68969 5.38641 5.625 5.22541 5.625 5.03328V3.74966H3.98081C3.92306 3.74966 3.87019 3.77372 3.82219 3.82184C3.77406 3.86984 3.75 3.92272 3.75 3.98047V14.0188C3.75 14.0766 3.77406 14.1295 3.82219 14.1775C3.87019 14.2256 3.92306 14.2497 3.98081 14.2497H7.6875C7.84688 14.2497 7.9805 14.3036 8.08838 14.4115C8.19613 14.5193 8.25 14.653 8.25 14.8123C8.25 14.9718 8.19613 15.1054 8.08838 15.213C7.9805 15.3208 7.84688 15.3747 7.6875 15.3747H3.98081ZM9.00131 3.83628C9.19369 3.83628 9.35456 3.77116 9.48394 3.64091C9.61319 3.51078 9.67781 3.34947 9.67781 3.15697C9.67781 2.96459 9.61275 2.80372 9.48263 2.67434C9.3525 2.54509 9.19119 2.48047 8.99869 2.48047C8.80631 2.48047 8.64544 2.54553 8.51606 2.67566C8.38681 2.80591 8.32219 2.96722 8.32219 3.15959C8.32219 3.35197 8.38725 3.51284 8.51738 3.64222C8.6475 3.77159 8.80881 3.83628 9.00131 3.83628Z" fill="white"/>
                                                                                                    </svg>
                                                                                                </i>
                                                                                            </RcTooltip>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </th>
                                                                    </tr>
                                                                )}
                                                            </thead>
                                                            <tbody>
                                                                {this.getDisplayedIncidentList().length > 0 ? this.renderVerticalIncidentRows() : (
                                                                <>
                                                                <tr className="tbl-row tbl-row--is-expanded">
                                                                    <td className="pr-0">
                                                                        <div className="icon-expand">
                                                                            {this.state.tblRowExpanded ?
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.0002 12.5998L15.9002 8.6998C16.0835 8.51647 16.3169 8.4248 16.6002 8.4248C16.8835 8.4248 17.1169 8.51647 17.3002 8.6998C17.4835 8.88314 17.5752 9.11647 17.5752 9.3998C17.5752 9.68314 17.4835 9.91647 17.3002 10.0998L12.7002 14.6998C12.6002 14.7998 12.4919 14.8706 12.3752 14.9123C12.2585 14.954 12.1335 14.9748 12.0002 14.9748C11.8669 14.9748 11.7419 14.954 11.6252 14.9123C11.5085 14.8706 11.4002 14.7998 11.3002 14.6998L6.7002 10.0998C6.51686 9.91647 6.42519 9.68314 6.42519 9.3998C6.42519 9.11647 6.51686 8.88314 6.7002 8.6998C6.88353 8.51647 7.11686 8.4248 7.4002 8.4248C7.68353 8.4248 7.91686 8.51647 8.10019 8.6998L12.0002 12.5998Z" fill="#99A1B7" />
                                                                                    </svg>
                                                                                </i>
                                                                                :
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#4B5675" />
                                                                                    </svg>
                                                                                </i>
                                                                            }

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="d-flex align-items-center">
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id="check1"
                                                                            />
                                                                            <a href="#!">
                                                                                <i className="mr-2"><FontAwesomeIcon icon={faDatabase} /></i>

                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="metric-stat-btns-group">
                                                                            <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                <button class="metric-stat-btn">:<strong className="value ml-1"></strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1"></span> <strong></strong>
                                                                                </button>
                                                                            </div>
                                                                            <div class="metric-stat-btns metric-stat-btns--danger d-none">
                                                                                <button class="metric-stat-btn">Unique Values:<strong className="value ml-1">01</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                </button>
                                                                            </div>
                                                                            {/* <OverlayTrigger
                                                                                                        trigger="click"
                                                                                                        placement={"bottom"}
                                                                                                        overlay={
                                                                                                            <Popover className="popover-dark py-2">
                                                                                                                <Popover.Content>
                                                                                                                    <div class="metric-stat-btns">
                                                                                                                        <sapn class="metric-stat-btn">Fill Rate:<strong className="value ml-1">100%</strong></sapn>
                                                                                                                        <span class="divider-line"></span>
                                                                                                                        <span className="metric-stat-btn">
                                                                                                                            <i>
                                                                                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                                    <path d="M4.42345 17.0837C4.00789 17.0837 3.6529 16.9365 3.35845 16.6422C3.06415 16.3478 2.91699 15.9928 2.91699 15.5772V4.42345C2.91699 4.00789 3.06415 3.6529 3.35845 3.35845C3.6529 3.06415 4.00789 2.91699 4.42345 2.91699H15.5772C15.9928 2.91699 16.3478 3.06415 16.6422 3.35845C16.9365 3.6529 17.0837 4.00789 17.0837 4.42345V15.5772C17.0837 15.9928 16.9365 16.3478 16.6422 16.6422C16.3478 16.9365 15.9928 17.0837 15.5772 17.0837H4.42345ZM14.0997 15.8337H15.5772C15.6521 15.8337 15.7135 15.8096 15.7616 15.7616C15.8096 15.7135 15.8337 15.6521 15.8337 15.5772V14.0997L14.0997 15.8337ZM4.75512 15.8337H6.54033L9.04033 13.3337H10.4426L7.94262 15.8337H9.61262L12.1126 13.3337H13.5147L11.0147 15.8337H12.6974L15.1974 13.3337H15.8337V4.42345C15.8337 4.34859 15.8096 4.28713 15.7616 4.23908C15.7135 4.19102 15.6521 4.16699 15.5772 4.16699H4.42345C4.34859 4.16699 4.28713 4.19102 4.23908 4.23908C4.19102 4.28713 4.16699 4.34859 4.16699 4.42345V15.0195L5.85283 13.3337H7.25512L4.75512 15.8337ZM6.37533 11.3705L5.50512 10.5003L8.89616 7.10928L10.5628 8.77595L13.6253 5.71345L14.4955 6.58366L10.5628 10.5372L8.89616 8.87053L6.37533 11.3705ZM4.16699 15.5772V4.16699V15.8337V15.5772Z" fill="currentColor" />
                                                                                                                                </svg>
                                                                                                                            </i>
                                                                                                                            <span className="mx-1">{">"}</span> <strong>90%</strong>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    <hr className="my-2" />
                                                                                                                    <div class="metric-stat-btns">
                                                                                                                        <sapn class="metric-stat-btn">Unique Values:<strong className="value ml-1">01</strong></sapn>
                                                                                                                        <span class="divider-line"></span>
                                                                                                                        <span className="metric-stat-btn">
                                                                                                                            <i>
                                                                                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                                    <path d="M4.42345 17.0837C4.00789 17.0837 3.6529 16.9365 3.35845 16.6422C3.06415 16.3478 2.91699 15.9928 2.91699 15.5772V4.42345C2.91699 4.00789 3.06415 3.6529 3.35845 3.35845C3.6529 3.06415 4.00789 2.91699 4.42345 2.91699H15.5772C15.9928 2.91699 16.3478 3.06415 16.6422 3.35845C16.9365 3.6529 17.0837 4.00789 17.0837 4.42345V15.5772C17.0837 15.9928 16.9365 16.3478 16.6422 16.6422C16.3478 16.9365 15.9928 17.0837 15.5772 17.0837H4.42345ZM14.0997 15.8337H15.5772C15.6521 15.8337 15.7135 15.8096 15.7616 15.7616C15.8096 15.7135 15.8337 15.6521 15.8337 15.5772V14.0997L14.0997 15.8337ZM4.75512 15.8337H6.54033L9.04033 13.3337H10.4426L7.94262 15.8337H9.61262L12.1126 13.3337H13.5147L11.0147 15.8337H12.6974L15.1974 13.3337H15.8337V4.42345C15.8337 4.34859 15.8096 4.28713 15.7616 4.23908C15.7135 4.19102 15.6521 4.16699 15.5772 4.16699H4.42345C4.34859 4.16699 4.28713 4.19102 4.23908 4.23908C4.19102 4.28713 4.16699 4.34859 4.16699 4.42345V15.0195L5.85283 13.3337H7.25512L4.75512 15.8337ZM6.37533 11.3705L5.50512 10.5003L8.89616 7.10928L10.5628 8.77595L13.6253 5.71345L14.4955 6.58366L10.5628 10.5372L8.89616 8.87053L6.37533 11.3705ZM4.16699 15.5772V4.16699V15.8337V15.5772Z" fill="currentColor" />
                                                                                                                                </svg>
                                                                                                                            </i>
                                                                                                                            <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                    <hr className="my-2" />
                                                                                                                    <div class="metric-stat-btns">
                                                                                                                        <sapn class="metric-stat-btn">Data Conformity:<strong className="value ml-1">0.9</strong></sapn>
                                                                                                                        <span class="divider-line"></span>
                                                                                                                        <span className="metric-stat-btn">
                                                                                                                            <i>
                                                                                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                                    <path d="M4.42345 17.0837C4.00789 17.0837 3.6529 16.9365 3.35845 16.6422C3.06415 16.3478 2.91699 15.9928 2.91699 15.5772V4.42345C2.91699 4.00789 3.06415 3.6529 3.35845 3.35845C3.6529 3.06415 4.00789 2.91699 4.42345 2.91699H15.5772C15.9928 2.91699 16.3478 3.06415 16.6422 3.35845C16.9365 3.6529 17.0837 4.00789 17.0837 4.42345V15.5772C17.0837 15.9928 16.9365 16.3478 16.6422 16.6422C16.3478 16.9365 15.9928 17.0837 15.5772 17.0837H4.42345ZM14.0997 15.8337H15.5772C15.6521 15.8337 15.7135 15.8096 15.7616 15.7616C15.8096 15.7135 15.8337 15.6521 15.8337 15.5772V14.0997L14.0997 15.8337ZM4.75512 15.8337H6.54033L9.04033 13.3337H10.4426L7.94262 15.8337H9.61262L12.1126 13.3337H13.5147L11.0147 15.8337H12.6974L15.1974 13.3337H15.8337V4.42345C15.8337 4.34859 15.8096 4.28713 15.7616 4.23908C15.7135 4.19102 15.6521 4.16699 15.5772 4.16699H4.42345C4.34859 4.16699 4.28713 4.19102 4.23908 4.23908C4.19102 4.28713 4.16699 4.34859 4.16699 4.42345V15.0195L5.85283 13.3337H7.25512L4.75512 15.8337ZM6.37533 11.3705L5.50512 10.5003L8.89616 7.10928L10.5628 8.77595L13.6253 5.71345L14.4955 6.58366L10.5628 10.5372L8.89616 8.87053L6.37533 11.3705ZM4.16699 15.5772V4.16699V15.8337V15.5772Z" fill="currentColor" />
                                                                                                                                </svg>
                                                                                                                            </i>
                                                                                                                            <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </Popover.Content>
                                                                                                            </Popover>
                                                                                                        }
                                                                                                    >
                                                                                                        <a href="#!" className="opacity-50 ml-2">+2 more</a>
                                                                                                    </OverlayTrigger> */}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">05:05:03 GMT</p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">Today</p>
                                                                    </td>
                                                                    <td>
                                                                        <Breadcrumb>
                                                                            {/* <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faDatabase} /></i>{item.source_names_info.integration_name}</Breadcrumb.Item> */}
                                                                            {/* <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERfCE_BILLING</Breadcrumb.Item> */}
                                                                        </Breadcrumb>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#B5B5C3" />
                                                                                    </svg>
                                                                                </i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu
                                                                                alignRight
                                                                                popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                                                            >
                                                                                <Dropdown.Header>Quick Action</Dropdown.Header>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item eventKey="1"><i><Image src={"icon_data_ignore"} /></i>Ignore/Mute</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="2"><i><Image src={"icon_data_resolve"} /></i>Resolved</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="3"><i><Image src={"icon_data_received"} /></i>Received</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="4"><i><Image src={"icon_data_assign"} /></i>Assign to teammat</Dropdown.Item>
                                                                                <Dropdown.Divider />
                                                                                {/* <Dropdown.Item eventKey="5"><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="6"><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="7"><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                                <tr className="tbl-row tbl-row--is-expanded">
                                                                    <td className="pr-0">
                                                                        <div className="icon-expand">
                                                                            {this.state.tblRowExpanded ?
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.0002 12.5998L15.9002 8.6998C16.0835 8.51647 16.3169 8.4248 16.6002 8.4248C16.8835 8.4248 17.1169 8.51647 17.3002 8.6998C17.4835 8.88314 17.5752 9.11647 17.5752 9.3998C17.5752 9.68314 17.4835 9.91647 17.3002 10.0998L12.7002 14.6998C12.6002 14.7998 12.4919 14.8706 12.3752 14.9123C12.2585 14.954 12.1335 14.9748 12.0002 14.9748C11.8669 14.9748 11.7419 14.954 11.6252 14.9123C11.5085 14.8706 11.4002 14.7998 11.3002 14.6998L6.7002 10.0998C6.51686 9.91647 6.42519 9.68314 6.42519 9.3998C6.42519 9.11647 6.51686 8.88314 6.7002 8.6998C6.88353 8.51647 7.11686 8.4248 7.4002 8.4248C7.68353 8.4248 7.91686 8.51647 8.10019 8.6998L12.0002 12.5998Z" fill="#99A1B7" />
                                                                                    </svg>
                                                                                </i>
                                                                                :
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#4B5675" />
                                                                                    </svg>
                                                                                </i>
                                                                            }

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="d-flex align-items-center">
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id="check2"
                                                                            />
                                                                            <a href="#!">
                                                                                <i className="mr-2"><FontAwesomeIcon icon={faDatabase} /></i>

                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="metric-stat-btns-group">
                                                                            <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                <button class="metric-stat-btn">Fill Rate:<strong className="value ml-1">90%</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1"></span> <strong></strong>
                                                                                </button>
                                                                            </div>
                                                                            <div class="metric-stat-btns metric-stat-btns--danger d-none">
                                                                                <button class="metric-stat-btn">Unique Values:<strong className="value ml-1">01</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                </button>
                                                                            </div>
                                                                            <OverlayTrigger
                                                                                trigger="click"
                                                                                placement={"bottom"}
                                                                                overlay={
                                                                                    <Popover className="popover-dark py-2">
                                                                                        <Popover.Content>
                                                                                            <div class="metric-stat-btns">
                                                                                                <sapn class="metric-stat-btn">Fill Rate:<strong className="value ml-1">100%</strong></sapn>
                                                                                                <span class="divider-line"></span>
                                                                                                <span className="metric-stat-btn">
                                                                                                    <span className="mx-1">{">"}</span> <strong>90%</strong>
                                                                                                </span>
                                                                                            </div>
                                                                                            <hr className="my-2" />
                                                                                            <div class="metric-stat-btns">
                                                                                                <sapn class="metric-stat-btn">Unique Values:<strong className="value ml-1">01</strong></sapn>
                                                                                                <span class="divider-line"></span>
                                                                                                <span className="metric-stat-btn">
                                                                                                    <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                                </span>
                                                                                            </div>
                                                                                            <hr className="my-2" />
                                                                                            <div class="metric-stat-btns">
                                                                                                <sapn class="metric-stat-btn">Data Conformity:<strong className="value ml-1">0.9</strong></sapn>
                                                                                                <span class="divider-line"></span>
                                                                                                <span className="metric-stat-btn">
                                                                                                    <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                                </span>
                                                                                            </div>
                                                                                        </Popover.Content>
                                                                                    </Popover>
                                                                                }
                                                                            >
                                                                                <a href="#!" className="opacity-50 ml-2">+2 more</a>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">05:05:03 GMT</p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">Today</p>
                                                                    </td>
                                                                    <td>
                                                                        <Breadcrumb>
                                                                            <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERfCE_BILLING</Breadcrumb.Item>
                                                                        </Breadcrumb>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#B5B5C3" />
                                                                                    </svg>
                                                                                </i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu
                                                                                alignRight
                                                                                popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                                                            >
                                                                                <Dropdown.Header>Quick Action</Dropdown.Header>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item eventKey="1"><i><Image src={"icon_data_ignore"} /></i>Ignore/Mute</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="2"><i><Image src={"icon_data_resolve"} /></i>Resolved</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="3"><i><Image src={"icon_data_received"} /></i>Received</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="4"><i><Image src={"icon_data_assign"} /></i>Assign to teammat</Dropdown.Item>
                                                                                <Dropdown.Divider />
                                                                                {/* <Dropdown.Item eventKey="5"><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="6"><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="7"><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                                <tr className="tbl-row tbl-row__nested">
                                                                    <td className="pr-0">
                                                                        <div className="icon-expand">
                                                                            {this.state.tblRowExpanded ?
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.0002 12.5998L15.9002 8.6998C16.0835 8.51647 16.3169 8.4248 16.6002 8.4248C16.8835 8.4248 17.1169 8.51647 17.3002 8.6998C17.4835 8.88314 17.5752 9.11647 17.5752 9.3998C17.5752 9.68314 17.4835 9.91647 17.3002 10.0998L12.7002 14.6998C12.6002 14.7998 12.4919 14.8706 12.3752 14.9123C12.2585 14.954 12.1335 14.9748 12.0002 14.9748C11.8669 14.9748 11.7419 14.954 11.6252 14.9123C11.5085 14.8706 11.4002 14.7998 11.3002 14.6998L6.7002 10.0998C6.51686 9.91647 6.42519 9.68314 6.42519 9.3998C6.42519 9.11647 6.51686 8.88314 6.7002 8.6998C6.88353 8.51647 7.11686 8.4248 7.4002 8.4248C7.68353 8.4248 7.91686 8.51647 8.10019 8.6998L12.0002 12.5998Z" fill="#99A1B7" />
                                                                                    </svg>
                                                                                </i>
                                                                                :
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#4B5675" />
                                                                                    </svg>
                                                                                </i>
                                                                            }

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="d-flex align-items-center">
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id="check3"
                                                                            />
                                                                            <a href="#!">
                                                                                <i className="mr-2"><FontAwesomeIcon icon={faDatabase} /></i>

                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="metric-stat-btns-group">
                                                                            <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                <button class="metric-stat-btn">Fill Rate:<strong className="value ml-1">90%</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1"></span> <strong></strong>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">05:05:03 GMT</p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">Today</p>
                                                                    </td>
                                                                    <td>
                                                                        <Breadcrumb>
                                                                            <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERfCE_BILLING</Breadcrumb.Item>
                                                                        </Breadcrumb>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#B5B5C3" />
                                                                                    </svg>
                                                                                </i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu
                                                                                alignRight
                                                                                popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                                                            >
                                                                                <Dropdown.Header>Quick Action</Dropdown.Header>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item eventKey="1"><i><Image src={"icon_data_ignore"} /></i>Ignore/Mute</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="2"><i><Image src={"icon_data_resolve"} /></i>Resolved</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="3"><i><Image src={"icon_data_received"} /></i>Received</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="4"><i><Image src={"icon_data_assign"} /></i>Assign to teammat</Dropdown.Item>
                                                                                <Dropdown.Divider />
                                                                                {/* <Dropdown.Item eventKey="5"><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="6"><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="7"><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                                <tr className="tbl-row tbl-row__nested tbl-row--is-expanded">
                                                                    <td className="pr-0">
                                                                        <div className="icon-expand">
                                                                            {this.state.tblRowExpanded ?
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.0002 12.5998L15.9002 8.6998C16.0835 8.51647 16.3169 8.4248 16.6002 8.4248C16.8835 8.4248 17.1169 8.51647 17.3002 8.6998C17.4835 8.88314 17.5752 9.11647 17.5752 9.3998C17.5752 9.68314 17.4835 9.91647 17.3002 10.0998L12.7002 14.6998C12.6002 14.7998 12.4919 14.8706 12.3752 14.9123C12.2585 14.954 12.1335 14.9748 12.0002 14.9748C11.8669 14.9748 11.7419 14.954 11.6252 14.9123C11.5085 14.8706 11.4002 14.7998 11.3002 14.6998L6.7002 10.0998C6.51686 9.91647 6.42519 9.68314 6.42519 9.3998C6.42519 9.11647 6.51686 8.88314 6.7002 8.6998C6.88353 8.51647 7.11686 8.4248 7.4002 8.4248C7.68353 8.4248 7.91686 8.51647 8.10019 8.6998L12.0002 12.5998Z" fill="#99A1B7" />
                                                                                    </svg>
                                                                                </i>
                                                                                :
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#4B5675" />
                                                                                    </svg>
                                                                                </i>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="d-flex align-items-center">
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id="check4"
                                                                            />
                                                                            <a href="#!">
                                                                                <i className="mr-2"><FontAwesomeIcon icon={faDatabase} /></i>

                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="metric-stat-btns-group">
                                                                            <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                <button class="metric-stat-btn">Unique Values:<strong className="value ml-1">01</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1">{">"}</span> <strong>10</strong>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">05:05:03 GMT</p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">Today</p>
                                                                    </td>
                                                                    <td>
                                                                        <Breadcrumb>
                                                                            <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERfCE_BILLING</Breadcrumb.Item>
                                                                        </Breadcrumb>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#B5B5C3" />
                                                                                    </svg>
                                                                                </i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu
                                                                                alignRight
                                                                                popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                                                            >
                                                                                <Dropdown.Header>Quick Action</Dropdown.Header>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item eventKey="1"><i><Image src={"icon_data_ignore"} /></i>Ignore/Mute</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="2"><i><Image src={"icon_data_resolve"} /></i>Resolved</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="3"><i><Image src={"icon_data_received"} /></i>Received</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="4"><i><Image src={"icon_data_assign"} /></i>Assign to teammat</Dropdown.Item>
                                                                                <Dropdown.Divider />
                                                                                {/* <Dropdown.Item eventKey="5"><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="6"><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="7"><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                                <tr className="tbl-row tbl-row__expanded-content">
                                                                    <td colSpan="12">
                                                                        <div className="tbl-dialog-box">
                                                                            <i class="icon-close">
                                                                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M5 6.06464L1.27376 9.79087C1.13435 9.93029 0.956907 10 0.741445 10C0.525982 10 0.348542 9.93029 0.209125 9.79087C0.0697085 9.65146 0 9.47402 0 9.25855C0 9.04309 0.0697085 8.86565 0.209125 8.72624L3.93536 5L0.209125 1.27376C0.0697085 1.13435 0 0.956907 0 0.741445C0 0.525982 0.0697085 0.348542 0.209125 0.209125C0.348542 0.0697085 0.525982 0 0.741445 0C0.956907 0 1.13435 0.0697085 1.27376 0.209125L5 3.93536L8.72624 0.209125C8.86565 0.0697085 9.04309 0 9.25855 0C9.47402 0 9.65146 0.0697085 9.79087 0.209125C9.93029 0.348542 10 0.525982 10 0.741445C10 0.956907 9.93029 1.13435 9.79087 1.27376L6.06464 5L9.79087 8.72624C9.93029 8.86565 10 9.04309 10 9.25855C10 9.47402 9.93029 9.65146 9.79087 9.79087C9.65146 9.93029 9.47402 10 9.25855 10C9.04309 10 8.86565 9.93029 8.72624 9.79087L5 6.06464Z" fill="#0F101E" />
                                                                                </svg>
                                                                            </i>
                                                                            <div className="tbl-dialog-box__left">
                                                                                <h4>No. of Rows decreased by <strong>50%</strong></h4>
                                                                                <p>Track the efficiency improvements with a 50% reduction in rows. Simplified data for sharper insights and streamlined operations.</p>
                                                                                <div class="error-detail">
                                                                                    <h6>Incident Location</h6>
                                                                                    <span class="chart-timestamp">2025-08-26 11:05:00 GMT</span>
                                                                                    <div className="nodes-group">
                                                                                        <div className="nodes-group__parent">
                                                                                            <div className="node ">
                                                                                                <button type="button" className="node-label tw-group" tabIndex="0" onClick={() => { if (this.state.kpiFullscreenItem) this.redirectToVerticalDasboard(this.state.kpiFullscreenItem); }}>
                                                                                                    <i><FontAwesomeIcon icon={faLayerGroup} /></i>
                                                                                                    <span>T_FACT_ECOMMERCE_BILLING</span>
                                                                                                    <i className="icon-external-link">
                                                                                                        <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                            <g>
                                                                                                                <path d="M4.5 3C3.67 3 3 3.67 3 4.5V13.5C3 14.33 3.67 15 4.5 15H13.5C14.33 15 15 14.33 15 13.5V10H14V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H4.5C4.36739 14 4.24021 13.9473 4.14645 13.8536C4.05268 13.7598 4 13.6326 4 13.5V4.5C4 4.22 4.22 4 4.5 4H8V3H4.5ZM11 4H13.3L9.14 8.15L9.84 8.85L14 4.71V7H15V3H11V4Z" fill="currentColor" />
                                                                                                            </g>
                                                                                                        </svg>
                                                                                                    </i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="nodes-group__child">
                                                                                            <div class="node">
                                                                                                <button type="button" className="node-label tw-group" tabIndex="0" onClick={() => { if (this.state.kpiFullscreenItem) this.redirectToVerticalDasboard(this.state.kpiFullscreenItem); }}>
                                                                                                    <i><FontAwesomeIcon icon={faTag} /></i>
                                                                                                    <span>INVOICE_CLOSED_AT</span>
                                                                                                    <i className="icon-external-link">
                                                                                                        <svg className="tw-block tw-text-[#F7F7F7] tw-opacity-75 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-ease-out tw-transform group-hover:tw-scale-105" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                            <g>
                                                                                                                <path d="M4.5 3C3.67 3 3 3.67 3 4.5V13.5C3 14.33 3.67 15 4.5 15H13.5C14.33 15 15 14.33 15 13.5V10H14V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H4.5C4.36739 14 4.24021 13.9473 4.14645 13.8536C4.05268 13.7598 4 13.6326 4 13.5V4.5C4 4.22 4.22 4 4.5 4H8V3H4.5ZM11 4H13.3L9.14 8.15L9.84 8.85L14 4.71V7H15V3H11V4Z" fill="currentColor" />
                                                                                                            </g>
                                                                                                        </svg>
                                                                                                    </i>
                                                                                                </button>
                                                                                                <div class="node-content">
                                                                                                    <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                                        <button class="metric-stat-btn">Fill Rate:<strong className="value ml-1">40%</strong></button>
                                                                                                        <button className="metric-stat-btn">
                                                                                                            <span className="mx-1">{">"}</span> <strong>75</strong>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="tbl-dialog-box__right">
                                                                                <div className="chart-box chart-box--lg w-100 m-0">
                                                                                    <div className="hero-banner__chart-filter">
                                                                                        <span className="metric-name d-flex align-items-center">Fill Rate <span class="text-danger ml-2">[Threshold Alert]</span></span>
                                                                                    </div>
                                                                                    <span className="chart-timestamp text-right">GMT</span>
                                                                                    <div class="chart-widget__toolbar">
                                                                                        <div className="chart-action-toolbar mt-0">
                                                                                            <div className="chart-action-toolbar__left d-none">
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Fullscreen</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className="chart-action-toolbar__btn">
                                                                                                        <i>
                                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M2.72622 7.20266C2.46355 7.20266 2.25 6.98985 2.25 6.72644V4.63109C2.25149 3.31703 3.31703 2.25152 4.63109 2.25H6.90207C7.16473 2.25 7.37829 2.46355 7.37829 2.72622C7.37829 2.98962 7.16473 3.20243 6.90207 3.20243H4.63109C3.8431 3.20392 3.20392 3.84236 3.20243 4.63109V6.72644C3.20243 6.85294 3.15258 6.97423 3.06329 7.06351C2.974 7.15279 2.8527 7.20266 2.72622 7.20266Z" fill="white" />
                                                                                                                <path d="M15.2591 7.22317C14.9957 7.22317 14.7828 7.01036 14.7828 6.74695V4.65159C14.7806 3.86361 14.1422 3.22517 13.3542 3.22294H11.0817C10.8183 3.22294 10.6055 3.01013 10.6055 2.74673C10.6055 2.48406 10.8183 2.27051 11.0817 2.27051H13.3542C14.6683 2.27274 15.733 3.33754 15.7353 4.65159V6.74695C15.7353 6.87345 15.6847 6.99474 15.5954 7.08402C15.5061 7.1733 15.3848 7.22317 15.2591 7.22317Z" fill="white" />
                                                                                                                <path d="M13.3575 15.7362H11.0924C10.8298 15.7362 10.6162 15.5234 10.6162 15.26C10.6162 14.9973 10.8298 14.7838 11.0924 14.7838H13.3575C14.1455 14.7815 14.7839 14.1431 14.7862 13.3551V11.2731C14.7862 11.0104 14.999 10.7969 15.2624 10.7969C15.525 10.7969 15.7386 11.0104 15.7386 11.2731V13.3684C15.7289 14.6773 14.6664 15.7339 13.3575 15.7362Z" fill="white" />
                                                                                                                <path d="M6.91532 15.7362H4.64281C3.32875 15.734 2.264 14.6692 2.26172 13.3551V11.2731C2.26172 11.0104 2.47453 10.7969 2.73794 10.7969C3.0006 10.7969 3.21415 11.0104 3.21415 11.2731V13.3684C3.21639 14.1564 3.85482 14.7949 4.64281 14.7971H6.91532C7.17798 14.7971 7.39153 15.0107 7.39153 15.2733C7.39153 15.536 7.17798 15.7495 6.91532 15.7495V15.7362Z" fill="white" />
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                            </div>
                                                                                            <div className="chart-action-toolbar__right">
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Like</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className={this.state.chartIconClicked === true ? "chart-action-toolbar__btn thumb-icon" : "chart-action-toolbar__btn"} onClick={this.handleChartIconTrigger}>
                                                                                                        <i>
                                                                                                            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#ffffff">
                                                                                                                {this.state.chartIconClicked === true ?
                                                                                                                    <path d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140ZM253.08-620v480H100v-480h153.08Z" />
                                                                                                                    : <path d="M709.23-140H288.46v-480l265.39-263.84L587.69-850q6.23 6.23 10.35 16.5 4.11 10.27 4.11 19.35V-804l-42.46 184h268q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.62 13.46-1.61 7.23-3.61 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140Zm-360.77-60h360.77q4.23 0 8.65-2.31 4.43-2.31 6.74-7.69L840-480v-67.69q0-5.39-3.46-8.85t-8.85-3.46H483.85L534-779.23 348.46-594.46V-200Zm0-394.46V-200v-394.46Zm-60-25.54v60H160v360h128.46v60H100v-480h188.46Z" />
                                                                                                                }
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Mark Unread</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className="chart-action-toolbar__btn" onClick={this.handleChartIconTrigger}>
                                                                                                        <i>
                                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M4.62769 11.1228H9.88307V10.0717H4.62769V11.1228ZM4.62769 9.02067H12.6859V7.96959H4.62769V9.02067ZM4.62769 6.91851H12.3153V6.87542C12.0135 6.78643 11.7418 6.65726 11.5002 6.48792C11.2585 6.31858 11.0474 6.11175 10.8667 5.86744H4.62769V6.91851ZM2 16.23V4.50647C2 4.15249 2.12263 3.85287 2.36788 3.60762C2.61313 3.36237 2.91274 3.23975 3.26672 3.23975H10.3035C10.2658 3.41492 10.2458 3.58899 10.2436 3.76196C10.2414 3.93492 10.2524 4.1112 10.2765 4.29082H3.26672C3.21277 4.29082 3.16337 4.3133 3.11852 4.35827C3.07356 4.40311 3.05108 4.45251 3.05108 4.50647V13.6698L4.03208 12.6994H14.0469C14.1009 12.6994 14.1503 12.677 14.1951 12.632C14.2401 12.5871 14.2626 12.5377 14.2626 12.4838V7.17865C14.4638 7.13369 14.6509 7.07617 14.8238 7.0061C14.9967 6.93603 15.1599 6.84395 15.3136 6.72984V12.4838C15.3136 12.8378 15.191 13.1374 14.9458 13.3826C14.7005 13.6279 14.4009 13.7505 14.0469 13.7505H4.47949L2 16.23ZM3.05108 4.50647V13.1845V4.29082V4.50647ZM13.5618 5.85395C13.0273 5.85395 12.5725 5.66645 12.1975 5.29145C11.8224 4.91633 11.6349 4.4615 11.6349 3.92697C11.6349 3.39244 11.8224 2.93768 12.1975 2.56268C12.5725 2.18756 13.0273 2 13.5618 2C14.0964 2 14.5511 2.18756 14.9261 2.56268C15.3013 2.93768 15.4888 3.39244 15.4888 3.92697C15.4888 4.4615 15.3013 4.91633 14.9261 5.29145C14.5511 5.66645 14.0964 5.85395 13.5618 5.85395Z" fill="white" />
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Share</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className="chart-action-toolbar__btn" onClick={this.handleChartIconTrigger}>
                                                                                                        <i>
                                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M14.5327 8.24982L11.4894 5.20651C11.3731 5.09013 11.3149 4.95651 11.3149 4.80563C11.3149 4.65463 11.3731 4.52094 11.4894 4.40457C11.6058 4.29594 11.7407 4.24282 11.8941 4.24519C12.0473 4.24769 12.1759 4.30082 12.2797 4.40457L15.6504 7.77526C15.7207 7.84551 15.7702 7.91957 15.7989 7.99744C15.8278 8.07532 15.8422 8.15944 15.8422 8.24982C15.8422 8.34019 15.8278 8.42432 15.7989 8.50219C15.7702 8.58007 15.7207 8.65413 15.6504 8.72438L12.2797 12.0951C12.1634 12.2113 12.0317 12.2676 11.8847 12.2638C11.7376 12.2599 11.6058 12.2037 11.4894 12.0951C11.3731 11.9787 11.3142 11.8458 11.3128 11.6963C11.3113 11.5468 11.3663 11.4162 11.4778 11.3046L14.5327 8.24982ZM10.5519 8.81232H5.4375C4.76437 8.81232 4.18987 9.05032 3.714 9.52632C3.238 10.0022 3 10.5767 3 11.2498V13.3123C3 13.4719 2.94613 13.6056 2.83838 13.7132C2.73075 13.8209 2.59712 13.8748 2.4375 13.8748C2.27787 13.8748 2.14425 13.8209 2.03663 13.7132C1.92888 13.6056 1.875 13.4719 1.875 13.3123V11.2498C1.875 10.2652 2.22262 9.42532 2.91787 8.73019C3.613 8.03494 4.45287 7.68732 5.4375 7.68732H10.5519L8.07112 5.20651C7.95487 5.09013 7.89675 4.95651 7.89675 4.80563C7.89675 4.65463 7.95487 4.52094 8.07112 4.40457C8.1875 4.29594 8.32237 4.24282 8.47575 4.24519C8.62912 4.24769 8.75775 4.30082 8.86162 4.40457L12.2321 7.77526C12.3024 7.84551 12.3519 7.91957 12.3808 7.99744C12.4097 8.07532 12.4241 8.15944 12.4241 8.24982C12.4241 8.34019 12.4097 8.42432 12.3808 8.50219C12.3519 8.58007 12.3024 8.65413 12.2321 8.72438L8.86162 12.0951C8.74525 12.2113 8.6135 12.2676 8.46637 12.2638C8.31925 12.2599 8.1875 12.2037 8.07112 12.0951C7.95487 11.9787 7.896 11.8458 7.8945 11.6963C7.893 11.5468 7.94806 11.4162 8.05969 11.3046L10.5519 8.81232Z" fill="white" />
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Ignore</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className="chart-action-toolbar__btn" onClick={this.handleChartIconTrigger}>

                                                                                                        <i>
                                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M14.8525 16.4567L13.1607 14.7649C12.5627 15.1985 11.9132 15.5336 11.2122 15.7703C10.5112 16.0068 9.77366 16.125 8.99966 16.125C8.01403 16.125 7.08778 15.9379 6.22091 15.5638C5.35403 15.1898 4.59997 14.6822 3.95872 14.0409C3.31747 13.3997 2.80984 12.6456 2.43584 11.7788C2.06172 10.9119 1.87466 9.98563 1.87466 9C1.87466 8.226 1.99291 7.4885 2.22941 6.7875C2.46603 6.0865 2.80116 5.437 3.23478 4.839L1.54297 3.14719L2.34491 2.34525L15.6544 15.6548L14.8525 16.4567ZM8.99966 15C9.61403 15 10.202 14.9096 10.7637 14.7289C11.3252 14.5481 11.853 14.289 12.3473 13.9515L4.04816 5.65238C3.71066 6.14663 3.45153 6.6745 3.27078 7.236C3.09003 7.79762 2.99966 8.38563 2.99966 9C2.99966 10.6625 3.58403 12.0781 4.75278 13.2469C5.92153 14.4156 7.33716 15 8.99966 15ZM14.988 12.8653L14.1675 12.0446C14.4425 11.5793 14.65 11.0923 14.7898 10.5836C14.9297 10.075 14.9997 9.54713 14.9997 9C14.9997 7.3375 14.4153 5.92188 13.2465 4.75313C12.0778 3.58438 10.6622 3 8.99966 3C8.45253 3 7.92466 3.06994 7.41603 3.20981C6.90741 3.34969 6.42041 3.55713 5.95503 3.83213L5.13434 3.01162C5.70709 2.64425 6.31778 2.36294 6.96641 2.16769C7.61516 1.97256 8.29291 1.875 8.99966 1.875C9.98528 1.875 10.9115 2.06206 11.7784 2.43619C12.6453 2.81019 13.3993 3.31781 14.0406 3.95906C14.6818 4.60031 15.1895 5.35437 15.5635 6.22125C15.9376 7.08812 16.1247 8.01438 16.1247 9C16.1247 9.70675 16.0271 10.3845 15.832 11.0333C15.6367 11.6819 15.3554 12.2926 14.988 12.8653Z" fill="white" />
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                                <RcTooltip trigger={["hover"]}
                                                                                                    placement="top"
                                                                                                    overlay={<span>Resolved</span>}
                                                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                                                >
                                                                                                    <div className="chart-action-toolbar__btn" onClick={this.handleChartIconTrigger}>

                                                                                                        <i>
                                                                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                <path d="M11.625 13.0958L15.4817 9.23909C15.5856 9.13522 15.7161 9.08209 15.8734 9.07972C16.0305 9.07734 16.1634 9.13047 16.2722 9.23909C16.3808 9.34772 16.4351 9.47947 16.4351 9.63434C16.4351 9.78909 16.3808 9.92078 16.2722 10.0294L12.0996 14.202C11.9639 14.3377 11.8058 14.4055 11.625 14.4055C11.4443 14.4055 11.2861 14.3377 11.1504 14.202L9.09225 12.1438C8.9885 12.04 8.93538 11.9095 8.93288 11.7523C8.9305 11.5951 8.98363 11.4622 9.09225 11.3535C9.201 11.2449 9.33275 11.1906 9.4875 11.1906C9.64225 11.1906 9.774 11.2449 9.88275 11.3535L11.625 13.0958ZM3.98081 15.3747C3.60794 15.3747 3.28875 15.2419 3.02325 14.9764C2.75775 14.7109 2.625 14.3917 2.625 14.0188V3.98047C2.625 3.60759 2.75775 3.28841 3.02325 3.02291C3.28875 2.75741 3.60794 2.62466 3.98081 2.62466H7.28513C7.389 2.25928 7.60125 1.95641 7.92188 1.71603C8.2425 1.47566 8.60188 1.35547 9 1.35547C9.4135 1.35547 9.77863 1.47566 10.0954 1.71603C10.4123 1.95641 10.6226 2.25928 10.7265 2.62466H14.0192C14.3921 2.62466 14.7113 2.75741 14.9768 3.02291C15.2423 3.28841 15.375 3.60759 15.375 3.98047V6.93716C15.375 7.09653 15.3211 7.23016 15.2132 7.33803C15.1053 7.44578 14.9717 7.49966 14.8123 7.49966C14.6528 7.49966 14.5192 7.44578 14.4116 7.33803C14.3039 7.23016 14.25 7.09653 14.25 6.93716V3.98047C14.25 3.92272 14.2259 3.86984 14.1778 3.82184C14.1298 3.77372 14.0769 3.74966 14.0192 3.74966H12.375V5.03328C12.375 5.22541 12.3103 5.38641 12.1809 5.51628C12.0516 5.64616 11.8913 5.71109 11.7 5.71109H6.29981C6.10856 5.71109 5.94831 5.64616 5.81906 5.51628C5.68969 5.38641 5.625 5.22541 5.625 5.03328V3.74966H3.98081C3.92306 3.74966 3.87019 3.77372 3.82219 3.82184C3.77406 3.86984 3.75 3.92272 3.75 3.98047V14.0188C3.75 14.0766 3.77406 14.1295 3.82219 14.1775C3.87019 14.2256 3.92306 14.2497 3.98081 14.2497H7.6875C7.84688 14.2497 7.9805 14.3036 8.08838 14.4115C8.19613 14.5193 8.25 14.653 8.25 14.8123C8.25 14.9718 8.19613 15.1054 8.08838 15.213C7.9805 15.3208 7.84688 15.3747 7.6875 15.3747H3.98081ZM9.00131 3.83628C9.19369 3.83628 9.35456 3.77116 9.48394 3.64091C9.61319 3.51078 9.67781 3.34947 9.67781 3.15697C9.67781 2.96459 9.61275 2.80372 9.48263 2.67434C9.3525 2.54509 9.19119 2.48047 8.99869 2.48047C8.80631 2.48047 8.64544 2.54553 8.51606 2.67566C8.38681 2.80591 8.32219 2.96722 8.32219 3.15959C8.32219 3.35197 8.38725 3.51284 8.51738 3.64222C8.6475 3.77159 8.80881 3.83628 9.00131 3.83628Z" fill="white" />
                                                                                                            </svg>
                                                                                                        </i>
                                                                                                    </div>
                                                                                                </RcTooltip>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr className="tbl-row tbl-row__nested">
                                                                    <td className="pr-0">
                                                                        <div className="icon-expand">
                                                                            {this.state.tblRowExpanded ?
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.0002 12.5998L15.9002 8.6998C16.0835 8.51647 16.3169 8.4248 16.6002 8.4248C16.8835 8.4248 17.1169 8.51647 17.3002 8.6998C17.4835 8.88314 17.5752 9.11647 17.5752 9.3998C17.5752 9.68314 17.4835 9.91647 17.3002 10.0998L12.7002 14.6998C12.6002 14.7998 12.4919 14.8706 12.3752 14.9123C12.2585 14.954 12.1335 14.9748 12.0002 14.9748C11.8669 14.9748 11.7419 14.954 11.6252 14.9123C11.5085 14.8706 11.4002 14.7998 11.3002 14.6998L6.7002 10.0998C6.51686 9.91647 6.42519 9.68314 6.42519 9.3998C6.42519 9.11647 6.51686 8.88314 6.7002 8.6998C6.88353 8.51647 7.11686 8.4248 7.4002 8.4248C7.68353 8.4248 7.91686 8.51647 8.10019 8.6998L12.0002 12.5998Z" fill="#99A1B7" />
                                                                                    </svg>
                                                                                </i>
                                                                                :
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#4B5675" />
                                                                                    </svg>
                                                                                </i>
                                                                            }

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="d-flex align-items-center">
                                                                            <Form.Check
                                                                                custom
                                                                                type="checkbox"
                                                                                id="check5"
                                                                            />
                                                                            <a href="#!">
                                                                                <i className="mr-2"><FontAwesomeIcon icon={faDatabase} /></i>

                                                                            </a>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div class="metric-stat-btns-group">
                                                                            <div class="metric-stat-btns metric-stat-btns--danger">
                                                                                <button class="metric-stat-btn">Data Confirmity:<strong className="value ml-1">10</strong>
                                                                                </button>
                                                                                <button className="metric-stat-btn">
                                                                                    <span className="mx-1"></span> <strong></strong>
                                                                                </button>
                                                                            </div>

                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">05:05:03 GMT</p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="d-flex align-items-center mb-0">Today</p>
                                                                    </td>
                                                                    <td>
                                                                        <Breadcrumb>
                                                                            <Breadcrumb.Item href="#"><i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERfCE_BILLING</Breadcrumb.Item>
                                                                        </Breadcrumb>
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown className="hide-toggle-arrow action-dropdown" alignRight>
                                                                            <Dropdown.Toggle variant="" id="dropdown-basic">
                                                                                <i>
                                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#B5B5C3" />
                                                                                    </svg>
                                                                                </i>
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu
                                                                                alignRight
                                                                                popperConfig={ACTION_DROPDOWN_POPPER_CONFIG}
                                                                            >
                                                                                <Dropdown.Header>Quick Action</Dropdown.Header>
                                                                                <Dropdown.Divider />
                                                                                <Dropdown.Item eventKey="1"><i><Image src={"icon_data_ignore"} /></i>Ignore/Mute</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="2"><i><Image src={"icon_data_resolve"} /></i>Resolved</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="3"><i><Image src={"icon_data_received"} /></i>Received</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="4"><i><Image src={"icon_data_assign"} /></i>Assign to teammat</Dropdown.Item>
                                                                                <Dropdown.Divider />
                                                                                {/* <Dropdown.Item eventKey="5"><i><FontAwesomeIcon icon={faCube} /></i>Metric View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="6"><i><FontAwesomeIcon icon={faDatabase} /></i>Profile View</Dropdown.Item>
                                                                                <Dropdown.Item eventKey="7"><i><FontAwesomeIcon icon={faChartArea} /></i>Monitor View</Dropdown.Item> */}
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                                </>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    )}
                                                    {this.state.allIncidentApiPaginated && (
                                                    <div className="react-bootstrap-table__footer">
                                                        <div className="row align-items-center">
                                                            <div className="col-sm-12 col-md-6">
                                                                <div className="btn-group react-table__length d-none" role="group">
                                                                    <span className="col-form-label mr-2">Show</span>
                                                                    <Select
                                                                        options={allIncidentPageSizeOptions}
                                                                        classNamePrefix="select-control"
                                                                        value={this.state.allIncidentpageSize}
                                                                        onChange={this.handleallIncidentpageSizeChange}
                                                                        isSearchable={false}
                                                                        menuPlacement="top"
                                                                    />
                                                                    <span className="col-form-label ml-2">items per page</span>
                                                                </div>
                                                                <span className="react-table__info">
                                                                    {filteredIncidentCount > 0
                                                                        ? `Showing ${incidentStart} to ${incidentEnd} of ${filteredIncidentCount} results`
                                                                        : "No results found"}
                                                                </span>
                                                            </div>
                                                            <div className="col-sm-12 col-md-6">
                                                                <ul className="pagination float-md-right mb-0">
                                                                    <li className={`page-item ${allIncidentCurrentPage <= 1 ? "disabled" : ""}`} title="previous page">
                                                                        <a
                                                                            href="#!"
                                                                            className="page-link"
                                                                            onClick={(event) => {
                                                                                event.preventDefault();
                                                                                if (allIncidentCurrentPage > 1) {
                                                                                    this.handleAllIncidentPageChange(allIncidentCurrentPage - 1);
                                                                                }
                                                                            }}
                                                                        >&lt;</a>
                                                                    </li>
                                                                    {Array.from({ length: totalIncidentPages }, (_, index) => (
                                                                        <li
                                                                            key={index + 1}
                                                                            className={`page-item ${allIncidentCurrentPage === index + 1 ? "active" : ""}`}
                                                                            title={`Page ${index + 1}`}
                                                                        >
                                                                            <a
                                                                                href="#!"
                                                                                className="page-link"
                                                                                onClick={(event) => {
                                                                                    event.preventDefault();
                                                                                    this.handleAllIncidentPageChange(index + 1);
                                                                                }}
                                                                            >{index + 1}</a>
                                                                        </li>
                                                                    ))}
                                                                    <li className={`page-item ${allIncidentCurrentPage >= totalIncidentPages ? "disabled" : ""}`} title="next page">
                                                                        <a
                                                                            href="#!"
                                                                            className="page-link"
                                                                            onClick={(event) => {
                                                                                event.preventDefault();
                                                                                if (allIncidentCurrentPage < totalIncidentPages) {
                                                                                    this.handleAllIncidentPageChange(allIncidentCurrentPage + 1);
                                                                                }
                                                                            }}
                                                                        >&gt;</a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    )}
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                    </div>
                                </FadeUpOnScroll>
                            </div>
                        </div>
                        {/* End: Incident Table */}
                        </>}

                        {/* Start: Incident Fullscreen */}
                        <div className={`qd-fullscreen qd-fullscreen-dark ${this.state.showFullscreen ? 'fade show' : ''}`}>
                            <div className="qd-fs_dialog">
                                <div className="qd-fs_content">
                                    <div className="portlet lineage-graph-portlet border-0 h-100">
                                        <div className="portlet-title">
                                            <div className="caption">
                                                <span className="text-white"><span>Pipeline:</span> <strong className="font-weight-semibold">timers_pending_count</strong></span>
                                                <p>Click on task or dataset in order to see their downstream</p>
                                            </div>
                                            <div className="actions">
                                                <div className="lg-toolbar">
                                                    {/* <div className="lg-toolbar-item">
                                                        <p class="mb-0 d-none"><label class="text-muted mb-0 d-none d-xl-inline-block">Last Sync:</label> <strong>Today at 04:00:00 PM</strong></p>
                                                    </div> */}
                                                    <div className="lg-toolbar-item">
                                                        <Form>
                                                            <Form.Group controlId="formBasicRangeCustom" className="form-inline flex-nowrap mb-0">
                                                                <Form.Label className="d-none d-xl-inline-block text-white opacity-50">Zoom</Form.Label>
                                                                <RangeSlider
                                                                    min={0}
                                                                    max={100}
                                                                    tooltip={false}
                                                                    value={this.state.rangeValue}
                                                                    onChange={this.setRangeValue}
                                                                />

                                                                <span className="rangeslider__label">{this.state.rangeValue + "%"}</span>
                                                            </Form.Group>
                                                        </Form>
                                                    </div>
                                                    <div className="lg-toolbar-item">
                                                        <button class="btn btn-light mr-4">Reset</button>
                                                        <button type="button" class="close" aria-label="Close" onClick={this.handleFullscreenVisible}><span aria-hidden="true"></span><span class="sr-only">Close</span></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="portlet-body p-0 overflow-hidden">
                                            <img width="100%" src={LineageFullscreen} alt="" />
                                            <div className="lineage-graph-sidebar">
                                                <div className="lg-sidebar__content">
                                                    <div className="lg-sidebar__header">
                                                        <div className="caption">
                                                            <span>Task</span>
                                                            <p>Pipeline_1 / SkinThickness</p>
                                                        </div>
                                                        <div className="action">
                                                            <button type="button" className="close"><span className="sr-only">Close</span></button>
                                                        </div>
                                                    </div>
                                                    <div className="lg-sidebar__body">
                                                        <div className="lg-section">
                                                            <h5 className="lg-section__title">Origin</h5>
                                                            <div className="lg-section__body">
                                                                <div className="pipeline-details">
                                                                    <p><label>Pipeline:</label><span><i><FontAwesomeIcon icon={faAsterisk} /></i></span></p>
                                                                    <p><label>Run:</label><span><i><FontAwesomeIcon icon={faClock} /></i><strong>At </strong></span></p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`qd-fullscreen qd-fullscreen-dark ${this.state.showBarFullscreen ? 'fade show' : ''}`}>
                            <div className="qd-fs_dialog">
                                <div className="qd-fs_content">
                                    <div className="qd-chartWidget qd-incidents-chartWidget">
                                        <div className="qd-cw-top">
                                            <div className="qd-cw-left">
                                                <div className="qd-cw-col">
                                                    <div className="qd-cw-btn">
                                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M17.3634 22.5113C16.6803 22.5121 16.0055 22.3616 15.3875 22.0706C14.7695 21.7795 14.2236 21.3552 13.7891 20.8281L3.7495 20.8638C3.51963 20.8636 3.29203 20.8182 3.07969 20.7301C2.86736 20.642 2.67446 20.513 2.51201 20.3503C2.34955 20.1877 2.22072 19.9947 2.13287 19.7822C2.04502 19.5698 1.99987 19.3421 2 19.1123V5.91128C2.00052 5.44744 2.18501 5.00275 2.513 4.67477C2.84098 4.34679 3.28567 4.1623 3.7495 4.16177H6.95049V3.02316C6.94746 2.95411 6.95843 2.88516 6.98276 2.82047C7.00709 2.75577 7.04427 2.69668 7.09205 2.64674C7.13984 2.59681 7.19724 2.55707 7.2608 2.52992C7.32436 2.50277 7.39277 2.48877 7.46188 2.48877C7.531 2.48877 7.5994 2.50277 7.66296 2.52992C7.72652 2.55707 7.78392 2.59681 7.83171 2.64674C7.87949 2.69668 7.91667 2.75577 7.941 2.82047C7.96533 2.88516 7.97631 2.95411 7.97327 3.02316V4.16177H15.201V3.02316C15.201 2.8874 15.2549 2.7572 15.3509 2.6612C15.4469 2.56521 15.5771 2.51128 15.7129 2.51128C15.8486 2.51128 15.9788 2.56521 16.0748 2.6612C16.1708 2.7572 16.2248 2.8874 16.2248 3.02316V4.16177H18.601C19.0647 4.16256 19.5091 4.34716 19.8369 4.67512C20.1646 5.00307 20.349 5.44761 20.3495 5.91128V14.3766C20.8706 14.7975 21.2898 15.3307 21.5756 15.9365C21.8614 16.5423 22.0065 17.2049 22 17.8746C21.9984 19.1039 21.5094 20.2823 20.6402 21.1515C19.771 22.0207 18.5926 22.5097 17.3634 22.5113ZM17.3634 14.2608C16.6483 14.2606 15.9493 14.4725 15.3547 14.8696C14.7601 15.2667 14.2966 15.8313 14.0229 16.4918C13.7492 17.1524 13.6775 17.8793 13.8169 18.5806C13.9564 19.2819 14.3007 19.9261 14.8063 20.4317C15.3119 20.9373 15.9561 21.2816 16.6574 21.4211C17.3587 21.5605 18.0856 21.4889 18.7462 21.2151C19.4067 20.9414 19.9713 20.4779 20.3684 19.8833C20.7656 19.2887 20.9774 18.5897 20.9772 17.8746C20.9762 16.9165 20.5951 15.9979 19.9176 15.3204C19.2401 14.6429 18.3215 14.2618 17.3634 14.2608ZM3.02376 19.1123C3.02376 19.3048 3.10019 19.4895 3.23627 19.6258C3.37234 19.7621 3.55693 19.8387 3.7495 19.839H13.1673C12.8765 19.225 12.726 18.554 12.7267 17.8746C12.7283 16.6454 13.2173 15.467 14.0865 14.5978C14.9557 13.7286 16.1341 13.2396 17.3634 13.238C18.0424 13.2376 18.713 13.388 19.3267 13.6786V9.31029H3.02376V19.1123ZM19.3267 8.28751V5.91128C19.3267 5.71871 19.2503 5.53401 19.1142 5.39775C18.9782 5.26149 18.7936 5.18481 18.601 5.18454H16.2248V6.73603C16.2249 6.91473 16.1732 7.08964 16.076 7.2396C15.9788 7.38956 15.8403 7.50815 15.6771 7.58103C15.5139 7.6539 15.3331 7.67793 15.1566 7.65022C14.9801 7.62251 14.8153 7.54424 14.6823 7.42488C14.5493 7.30552 14.4538 7.15018 14.4072 6.97765C14.3606 6.80512 14.365 6.62279 14.4199 6.45272C14.4748 6.28265 14.5778 6.13212 14.7164 6.01934C14.855 5.90655 15.0233 5.83635 15.201 5.81722V5.18454H7.97327V6.73603C7.9732 6.91449 7.92143 7.08912 7.82423 7.23879C7.72703 7.38846 7.58855 7.50677 7.42554 7.57942C7.26253 7.65207 7.08197 7.67594 6.90568 7.64816C6.72939 7.62037 6.56493 7.54211 6.43217 7.42285C6.29941 7.30358 6.20403 7.14841 6.15758 6.9761C6.11113 6.80378 6.11559 6.62171 6.17041 6.45187C6.22524 6.28204 6.32809 6.13172 6.46652 6.01909C6.60496 5.90646 6.77306 5.83634 6.95049 5.81722V5.18454H3.7495C3.55684 5.18481 3.37215 5.26146 3.23592 5.39769C3.09968 5.53392 3.02303 5.71862 3.02277 5.91128V8.28751H19.3267Z" fill="white" />
                                                            <path d="M16.5396 20.0358C16.4723 20.0361 16.4058 20.0229 16.3437 19.997C16.2816 19.9712 16.2254 19.9332 16.1782 19.8853L14.9406 18.6477C14.8923 18.6006 14.854 18.5442 14.828 18.4819C14.802 18.4197 14.7887 18.3528 14.7891 18.2853C14.7899 18.1499 14.8444 18.0203 14.9406 17.925C14.9878 17.8774 15.0441 17.8396 15.106 17.8139C15.168 17.7881 15.2344 17.7749 15.3014 17.7749C15.3685 17.7749 15.4349 17.7881 15.4969 17.8139C15.5588 17.8396 15.615 17.8774 15.6623 17.925L16.5386 18.8002L19.0653 16.2735C19.1371 16.2022 19.2283 16.1537 19.3276 16.1342C19.4268 16.1146 19.5296 16.1249 19.6231 16.1636C19.7165 16.2023 19.7964 16.2678 19.8527 16.3519C19.9091 16.4359 19.9393 16.5347 19.9396 16.6358C19.9394 16.7029 19.9259 16.7693 19.8999 16.8312C19.8739 16.8931 19.8359 16.9492 19.7881 16.9962L16.9 19.8834C16.8531 19.9316 16.7971 19.9699 16.7352 19.9961C16.6733 20.0223 16.6068 20.0358 16.5396 20.0358Z" fill="white" />
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div className="qd-cw-col">
                                                    <Dropdown className="qd-cw_dropdown-wrap hide-toggle-arrow">
                                                        <Dropdown.Toggle variant="" id="dropdown-basic" className="qd-cw-btn">
                                                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M7 5.5V20.5M4 18.5H6.5M10 9.5H7.5M16 4.5V19.5M13 7.5H15.5M19 14.5H16.5" stroke="white" stroke-linecap="square" />
                                                            </svg>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="#!">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="24" height="24"><g fill="none" stroke="currentColor" stroke-linecap="square"><path d="M10.5 7.5v15M7.5 20.5H10M13.5 11.5H11M19.5 6.5v15M16.5 9.5H19M22.5 16.5H20"></path></g></svg> Bar
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="#/action-2">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="24" height="24" fill="currentColor"><path d="M12.5 17.207L18.707 11h2l3.647-3.646-.708-.708L20.293 10h-2L12.5 15.793l-3-3-4.854 4.853.708.708L9.5 14.207z"></path><path d="M9 16h1v1H9zm1 1h1v1h-1zm-1 1h1v1H9zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1H9zm2 0h1v1h-1zm-3-3h1v1H8zm-1 1h1v1H7zm-1 1h1v1H6zm2 0h1v1H8zm-1 1h1v1H7zm-2 0h1v1H5zm17-9h1v1h-1zm1-1h1v1h-1zm0 2h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-5-7h1v1h-1zm2 0h1v1h-1zm1-1h1v1h-1zm-2 2h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-2-6h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-3-3h1v1h-1zm-1 1h1v1h-1zm-1 1h1v1h-1zm2 0h1v1h-1zm-1 1h1v1h-1z"></path></svg> Area
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                            <div className="qd-cw-right">
                                                <div className="qd-cw-col">
                                                    <div className="qd-cw-btn">
                                                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M12 15.5C11.606 15.5 11.2159 15.4224 10.8519 15.2716C10.488 15.1209 10.1573 14.8999 9.87868 14.6213C9.6001 14.3427 9.37913 14.012 9.22836 13.6481C9.0776 13.2841 9 12.894 9 12.5C9 12.106 9.0776 11.7159 9.22836 11.3519C9.37913 10.988 9.6001 10.6573 9.87868 10.3787C10.1573 10.1001 10.488 9.87913 10.8519 9.72836C11.2159 9.5776 11.606 9.5 12 9.5C12.7956 9.5 13.5587 9.81607 14.1213 10.3787C14.6839 10.9413 15 11.7044 15 12.5C15 13.2956 14.6839 14.0587 14.1213 14.6213C13.5587 15.1839 12.7956 15.5 12 15.5ZM12 14.5C12.5304 14.5 13.0391 14.2893 13.4142 13.9142C13.7893 13.5391 14 13.0304 14 12.5C14 11.9696 13.7893 11.4609 13.4142 11.0858C13.0391 10.7107 12.5304 10.5 12 10.5C11.4696 10.5 10.9609 10.7107 10.5858 11.0858C10.2107 11.4609 10 11.9696 10 12.5C10 13.0304 10.2107 13.5391 10.5858 13.9142C10.9609 14.2893 11.4696 14.5 12 14.5Z" fill="white" />
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.00505 14.5C2.87274 14.5003 2.74169 14.4744 2.61945 14.4238C2.4972 14.3732 2.38617 14.2989 2.29275 14.2052C2.19934 14.1115 2.12538 14.0002 2.07515 13.8778C2.02491 13.7554 1.99939 13.6243 2.00005 13.492V11.508C1.99873 11.3759 2.02363 11.2449 2.07332 11.1225C2.123 11.0002 2.19648 10.8889 2.2895 10.7951C2.38252 10.7014 2.49322 10.627 2.61519 10.5763C2.73716 10.5257 2.86798 10.4997 3.00005 10.5H4.25205C4.43718 9.77633 4.7244 9.08271 5.10505 8.44L4.18605 7.515C3.83005 7.118 3.83805 6.515 4.21605 6.136L5.63605 4.716C5.7294 4.62333 5.84012 4.54999 5.96186 4.50018C6.0836 4.45036 6.21397 4.42506 6.3455 4.42571C6.47704 4.42636 6.60715 4.45295 6.72839 4.50397C6.84963 4.55498 6.95962 4.62941 7.05205 4.723L7.94105 5.605C8.58404 5.22586 9.27716 4.93905 10.0001 4.753V3.5C10.0001 2.986 10.4601 2.5 11.0001 2.5H13.0001C13.5571 2.5 14.0001 2.94 14.0001 3.5V4.753C14.7233 4.93897 15.4167 5.22578 16.0601 5.605L16.9481 4.723C17.0405 4.62948 17.1506 4.55512 17.2719 4.5042C17.3931 4.45327 17.5233 4.42677 17.6548 4.42621C17.7863 4.42565 17.9167 4.45105 18.0384 4.50095C18.1601 4.55085 18.2708 4.62427 18.364 4.717L19.784 6.137C19.9646 6.31896 20.0684 6.56339 20.0738 6.8197C20.0792 7.07602 19.9858 7.3246 19.813 7.514C19.813 7.514 19.413 7.92 18.8951 8.44C19.2757 9.08271 19.5629 9.77633 19.748 10.5H21C21.557 10.5 22 10.947 22 11.508V13.492C22.0014 13.6241 21.9765 13.7551 21.9268 13.8775C21.8771 13.9998 21.8036 14.1111 21.7106 14.2049C21.6176 14.2986 21.5069 14.373 21.3849 14.4237C21.2629 14.4743 21.1321 14.5003 21 14.5H19.748C19.5629 15.2237 19.2757 15.9173 18.8951 16.56L19.7771 17.448C19.8706 17.5405 19.9449 17.6505 19.9959 17.7718C20.0468 17.8931 20.0733 18.0232 20.0738 18.1548C20.0744 18.2863 20.049 18.4166 19.9991 18.5383C19.9492 18.6601 19.8758 18.7707 19.7831 18.864L18.3631 20.284C18.2697 20.3765 18.1591 20.4497 18.0374 20.4995C17.9158 20.5492 17.7855 20.5744 17.6541 20.5738C17.5227 20.5731 17.3927 20.5466 17.2715 20.4957C17.1504 20.4447 17.0405 20.3704 16.9481 20.277L16.0591 19.395C15.4161 19.7741 14.7229 20.0609 14.0001 20.247V21.495C14.0001 22.055 13.55 22.5 12.9921 22.5H11.0081C10.8758 22.5005 10.7447 22.4749 10.6224 22.4246C10.5 22.3743 10.3888 22.3004 10.2952 22.207C10.2015 22.1136 10.1272 22.0026 10.0766 21.8804C10.0259 21.7583 9.99992 21.6273 10.0001 21.495V20.247C9.27682 20.061 8.58335 19.7742 7.94005 19.395L7.05205 20.277C6.95955 20.3705 6.84952 20.4449 6.72824 20.4958C6.60696 20.5467 6.47683 20.5732 6.34529 20.5738C6.21376 20.5743 6.08341 20.549 5.9617 20.4991C5.84 20.4492 5.72934 20.3757 5.63605 20.283L4.21605 18.863C4.12353 18.7697 4.05032 18.659 4.00059 18.5374C3.95087 18.4157 3.92561 18.2855 3.92626 18.154C3.92691 18.0226 3.95346 17.8926 4.00438 17.7715C4.05531 17.6503 4.12961 17.5404 4.22305 17.448L5.10505 16.56C4.7244 15.9173 4.43718 15.2237 4.25205 14.5H3.00505ZM6.38305 8.307L6.15605 8.647C5.66142 9.39099 5.31633 10.2242 5.14005 11.1L5.05805 11.5H3.00505C3.00205 11.5 3.00005 12.164 3.00005 13.492C3.00005 13.497 3.68605 13.5 5.05805 13.5L5.14005 13.9C5.32005 14.783 5.66005 15.61 6.15605 16.353L6.38305 16.693L4.93305 18.153C4.92905 18.156 5.39905 18.63 6.34305 19.575L7.80705 18.117L8.14705 18.344C8.89224 18.8371 9.72541 19.182 10.6011 19.36L11.0001 19.443V21.495C11.0001 21.498 11.6641 21.5 12.9921 21.5C12.9971 21.5 13.0001 20.814 13.0001 19.443L13.3991 19.36C14.2747 19.182 15.1079 18.8371 15.8531 18.344L16.1931 18.117L17.6531 19.567C17.6561 19.571 18.1301 19.101 19.0751 18.157L17.6171 16.693L17.8441 16.353C18.3387 15.609 18.6838 14.7758 18.8601 13.9L18.942 13.5H20.9951C20.9981 13.5 21 12.836 21 11.508C21 11.503 20.314 11.5 18.942 11.5L18.8601 11.1C18.6838 10.2242 18.3387 9.39099 17.8441 8.647L17.6171 8.307L18.993 6.923L19.074 6.841L17.6581 5.425L16.1931 6.883L15.8531 6.656C15.1079 6.16293 14.2747 5.81798 13.3991 5.64L13.0001 5.557V3.5C13.0001 3.497 12.3361 3.497 11.0081 3.5C11.0031 3.5 11.0001 4.186 11.0001 5.557L10.6011 5.64C9.72541 5.81798 8.89224 6.16293 8.14705 6.656L7.80705 6.883L6.34705 5.433C6.34405 5.429 5.87005 5.899 4.92605 6.841L6.38305 8.307Z" fill="white" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="close-icon" onClick={this.handleBarFullscreen}>
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_15053_34781)">
                                                        <path d="M19 6.91L17.59 5.5L12 11.09L6.41 5.5L5 6.91L10.59 12.5L5 18.09L6.41 19.5L12 13.91L17.59 19.5L19 18.09L13.41 12.5L19 6.91Z" fill="currentColor" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_15053_34781">
                                                            <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="qd-cw-main text-center">
                                            <img width="80%" src={BarChartFullscreen} alt="" />
                                        </div>
                                        <div className="qd-cw-bottom">
                                            <div className="qd-cw-bottom-content">
                                                <div class="textarea">
                                                    <h5>No. of Rows decreased</h5>
                                                    <p>Track the efficiency improvements with a 50% reduction in rows. Simplified data for sharper insights and streamlined operations. Track the efficiency improvements with a 50% reduction in rows. Simplified data for sharper insights and streamlined operations.</p>
                                                </div>
                                                <div class="error-detail">
                                                    <h6>Incident Location</h6>
                                                    <ul>
                                                        <li>
                                                            <a href="#!" onClick={(e) => { e.preventDefault(); if (this.state.kpiFullscreenItem) this.redirectToVerticalDasboard(this.state.kpiFullscreenItem); }} className="text-danger">
                                                                <i className="mr-1"><FontAwesomeIcon icon={faLayerGroup} /></i>T_FACT_ECOMMERCE_BILLING
                                                                <i className="ml-1 icon-external-link">
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g opacity="0.5">
                                                                            <path d="M4.5 3C3.67 3 3 3.67 3 4.5V13.5C3 14.33 3.67 15 4.5 15H13.5C14.33 15 15 14.33 15 13.5V10H14V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H4.5C4.36739 14 4.24021 13.9473 4.14645 13.8536C4.05268 13.7598 4 13.6326 4 13.5V4.5C4 4.22 4.22 4 4.5 4H8V3H4.5ZM11 4H13.3L9.14 8.15L9.84 8.85L14 4.71V7H15V3H11V4Z" fill="currentColor" />
                                                                        </g>
                                                                    </svg>
                                                                </i>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#!" onClick={(e) => { e.preventDefault(); if (this.state.kpiFullscreenItem) this.redirectToVerticalDasboard(this.state.kpiFullscreenItem); }} className="text-danger">
                                                                <i className="mr-1"><FontAwesomeIcon icon={faTag} /></i>TRANSACTION_DATE
                                                                <i className="ml-1 icon-external-link">
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <g opacity="0.5">
                                                                            <path d="M4.5 3C3.67 3 3 3.67 3 4.5V13.5C3 14.33 3.67 15 4.5 15H13.5C14.33 15 15 14.33 15 13.5V10H14V13.5C14 13.6326 13.9473 13.7598 13.8536 13.8536C13.7598 13.9473 13.6326 14 13.5 14H4.5C4.36739 14 4.24021 13.9473 4.14645 13.8536C4.05268 13.7598 4 13.6326 4 13.5V4.5C4 4.22 4.22 4 4.5 4H8V3H4.5ZM11 4H13.3L9.14 8.15L9.84 8.85L14 4.71V7H15V3H11V4Z" fill="currentColor" />
                                                                        </g>
                                                                    </svg>
                                                                </i>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div class="metric-stat-btns metric-stat-btns--royalblue mb-2">
                                                        <button class="metric-stat-btn">Fill Rate:<strong className="value ml-1">99%</strong>
                                                        </button>
                                                        <button className="metric-stat-btn">
                                                            <span className="mx-1">{">"}</span> <strong>90</strong>
                                                        </button>
                                                    </div>
                                                    <div class="metric-stat-btns metric-stat-btns--royalblue">
                                                        <button class="metric-stat-btn">Date Conformity:<strong className="value ml-1">0.9</strong>
                                                        </button>
                                                        <button className="metric-stat-btn">
                                                            <span className="mx-1">{"<"}</span> <strong>10</strong>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End: Incident Fullscreen */}

                        {/* Start: KPI Card Fullscreen */}
                        {(() => {
                            const fs = this.state.kpiFullscreenItem;
                            if (!fs) return null;

                            const fsTitle       = fs?.kpi_name || fs?.title || fs?.name || "KPI Metric";
                            const fsRaw         = fs?.kpi_agg_value ?? fs?.issue_count ?? fs?.value ?? fs?.count;
                            const fsUnits       = this.getChartDisplayUnits(fs);
                            const fsDesc        = fs?.description || fs?.trend_text || "â€”";
                            const fsTrendsVal   = fs?.trends_value != null ? fs.trends_value : null;
                            const fsSrc         = fs?.source || {};
                            const fsSrcLabel    = fsSrc.subject_area_name || fsSrc.business_area_name || fs?.subject_name || "KPI";
                            const fsGenAt       = fs?.generated_at ? this.getIncidentDate(fs.generated_at) : "";
                            const fsTrendIsUp   = this.isTrendUp(fs);
                            const { xValues: fsXValues, yValues: fsYValues, zValues: fsZValues, compareIndex: fsCompareIndex, driftValues: fsDriftValues, previousAvgValues: fsPreviousAvgValues } = this.getIncidentChartSeries(fs);
                            const selectedChart = this.state.selectedChartFilterOption?.value || 'Combo Chart';
                            const fsChartType   = selectedChart === 'Bar Chart' ? 'bar' : selectedChart === 'Area Chart' ? 'area' : 'area';

                            return (
                                <div className="qd-fullscreen qd-fullscreen-dark fade show" style={{ zIndex: 9999 }}>
                                    <div className="qd-fs_dialog" style={{ maxWidth: '900px', width: '90%', margin: '0 auto' }}>
                                        <div className="qd-fs_content" style={{ borderRadius: '24px', overflow: 'hidden', background: 'linear-gradient(180deg,#191932,#161A2C)', border: '1px solid rgba(255,255,255,0.1)' }}>
                                            <div className="tw-p-8">
                                                {/* Header */}
                                                <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                                                    <div>
                                                        <div className="tw-inline-flex tw-items-center tw-rounded-[999px] tw-bg-[#000000]/20 tw-py-1 tw-px-2 tw-border tw-border-[#ffffff]/5 tw-mb-3">
                                                            <i><svg className="tw-block" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.75"><path d="M4.6155 19C4.15517 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8448 3 17.3845V6.6155C3 6.15517 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15517 5 4.6155 5H8.925C9.14033 5 9.34967 5.04358 9.553 5.13075C9.75617 5.21792 9.93017 5.33392 10.075 5.47875L11.5963 7H19.3845C19.8448 7 20.2292 7.15417 20.5375 7.4625C20.8458 7.77083 21 8.15517 21 8.6155V17.3845C21 17.8448 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8448 19 19.3845 19H4.6155Z" fill="#007BFF" /></g></svg></i>
                                                            <span className="tw-text-xs tw-text-[#AAAAAA] tw-font-medium tw-px-1">{fsSrcLabel}</span>
                                                        </div>
                                                        <h2 className="tw-text-[28px] md:tw-text-[36px] tw-font-bold tw-text-white tw-leading-[34px] md:tw-leading-[44px] tw-mb-0">{fsTitle}</h2>
                                                    </div>
                                                    <button
                                                        className="tw-p-2 tw-border-0 tw-bg-white/10 tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white/20 tw-transition-all tw-duration-200 tw-shrink-0 tw-ml-4"
                                                        onClick={this.handleKpiCloseFullscreen}
                                                        aria-label="Close fullscreen"
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15 5L5 15M5 5L15 15" stroke="rgba(255,255,255,0.8)" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                {/* Value + trend */}
                                                <div className="tw-mb-6">
                                                    {this.renderMetricValueWithUnits(
                                                        fsRaw,
                                                        fsUnits,
                                                        "tw-text-[48px] md:tw-text-[64px] tw-leading-[56px] md:tw-leading-[72px] tw-text-white tw-font-medium tw-block tw-mb-2",
                                                        1
                                                    )}
                                                    <p className="tw-text-[#94979C] tw-text-sm tw-flex tw-items-center tw-gap-2 tw-mb-0">
                                                        {fsTrendsVal != null && this.renderTrendBadge(
                                                                fsTrendIsUp,
                                                                this.formatDriftDisplayValue(fsTrendsVal, "—"),
                                                                16
                                                            )}
                                                        <span>{fsDesc}</span>
                                                    </p>
                                                </div>
                                                {/* Chart */}
                                                <div className="tw-mb-6" style={{ height: `${VERTICAL_CHART_HEIGHT.HERO_BANNER}px` }}>
                                                    <VerticalChart xValues={fsXValues} yValues={fsYValues} zValues={fsZValues} compareIndex={fsCompareIndex} driftValues={fsDriftValues} previousAvgValues={fsPreviousAvgValues} type={fsChartType} showYAxis={true} units={this.getChartDisplayUnits(fs)} height={VERTICAL_CHART_HEIGHT.HERO_BANNER} axisFontSize={VERTICAL_CHART_AXIS_FONT.HERO_BANNER} heroBarLayout={true} />
                                                </div>
                                                {/* Footer */}
                                                {this.renderChartActionToolbar(fs, {
                                                    wrapperClassName: 'tw-flex tw-items-center tw-justify-between tw-pt-4 tw-border-t tw-border-white/10',
                                                    timestamp: fsGenAt || null,
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="qd-fs_backdrop" onClick={this.handleKpiCloseFullscreen} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: -1 }} />
                                </div>
                            );
                        })()}
                        {/* End: KPI Card Fullscreen */}
                        <LineageModal
                            show={this.state.showLineageModal}
                            onClose={this.handleDiagnosticsMapClose}
                            row={this.state.diagnosticMapIncident || {}}
                            data={this.state.diagnosticMapData}
                            loading={this.state.diagnosticMapLoading}
                            error={this.state.diagnosticMapError}
                        />

                        <VerticalDashboardModal
                            isOpen={this.state.showMonitorDataDriftModal}
                            onClose={this.handleCloseMonitorDataDriftModal}
                            incidentData={this.state.selectedDriftIncident}
                            teamId={this.state.teamId}
                            userId={this.state.userId}
                            envId={this.state.selectedEnvId}
                            targetType={this.state.selectedDriftTargetType}
                            onOpenFullMonitor={(data) => this.redirectToVerticalDasboard(data, this.state.selectedDriftTargetType)}
                        /> 

                        {/* End: Incident Fullscreen */}
                    </div >
                </main >
                <CopyRightsFooter />
                {this.state.showNotifyToast && (
                    <NotifyToast
                        message={this.state.notifyMessage}
                        variant={this.state.notifyToastVariant}
                        icon={this.state.notifyToastIcon}
                    />
                )}
            </>
        )
    }
}
